webpackJsonp([31],{

/***/ "+1kW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+3+F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+sLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav-header flex-box",style:({height: _vm.height + 'px',paddingLeft: _vm.paddingLeft + 'px',paddingRight: _vm.paddingRight + 'px',borderBottom: _vm.borderBottom ? _vm.borderBottom : '1px solid #e5e5e5'})},[_c('h3',{staticClass:"title"},[_vm._t("line",function(){return [_c('i',{staticClass:"line"})]}),_vm._v(" "),_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"g-flex-right"},[_vm._t("right")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+uJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"aside-cont navbar g-elmenu",staticStyle:{"width":"202px","font-size":"12px","height":"calc(100% - 90px)"},attrs:{"default-active":_vm.url,"background-color":"#333743","active-text-color":"#fff","text-color":"#33CCFF","router":"","unique-opened":true,"collapse":_vm.isCollapse}},[_vm._l((_vm.$router.options.routes),function(item,index){return (!item.hidden)?[(!item.leaf&&_vm.$checkPermissions(item.permission))?_c('el-submenu',{attrs:{"index":index+''}},[_c('template',{slot:"title"},[_c('i',{class:'iconfont '+ item.iconCls+' '+((_vm.netaddress===item.children[0].path&&_vm.isCollapse)?'actived':'')}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_vm._l((item.children),function(child){return (!child.hidden && _vm.$checkPermissions(child.permission))?_c('el-menu-item',{key:child.path,attrs:{"index":child.path},nativeOn:{"click":function($event){return _vm.shows(child.path)}}},[_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(child.name))]),_vm._v(" "),(child.path === '/remindBill' && _vm.billRemindsCount !== 0)?_c('span',{staticClass:"remindNumBox"},[_vm._v(_vm._s(_vm.getBillRemindsCount))]):_vm._e(),_vm._v(" "),(child.path === '/remindOverTime' && _vm.contractRemindsCount !== 0)?_c('span',{staticClass:"remindNumBox"},[_vm._v(_vm._s(_vm.getContractRemindsCount))]):_vm._e()]):_vm._e()})],2):_vm._e(),_vm._v(" "),(item.leaf && item.children.length > 0)?_c('el-menu-item',{class:_vm.netaddress===item.children[0].path?'':'',attrs:{"index":item.children[0].path},nativeOn:{"click":function($event){return _vm.shows(item.children[0].path)}}},[_c('i',{class:'iconfont '+ item.iconCls}),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(item.name))])]):_vm._e()]:_vm._e()}),_vm._v(" "),([283,292,289,12,50,281,261,230].includes(_vm.channelId))?_c('el-menu-item',{nativeOn:{"click":function($event){return _vm.openUrl('https://www.wzjrfw.com/')}}},[_c('i',{staticClass:"iconfont icon-attchment"}),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("金融综合服务平台")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/1cT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {},
      fileList: [],
      submitLoading: false,
      conts: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  computed: {},
  props: ['fileSendId'],
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      } else {
        this.$emit('closeDialog');
      }
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_15" /* getFileDetail */]({ fileSendFileId: this.fileSendId }).then(function (res) {
        _this.parkListLoading = false;
        if (res.data.code == "success") {
          _this.info = res.data.data.fileDetail;
        }
      }).catch(function (_) {
        console.log(_);
        _this.parkListLoading = false;
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "/Me2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mUtils__ = __webpack_require__("yclV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSave: false,
      submitLoading: false,
      sellOptions: [],
      checkOptions: [],
      dateSection: [],
      info: {
        noteType: '',
        noteCompanyName: '',
        noteBillInfo: '',
        noteContractInfo: '',
        noteDescription: '',
        invoiceMakeFileNames: '',
        noteVoucherFile: '',
        noteTaxpayer: '',
        noteAddress: '',
        notePhone: '',
        noteBank: '',
        noteAccount: ''
      },
      rules: {
        noteType: [{ required: true, message: "请选择发票类型", trigger: ["blur", "change"] }],
        noteCompanyName: [{ required: true, message: "请输入企业名称", trigger: ["blur", "change"] }],
        noteDescription: [{ required: true, message: "请输入情况描述", trigger: ["blur", "change"] }],
        noteVoucherFile: [{ required: true, message: "请选择文件", trigger: ["blur", "change"] }],

        noteTaxpayer: [{ required: true, message: "请输入纳税识别号 ", trigger: ["blur", "change"] }],
        noteAddress: [{ required: true, message: "请输入地址 ", trigger: ["blur", "change"] }],
        notePhone: [{ required: true, message: "请输入电话 ", trigger: ["blur", "change"] }],
        noteBank: [{ required: true, message: "请输入开户行 ", trigger: ["blur", "change"] }],
        noteAccount: [{ required: true, message: "请输入帐号 ", trigger: ["blur", "change"] }]

      },
      invoiceDefaultIsHaveNumber: 0,
      BillInfoList: [],
      ContractInfoList: [],
      ContractInfoSelect: [],
      contractId: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getContracts(); //获取合同下拉列表
    // this.getBills();//获取账单下拉列表
    this.init();
  },

  props: [],
  computed: {},
  methods: {
    changeSelectContract: function changeSelectContract(val) {
      //选择合同
      var tempId = this.$refs['contractCascader'].getCheckedNodes()[0].data.contractId;
      this.contractId = tempId.substr(2);
      if (val && val.length) {
        this.getBills(this.contractId, val[0]);
        var str = '';
        this.ContractInfoList.forEach(function (item) {
          if (item.contractId == val[0]) {
            str = item.contractContent;
            item.contracts.forEach(function (ele) {
              if (ele.contractId == val[1]) {
                str = str + '/' + ele.contractContent;
              }
            });
          }
        });
        this.info.noteContractInfo = str;
      }
      this.info.noteBillInfo = '';
    },
    getContracts: function getContracts() {
      var _this = this;

      //处理级联数据，生成唯一id拼接显示
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_13" /* getContracts */]().then(function (res) {
        if (res.data.code == 1 || res.data.code == 'success') {
          var arr = res.data.data || [];
          if (arr.length) {
            arr.forEach(function (ele, index) {
              ele.contracts.forEach(function (item) {
                if (ele.contractId == 1) {
                  //租赁
                  item.contractId = 'ZL' + item.contractId;
                } else if (ele.contractId == 2) {
                  //物业
                  item.contractId = 'WY' + item.contractId;
                } else if (ele.contractId == 3) {
                  //车位
                  item.contractId = 'CW' + item.contractId;
                } else if (ele.contractId == 4) {
                  //公寓租赁
                  item.contractId = 'GZ' + item.contractId;
                } else if (ele.contractId == 5) {
                  //公寓物业
                  item.contractId = 'GW' + item.contractId;
                }
                item.contractContent = item.contractNumber + '   (' + new Date(item.contractStartTime).format('yyyy-MM-dd') + '~' + new Date(item.contractEndTime).format('yyyy-MM-dd') + ')';
              });
            });

            _this.ContractInfoList = arr || [];
            console.log(_this.ContractInfoList);
          }
        }
      }).catch(function (err) {});
    },
    getBills: function getBills(contractId, type) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_9" /* getBills */]({ contractId: contractId, contractType: type }).then(function (res) {
        if (res.data.code == 1 || res.data.code == 'success') {
          _this2.BillInfoList = res.data.data || [];
          _this2.BillInfoList.forEach(function (ele, index) {
            var billType = __WEBPACK_IMPORTED_MODULE_2__config_mUtils__["a" /* billTypeNew */](ele.allBillType);
            ele.noteBillInfo = billType + '/' + new Date(ele.allBillStartTime).format('yyyy-MM-dd') + '~' + new Date(ele.allBillEndTime).format('yyyy-MM-dd');
          });
          console.log(_this2.BillInfoList);
        }
      }).catch(function (err) {});
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    onFileChangeBills: function onFileChangeBills(obj) {
      var url = [];
      obj.fileList.forEach(function (item) {
        url.push(item);
      });
      this.info.noteVoucherFile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(url);
    },
    init: function init() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_56" /* noteCompanyDetail */]().then(function (res) {
        _this3.info.noteTaxpayer = res.data.data.noteTaxpayer;
        _this3.info.noteAddress = res.data.data.noteAddress;
        _this3.info.notePhone = res.data.data.notePhone;
        _this3.info.noteBank = res.data.data.noteBank;
        _this3.info.noteAccount = res.data.data.noteAccount;
        // this.info = Object.assign(this.info,res.data.data)
      }).catch(function (err) {
        _this3.submitLoading = false;
        _this3.$message.error("服务器开小差了...");
      });
    },
    submit: function submit() {
      var _this4 = this;

      this.submitLoading = true;
      this.$refs["info"].validate(function (valid) {
        if (valid) {
          _this4.info.isPreserve = _this4.isSave ? 1 : 0;
          __WEBPACK_IMPORTED_MODULE_1__service_getData__["_55" /* noteAddNote */](_this4.info).then(function (res) {
            _this4.submitLoading = false;
            if (res.data.code == 1) {
              _this4.$message({
                message: "新增成功",
                type: "success"
              });
              _this4.close(1);
            } else {
              _this4.$message({
                message: res.data.message,
                type: "error"
              });
            }
          }).catch(function (err) {
            _this4.submitLoading = false;
            _this4.$message.error("服务器开小差了...");
          });
        } else {
          _this4.submitLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "/RBp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[(_vm.isEdit&&_vm.formData.rfIsMust)?_c('sup',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.formData.rfName)+"\n    "),(_vm.isEdit&&_vm.formData.rfRemake!=''&&_vm.formData.rfRemake)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.formData.rfRemake,"placement":"right"}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"5px","color":"grey"}})]):_vm._e()],1),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[(_vm.formData.rfType==1)?_c('div',{ref:"formText",class:{'width-100':_vm.isEdit},staticStyle:{"padding":"0 8px"}},[(!_vm.isEdit||((_vm.formData.rfName=='企业名称'||_vm.formData.rfName=='企业类型'||_vm.formData.rfName=='所在区域')&&_vm.formData.rfIsDefault))?_c('el-popover',{attrs:{"placement":"top-start","width":"200","trigger":"hover","disabled":_vm.isOverflow,"content":_vm.formData.cdValue}},[_c('div',{ref:"popover",staticClass:"ellipsis-text",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm._f("empty")(_vm.formData.cdValue)))])]):_c('el-input',{attrs:{"width":"100"},model:{value:(_vm.formData.cdValue),callback:function ($$v) {_vm.$set(_vm.formData, "cdValue", $$v)},expression:"formData.cdValue"}})],1):_vm._e(),_vm._v(" "),(_vm.formData.rfType==2)?_c('div',{ref:"formText",class:{'width-100':_vm.isEdit},staticStyle:{"padding":"5px 8px"}},[(!_vm.isEdit)?_c('el-popover',{attrs:{"placement":"top-start","width":"200","trigger":"hover","disabled":_vm.isOverflow,"content":_vm.formData.cdValue}},[_c('div',{ref:"popover",staticClass:"ellipsis-text",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm._f("empty")(_vm.formData.cdValue)))])]):_c('el-input',{attrs:{"type":"textarea","rows":"1","width":"100"},model:{value:(_vm.formData.cdValue),callback:function ($$v) {_vm.$set(_vm.formData, "cdValue", $$v)},expression:"formData.cdValue"}})],1):_vm._e(),_vm._v(" "),(_vm.formData.rfType==3||_vm.formData.rfType==4)?_c('div',{ref:"formText",class:{'width-100':_vm.isEdit},staticStyle:{"padding":"0 8px"}},[(_vm.isEdit)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择","multiple":_vm.formData.rfType==4,"disabled":!_vm.isEdit},model:{value:(_vm.formData.cdValue),callback:function ($$v) {_vm.$set(_vm.formData, "cdValue", $$v)},expression:"formData.cdValue"}},_vm._l((_vm.getOptions(_vm.formData.rfTypeNames)),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1):_vm._e(),_vm._v(" "),(!_vm.isEdit)?_c('el-popover',{attrs:{"placement":"top-start","width":"200","trigger":"hover","disabled":_vm.isOverflow,"content":_vm.selectOption()}},[_c('div',{ref:"popover",staticClass:"ellipsis-text",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm._f("empty")(_vm.selectOption())))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.formData.rfType==5)?_c('div',{staticClass:"width-100 file-box",staticStyle:{"padding":"0 8px"}},[(_vm.formData.cdValue)?_c('a',{staticClass:"file-style ellipsis-text",class:{'file-edit':_vm.isEdit},attrs:{"href":_vm.getFilePath(),"target":"_blank"}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("\n        "+_vm._s(_vm.getFileName())+"\n      ")]):_c('p',[_vm._v("-")]),_vm._v(" "),(!_vm.formData.cdValue&&_vm.isEdit)?_c('v-file-upload',{attrs:{"number":1},on:{"onFileChange":function($event){return _vm.onFileChange(arguments)}}}):_vm._e(),_vm._v(" "),(_vm.formData.cdValue&&_vm.isEdit)?_c('p',{on:{"click":function($event){return _vm.delFile()}}},[_vm._v("删除")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.formData.rfType==6)?_c('div',{staticClass:"width-100",staticStyle:{"padding":"0 8px"}},[(_vm.isEdit)?_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","placeholder":"选择日期"},model:{value:(_vm.formData.cdValue),callback:function ($$v) {_vm.$set(_vm.formData, "cdValue", $$v)},expression:"formData.cdValue"}}):_c('p',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(_vm._f("empty")(_vm.formData.cdValue)))])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/aVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/m8p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/pot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mUtils__ = __webpack_require__("yclV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    var checkCarNumber = function checkCarNumber(rule, value, callback) {
      var info = _this.info;
      var reg = /(^[A-Z0-9]{5}$)|(^[A-Z0-9]{6}$)|(^[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]$)/;
      // let reg = /(^[A-Z0-9]{5}$)|(^[A-Z0-9]{6}$)/;
      if (!info.province) {
        callback("请选择省字母！");
        return;
      }
      if (!info.letter) {
        callback("请选择英文字母！");
        return;
      }
      if (!info.licensePlateNumber) {
        callback("请输入5/6位车牌号！");
        return;
      }
      if (!reg.test(info.licensePlateNumber)) {
        callback("5/6位车牌号格式为5/6位的大写字母 + 数字组合！");
        return;
      }
      var carNumber = "" + (info.province ? info.province : "") + (info.letter ? info.letter : "") + (info.licensePlateNumber ? info.licensePlateNumber : "");
      if (!__WEBPACK_IMPORTED_MODULE_2__config_mUtils__["b" /* cardNumRule */].test(carNumber)) {
        callback("该车牌号不规范！");
        return;
      }
      callback();
    };
    return {
      info: {
        province: '',
        letter: '',
        licensePlateNumber: '',
        vaVehicleUserId: '',
        vaVehicleNumber: '',
        vaVehicleEndTime: '',
        vaCarParkIds: '',
        vaCarParkList: []
      },
      rules: {
        vaVehicleNumber: [{ required: true, validator: checkCarNumber, trigger: ["blur", "change"] }],
        vaVehicleUserId: [{ required: true, message: "请选择车主姓名", trigger: ["blur", "change"] }],
        vaVehicleEndTime: [{ required: true, message: "请选择租赁有效期", trigger: ["blur", "change"] }],
        vaCarParkList: [{ required: true, message: "请选择可用停车场", trigger: ["blur", "change"] }]
      },
      submitLoading: false,
      billSelectList: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        },

        shortcuts: [{
          text: '半年后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
            picker.$emit('pick', date);
          }
        }, {
          text: '一年后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
            picker.$emit('pick', date);
          }
        }, {
          text: '二年后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365 * 2);
            picker.$emit('pick', date);
          }
        }, {
          text: '三年后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 365 * 3);
            picker.$emit('pick', date);
          }
        }]
      },
      dateSection: [],
      carParkGroupList: [],
      carOwnerList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getAllCarParkGroupList(); //获取车场列表
    this.getAllCarOwnerList(); //车主列表
    this.init();
  },

  props: ["vaId"],
  computed: {},
  methods: {
    getAllCarOwnerList: function getAllCarOwnerList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_4" /* getAllCarOwnerList */]().then(function (res) {
        if (res.data.code == 1) {
          _this2.carOwnerList = res.data.data || [];
        }
      });
    },
    changeCarParkGroup: function changeCarParkGroup(val) {
      if (val) {
        var carParkNameList = [];
        this.carParkGroupList.forEach(function (item) {
          val.forEach(function (ele) {
            if (ele === item.carParkId) {
              carParkNameList.push(item.parkingName);
            }
          });
        });
        this.info.vaCarParkName = carParkNameList.join(',');
      }
    },
    getAllCarParkGroupList: function getAllCarParkGroupList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_5" /* getAllCarParkGroupList */]().then(function (res) {
        if (res.data.code == 1) {
          _this3.carParkGroupList = res.data.data || [];
        }
      });
    },
    getCarNumber: function getCarNumber(province, letter, licensePlateNumber) {
      var info = this.info;
      info.province = province;
      info.letter = letter;
      info.licensePlateNumber = licensePlateNumber;
      info.vaVehicleNumber = province + letter + licensePlateNumber;
    },
    init: function init() {
      var _this4 = this;

      if (this.vaId) {
        __WEBPACK_IMPORTED_MODULE_1__service_getData__["_29" /* getVehicleDetail */]({ vaId: this.vaId }).then(function (res) {
          if (res.data.code != 1) {
            _this4.$message.error(res.data.message);
            return;
          }
          var data = res.data.data.vehicleApproveForm;
          var vehicle = res.data.data.carNumber;
          var vaCarParkIds = data.vaCarParkIds.split(',').map(function (item) {
            return Number(item);
          });
          _this4.info = {
            vaId: data.vaId,
            province: vehicle[0],
            letter: vehicle[1],
            licensePlateNumber: vehicle[2],
            vaVehicleUserId: data.vaVehicleUserId,
            vaVehicleNumber: data.vaVehicleNumber,
            vaVehicleEndTime: data.vaVehicleEndTime,
            vaCarParkIds: data.vaCarParkIds,
            vaCarParkList: vaCarParkIds,
            vaCarParkName: data.vaCarParkName
          };
        });
      }
    },
    lookBigImg: function lookBigImg(imgUrl) {
      if (imgUrl) {
        this.imgUrl = imgUrl + "?x-oss-process=image/resize,w_500/auto-orient,1";
        this.lookBigImgDialog = true;
      } else {
        this.$message.warning("抱歉，该图片无法查看！");
      }
    },
    submits: function submits(type) {
      var _this5 = this;

      this.$refs["info"].validate(function (valid) {
        if (valid) {
          _this5.info.vaCarParkIds = _this5.info.vaCarParkList.join(',');
          var info = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this5.info));
          _this5.submitLoading = true;
          if (_this5.vaId) {
            _this5.edit();
          } else {
            _this5.add();
          }
        } else {}
      });
    },
    add: function add() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["k" /* addVehicleApprove */](this.info).then(function (res) {
        _this6.submitLoading = false;
        if (res.data.code === 1) {
          _this6.$message({
            type: "success",
            message: "新增成功!"
          });
          _this6.close(2);
        } else {
          _this6.$message({
            type: "info",
            message: res.data.message
          });
        }
      }).catch(function (err) {
        console.log(err);
        _this6.submitLoading = false;
      });
    },
    edit: function edit() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["Q" /* editVehicleApprove */](this.info).then(function (res) {
        _this7.submitLoading = false;
        if (res.data.code === 1) {
          _this7.$message({
            type: "success",
            message: "编辑成功!"
          });
          _this7.close(2);
        } else {
          _this7.$message({
            type: "info",
            message: res.data.message
          });
        }
      }).catch(function (err) {
        console.log(err);
        _this7.submitLoading = false;
      });
    },
    onFileChange: function onFileChange(obj, row, index) {
      var arr = [];
      if (obj.file) {
        arr.push(obj.file);
      }
      row.monitorBlackListPic = arr;
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("search");
      } else if (type === 2) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "0b/P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fnm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1L/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_prevent_plague_details_vue__ = __webpack_require__("qRh5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_418b6d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_prevent_plague_details_vue__ = __webpack_require__("QZww");
function injectStyle (ssrContext) {
  __webpack_require__("VLSL")
  __webpack_require__("rLMe")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418b6d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_prevent_plague_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_418b6d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_prevent_plague_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1WKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_site_details_vue__ = __webpack_require__("YggF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_279d8315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_site_details_vue__ = __webpack_require__("Z+T+");
function injectStyle (ssrContext) {
  __webpack_require__("RfWQ")
  __webpack_require__("0fnm")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-279d8315"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_site_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_279d8315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_site_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2+ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types_js__ = __webpack_require__("Qgp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__story___ = __webpack_require__("Zsfk");





/* harmony default export */ __webpack_exports__["a"] = ({

  /*  async getCartlist({
      commit,
      state
    }) {
      let res = await getData.shoppingCartNum();
      commit(types.SAVE_CARTLIST, res.shoppingCartNum)
    }*/

});

/***/ }),

/***/ "25Ue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      submitLoading: false,
      info: {
        bwcName: '',
        bwcContact: '',
        bwcFace: '',
        remindContent: []
      },
      rules: {
        bwcName: [{ required: true, message: '请输入提醒人员名称', trigger: ['blur', 'change'] }],
        bwcContact: [{ required: true, message: '请填写常用联系方式', trigger: ['blur', 'change'] }, { pattern: __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["i" /* phoneRule */], message: "手机号码格式错误" }],
        remindContent: [{ required: true, message: '请选择提醒内容', trigger: ['blur', 'change'] }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.bwcId) {
      this.init();
    }
  },

  props: ['bwcId'],
  computed: {},
  methods: {
    init: function init() {
      var _this = this;

      this.openSecrecyDialog = false;
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_31" /* getWalletContact */]({ bwcId: this.bwcId }).then(function (res) {
        if (res.data.code == 1) {
          if (res.data.data) {
            _this.info.bwcContact = res.data.data.bwcContact;
            _this.info.bwcName = res.data.data.bwcName;
            _this.info.bwcId = res.data.data.bwcId;
            _this.info.bwcFace = res.data.data.bwcFace;
            _this.info.remindContent = res.data.data.bwcFace ? res.data.data.bwcFace.split(',') : [];
          }
        }
      }).catch(function (_) {
        console.log('getContractDefaultSetting:::' + _);
      });
    },
    close: function close() {
      this.$emit('init');
    },
    submit: function submit() {
      var _this2 = this;

      this.submitLoading = true;
      this.$refs["info"].validate(function (valid) {
        if (valid) {
          _this2.info.bwcFace = _this2.info.remindContent.join(',');
          __WEBPACK_IMPORTED_MODULE_1__service_getData__["l" /* addWalletContact */](_this2.info).then(function (res) {
            _this2.submitLoading = false;
            if (res.data.code == 1) {
              if (_this2.bwcId) {
                _this2.$message({ message: "编辑成功", type: "success" });
              } else {
                _this2.$message({ message: "新增成功", type: "success" });
              }

              _this2.close();
            } else {
              _this2.$message({
                message: res.data.message,
                type: "error"
              });
            }
          }).catch(function (err) {
            _this2.submitLoading = false;
            _this2.$message.error("服务器开小差了...");
          });
        } else {
          _this2.submitLoading = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "2mXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3SWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_upload_file_vue__ = __webpack_require__("3TFb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_54486cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_upload_file_vue__ = __webpack_require__("iXIk");
function injectStyle (ssrContext) {
  __webpack_require__("Tzs3")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54486cf0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_upload_file_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_54486cf0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_upload_file_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3TFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_env__ = __webpack_require__("uaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__ = __webpack_require__("w7Bb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fileList: [],
      imgUrl: '',
      lookBigImgDialog: false,
      accept: '',
      checkNumber: 0
    };
  },

  // props: ['number', 'type', 'size', 'list'],
  props: {
    number: {
      type: Number //文件数量
    },
    type: {
      type: String //文件限制类型
    },
    size: {
      type: Number //文件大小限制
    },
    img: {
      default: false, //是否是图片
      type: Boolean
    },
    video: {
      default: false, //是否是视频文件
      type: Boolean
    },
    list: {
      type: Array //文件列表
    },
    videoNumber: {
      type: Number //视频文件数量
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.list) {
      // console.log(this.list);
      if (this.img) {
        this.handleImg(this.list);
      } else {
        this.handleFile(this.list);
      }
    }
    if (this.type) {
      this.accept = this.type;
      // console.log(this.type)
    } else if (this.img) {
      this.accept = 'image/png,image/jpeg,image/jpg,image/gif';
    } else if (this.video) {
      this.accept = 'video/mp4,video/rmvb,video/avi,video/ts';
    }
  },

  computed: {},
  methods: {
    del: function del(arr, index, type) {
      arr.splice(index, 1);
      var obj = {
        file: '',
        fileList: arr,
        index: index
      };
      this.$emit('onFileChange', obj);
      if (type) {
        this.removeFile();
      }
    },
    lookFile: function lookFile(item) {
      if (item.address) {
        window.open(item.address);
      }
      // window.location.href = this.costEdit.address;
    },
    removeFile: function removeFile() {
      var fileObj = this.$refs['file'];
      if (fileObj) {
        fileObj.value = '';
      }
    },
    checkOss: function checkOss(e) {
      var _this = this;

      var pat = /[`~!@#$%^&*()_+<>?:"{},\/;'[\]]/im;
      var files = e.target.files || e.dataTransfer.files;
      // pat.test(files[0].name)
      if (files[0].name.indexOf(',') !== -1 || files[0].name.indexOf('，') !== -1) {
        this.removeFile();
        this.$message({
          type: 'error',
          message: '请选择没有特殊字符的图片名的图片'
        });
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__service_getData__["_27" /* getSystemOssByUrl */])().then(function (res) {
        if (res.data.code === 1) {
          var clientConfig = {
            accessKeyId: res.data.data.AccessKeyId, //通过阿里云控制台创建的access key
            accessKeySecret: res.data.data.AccessKeySecret, //通过阿里云控制台创建的access secret。
            stsToken: res.data.data.SecurityToken, //使用临时授权方式。
            bucket: res.data.data.SystemOssBucket, // 通过控制台创建的bucket。
            endpoint: res.data.data.SystemOssEndpoint, //OSS域名。
            SystemOssChannelName: res.data.data.SystemOssChannelName, // OSS文件名
            cname: true, //是否支持上传自定义域名，默认false。如果cname为true，endpoint传入自定义域名时，自定义域名需要先同bucket进行绑定。
            region: 'oss-cn-hangzhou' //bucket 所在的区域，默认 oss-cn-hangzhou（是根据当前所在区域自动确认的）。
          };
          sessionStorage.setItem('clientConfig', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clientConfig));
          sessionStorage.setItem('expiration', res.data.data.Expiration);
          _this.onFileChange(e);
        }
      });
    },
    onFileChange: function onFileChange(e) {
      var _this2 = this;

      var file = __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["o" /* selectOtherFile */](e, this.$message, this.size);
      var imgArr = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      var videoArr = ['video/mp4', 'video/rmvb', 'video/avi', 'video/ts'];
      var arr = [];
      var typeOk = [];
      if (this.type) {
        arr = this.type.split(',');
        if (this.img && arr.length === 0) {
          arr = imgArr;
        }
        arr.forEach(function (item) {
          typeOk.push(file[0].type === item ? 1 : 0);
        });
        if (typeOk.indexOf(1) === -1) {
          // this.$emit('typeError');
          this.$message({
            type: 'error',
            message: '选择文件格式错误！'
          });
          this.removeFile();
          return;
        }
        if (this.video) {
          if (videoArr.indexOf(file[0].type) !== -1) {
            var checkNumber = 0;
            this.fileList.forEach(function (item) {
              if (item.type == 'video') {
                checkNumber++;
              }
            });
            if (checkNumber >= this.videoNumber) {
              this.$message({
                type: 'error',
                message: '\u4E0A\u4F20\u7684\u89C6\u9891\u6587\u4EF6\u6700\u591A' + this.videoNumber + '\u4E2A\uFF01'
              });
              this.removeFile();
              return;
            }
          }
        }
      } else if (this.img) {
        arr = imgArr;
        arr.forEach(function (item) {
          typeOk.push(file[0].type === item ? 1 : 0);
        });
        if (typeOk.indexOf(1) == -1) {
          // this.$emit('typeError');
          this.$message({
            type: 'error',
            message: '选择图片格式错误！'
          });
          this.removeFile();
          return;
        }
      }
      if (this.size) {
        if (file[0].size > this.size * 1024 * 1024) {
          this.$message({
            type: 'error',
            message: '\u9009\u62E9\u6587\u4EF6\u6700\u5927\u4E3A' + this.size + 'M'
          });
          return;
        }
      }

      var isOk = true;
      if (this.number && this.number > 1) {
        if (this.fileList.length < this.number) {
          this.fileList.forEach(function (item, index) {
            if (item.fileName == file[0].name) {
              isOk = false;
            }
          });
          if (isOk) {
            if (this.img || this.video && imgArr.indexOf(file[0].type) !== -1) {
              var exportFile = file[0];
              var fileName = file[0].name;
              var config = {
                //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
                isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
                clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
              }; //配置项
              Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["b" /* upload */])(e, config).then(function (resolve) {
                var result = resolve.data;
                var url = Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
                //url = url.slice(0, url.indexOf('?'));
                _this2.fileList.push({
                  exportFile: url,
                  fileName: fileName,
                  imgUrl: url
                });
                var obj = {
                  file: url,
                  fileList: _this2.fileList
                };
                _this2.$emit('onFileChange', obj);
                _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
              }).catch(function (_) {
                console.log(_.err);
                _this2.removeFile();
              });
            } else {
              var _config = {
                //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
                isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
                clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
              }; //配置项
              Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["b" /* upload */])(e, _config).then(function (resolve) {
                var result = resolve.data;
                var url = Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
                //url = url.slice(0, url.indexOf('?'));
                console.log(_this2.fileList, 1111);
                var fileName = file[0].name;
                if (videoArr.indexOf(file[0].type) !== -1) {
                  _this2.fileList.push({
                    exportFile: url,
                    fileName: fileName,
                    type: 'video'
                  });
                } else {
                  _this2.fileList.push({
                    exportFile: url,
                    fileName: fileName
                  });
                }

                var obj = {
                  file: url,
                  fileList: _this2.fileList
                };
                _this2.$emit('onFileChange', obj);
                _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
              }).catch(function (_) {
                console.log(_.err);
                _this2.removeFile();
              });
            }
          } else {
            this.$message({
              type: 'error',
              message: '已经存在该文件！'
            });
          }
        } else {
          this.$message({
            type: 'error',
            message: '\u6700\u591A\u53EA\u80FD\u4E0A\u4F20' + this.number + '\u4E2A\u6587\u4EF6\uFF01'
          });
        }
      } else {
        if (this.img) {
          var _exportFile = file[0];
          var _fileName = file[0].name;
          var _config2 = {
            //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
            isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
            clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
          }; //配置项
          Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["b" /* upload */])(e, _config2).then(function (resolve) {
            var result = resolve.data;
            var url = Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
            // url = url.slice(0, url.indexOf('?'));
            _this2.fileList = [{
              exportFile: url,
              fileName: _fileName,
              imgUrl: url
            }];
            var obj = {
              file: url,
              fileList: _this2.fileList
            };
            _this2.$emit('onFileChange', obj);
            _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
          }).catch(function (_) {
            console.log(_.err);
            _this2.removeFile();
          });
        } else {
          var _config3 = {
            //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
            isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
            clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
          }; //配置项
          var _fileName2 = file[0].name;
          Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["b" /* upload */])(e, _config3).then(function (resolve) {
            var result = resolve.data;
            var url = Object(__WEBPACK_IMPORTED_MODULE_4__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
            // url = url.slice(0, url.indexOf('?'));
            _this2.fileList = [{
              exportFile: url,
              fileName: _fileName2
            }];
            var obj = {
              file: url,
              fileList: _this2.fileList
            };
            _this2.$emit('onFileChange', obj);
            _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
          }).catch(function (_) {
            console.log(_.err);
            _this2.removeFile();
          });
        }
      }
    },
    lookBigImg: function lookBigImg(row) {
      this.imgUrl = row.imgUrl;
      this.lookBigImgDialog = true;
    },
    handleFile: function handleFile(val) {
      var _this3 = this;

      var imgArr = ['image/png', 'image/jpeg', 'image/gif'];
      var videoArr = ['video/mp4', 'video/rmvb', 'video/avi', 'video/ts'];
      this.fileList = [];
      if (this.img) {
        val.forEach(function (fileItem) {
          _this3.fileList.push({
            exportFile: fileItem.exportFile,
            fileName: fileItem.fileName,
            imgUrl: fileItem.imgUrl
          });
        });
      } else {
        val.forEach(function (fileItem) {
          if (_this3.video && fileItem.address) {
            _this3.fileList.push({
              fileName: fileItem.fileName,
              address: fileItem.address,
              type: 'video'
            });
          } else if (fileItem.imgUrl) {
            _this3.fileList.push({
              fileName: fileItem.fileName,
              imgUrl: fileItem.imgUrl,
              type: 'img'
            });
          } else {
            if (fileItem.exportFile && fileItem.fileName) {
              _this3.fileList.push({
                exportFile: fileItem.exportFile,
                fileName: fileItem.fileName
              });
            } else if (fileItem.fileUrl && fileItem.fileName) {
              _this3.fileList.push({
                exportFile: fileItem.fileUrl,
                fileName: fileItem.fileName
              });
            } else if (fileItem.fileName) {
              _this3.fileList.push({
                exportFile: '',
                fileName: fileItem.fileName
              });
            } else {
              _this3.fileList.push({
                exportFile: '',
                fileName: fileItem
              });
            }
          }
        });
      }
    },
    handleImg: function handleImg(val) {
      var _this4 = this;

      this.fileList = [];
      if (this.img) {
        val.forEach(function (fileItem) {
          _this4.fileList.push({
            exportFile: fileItem.exportFile,
            fileName: fileItem.fileName,
            imgUrl: fileItem.imgUrl
          });
        });
      } else {
        val.forEach(function (fileItem) {
          if (fileItem.exportFile && fileItem.fileName) {
            _this4.fileList.push({
              exportFile: fileItem.exportFile,
              fileName: fileItem.fileName
            });
          } else if (fileItem.fileName) {
            _this4.fileList.push({
              exportFile: '',
              fileName: fileItem.fileName
            });
          } else {
            _this4.fileList.push({
              exportFile: '',
              fileName: fileItem
            });
          }
        });
      }
    }
  },
  components: {},
  watch: {
    list: function list(val) {
      if (val) {
        if (this.img) {
          this.handleImg(val);
        } else {
          this.handleFile(val);
        }
      }
    }
  }
});

/***/ }),

/***/ "3gFr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4DAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_details_vue__ = __webpack_require__("Ez6J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9c7f6376_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_details_vue__ = __webpack_require__("CKqs");
function injectStyle (ssrContext) {
  __webpack_require__("JuEY")
  __webpack_require__("g6ak")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c7f6376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9c7f6376_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4GFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  props: ['formData', 'isEdit'],
  components: {},
  data: function data() {
    return {
      isOverflow: false
    };
  },
  mounted: function mounted() {
    this.judgeOverflow();
    if (this.formData.rfType == 4 && this.formData.cdValue != null && this.formData.cdValue != "") {
      this.formData.cdValue = this.formData.cdValue.split('，');
    }
  },

  watch: {
    formData: function formData() {
      if (this.formData.rfType == 4 && this.formData.cdValue != null && this.formData.cdValue != "") {
        this.formData.cdValue = this.formData.cdValue.split('，');
      }
    }
  },

  methods: {
    judgeOverflow: function judgeOverflow() {
      if (this.$refs['formText']) {
        if (this.$refs['formText'].parentNode.clientWidth - this.$refs['popover'].clientWidth < 18) {
          this.isOverflow = false;
        } else {
          this.isOverflow = true;
        }
      }
    },
    selectOption: function selectOption() {
      if (Array.isArray(this.formData.cdValue)) {
        return this.formData.cdValue.join('，');
      } else {
        return this.formData.cdValue;
      }
    },
    getOptions: function getOptions(val) {
      if (val) {
        var arr = val.split('$-$');
        return arr;
      }
    },
    onFileChange: function onFileChange(obj) {
      var file = {
        fileName: obj[0].fileList[0].fileName,
        filePath: obj[0].fileList[0].exportFile
      };
      this.formData.cdValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(file);
    },
    delFile: function delFile() {
      var _this = this;

      this.$confirm('确认要删除该附件吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.formData.cdValue = '';
      }).catch(function () {
        _this.$message.info('操作取消');
      });
    },
    getFilePath: function getFilePath() {
      return JSON.parse(this.formData.cdValue).filePath;
    },
    getFileName: function getFileName() {
      return JSON.parse(this.formData.cdValue).fileName;
    }
  }
});

/***/ }),

/***/ "4zd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "51dY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSwitch: true,
      applicationActive: 0,
      active: '',
      name: '',
      seacrhcont: '',
      path: '',
      adminPortraitUrl: '',
      headerNavList: [],
      nowSystem: 0,
      url: this.$route.path,
      query: this.$route.query.single,
      myPermission: {},
      logoUrl: '',
      chooseCompanyDialog: false,
      showSwitchCompany: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.logoUrl = sessionStorage.getItem('logoUrl');
    this.switchCompany();
    // getData.getChannelIdByChannelUrl().then((res) => {
    //   if (res.data.code == 1) {
    //     // return
    //     this.logoUrl = res.data.url;
    //   }
    // })
  },

  methods: {
    selectDropdown: function selectDropdown(val) {
      console.log(val);
    },
    urlReplace: function urlReplace(item, index) {
      /* this.applicationActive = index;*/
      this.$router.push({ path: item.path });
    },
    goOther: function goOther(item, index) {
      this.isActive = item.id;
      this.$router.push({ path: item.path });
    },
    judgeBuildingDetail: function judgeBuildingDetail(val, id) {
      var _this = this;

      if (val == '/index') {
        this.$router.replace({ path: '/applicationList' });
        this.applicationActive = 0;
      } else {
        if (this.asideList) {
          this.asideList.forEach(function (item, index) {
            if (val.indexOf(item.path) != -1) {
              _this.applicationActive = index;
            }
          });
        }
      }
    },
    loginOut: function loginOut() {
      var _this2 = this;

      this.$confirm('是否确认退出?', '提示', {
        type: 'warning'
      }).then(function () {
        var allSessionId = sessionStorage.getItem("allSessionId");
        __WEBPACK_IMPORTED_MODULE_0__service_getData__["_45" /* logout */](allSessionId).then(function (res) {
          sessionStorage.clear();
          if (res.data.code == 'success') {
            _this2.$router.push({ path: '/login' });
          } else {
            _this2.$message({
              message: res.data.message,
              type: 'error'
            });
            _this2.$router.push({ path: '/login' });
          }
        }).catch(function () {
          _this2.$router.push({ path: '/login' });
        });
      }).catch(function () {});
    },
    switchCompany: function switchCompany() {
      var _this3 = this;

      //切换公
      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_86" /* userCompanyList */]().then(function (res) {
        if (res.data.code != 1) {
          return;
        }
        _this3.companyIcList = res.data.data;
        if (_this3.companyIcList.length > 1) {
          _this3.showSwitchCompany = true;
        }
      }).catch(function (_) {});
    },
    load: function load() {
      this.chooseCompanyDialog = false;
      // setTimeout()
      setTimeout(function () {
        history.go(0);
      }, 1000);
      // history.go(0);
    }
  },
  watch: {
    '$route': function $route(val) {
      this.judgeBuildingDetail(val.path);
    }
  }
});

/***/ }),

/***/ "6Q9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_oss_sdk__ = __webpack_require__("w7Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_getData__ = __webpack_require__("i84Q");






/** oss 上传图片
 * @param files
 */
/* harmony default export */ __webpack_exports__["a"] = (function (e) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolvewai, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_2__service_getData__["_27" /* getSystemOssByUrl */])().then(function (res) {
      if (res.data.code === 1) {
        var clientConfig = {
          accessKeyId: res.data.data.AccessKeyId, // 通过阿里云控制台创建的access key
          accessKeySecret: res.data.data.AccessKeySecret, // 通过阿里云控制台创建的access secret。
          stsToken: res.data.data.SecurityToken, // 使用临时授权方式。
          bucket: res.data.data.SystemOssBucket, // 通过控制台创建的bucket。
          endpoint: res.data.data.SystemOssEndpoint, // OSS域名。
          SystemOssChannelName: res.data.data.SystemOssChannelName, // 上传指定文件夹
          cname: true, // 是否支持上传自定义域名，默认false。如果cname为true，endpoint传入自定义域名时，自定义域名需要先同bucket进行绑定。
          region: 'oss-cn-hangzhou' // bucket 所在的区域，默认 oss-cn-hangzhou（是根据当前所在区域自动确认的）。
        };
        var config = {
          isNotNeedRequest: true, // 默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
          clientRequest: clientConfig // 当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
        }; // 配置项
        Object(__WEBPACK_IMPORTED_MODULE_1__plugins_oss_sdk__["b" /* upload */])(e, config, true).then(function (resolve) {
          var result = resolve.data;
          var url = Object(__WEBPACK_IMPORTED_MODULE_1__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
          resolvewai({
            exportFile: url,
            fileName: result.name,
            imgUrl: url
          });
        }).catch(function (_) {
          reject({
            err: _.err
          });
          console.log(_.err);
        });
      } else {
        reject({
          err: res.data.message
        });
      }
    });
  });
});

/***/ }),

/***/ "6eFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6xLt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3JpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo1NjQ4NDk0My1kMjlhLTQ0NWEtOTk0Yi1hMGI2MTJjNmQ2ODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDcyRjY5NEVERDg3MTFFODgxRDk4MEZGNjhCQTBDNkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDcyRjY5NERERDg3MTFFODgxRDk4MEZGNjhCQTBDNkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmOGNjNTJmNC1kMjAxLTQ1OWQtYjg3OC03Y2E2ZjUwNDk5ODAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTY0ODQ5NDMtZDI5YS00NDVhLTk5NGItYTBiNjEyYzZkNjg4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+88hmMQAAA3RJREFUeNqkVF2IVVUUXmvtfc69MyOOSKGpTBlBDwo2+FAKai8+aJoPgSDVWxC9FT4qvgkGvigERs/RiwkqCPo00TwIgqAgoYg1oo1I4TTN3J9z9l6rb59z53pvMxTWgX3PuXutvda3vvXtxbTtYyLJKQt/kMw/JB7feM7lq7abhkj//AhWO5ruSX+K35WsYPKOjUw7xPnIjmzT5BbtLDqLxX1iCf8S0GGF3Lkv1Gy2kHgRO20enTxSm5me4XcN/cdH1d5T0iveaCkeghk9JLP93HDETkg7IaG02rzsMRYSGN+nSF+Ko4ZjlNw3c+WyQOzvxLkWhact8htXkzQ9WdQVGGQkBM3ME66B5KrBzAYC1lB9ihwWQ3J4hb1cZrIcW8sispiPhbtgQjeo+byIvyG0EUNz/foxihvGZjnoMVIcWaliU6Msf8zMbxJ1U3WP0V7yCaYR7/E1yJ/Z2SjgfeBj4pkecEpDtiweq5D5bsnC4AScqx4KFG96EToN+1GrzvBMVG1g77Aw58Z1pGF8SA+isWCXa/h7G1WgiXzCkX83cXa0OpFWoFchr2dm8aBWtK1UKlF0mnoCVNXB3UtZnbndHh+lRZ7Bew1a/zr6haD0GYvfimKbZoOBgck7KhfaZ0KIl3yzQW4k+4igArj9RGwbEnUZePzeop1Ei06zo3twmNaiOMbO/SreTyCQ7xVvxuVv3JU73jcOuAadUY3z2tG3oIjVnPGUJEdxtk5E/4zt4tNYlh+ColXMdlaDbi7ajWktaUqNp4LKD7EdfsnWZlfdOJ9Hsy7Hlk4izy3J+CXEEunxoqksznCFYjwfOu23jfILPm9+K66cAiU70bSX2fRrl+f3zfJOudB6LRTdz9n71JC+BGVQhwKDcL2lpZ4KqhPOx2nJ9Ds04S4Obtao+8qOHIJUniQkQFZd0yTLYWFXJDk4OIphEQmQmVlB/nEuul/JyNgbSvxjcks5wTlVfGFaDcrU965IbwQgW9JZGgwDkjHVWbxmKxerNuDjqC5mWPS+v8Hcw2nkmk1oqveNQ5pllSWNFnQTdeCqia+br8N6HRoOXKn1+cCCSLAnxNBbuoDVxelL0no4eOmzP8aT21z/tgxPn/o1eMKWVblU3KMKISfoobsXCvpkqOsvOLARdFcVULut69Icfcdi+Ib+//PoLwEGAN60mlaxxwApAAAAAElFTkSuQmCC"

/***/ }),

/***/ "7/mN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","label-position":"top"}},[_c('h3',{staticClass:"title"},[_vm._v("基础信息：")]),_vm._v(" "),(_vm.info)?_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"g-service-type"},[_vm._v(_vm._s(_vm._f("vehicleState")(_vm.info.vaStatus)))]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("车牌号："+_vm._s(_vm._f("empty")(_vm.info.vaVehicleNumber)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("申请提交时间："+_vm._s(new Date(_vm.info.vaCreateTime).format('yyyy-MM-dd hh:mm:ss')))])])],1),_vm._v(" "),_c('div',{staticClass:"g-col-line"}),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("车主姓名："+_vm._s(_vm._f("empty")(_vm.info.vaVehicleName)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("所属企业："+_vm._s(_vm._f("empty")(_vm.info.vaCompanyName)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("租赁有效期："+_vm._s(_vm._f("date")(_vm.info.vaVehicleEndTime)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("可用停车场："+_vm._s(_vm._f("empty")(_vm.info.vaCarParkName)))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.info.vaStatus !== 1),expression:"info.vaStatus !== 1"}],staticClass:"title"},[_vm._v("审批信息：")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.info.vaStatus !== 1),expression:"info.vaStatus !== 1"}],staticClass:"dialog_form basic_info"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("审批时间："+_vm._s(_vm._f("datetime")(_vm.info.vaApproveTime)))])])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin":"10px 0"}},[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("审批意见："+_vm._s(_vm._f("empty")(_vm.info.vaRemark)))])])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[(_vm.info.vaStatus==1)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":_vm.edit}},[_vm._v("编辑")]):_vm._e(),_vm._v(" "),(_vm.info.vaStatus==3)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":_vm.edit}},[_vm._v("重新发起")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dialog',{staticStyle:{"padding":"0"},attrs:{"title":"车位租赁编辑申请","visible":_vm.createInvoiceDialog,"top":"5%","center":"","width":"650px","modal-append-to-body":false,"append-to-body":true},on:{"update:visible":function($event){_vm.createInvoiceDialog=$event}}},[(_vm.createInvoiceDialog)?_c('v-parking-rental-application',{attrs:{"vaId":_vm.vaId},on:{"closeDialog":function($event){_vm.createInvoiceDialog=false},"init":function($event){return _vm.init()}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7JM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_notification_details_vue__ = __webpack_require__("DmYM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f917d940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_notification_details_vue__ = __webpack_require__("Z7/K");
function injectStyle (ssrContext) {
  __webpack_require__("qveY")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f917d940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_notification_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f917d940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_notification_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7SwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_contract_details_vue__ = __webpack_require__("rRop");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_466838bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_contract_details_vue__ = __webpack_require__("ec3a");
function injectStyle (ssrContext) {
  __webpack_require__("i13J")
  __webpack_require__("cg1N")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-466838bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_contract_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_466838bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_contract_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8DhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSwitch),expression:"isSwitch"}],staticClass:"aside-cont"},[_c('div',{staticClass:"logo"},[_c('div',{staticClass:"f-imgtopbox2"},[_c('transition',[_c('img',{staticClass:"img2",attrs:{"src":_vm.logoUrl,"alt":""}})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSwitch),expression:"isSwitch"}],staticClass:"icon_switch",staticStyle:{"right":"-15px"},on:{"click":function($event){_vm.isSwitch=!_vm.isSwitch}}},[_c('i',{class:_vm.isSwitch?'el-icon-caret-left':'el-icon-caret-right'})]),_vm._v(" "),_c('v-left-nav-bar')],1)]),_vm._v(" "),_c('el-container',{staticClass:"w100 h100"},[_c('el-header',{staticClass:"header flex-box"},[_c('h4',{staticClass:"g-proName"},[_vm._v("企业工作门户平台")]),_vm._v(" "),_c('ul',{staticClass:"header_right flex-box"},[(_vm.showSwitchCompany)?_c('li',{on:{"click":function($event){_vm.chooseCompanyDialog = true}}},[_c('i',{staticClass:"iconfont icon-qiehuan"}),_vm._v(" "),_c('span',[_vm._v("切换公司")])]):_vm._e(),_vm._v(" "),_c('li',[_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.selectDropdown}},[_c('li',{staticClass:"last",staticStyle:{"padding-right":"0","border":"none"}},[_c('span',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"iconfont icon-gerenxinxi"}),_vm._v("\n                 "+_vm._s(_vm.$store.state.adminName)),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})])]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('div',{on:{"click":_vm.loginOut}},[_c('el-dropdown-item',{attrs:{"command":1}},[_vm._v("退出")])],1)])],1)],1)])]),_vm._v(" "),_c('el-main',{staticClass:"main w100 h100"},[_c('router-view')],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(!_vm.isSwitch)?_c('div',{staticClass:"icon_switch",staticStyle:{"left":"0"},on:{"click":function($event){_vm.isSwitch=!_vm.isSwitch}}},[_c('i',{class:_vm.isSwitch?'el-icon-caret-left':'el-icon-caret-right'})]):_vm._e()]),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"请选择登录企业","visible":_vm.chooseCompanyDialog,"append-to-body":true,"width":"700px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.chooseCompanyDialog=$event}}},[(_vm.chooseCompanyDialog)?_c('v-switch-company',{attrs:{"companyIcList":_vm.companyIcList},on:{"closeDialog":function($event){return _vm.load()}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Sqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: {
    "height": {
      type: Number,
      default: 50
    },
    "paddingRight": {
      type: Number,
      default: 10
    },
    "paddingLeft": {
      type: Number,
      default: 25
    },
    "borderBottom": {
      type: String
    }
  }
});

/***/ }),

/***/ "9Bro":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Iod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp position-relative"},[_c('h3',[_vm._v("访客基础信息：")]),_vm._v(" "),_c('div',{staticClass:"visitor-tag",class:{disabled:_vm.basicInfo.visitorState === '已过期'}},[_vm._v(_vm._s(_vm.basicInfo.visitorState))]),_vm._v(" "),_c('div',{staticClass:"dialog-form"},[_c('div',{staticClass:"item-content"},[_vm._v("访客姓名："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorName)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("联系方式："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorContract)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("身份证号："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorIdcard)))])])]),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"20px"}},[_vm._v("访客登记信息：")]),_vm._v(" "),_c('div',{staticClass:"dialog-form"},[_c('div',{staticClass:"item-content"},[_vm._v("登记时间："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.createTime)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("登记方式："),_c('p',[_c('span',{staticStyle:{"color":"#FF0000"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorRegisterType)))])])]),_vm._v(" "),(_vm.basicInfo.visitorRegisterType == '来访登记' || _vm.basicInfo.visitorRegisterType == '访客邀请')?_c('div',{staticClass:"item-content",staticStyle:{"color":"#FF0000"}},[_vm._v("邀请人员："),_c('p',{staticStyle:{"color":"#FF0000"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.createName)))])]):_vm._e()]),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"20px"}},[_vm._v("访客人脸信息：")]),_vm._v(" "),_c('div',{staticClass:"dialog-form"},[_c('div',{staticClass:"item-content"},[_vm._v("人脸图片：\n        "),_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.basicInfo.facePhotoUrl + '?x-oss-process=image/resize,w_500/auto-orient,1',"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.lookBigImg.apply(null, arguments)}}})])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("上传图片时间："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.createTime)))])])]),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"20px"}},[_vm._v("访客来访信息：")]),_vm._v(" "),_c('div',{staticClass:"dialog-form"},[_c('div',{staticClass:"item-content"},[_vm._v("来访时间："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorStartTime)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("来访目的："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorVisitType)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("来访人数："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorNum)))])]),_vm._v(" "),_c('div',{staticClass:"item-content"},[_vm._v("备注："),_c('p',[_vm._v(_vm._s(_vm._f("empty")(_vm.basicInfo.visitorRemark)))])])]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px","justify-content":"space-between"}},[_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":_vm.close}},[_vm._v("完成查看")])],1),_vm._v(" "),_c('el-dialog',{staticClass:"file-big-img append-body",attrs:{"title":"查看大图","visible":_vm.lookBigImgDialog,"top":"5%","append-to-body":true,"center":"","width":"900px"},on:{"update:visible":function($event){_vm.lookBigImgDialog=$event}}},[_c('div',{staticClass:"dialog-warp text-center"},[_c('img',{staticClass:"big-img",attrs:{"src":_vm.imgUrl,"alt":"图片不见了"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9P4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_jd_province_city_area_id__ = __webpack_require__("gTve");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_jd_province_city_area_id___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__plugins_jd_province_city_area_id__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      expireTimeOption: {
        disabledDate: function disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },
      // startDatePicker: this.beginDate(),
      // endDatePicker: this.processDate(),
      vrInfo: {
        erAddDistrict: "",
        erAddHolidayDistrict: "",

        baseName: "",
        baseCompanyId: "",
        baseCompanyName: "",
        baseIdcrad: "",
        basePhone: "",
        baseProvince: "",
        baseCity: "",
        baseDistrict: "",
        // erReworkTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        erHolidayProvince: "",
        erHolidayCity: "",
        erHolidayDistrict: "",
        erHolidayAddress: "",
        erLocation: "",
        erIsReturn: 2,
        erReturnTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        erHealth: 1,
        erHealthRemark: "",
        erContact: 1,
        erContactRemark: "",
        erContactHistory: 1,
        erContactHistoryRemark: "",
        erIsAirplane: 2,
        erIsBulletTrain: 2,
        erIsBus: 2,
        erIsPrivateCar: 2,
        erFlightNumber: "",
        erTrainService: "",
        erBusNumber: "",
        erOtherRemark: "",
        // erIsRework: 2,
        // erLeaveTime: "",
        erFamilyHealth: 1,
        erFamilyHealthRemark: "",
        erIsIsolation: 2,
        // erIsolationStartTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        // erIsolationEndTime: "",
        erHaveReworkTime: 1
      },
      rules: {
        baseName: [{ required: true, message: "请输入姓名", trigger: ["blur", "change"] }],
        baseCompanyId: [{ required: true, message: "请选择企业", trigger: ["blur", "change"] }],
        basePhone: [{ required: true, message: "请输入手机号码", trigger: "blur" }, { pattern: __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["k" /* phoneRule5 */], message: "手机号码格式错误" }],
        erAddDistrict: [{
          required: true,
          message: "请选择本人户籍",
          trigger: ["blur", "change"]
        }],
        // erReworkTime: [
        //   {
        //     required: true,
        //     message: "请选择复工时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // erReworkTimeNone: [
        //   {
        //     required: false,
        //     trigger: ["blur", "change"]
        //   }
        // ],
        baseIdcrad: [{ required: true, message: "请输入身份证号码", trigger: "blur" }, { pattern: __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["e" /* idcard */], message: "身份证号码格式错误" }],
        erReturnTime: [{
          required: true,
          message: "请选择返程时间",
          trigger: ["blur", "change"]
        }],
        erAddHolidayDistrict: [{
          required: true,
          message: "请选择假期所在地区",
          trigger: ["blur", "change"]
        }],
        erHolidayAddress: [{
          required: true,
          message: "请输入假期所在居住地址",
          trigger: ["blur", "change"]
        }],
        erLocation: [{
          required: true,
          message: "请输入工作地居住地址",
          trigger: ["blur", "change"]
        }],
        erFlightNumber: [{
          required: true,
          message: "请输入航班号",
          trigger: ["blur", "change"]
        }],
        erTrainService: [{
          required: true,
          message: "请输入动车班次",
          trigger: ["blur", "change"]
        }],
        erBusNumber: [{
          required: true,
          message: "请输入客车班次",
          trigger: ["blur", "change"]
        }],
        erHealthRemark: [{
          required: true,
          message: "请输入症状描述",
          trigger: ["blur", "change"]
        }],
        erFamilyHealthRemark: [{
          required: true,
          message: "请输入家人健康症状描述",
          trigger: ["blur", "change"]
        }],
        erContactRemark: [{
          required: true,
          message: "请输入前往过疫区情况描述",
          trigger: ["blur", "change"]
        }],
        // erIsolationStartTime: [
        //   {
        //     required: true,
        //     message: "请选择隔离开始时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // erIsolationEndTime: [
        //   {
        //     required: true,
        //     message: "请选择隔离结束时间",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        erContactHistoryRemark: [{
          required: true,
          message: "请输入接触人员等信息",
          trigger: ["blur", "change"]
        }]
      },
      submitLoading: false,
      companyList: [],
      district: __WEBPACK_IMPORTED_MODULE_2__plugins_jd_province_city_area_id___default.a
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ["id"],
  computed: {
    // erReworkTimeVerify(){
    //   if(this.vrInfo.erIsRework==2&&this.vrInfo.erHaveReworkTime==2){
    //     return 'erReworkTimeNone'
    //   }else{
    //     return 'erReworkTime'
    //   }
    // }
  },
  methods: {
    // beginDate(){
    //   const self = this
    //   return {
    //     disabledDate(time){
    //       if (self.vrInfo.erIsolationEndTime) {
    //         return new Date(self.vrInfo.erIsolationEndTime).getTime() < time.getTime()
    //       } else {
    //         // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
    //       }
    //     }
    //   }
    // },
    // processDate() {
    //   const  self = this
    //   return {
    //     disabledDate(time) {
    //       if (self.vrInfo.erIsolationStartTime) { 
    //         return new Date(self.vrInfo.erIsolationStartTime).getTime() > time.getTime()
    //       } else {
    //         // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
    //       }
    //     }
    //   }
    // },
    timeFormat: function timeFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["q" /* toDateTime */](time);
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },

    // haveReworkTimeChange(){
    //   if(this.vrInfo.erHaveReworkTime==2){
    //     this.vrInfo.erHaveReworkTime=1;
    //   }else{
    //     this.vrInfo.erHaveReworkTime=2;
    //   }
    //   this.$nextTick(()=>{
    //     this.$refs.info.validateField('erReworkTimeNone')
    //   })
    // },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_37" /* indexDate */]().then(function (res) {
        if (res.data.code == "success") {
          var datas = res.data.data;
          _this.vrInfo.baseCompanyId = datas.companyId;
          _this.vrInfo.baseCompanyName = datas.companyName;
        }
      });
      if (this.id) {
        __WEBPACK_IMPORTED_MODULE_1__service_getData__["_92" /* vrDetail */](this.id).then(function (res) {
          if (res.data.code != "success") {
            _this.$message.error(res.data.message);
            return;
          }
          _this.vrInfo = res.data.data.epidemicRegister;
          _this.vrInfo.erAddDistrict = [_this.vrInfo.baseProvince, _this.vrInfo.baseCity, _this.vrInfo.baseDistrict];
          console.log(_this.vrInfo.erAddDistrict);
          _this.vrInfo.erAddHolidayDistrict = [_this.vrInfo.erHolidayProvince, _this.vrInfo.erHolidayCity, _this.vrInfo.erHolidayDistrict];
        }).catch(function (_) {
          console.log(_);
        });
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs["info"].validate(function (valid) {
        if (valid) {
          _this2.vrInfo.baseProvince = _this2.vrInfo.erAddDistrict[0];
          _this2.vrInfo.baseCity = _this2.vrInfo.erAddDistrict[1];
          _this2.vrInfo.baseDistrict = _this2.vrInfo.erAddDistrict[2];

          _this2.vrInfo.erHolidayProvince = _this2.vrInfo.erAddHolidayDistrict[0];
          _this2.vrInfo.erHolidayCity = _this2.vrInfo.erAddHolidayDistrict[1];
          _this2.vrInfo.erHolidayDistrict = _this2.vrInfo.erAddHolidayDistrict[2];

          _this2.submitLoading = true;

          _this2.companyList.forEach(function (item) {
            if (item.companyId == _this2.vrInfo.baseCompanyId) {
              _this2.vrInfo.baseCompanyName = item.companyName;
            }
          });

          __WEBPACK_IMPORTED_MODULE_1__service_getData__["c" /* addEpidemicRegister */](_this2.vrInfo).then(function (res) {
            _this2.submitLoading = false;
            if (res.data.code != 1) {
              _this2.$message({
                type: "error",
                message: res.data.message || res.data.msg
              });
              return;
            }
            if (_this2.id) {
              _this2.$message.success("编辑成功！");
            } else {
              _this2.$message.success("上传成功！");
            }
            _this2.close(1);
          }).catch(function (_) {
            console.log(_);
            _this2.submitLoading = false;
          });
        }
      });
    },
    changeTraffic: function changeTraffic(attr) {
      if (this.vrInfo[attr] == 1) {
        this.vrInfo[attr] = 2;
      } else {
        this.vrInfo[attr] = 1;
      }
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "9Z4d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A4jK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A8UH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AI8F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_add_register_vue__ = __webpack_require__("aLBv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f5a6e12a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_add_register_vue__ = __webpack_require__("g7e9");
function injectStyle (ssrContext) {
  __webpack_require__("PQtR")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5a6e12a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_add_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f5a6e12a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_add_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ax7W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BAc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","model":_vm.vrInfo,"rules":_vm.rules,"label-width":"140px"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"隔离方式：","prop":"quarantineWay"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.quarantineWay),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantineWay", $$v)},expression:"vrInfo.quarantineWay"}},[_vm._v("自我隔离")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.quarantineWay),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantineWay", $$v)},expression:"vrInfo.quarantineWay"}},[_vm._v("强制隔离")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label":"开始隔离时间：","prop":"quarantineStartTime"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd hh:mm:ss","type":"date","placeholder":"选择日期"},model:{value:(_vm.vrInfo.quarantineStartTime),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantineStartTime", $$v)},expression:"vrInfo.quarantineStartTime"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label":"隔离天数：","prop":"quarantineDays"}},[_c('el-input',{attrs:{"placeholder":"请填写隔离天数"},model:{value:(_vm.vrInfo.quarantineDays),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantineDays", _vm._n($$v))},expression:"vrInfo.quarantineDays"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label":"监管负责人：","prop":"quarantinePerson"}},[_c('el-input',{attrs:{"placeholder":"请填写监管负责人"},model:{value:(_vm.vrInfo.quarantinePerson),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantinePerson", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.quarantinePerson"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('el-form-item',{attrs:{"label":"情况描述：","prop":"quarantineDescription"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"请在此填写隔离详情，比如隔离地点，目前状态等"},model:{value:(_vm.vrInfo.quarantineDescription),callback:function ($$v) {_vm.$set(_vm.vrInfo, "quarantineDescription", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.quarantineDescription"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BEeY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAArZJREFUSEvNlT1oVEEQx/+zh5DYCEqQFBKISpQrkvd2Yx1RlEhMBBFjZ6WN4EcURAQRBAtNiGCjlZ1BLdREFKKibW7nvbvigl8EBT/ws7AwAfN2ZIVIPt69y4kEp9zdmd987MwQlkBoCRj4ryC5IAh2KaW2AlgtIp9EZDSO49sAkmrZqBpJGIYbiegmgHyKsXHn3J44jsezQJmQIAialFIFAA0APgK4JiITRNQMYL+PCsCXJEnai8Xi60qgTIjW2qejB8DY1NRUZ7lc/jZjKJ/Pr6yrq7sPYBOAEWbeWTNEa90oIm+JSERkQxRFr+Yb0VqvBfAcgJqenl5TKpXepYEqRhKGYRcRDQNgZjaVvAzDcIyI2p1zPXEc360JYozZLSK3RORpFEUdlSBa68cANovI3iiKbtQECYKgVSlVBPAdQCMz/0hJ13IA7wGsUEoFhULBv18g1Qr/DEALEQ1aa4/O1zbGDIiIP3/BzC01F94rGGN2OOeGiUiJyFAulxsgogkRaU6S5BgR9YqII6JuZr73VxCvpLU+CeB8RrOdYuas++zZZYzxnl4GsCoD8pWIDllrh2qORGvdB+AC8NuRkogMOueeOOc+K6UalFIdRHQEQCsAAXCCmfsXXXhjTKdzbsTXAsA5Zj4DwKUYUFrrswBO+9oopbqstX4KzJEFv0trvQxAGcB6AJeY2XubKVrrQQCHAbz0g5SZf85WWAAxxnSLyB0AHwCsS+uPCv3ix04jEfVYa+d0fhrkiogcANDPzMerRTFzr7W+CKCPiK5aaw9mRhKG4UMi2uKc2xfHccUfMx8eBEGvUuq6iDyKosgvtz+SVpMHALYlSRIWi8XUMZEWXVtbW1sul4sAjDLz9kyI3xP19fVN1tp4samaeWeMCSYnJ9/M3jv+rur6rRW06D75F4Zn2/gFJ3EZKeqcja0AAAAASUVORK5CYII="

/***/ }),

/***/ "Bu6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"model":_vm.info,"rules":_vm.rules,"size":"mini","label-width":"130px"}},[_c('h3',{staticClass:"title"},[_vm._v("基础信息：")]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"票据类型：","prop":"noteType"}},[_c('el-radio-group',{model:{value:(_vm.info.noteType),callback:function ($$v) {_vm.$set(_vm.info, "noteType", $$v)},expression:"info.noteType"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("普票")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v("专票")]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v("收据")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"选择合同："}},[_c('el-cascader',{ref:"contractCascader",staticStyle:{"width":"387px"},attrs:{"props":{label:'contractContent',value:'contractId',children:'contracts'},"options":_vm.ContractInfoList},on:{"change":_vm.changeSelectContract},model:{value:(_vm.ContractInfoSelect),callback:function ($$v) {_vm.ContractInfoSelect=$$v},expression:"ContractInfoSelect"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"选择账单："}},[_c('el-select',{ref:"billCascader",attrs:{"placeholder":"请选择账单"},model:{value:(_vm.info.noteBillInfo),callback:function ($$v) {_vm.$set(_vm.info, "noteBillInfo", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.noteBillInfo"}},_vm._l((_vm.BillInfoList),function(item,index){return _c('el-option',{key:item.noteBillInfo,staticClass:"flex-box text-space",staticStyle:{"justify-content":"space-between"},attrs:{"value":item.noteBillInfo}},[_c('span',[_vm._v(_vm._s(_vm._f("billTypeNew")(item.allBillType)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("date")(item.allBillStartTime))+" ~"+_vm._s(_vm._f("date")(item.allBillEndTime))+" ")])])}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"情况描述：","prop":"noteDescription"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入情况描述","maxlength":"100"},model:{value:(_vm.info.noteDescription),callback:function ($$v) {_vm.$set(_vm.info, "noteDescription", $$v)},expression:"info.noteDescription"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"票据附件：","prop":"noteVoucherFile"}},[_c('v-upload-file',{attrs:{"size":20,"number":3},on:{"onFileChange":_vm.onFileChangeBills}})],1)],1)],1),_vm._v(" "),(_vm.info.noteType==1||_vm.info.noteType==2)?_c('h3',{staticClass:"title"},[_vm._v("发票抬头信息：")]):_vm._e(),_vm._v(" "),(_vm.info.noteType==1||_vm.info.noteType==2)?_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"纳税人识别号：","prop":"noteTaxpayer"}},[_c('el-input',{attrs:{"placeholder":"请输入纳税人识别号","maxlength":"50"},model:{value:(_vm.info.noteTaxpayer),callback:function ($$v) {_vm.$set(_vm.info, "noteTaxpayer", $$v)},expression:"info.noteTaxpayer"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"地址：","prop":"noteAddress"}},[_c('el-input',{attrs:{"placeholder":"请输入地址","maxlength":"50"},model:{value:(_vm.info.noteAddress),callback:function ($$v) {_vm.$set(_vm.info, "noteAddress", $$v)},expression:"info.noteAddress"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"电话：","prop":"notePhone"}},[_c('el-input',{attrs:{"placeholder":"请输入电话","maxlength":"50"},model:{value:(_vm.info.notePhone),callback:function ($$v) {_vm.$set(_vm.info, "notePhone", $$v)},expression:"info.notePhone"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"开户行：","prop":"noteBank"}},[_c('el-input',{attrs:{"placeholder":"请输入开户行","maxlength":"50"},model:{value:(_vm.info.noteBank),callback:function ($$v) {_vm.$set(_vm.info, "noteBank", $$v)},expression:"info.noteBank"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":18,"offset":2}},[_c('el-form-item',{attrs:{"label":"帐号：","prop":"noteAccount"}},[_c('el-input',{attrs:{"placeholder":"请输入帐号","maxlength":"50"},model:{value:(_vm.info.noteAccount),callback:function ($$v) {_vm.$set(_vm.info, "noteAccount", $$v)},expression:"info.noteAccount"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('el-button',{on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("生成")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CAQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      channelId: sessionStorage.getItem("channelId"),
      adminAccount: sessionStorage.getItem("adminAccount"),
      allSessionId: sessionStorage.getItem("allSessionId"),
      importTip: "\u8BF7\u5C06Excel\u6E05\u5355\u6587\u4EF6\u62D6\u5230\u6B64\u533A\u57DF\uFF0C\u6216<em>\u70B9\u51FB\u4E0A\u4F20</em><br/>\u7CFB\u7EDF\u5C06\u8BC6\u522B\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u81EA\u52A8\u5BFC\u5165",
      importTipDefalue: "\u8BF7\u5C06Excel\u6E05\u5355\u6587\u4EF6\u62D6\u5230\u6B64\u533A\u57DF\uFF0C\u6216<em>\u70B9\u51FB\u4E0A\u4F20</em><br/>\u7CFB\u7EDF\u5C06\u8BC6\u522B\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u81EA\u52A8\u5BFC\u5165",
      importTipSuccess: "<div class=\"tit green\"><i class=\"el-icon-success\"></i>\u6E05\u5355\u5F55\u5165\u5B8C\u6210\uFF01</div>",
      importTipError: " <div class=\"tit red\"><i class=\"el-icon-error\"></i>\u5F55\u5165\u5F02\u5E38\uFF01</div><div class=\"info\">\u8BF7\u68C0\u67E5\u6587\u4EF6\u662F\u5426\u51FA\u73B0\u9519\u8BEF\u6570\u636E\u6216\u7A7A\u7F3A\u6570\u636E<br/>\u4FEE\u6539\u5B8C\u6210\u540E\u518D\u6B21\u4E0A\u4F20</div>",
      errorList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  props: [],
  computed: {},
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    download: function download() {
      window.open('https://park-common.oss-cn-hangzhou.aliyuncs.com/main.zhihuipk.com/common/%E4%BC%81%E4%B8%9A%E9%98%B2%E7%96%AB%E7%99%BB%E8%AE%B0%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFcommon.xlsx');
    },
    importSuccess: function importSuccess(res) {
      if (res.code === 1) {

        if (res.errorList.length) {
          this.importTip = this.importTipError;
          this.errorList = res.errorList;
        } else {
          this.importTip = this.importTipSuccess;
        }
        this.$emit("init");
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    importError: function importError() {
      this.importTip = this.importTipError;
    },
    change: function change() {
      this.importTip = this.importTipDefalue;
      this.errorList = [];
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "CETB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_mUtils__ = __webpack_require__("yclV");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var isAccountCorrect = function isAccountCorrect(rule, value, callback) {
      var myReg = /^\S+$/;
      if (!value) {
        return callback(new Error('账号不能为空！'));
      }
      if (!myReg.test(value)) {
        return callback(new Error('账号不能包含空白字符！'));
      } else {
        callback();
      }
    };
    var isTypeCorrect = function isTypeCorrect(rule, value, callback) {
      var myReg = /^\S+$/;
      if (!value) {
        return callback(new Error('密码不能为空！'));
      }
      if (!myReg.test(value)) {
        return callback(new Error('密码不能包含空白字符！'));
      } else {
        callback();
      }
    };
    return {
      logining: false,
      loginInfo: {
        mhManagerAccount: '',
        mhManagerPassword: ''
      },
      channelId: 1,
      permissions: [],
      rules2: {
        mhManagerAccount: [{ required: true, validator: isAccountCorrect, trigger: 'blur' }],
        mhManagerPassword: [{ required: true, validator: isTypeCorrect, trigger: 'blur' }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var url = window.location.origin + '/';
    // let url = test-mh-company.test176.cn;
    __WEBPACK_IMPORTED_MODULE_1__service_getData__["_10" /* getChannelIdByUrl */](url).then(function (res) {
      sessionStorage.setItem('channelId', res.data.channelId);
      _this.channelId = res.data.channelId;
    });
  },

  methods: {
    handleSubmit2: function handleSubmit2() {
      var _this2 = this;

      this.logining = true;
      this.$refs.loginInfo.validate(function (valid) {
        if (valid) {
          __WEBPACK_IMPORTED_MODULE_1__service_getData__["_44" /* login */](_this2.loginInfo.mhManagerAccount, _this2.loginInfo.mhManagerPassword, _this2.channelId).then(function (res) {
            if (res.data.code == 'success') {
              _this2.$message({
                message: '登录成功',
                type: 'success'
              });
              sessionStorage.setItem('permissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.permissions));
              sessionStorage.setItem('allSessionId', res.data.data.allSessionId);
              sessionStorage.setItem('companyId', res.data.data.companyId);
              _this2.$router.push('/workbench');
              _this2.logining = false;
            } else {
              _this2.$message({
                message: res.data.message,
                type: 'error'
              });
              _this2.logining = false;
            }
          });
        } else {
          console.log('error submit!!');
          _this2.logining = false;
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ "CKqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[(_vm.contractType==1)?_c('div',{staticClass:"title"},[_vm._v("租赁账单明细：")]):_c('div',{staticClass:"title"},[_vm._v("物业账单明细：")]),_vm._v(" "),_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","overflow":"hidden","max-height":"100%"},attrs:{"data":_vm.tableList,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.parkListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.parkListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fileSendTypeName","label":"区间","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.startTime)+"~"+_vm._s(scope.row.endTime)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"billPayDate","label":"付款日","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"billName","label":"类型","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payPrice","label":"需付金额","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.payPrice)+"元")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"state","label":"支付情况","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.state==3)?_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm._f("billState")(scope.row.state)))]):_c('p',[_vm._v(_vm._s(_vm._f("billState")(scope.row.state)))])]}}])})],2),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.close}},[_vm._v("完成查看")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CoWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__ = __webpack_require__("w7Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_oss__ = __webpack_require__("6Q9E");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fileList: [],
      imgUrl: '',
      lookBigImgDialog: false,
      accept: '',
      checkNumber: 0
    };
  },

  // props: ['number', 'type', 'size', 'list'],
  props: {
    disabled: {
      type: Boolean //是否禁用
    },
    number: {
      type: Number //文件数量
    },
    type: {
      type: String //文件限制类型
    },
    size: {
      type: Number //文件大小限制
    },
    img: {
      default: false, //是否是图片
      type: Boolean
    },
    video: {
      default: false, //是否是视频文件
      type: Boolean
    },
    list: {
      type: Array //文件列表
    },
    videoNumber: {
      type: Number //视频文件数量
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.list) {
      // console.log(this.list);
      if (this.img) {
        this.handleImg(this.list);
      } else {
        this.handleFile(this.list);
      }
    }
    if (this.type) {
      this.accept = this.type;
      // console.log(this.type)
    } else if (this.img) {
      this.accept = 'image/png,image/jpeg,image/jpg,image/gif';
    } else if (this.video) {
      this.accept = 'video/mp4,video/rmvb,video/avi,video/ts';
    }
  },

  computed: {},
  methods: {
    del: function del(arr, index, type) {
      if (this.disabled) {
        this.$message.info('现场照片不可修改');
        return;
      }
      arr.splice(index, 1);
      var obj = {
        file: '',
        fileList: arr,
        index: index
      };
      this.$emit('onFileChange', obj);
      if (type) {
        this.removeFile();
      }
      console.log(this.fileList, 88);
    },
    lookFile: function lookFile(item) {
      if (item.address) {
        window.open(item.address);
      }
      // window.location.href = this.costEdit.address;
    },
    removeFile: function removeFile() {
      var fileObj = this.$refs['file'];
      if (fileObj) {
        fileObj.value = '';
      }
    },
    checkOss: function checkOss(e) {
      var _this = this;

      var pat = /[`~!@#$%^&*()_+<>?:"{},\/;'[\]]/im;
      var files = e.target.files || e.dataTransfer.files;
      // pat.test(files[0].name)
      if (files[0].name.indexOf(',') !== -1 || files[0].name.indexOf('，') !== -1) {
        this.removeFile();
        this.$message({
          type: 'error',
          message: '请选择没有特殊字符的图片名的图片'
        });
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__config_oss__["a" /* default */])(e).then(function (res) {
        console.log(res);
      });
      Object(__WEBPACK_IMPORTED_MODULE_2__service_getData__["_27" /* getSystemOssByUrl */])().then(function (res) {
        if (res.data.code === 1) {
          var clientConfig = {
            accessKeyId: res.data.data.AccessKeyId, //通过阿里云控制台创建的access key
            accessKeySecret: res.data.data.AccessKeySecret, //通过阿里云控制台创建的access secret。
            stsToken: res.data.data.SecurityToken, //使用临时授权方式。
            bucket: res.data.data.SystemOssBucket, // 通过控制台创建的bucket。
            endpoint: res.data.data.SystemOssEndpoint, //OSS域名。
            SystemOssChannelName: res.data.data.SystemOssChannelName, // OSS文件夹名
            cname: true, //是否支持上传自定义域名，默认false。如果cname为true，endpoint传入自定义域名时，自定义域名需要先同bucket进行绑定。
            region: 'oss-cn-hangzhou' //bucket 所在的区域，默认 oss-cn-hangzhou（是根据当前所在区域自动确认的）。
          };
          sessionStorage.setItem('clientConfig', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(clientConfig));
          sessionStorage.setItem('expiration', res.data.data.Expiration);

          _this.onFileChange(e);
        }
      });
    },
    onFileChange: function onFileChange(e) {
      var _this2 = this;

      var file = __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["o" /* selectOtherFile */](e, this.$message);
      var imgArr = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      var videoArr = ['video/mp4', 'video/rmvb', 'video/avi', 'video/ts'];
      var arr = [];
      var typeOk = [];
      if (this.type) {
        arr = this.type.split(',');
        if (this.img && arr.length === 0) {
          arr = imgArr;
        }
        arr.forEach(function (item) {
          typeOk.push(file[0].type === item ? 1 : 0);
        });
        if (typeOk.indexOf(1) === -1) {
          // this.$emit('typeError');
          this.$message({
            type: 'error',
            message: '选择文件格式错误！'
          });
          this.removeFile();
          return;
        }
        if (this.video) {
          if (videoArr.indexOf(file[0].type) !== -1) {
            var checkNumber = 0;
            this.fileList.forEach(function (item) {
              if (item.type == 'video') {
                checkNumber++;
              }
            });
            if (checkNumber >= this.videoNumber) {
              this.$message({
                type: 'error',
                message: '\u4E0A\u4F20\u7684\u89C6\u9891\u6587\u4EF6\u6700\u591A' + this.videoNumber + '\u4E2A\uFF01'
              });
              this.removeFile();
              return;
            }
          }
        }
      } else if (this.img) {
        arr = imgArr;
        arr.forEach(function (item) {
          typeOk.push(file[0].type === item ? 1 : 0);
        });
        if (typeOk.indexOf(1) == -1) {
          // this.$emit('typeError');
          this.$message({
            type: 'error',
            message: '选择图片格式错误！'
          });
          this.removeFile();
          return;
        }
      }
      if (this.size) {
        if (file[0].size > this.size * 1024 * 1024) {
          this.$message({
            type: 'error',
            message: '\u9009\u62E9\u6587\u4EF6\u6700\u5927\u4E3A' + this.size + 'M'
          });
          return;
        }
      }
      var isOk = true;
      if (this.number && this.number > 1) {
        if (this.fileList.length < this.number) {
          this.fileList.forEach(function (item, index) {
            if (item.fileName == file[0].name) {
              isOk = false;
            }
          });
          if (isOk) {
            if (this.img || this.video && imgArr.indexOf(file[0].type) !== -1) {
              var exportFile = file[0];
              var fileName = file[0].name;
              var config = {
                //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
                isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
                clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
              }; //配置项
              Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["b" /* upload */])(e, config).then(function (resolve) {
                var result = resolve.data;
                var url = Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
                //url = url.slice(0, url.indexOf('?'));
                _this2.fileList.push({
                  exportFile: url,
                  fileName: fileName,
                  imgUrl: url
                });
                var obj = {
                  file: url,
                  fileList: _this2.fileList
                };
                _this2.$emit('onFileChange', obj);
                _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
              }).catch(function (_) {
                console.log(_.err);
                _this2.removeFile();
              });
              // global.selectImgFile(e, this.$message).then(res => {
              //   this.fileList.push({
              //     exportFile: exportFile,
              //     fileName: fileName,
              //     imgUrl: res,
              //   });
              //   let obj = {
              //     file: file,
              //     fileList: this.fileList
              //   };
              //   this.$emit('onFileChange', obj);
              //   this.removeFile();
              // })
            } else {
              var _config = {
                //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
                isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
                clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
              }; //配置项
              Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["b" /* upload */])(e, _config).then(function (resolve) {
                var result = resolve.data;
                var url = Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
                //url = url.slice(0, url.indexOf('?'));

                var fileName = file[0].name;
                if (videoArr.indexOf(file[0].type) !== -1) {
                  _this2.fileList.push({
                    exportFile: url,
                    fileName: fileName,
                    type: 'video'
                  });
                } else {
                  _this2.fileList.push({
                    exportFile: url,
                    fileName: fileName
                  });
                }
                var obj = {
                  file: url,
                  fileList: _this2.fileList
                };
                _this2.$emit('onFileChange', obj);
                _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
              }).catch(function (_) {
                console.log(_.err);
                _this2.removeFile();
              });
              // if (videoArr.indexOf(file[0].type) !== -1) {
              //   this.fileList.push({
              //     exportFile: file[0],
              //     fileName: file[0].name,
              //     type: 'video'
              //   });
              // } else {
              //   this.fileList.push({
              //     exportFile: file[0],
              //     fileName: file[0].name
              //   });
              // }
              // let obj = {
              //   file: file,
              //   fileList: this.fileList
              // };
              // this.$emit('onFileChange', obj);
              // this.removeFile();
            }
          } else {
            this.$message({
              type: 'error',
              message: '已经存在该文件！'
            });
          }
        } else {
          this.$message({
            type: 'error',
            message: '\u6700\u591A\u53EA\u80FD\u4E0A\u4F20' + this.number + '\u4E2A\u6587\u4EF6\uFF01'
          });
        }
      } else {
        if (this.img) {
          var _exportFile = file[0];
          var _fileName = file[0].name;
          var _config2 = {
            //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
            isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
            clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
          }; //配置项
          Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["b" /* upload */])(e, _config2).then(function (resolve) {
            var result = resolve.data;
            var url = Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
            // url = url.slice(0, url.indexOf('?'));
            _this2.fileList = [{
              exportFile: url,
              fileName: _fileName,
              imgUrl: url
            }];
            var obj = {
              file: url,
              fileList: _this2.fileList
            };
            _this2.$emit('onFileChange', obj);
            _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
          }).catch(function (_) {
            console.log(_.err);
            _this2.removeFile();
          });
          // global.selectImgFile(e, this.$message).then(res => {
          //   // console.log(res)
          //   this.fileList = [{
          //     exportFile: exportFile,
          //     fileName: fileName,
          //     imgUrl: res,
          //   }];
          //   let obj = {
          //     file: file,
          //     fileList: this.fileList
          //   };
          //   this.$emit('onFileChange', obj);
          //   this.removeFile();
          // }).catch(err => {
          //   console.log(err)
          // })
        } else {
          var _config3 = {
            //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
            isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
            clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
          }; //配置项
          var _fileName2 = file[0].name;
          Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["b" /* upload */])(e, _config3).then(function (resolve) {
            var result = resolve.data;
            var url = Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
            // url = url.slice(0, url.indexOf('?'));
            _this2.fileList = [{
              exportFile: url,
              fileName: _fileName2
            }];
            var obj = {
              file: url,
              fileList: _this2.fileList
            };
            _this2.$emit('onFileChange', obj);
            _this2.removeFile(); //移除选择文件的选中状态，可以继续选择文件
          }).catch(function (_) {
            console.log(_.err);
            _this2.removeFile();
          });
          // this.fileList = [{
          //   exportFile: file[0],
          //   fileName: file[0].name
          // }];
          // let obj = {
          //   file: file,
          //   fileList: this.fileList
          // };
          // this.$emit('onFileChange', obj);
          // this.removeFile();
        }
      }
      console.log(this.fileList, 111);
    },
    lookBigImg: function lookBigImg(row) {
      this.imgUrl = row.imgUrl;
      this.lookBigImgDialog = true;
    },
    handleFile: function handleFile(val) {
      var _this3 = this;

      var imgArr = ['image/png', 'image/jpeg', 'image/gif'];
      var videoArr = ['video/mp4', 'video/rmvb', 'video/avi', 'video/ts'];
      this.fileList = [];
      if (this.img) {
        val.forEach(function (fileItem) {
          _this3.fileList.push({
            exportFile: '',
            fileName: '',
            imgUrl: fileItem
          });
        });
      } else {
        val.forEach(function (fileItem) {
          if (_this3.video && fileItem.address) {
            _this3.fileList.push({
              fileName: fileItem.fileName,
              address: fileItem.address,
              type: 'video'
            });
          } else if (fileItem.imgUrl) {
            _this3.fileList.push({
              fileName: fileItem.fileName,
              imgUrl: fileItem.imgUrl,
              type: 'img'
            });
          } else {
            if (fileItem.exportFile && fileItem.fileName) {
              _this3.fileList.push({
                exportFile: fileItem.exportFile,
                fileName: fileItem.fileName
              });
            } else if (fileItem.fileName) {
              _this3.fileList.push({
                exportFile: '',
                fileName: fileItem.fileName
              });
            } else {
              _this3.fileList.push({
                exportFile: '',
                fileName: fileItem
              });
            }
          }
        });
      }
    },
    uoloadImgOss: function uoloadImgOss(e) {
      var _this4 = this;

      var config = {
        //action: ossActionUrl, //获取取配置信息接口请求地址，当isNotNeedRequest为false时必传。
        isNotNeedRequest: true, //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
        clientRequest: __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["p" /* strParse */](sessionStorage.getItem('clientConfig')) //当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
      }; //配置项
      Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["b" /* upload */])(e, config).then(function (resolve) {
        var result = resolve.data;
        var url = Object(__WEBPACK_IMPORTED_MODULE_3__plugins_oss_sdk__["a" /* getExtranetUrl */])(result.name, 2); //获取图片外网访问地址
        //url = url.slice(0, url.indexOf('?'));
        if (that.number === 1) {}
        _this4.fileList.push({
          exportFile: url,
          fileName: result.name,
          imgUrl: url
        });
        var obj = {
          file: url,
          fileList: _this4.fileList
        };
        _this4.$emit('onFileChange', obj);
        _this4.removeFile(); //移除选择文件的选中状态，可以继续选择文件
      }).catch(function (_) {
        console.log(_.err);
        _this4.removeFile();
      });
    },
    handleImg: function handleImg(val) {
      var _this5 = this;

      this.fileList = [];
      if (this.img) {
        val.forEach(function (fileItem) {
          _this5.fileList.push({
            exportFile: '',
            fileName: '',
            imgUrl: fileItem
          });
        });
      } else {
        val.forEach(function (fileItem) {
          if (fileItem.exportFile && fileItem.fileName) {
            _this5.fileList.push({
              exportFile: fileItem.exportFile,
              fileName: fileItem.fileName
            });
          } else if (fileItem.fileName) {
            _this5.fileList.push({
              exportFile: '',
              fileName: fileItem.fileName
            });
          } else {
            _this5.fileList.push({
              exportFile: '',
              fileName: fileItem
            });
          }
        });
      }
    }
  },
  components: {},
  watch: {
    list: function list(val) {
      if (val) {
        if (this.img) {
          this.handleImg(val);
        } else {
          this.handleFile(val);
        }
      }
    }
  }
});

/***/ }),

/***/ "CyG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("8Sqn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_11504156_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("+sLz");
function injectStyle (ssrContext) {
  __webpack_require__("q57K")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11504156"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_11504156_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D2CD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_prevent_plague_add_vue__ = __webpack_require__("9P4B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33568d5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_prevent_plague_add_vue__ = __webpack_require__("ct6f");
function injectStyle (ssrContext) {
  __webpack_require__("4zd2")
  __webpack_require__("9Z4d")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33568d5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_prevent_plague_add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_33568d5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_prevent_plague_add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D9Wk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEJklEQVRYR7WXXWhcRRTH//+bNRu10ChWgh+04IP6qBXaBhtC68sG453Zuv2gWD+gYLFSBX3xgxYVBK1KPxBtUaqU2Dayc++uZPug7dJq9FFFsQ+CBlsU7UPezGV358gsu+F63WR34+Y+7MfcmXN+58yZc+YQjUcptYbkawB2APCa4z3+tiIyISIvhGH4m5NN96G13i0iRwD8DuAjkhdExPZSubWWnuetBrAVwCaSTxtjjjObza631k4DeC+KomdLpVLUS8WtZCmlnLFPeZ43TKXUaZJ3GWPuAdBTqxcyZHR0NDU4OPgdgB+otf4TwFFjzCvLbXlcvlLqgPOCAxBr7fYwDE8nAJx3nmjs1/UiMh1F0aFebZFSagfJiTqACwxjzGQcQGsdAnhQRL4CcDPJOwH8lEql1k5OTv79f73l+/42z/NOtQTwfX+M5GfW2s2FQuF846RkAUyKyIEgCF5dboA3SG4KguC+hFdOishQEAQPLCuA1vpNt/fGmLUJgGMA7jDGbF5WgOYWOIggCMpOWTabXW2t/R7AwXZb4Obm8/mZxSAXjYHGnucB+CJiSF4VERe1V9oEoYupDwDsstbmwjA0C0G0BXBpOn4MAXyTSqUOLXIC6spFRAE4DOBFko8YY061gugEoJttnldeq9U2FovFH7XWLoccB7CzFUQvAf6jPFZh95A82gqiVwALKo9BPEPyrSRExwBKqa0ky8YYVzPiT1vlcQgAb5N8zBjzsRvvCKCRD54DcGlubm6kVCr91RDasfIYxH4A+5sQbQEaNXs3gIdIvgzgpgbE1Wa0NwOu02hVSr0DYJ+DsNZGC9YCrfUxEdlFcswYc258fPy6vr6+cyRXAvhSRLZ0qzzmiSZEsW5cohq6/+8DeBRAxilvLszlcisqlcrnJNdZa3eGYTjRqeXJeUqpd0nuceNxgE+11icAbHcxYow5m1zYgLgAYE2tVhsuFouXlgqhtf4QwONNAHcTdmn3YZLjrZTHPLGyUqmcJ3lbtVodWSpEMghnRORWa+2WQqFQaGdVLpebh3CeKBQKP7dbk3yfBKjVarVsJ8oTnrhIcpWIbAiC4NduIJIAzxtjDnYjwM3N5XI3ViqVMskbRGRjNxD/AhCRbUEQnOkWoAlRrVbdvXEFyQ35fP5yJ3K01i7YP3El12W3w+0uGYsJzWQyqwYGBtzpuJbk/Z1AKKVcZtxbb0wA3D07O3tvuVyudkLfao6DSKfT0ySviaJo/dTU1B+LyPKUUt+6WzZ9319H8muSR4wx+5YK4NaNjY0N9ff3X3S/oygajtWOebGZTCadTqddNnyy3pq5N645dd2RiHwB4Iy1dsbzPNcvdP2QHBKREyR/EZG9AGr1jEd6IjLisizJW5z7681pU4Pv+7d7nvf6crfnAE5aa19qtuf/APvXi08LNRQCAAAAAElFTkSuQmCC"

/***/ }),

/***/ "D9sh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DUfg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dcwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      approvalInfo: {
        result: 1,
        erAuditIds: []
      },
      submitLoading: false,
      checkAll: false,
      checkedStaff: [],
      staffs: [],
      isIndeterminate: true
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    if (this.approvalTitle == "审批") {
      this.approvalInfo.erAuditIds = [this.erAuditId];
    }
    if (this.approvalTitle == "批量审批") {
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["q" /* batchList */]().then(function (res) {
        if (res.data.code != 1) {
          _this.$message.error(res.data.message);
          return;
        }

        _this.staffs = res.data.data;
      }).catch(function (_) {
        console.log(_);
      });
    }
  },

  props: ["approvalTitle", "erAuditId"],
  computed: {},
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedStaff = val ? this.staffs : [];
      this.approvalInfo.erAuditIds = this.checkedStaff.map(function (item) {
        return item.erAuditId;
      });
      this.isIndeterminate = false;
    },
    handlecheckedStaffChange: function handlecheckedStaffChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.staffs.length;
      this.approvalInfo.erAuditIds = this.checkedStaff.map(function (item) {
        return item.erAuditId;
      });
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.staffs.length;
    },
    submit: function submit() {
      var _this2 = this;

      console.log(this.approvalInfo);
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["R" /* erAuditApproval */](this.approvalInfo).then(function (res) {
        if (res.data.code != 1) {
          _this2.$message.error(res.data.message);
          return;
        }
        _this2.$message({
          type: "success",
          message: "审批成功！"
        });
        _this2.close(1);
      }).catch(function (_) {
        _this2.$message({
          type: "warning",
          message: "审批失败！"
        });
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "DmYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      notifyInfo: {},
      fileList: [],
      submitLoading: false,
      conts: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__service_getData__["_3" /* findNotify */](this.notifyId).then(function (res) {
      if (res.data.code == "success") {
        _this.notifyInfo = res.data.data.notify;
        _this.fileList = _this.notifyInfo.notifyFileList ? _this.notifyInfo.notifyFileList : [];
      } else {
        _this.$message({
          message: res.data.message,
          type: "error"
        });
      }
    });
  },

  computed: {},
  props: ['notifyId'],
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      } else {
        this.$emit('closeDialog');
      }
    },
    downloadFile: function downloadFile(row, index) {
      if (!row.notifyFileUrl || !row.notifyFileName) {
        this.$message({
          type: "warning",
          message: "下载地址不存在！"
        });
        return;
      }
      if (row.notifyFileId) {
        window.location.href = '/company/notify/downloadFile?notifyFileId=' + row.notifyFileId;
      } else {
        window.location.href = '/company/notify/downloadFile?notifyFileUrl=' + row.notifyFileUrl + '&notifyFileName=' + row.notifyFileName;
      }
    },
    submits: function submits() {
      var _this2 = this;

      if (this.notifyInfo.notifyNecessityReply) {
        if (!this.conts) {
          this.$message.error('请填写回复内容！');
          return;
        }
      }
      var info = {
        notifyId: this.notifyId,
        replyContent: this.conts
      };
      this.submitLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_68" /* readConfirm */](info).then(function (res) {
        _this2.submitLoading = false;
        if (res.data.code === 1 || res.data.code === 'success') {
          _this2.$message.success('回复成功！');
          _this2.close(1);
        }
      }).catch(function (err) {
        _this2.submitLoading = false;
        console.log(err);
      });
    }
  },
  components: {},
  watch: {},
  filters: {
    notifyType: function notifyType(val) {
      switch (val) {
        case 1:
          return '园区通知';
        case 2:
          return '政策通知';
        default:
          return '-';
      }
    }
  }
});

/***/ }),

/***/ "Ez6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {},
      fileList: [],
      submitLoading: false,
      conts: '',
      tableList: [],
      parkListLoading: false,
      billStatistics: {},
      contractPriceDecimal: 1,
      filters: {
        contractId: '',
        type: ''
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.filters.contractId = this.contractId;
    this.filters.type = this.contractType;
    this.init();
  },

  computed: {},
  props: ['contractId', 'contractType'],
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      } else {
        this.$emit('closeDialog');
      }
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["r" /* billList */](this.filters).then(function (res) {
        _this.parkListLoading = false;
        if (res.data.code == "success") {
          _this.tableList = res.data.data.data.list;
        }
      }).catch(function (_) {
        console.log(_);
        _this.parkListLoading = false;
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "F6PB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fiv5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GMIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__("Qgp7");


var _types$SAVE_ORDERFLOW;



/* harmony default export */ __webpack_exports__["a"] = (_types$SAVE_ORDERFLOW = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["b" /* SAVE_ORDERFLOWADD */], function (state, orderFlowInfo) {
  state.orderFlowInfo = orderFlowInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["a" /* SAVE_ORDERFLOWACTIVE */], function (state, orderFlowInfoActive) {
  state.orderFlowInfoActive = orderFlowInfoActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$SAVE_ORDERFLOW, __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__["c" /* SHOW_HOUSE_INFO */], function (state, company) {
  state.houseDialog = !state.houseDialog;
  if (company) {
    state.finalState = company.colorType;
    state.houseResId = company.houseResId;
  }
}), _types$SAVE_ORDERFLOW);

/***/ }),

/***/ "GVgq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gt+G":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAAiBJREFUSEvt1rFrE1EcB/DvNxexCBKIOljERogdFMndvWQQiqMgLlLRQUWsqODk4KL+AdbFwalQxYqog2JxEcFRCg7J7+6C6KCBpiJ1UANBkIq5/OTAFhuTXEiwOHjre+/7ud+9d787Yg0u9mhYhUJhTFXHAGwG8JnkXLFYnAMQxmXEIo7j7CM5RXJXa5iqvlHV877vv+gGdUVc1z1K8t6vgLskZ0kuquqwqo4DOBmNqeoJz/MedoI6IrlcbjSZTAaquqSqB33ff9ka4jjOXpJPSQ41Gg27XC6/bQd1RIwx9wEcU9XDnufNdrpL13XHST4G8EBEjveMZLPZ9alU6guABRHZHbexxpjXAEbq9fqmSqXyvXV+20ps295pWVZU+k0ROdcDMg3gbBiGo0EQvOuKGGP2A7gIYCuAPQAWSS7EIao6AmAYwCsAHwFcF5Hny+tWKslkMkPpdPoTgA0kf8QFdxpX1XUAvtVqtS3VanUpmreC2LadsSxrHsAdEZnoFzHGzAA4FYbhjiAIqm0RkjOlUul0v0g+n7+tqhP/NuI4zoFEIvGo2Wwe8X3/WbtqB67EGHMJwCSAyyJy7T8y3+10rdXjcgHcAHBBRLy/sie9vDsDn66BEWPM9qi1A3iiqld6CWz77SCvAjgUtX4Reb+qrQCwjDFRr9nWL/Dbug8ikln+yVj1PXFdN0vyDICNA0BfVfWW53mVP1r9AKGxS38CXoRiKdmK+woAAAAASUVORK5CYII="

/***/ }),

/***/ "GtMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var checkNumber = function checkNumber(rule, value, callback) {
      if (value === "") {
        return callback(new Error("请输入隔离天数"));
      }
      if (value >= 0 && value <= 99) {
        callback();
      } else {
        return callback(new Error("请输入0-99"));
      }
    };

    return {
      vrInfo: {
        quarantineWay: 1,
        quarantineStartTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        quarantineDays: "",
        quarantinePerson: '',
        quarantineDescription: '',
        quarantineBaseId: ''
      },
      rules: {
        quarantineWay: [{ required: true, message: "请选择隔离方式", trigger: ["blur", "change"] }],
        quarantineStartTime: [{ required: true, message: "请选择隔离开始时间", trigger: ["blur", "change"] }],
        quarantineDays: [{
          required: true,
          // pattern: global.number,
          type: 'number',
          message: "隔离天数格式错误",
          trigger: ["blur", "change"],
          transform: function transform(value) {
            return Number(value);
          }
        }, { validator: checkNumber, trigger: ["blur", "change"] }],
        quarantineDescription: [{ max: 200, message: "长度在 200 个字符内", trigger: "blur" }]

      },
      submitLoading: false,
      companyList: [],
      quarantineList: null,
      quarantine: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    console.log(this.baseId);
    this.init();
  },

  props: ["id", "baseId"],
  computed: {},
  methods: {
    timeFormat: function timeFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["q" /* toDateTime */](time);
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_39" /* isIsolationRegister */](this.baseId).then(function (res) {
        if (res.data.code != 'success') {
          _this.$message.error(res.data.message);
          return;
        }
        var data = res.data.data;
        _this.quarantine = data.quarantine;
        if (_this.quarantine != null) {

          _this.getQuarantine(_this.quarantine.quarantineId);
        }
      }).catch(function (_) {
        console.log(_);
      });
    },
    getQuarantine: function getQuarantine(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_24" /* getQuarantine */](id).then(function (res) {
        var data = res.data.data.quarantine;
        _this2.quarantineList = data;
        if (data != null) {
          _this2.vrInfo.quarantineWay = data.quarantineWay;
          _this2.vrInfo.quarantineStartTime = data.quarantineStartTime;
          _this2.vrInfo.quarantineDays = data.quarantineDays;
          _this2.vrInfo.quarantinePerson = data.quarantinePerson;
          _this2.vrInfo.quarantineDescription = data.quarantineDescription;
          _this2.vrInfo.quarantineId = data.quarantineId;
        }
      }).catch(function (_) {
        console.log(_);
      });
    },
    submit: function submit() {
      var _this3 = this;

      this.$refs["info"].validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;

          if (_this3.quarantineList != null) {
            _this3.vrInfo.quarantineBaseId = _this3.baseId;
            // console.log(this.vrInfo.quarantineBaseId)
            __WEBPACK_IMPORTED_MODULE_1__service_getData__["_85" /* updateQuarantine */](_this3.vrInfo.quarantineId, _this3.vrInfo.quarantineWay, _this3.vrInfo.quarantineStartTime, _this3.vrInfo.quarantineDays, _this3.vrInfo.quarantinePerson, _this3.vrInfo.quarantineDescription, _this3.vrInfo.quarantineBaseId).then(function (res) {
              _this3.submitLoading = false;
              if (res.data.code != "success") {
                _this3.$message({
                  type: "error",
                  message: res.data.message || res.data.msg
                });
                return;
              }
              _this3.$message.success("更新成功！");
              _this3.close(1);
            }).catch(function (_) {
              console.log(_);
              _this3.submitLoading = false;
            });
          } else {
            _this3.vrInfo.quarantineBaseId = _this3.baseId;
            console.log(_this3.vrInfo.quarantineBaseId);
            __WEBPACK_IMPORTED_MODULE_1__service_getData__["i" /* addQuarantine */](_this3.vrInfo.quarantineWay, _this3.vrInfo.quarantineStartTime, _this3.vrInfo.quarantineDays, _this3.vrInfo.quarantinePerson, _this3.vrInfo.quarantineDescription, _this3.vrInfo.quarantineBaseId).then(function (res) {
              console.log(res);
              _this3.submitLoading = false;
              if (res.data.code != "success") {
                _this3.$message({
                  type: "error",
                  message: res.data.message || res.data.msg
                });
                return;
              }
              _this3.$message.success("添加成功！");
              _this3.close(1);
            }).catch(function (_) {
              console.log(_);
              _this3.submitLoading = false;
            });
          }
        }
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "Gvv4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Hefa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"form-style"},[_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("统一社会信用代码")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.creditCode))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("组织机构代码")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.companyCode))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("工商注册号")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.regNumber))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("公司类型")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.regType))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("法定代表人")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.faRen))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("联系方式")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.phone))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":8}},[_c('el-col',{staticClass:"form-title",attrs:{"span":9}},[_vm._v("所属行业")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":15}},[_vm._v(_vm._s(_vm.baseInfo.industry))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"-2px","display":"flex"},attrs:{"span":16}},[_c('el-col',{staticClass:"form-title",attrs:{"span":5,"id":"address-title"}},[_vm._v("注册地址")]),_vm._v(" "),_c('el-col',{staticClass:"form-value",attrs:{"span":20,"id":"address-value"}},[_vm._v(_vm._s(_vm.baseInfo.address))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I/3Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_file_upload_vue__ = __webpack_require__("CoWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ad24928_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_file_upload_vue__ = __webpack_require__("yH66");
function injectStyle (ssrContext) {
  __webpack_require__("Ztlu")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad24928"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_file_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_2ad24928_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_file_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I989":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_parking_rental_details_vue__ = __webpack_require__("hDPA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dd81428a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_parking_rental_details_vue__ = __webpack_require__("7/mN");
function injectStyle (ssrContext) {
  __webpack_require__("v0B7")
  __webpack_require__("bRA7")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd81428a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_parking_rental_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_dd81428a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_parking_rental_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "INaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_meter_batch_import_vue__ = __webpack_require__("TBSr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8703e062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_meter_batch_import_vue__ = __webpack_require__("b/am");
function injectStyle (ssrContext) {
  __webpack_require__("xBfx")
  __webpack_require__("ofJ0")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8703e062"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_meter_batch_import_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8703e062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_meter_batch_import_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ImgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_evaluationResult_vue__ = __webpack_require__("f3Wb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3406cf6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_evaluationResult_vue__ = __webpack_require__("NPIN");
function injectStyle (ssrContext) {
  __webpack_require__("W//h")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3406cf6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_evaluationResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3406cf6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_evaluationResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J89O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_checkChangeRecords_vue__ = __webpack_require__("jKFU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_639d722c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_checkChangeRecords_vue__ = __webpack_require__("SJ5I");
function injectStyle (ssrContext) {
  __webpack_require__("A8UH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-639d722c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_checkChangeRecords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_639d722c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_checkChangeRecords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JWIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_quarantine_register_add_vue__ = __webpack_require__("GtMx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9900667a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_quarantine_register_add_vue__ = __webpack_require__("BAc0");
function injectStyle (ssrContext) {
  __webpack_require__("vGzk")
  __webpack_require__("vtmy")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9900667a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_quarantine_register_add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9900667a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_quarantine_register_add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JuEY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K6HH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // companyIcList: [],
      companyId: ''
    };
  },

  props: ['companyIcList'],
  created: function created() {},
  mounted: function mounted() {
    this.companyId = sessionStorage.getItem('companyId') || '';
  },

  methods: {
    getAdminInfo: function getAdminInfo(item, index) {
      this.companyId = item.companyId;
    },
    examineInvestment: function examineInvestment() {
      var _this = this;

      //切换账号公司
      __WEBPACK_IMPORTED_MODULE_0__service_getData__["v" /* chooseCompany */]({ companyId: this.companyId }).then(function (res) {
        if (res.data.code != 1) {
          _this.$message.error(res.data.message);
          return;
        }
        sessionStorage.setItem('companyId', _this.companyId);
        _this.$emit('closeDialog');
      }).catch(function (_) {});
    }
  }
});

/***/ }),

/***/ "Km6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");
var on = function () {
  if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();



// 所有绑定了clickoutside指令的元素的dom对象数组
var nodeList = [];
// 用来做存放于dom对象中clickoutside相关参数对象的key
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;
// 鼠标按下时，记录此时事件信息
!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isServer && on(document, 'mousedown', function (e) {
  return startClick = e;
});
// 鼠标松开时候，遍历绑定clickoutside的节点，进行判断是否在节点外部以触发回调
!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isServer && on(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    node[ctx].documentHandler(e, startClick);
  });
});

// 是否在特殊限定范围内
function ifInExact(exactElms, target1, taget2) {
  for (var i = 0; i < exactElms.length; i++) {
    var elm = exactElms[i];
    if (elm.contains(target1) || elm.contains(taget2) || elm === target1) return true;
  }
  return false;
}

// 是否有特殊限定范围
function ifHasExact(el, exactArea) {
  if (!exactArea) return false;
  return el.getElementsByClassName(exactArea);
}

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
    var exactElms = ifHasExact(el, el[ctx].exactArea);
    // 如果是有特殊限定范围的，则进行判断当前点击是否在 限定范围内
    if (exactElms) {
      if (ifInExact(exactElms, mouseup.target, mousedown.target)) {
        return;
      }
      // 无特殊限定范围，则判断点击是否在默认的指令所在范围内
    } else if (el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target) {
      return;
    }
    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   *指令的钩子函数
   *
   bind：只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
     inserted：被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
     update：所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。
   但是你可以通过比较更新前后的值来忽略不必要的模板更新。
     componentUpdated：指令所在组件的 VNode 及其子 VNode 全部更新后调用。
     unbind：只调用一次，指令与元素解绑时调用。
   */
  bind: function bind(el, binding, vnode) {
    /**
     * 指令钩子函数会被传入以下参数：
       el：指令所绑定的元素，可以用来直接操作 DOM 。
     binding：一个对象，包含以下属性：
         name：指令名，不包括 v- 前缀。
         value：指令的绑定值，例如：v-my-directive="1 + 1" 中，绑定值为 2。
         oldValue：指令绑定的前一个值，仅在 update 和 componentUpdated 钩子中可用。无论值是否改变都可用。
         expression：字符串形式的指令表达式。例如 v-my-directive="1 + 1" 中，表达式为 "1 + 1"。
         arg：传给指令的参数，可选。例如 v-my-directive:foo 中，参数为 "foo"。
         modifiers：一个包含修饰符的对象。例如：v-my-directive.foo.bar 中，修饰符对象为 { foo: true, bar: true }。
       vnode：Vue 编译生成的虚拟节点。
     oldVnode：上一个虚拟节点，仅在 update 和 componentUpdated 钩子中可用。
     */
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value,
      // 特殊限定范围的class，限定范围为该class的所有元素的并集
      exactArea: binding.arg
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
    // 附加 真正起作用部分
    el[ctx].exactArea = binding.arg;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
  /**
   *用法升级（点击A和B的外部才触发，点击A和B不触发）在A和B上添加相同类，在父级元素绑定指令，并加上相同类
   <div style="width:700px;height:700px;border:solid;" v-clickoutside:exactAreaClassName="handleClose">
       <div style="width:300px;height:300px;background:red;margin:20px;" class="exactAreaClassName">A</div>
       <div style="width:300px;height:300px;background:red;margin:20px;" class="exactAreaClassName">B</div>
   </div>
   */

});

/***/ }),

/***/ "L/ig":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L8Y5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("51dY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_438bb3fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("8DhQ");
function injectStyle (ssrContext) {
  __webpack_require__("/m8p")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_438bb3fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LFfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vue__ = __webpack_require__("j8X4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e67e89e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vue__ = __webpack_require__("yd53");
function injectStyle (ssrContext) {
  __webpack_require__("XjDz")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e67e89e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6e67e89e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LvU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_parking_rental_application_vue__ = __webpack_require__("/pot");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e6fce08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_parking_rental_application_vue__ = __webpack_require__("YNmQ");
function injectStyle (ssrContext) {
  __webpack_require__("s+T+")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e6fce08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_parking_rental_application_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7e6fce08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_parking_rental_application_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M7eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");

/**
 * 转换前先替换为 IE 可识别的格式
 * @param time
 * @returns {string}
 */
var replaceTime = function replaceTime(time) {
  return typeof time === 'string' ? time.replace(/-/g, '/') : time;
};

/**
 * 静态数据
 */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.J_options = {
  visitorVisitType: [//选择拜访标签
  { label: '全部', value: 0 }, { label: '面试', value: 1 }, { label: '商业洽谈', value: 2 }, { label: '参观学习', value: 3 }, { label: '企业拜访', value: 4 }, { label: '领导来访', value: 5 }, { label: '其他', value: 6 }],
  visitorState: [//选择状态
  { label: '全部', value: 0 }, { label: '未过期', value: 1 }, { label: '已过期', value: 2 }],
  problemType: [{ label: '水电维修', value: 1 }, { label: '卫生保洁', value: 2 }, { label: '设施维修', value: 3 }, { label: '绿化保养', value: 4 }, { label: '其他', value: 5 }],
  feedFromType: [{ label: '手机端', value: 1 }, { label: '企业门户', value: 2 }],
  problemState: [{ label: '未处理', value: 1 }, { label: '已处理', value: 2 }]
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('empty', function (val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return val;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', function (val) {
  switch (val) {
    case null:
    case undefined:
    case 0:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy-MM-dd');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('datetime', function (val) {
  switch (val) {
    case null:
    case undefined:
    case 0:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy-MM-dd hh:mm:ss');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('feedFromType', function (val) {
  switch (val) {
    case null:
    case undefined:
    case 0:
      return;
    case 1:
      return '手机端';
    case 2:
      return '企业门户';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date2', function (val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format('yyyy/MM/dd');
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('buildType', function (val) {
  switch (val) {
    case 1:
      return '办公';
    case 2:
      return '商务';
    case 3:
      return '综合';
    default:
      return val;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('visitorState', function (value) {
  switch (value) {
    case 0:
      return;
    case 1:
      return '未过期';
    case 2:
      return '已过期';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('problemType', function (value) {
  switch (value) {
    case 0:
      return;
    case 1:
      return '水电维修';
    case 2:
      return '卫生保洁';
    case 3:
      return '设施维修';
    case 4:
      return '绿化保养';
    case 5:
      return '其他';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('compactType', function (value) {
  switch (value) {
    case 1:
      return '租赁合同';
    case 2:
      return '物业合同';
    case 3:
      return '车位合同';
    case 4:
      return '公寓租赁合同';
    case 5:
      return '公寓物业合同';
    default:
      return value;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('visitorVisitType', function (value) {
  switch (value) {
    case 0:
      return;
    case 1:
      return '面试';
    case 2:
      return '商业洽谈';
    case 3:
      return '参观学习';
    case 4:
      return '企业拜访';
    case 5:
      return '领导来访';
    case 6:
      return '其他';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('billType', function (value) {
  switch (value) {
    case 1:
      return '租赁';
    case 2:
      return '物业';
    case 3:
      return '车位';
    case 4:
      return '租赁押金';
    case 5:
      return '物业押金';
    case 6:
      return '车位押金';
    default:
      return '-';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('billTypeNew', function (value) {
  switch (value) {
    case 1:
      return '租赁费';
    case 2:
      return '物业费';
    case 3:
      return '车位费';
    case 4:
      return '租赁押金';
    case 5:
      return '物业押金';
    case 6:
      return '车位押金';
    case 7:
      return '公寓租金';
    case 8:
      return '公寓押金';
    case 9:
      return '公寓物业租金';
    case 10:
      return '公寓物业押金';
    case 11:
      return '租赁自定义账单';
    case 12:
      return '物业自定义账单';
    default:
      return '-';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('datetimeType', function (val, type) {
  //自定义 date、datetime格式显示
  switch (val) {
    case null:
    case 'null':
    case undefined:
    case 'undefined':
    case '':
      return '-';
    default:
      return new Date(replaceTime(val)).format(type);
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('roundTwo', function (value) {
  switch (value) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      var num = Math.round(value * 100) / 100;
      num = isNaN(num) ? 0 : num;
      return num;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('roundThree', function (value) {
  switch (value) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      var num = Math.round(value * 1000) / 1000;
      num = isNaN(num) ? 0 : num;
      return num;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('contractType', function (value) {
  switch (value) {
    case 1:
      return '企业租赁';
    case 2:
      return '企业物业';
    case 3:
      return '公寓租赁';
    case 4:
      return '公寓物业';
    default:
      return '-';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('billState', function (value) {
  switch (value) {
    case 1:
      return '未收款';
    case 2:
      return '已收款';
    case 3:
      return '逾期';
    case 4:
      return '未缴清';
    default:
      return '-';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('billState1', function (value) {
  switch (value) {
    case 1:
      return '未结清';
    case 2:
      return '已结清';
    case 3:
      return '逾期';
    case 4:
      return '未缴清';
    default:
      return '-';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('rentState', function (value) {
  switch (value) {
    case 1:
      return '空闲中';
    case 2:
      return '租赁中';
    case 3:
      return '自用';
    default:
      return '-';
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('fixState', function (value) {
  switch (value) {
    case 1:
      return '毛胚';
    case 2:
      return '简装';
    case 3:
      return '精装';
    default:
      return '-';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("noteType", function (val) {
  switch (val) {
    case 1:
      return "普票";
    case 2:
      return "专票";
    case 3:
      return "收据";
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("noteState", function (val) {
  switch (val) {
    case 1:
      return "审批中";
    case 2:
      return "已通过";
    case 3:
      return "已驳回";
    case 4:
      return "已确认";
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter("vehicleState", function (val) {
  switch (val) {
    case 1:
      return "待审批";
    case 2:
      return "已通过";
    case 3:
      return "已驳回";
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ba2dcf3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("q+d9");
function injectStyle (ssrContext) {
  __webpack_require__("eYLq")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ba2dcf3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MQnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_switch_company_vue__ = __webpack_require__("K6HH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_283dabef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_switch_company_vue__ = __webpack_require__("rmvN");
function injectStyle (ssrContext) {
  __webpack_require__("nieQ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-283dabef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_switch_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_283dabef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_switch_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mk83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table",staticStyle:{"width":"100%"}},[_c('el-table',{key:_vm.recordId,staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"size":"mini","border":"","header-cell-style":{background:'#f6faff','text-align':'center' }}},[_c('template',{slot:"empty"},[(_vm.tableDataLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"no-data"},[(!_vm.tableDataLoading)?_c('span',[_vm._v("暂无"+_vm._s(_vm.baseData.recordName)+"信息")]):_vm._e()])],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"indexNum","label":"序号","type":"index"}}),_vm._v(" "),(_vm.formList.length)?_vm._l((_vm.formList),function(item,index){return _c('el-table-column',{key:index,attrs:{"min-width":140,"prop":item.valueKey,"label":item.rfName,"show-overflow-tooltip":"","align":"center"},scopedSlots:_vm._u([{key:"header",fn:function(){return [(_vm.isEdit&&item.rfRemake!=''&&item.rfRemake)?_c('p',[_vm._v("\r\n          "+_vm._s(item.rfName)+"\r\n          "),(item.rfIsMust==1)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.rfRemake,"placement":"right"}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"5px","color":"grey"}})])],1):_c('p',[_vm._v(_vm._s(item.rfName)),(item.rfIsMust==1&&_vm.isEdit)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e()])]},proxy:true},{key:"default",fn:function(scope){return [(item.rfType==1)?_c('div',{ref:"formText",refInFor:true,class:{'width-100':_vm.isEdit},staticStyle:{"padding":"0 8px"}},[(!_vm.isEdit)?_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.tableData[scope.$index][item.valueKey])))]):_c('el-input',{attrs:{"width":"100"},model:{value:(_vm.tableData[scope.$index][item.valueKey]),callback:function ($$v) {_vm.$set(_vm.tableData[scope.$index], item.valueKey, $$v)},expression:"tableData[scope.$index][item.valueKey]"}})],1):_vm._e(),_vm._v(" "),(item.rfType==2)?_c('div',{ref:"formText",refInFor:true,class:{'width-100':_vm.isEdit},staticStyle:{"padding":"5px 8px"}},[(!_vm.isEdit)?_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.tableData[scope.$index][item.valueKey])))]):_c('el-input',{attrs:{"type":"textarea","rows":"1","width":"100"},model:{value:(_vm.tableData[scope.$index][item.valueKey]),callback:function ($$v) {_vm.$set(_vm.tableData[scope.$index], item.valueKey, $$v)},expression:"tableData[scope.$index][item.valueKey]"}})],1):_vm._e(),_vm._v(" "),(item.rfType==3||item.rfType==4)?_c('div',{ref:"formText",refInFor:true,class:{'width-100':_vm.isEdit},staticStyle:{"padding":"0 8px"}},[(_vm.isEdit)?_c('el-select',{attrs:{"clearable":"","placeholder":"请选择","multiple":item.rfType==4,"disabled":!_vm.isEdit,"width":"100"},model:{value:(_vm.tableData[scope.$index][item.valueKey]),callback:function ($$v) {_vm.$set(_vm.tableData[scope.$index], item.valueKey, $$v)},expression:"tableData[scope.$index][item.valueKey]"}},_vm._l((_vm.getOptions(item.rfTypeNames)),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1):_c('div',{staticStyle:{"overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.selectOption(_vm.tableData[scope.$index][item.valueKey]))))])],1):_vm._e(),_vm._v(" "),(item.rfType==5)?_c('div',{staticClass:"file-box",staticStyle:{"padding":"0 8px"}},[(_vm.tableData[scope.$index][item.valueKey])?_c('a',{staticClass:"file-style ellipsis-text",class:{'file-edit':_vm.isEdit},attrs:{"target":"_blank","href":_vm.getFilePath(_vm.tableData[scope.$index][item.valueKey])}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("\r\n            "+_vm._s(_vm.getFileName(_vm.tableData[scope.$index][item.valueKey]))+"\r\n          ")]):_c('p',[_vm._v("-")]),_vm._v("  \r\n          "),_vm._v(" "),(!_vm.tableData[scope.$index][item.valueKey]&&_vm.isEdit)?_c('v-file-upload',{attrs:{"number":1},on:{"onFileChange":function($event){return _vm.onFileChange(arguments,scope.$index,item.valueKey)}}}):_vm._e(),_vm._v(" "),(_vm.tableData[scope.$index][item.valueKey]&&_vm.isEdit)?_c('p',{on:{"click":function($event){return _vm.delFile(scope.$index,item.valueKey)}}},[_vm._v("删除")]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.rfType==6)?_c('div',{staticStyle:{"padding":"0 8px"}},[(_vm.isEdit)?_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","placeholder":"选择日期"},model:{value:(_vm.tableData[scope.$index][item.valueKey]),callback:function ($$v) {_vm.$set(_vm.tableData[scope.$index], item.valueKey, $$v)},expression:"tableData[scope.$index][item.valueKey]"}}):_c('p',{staticClass:"ellipsis-text"},[_vm._v(_vm._s(_vm._f("empty")(_vm.tableData[scope.$index][item.valueKey])))])],1):_vm._e()]}}],null,true)})}):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('el-table-column',{attrs:{"label":"操作","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.del(scope.$index)}}},[_vm._v("删除\r\n        ")])]}}],null,false,4249178818)}):_vm._e()],2),_vm._v(" "),(_vm.isEdit)?_c('p',{staticClass:"add-row",on:{"click":function($event){return _vm.add()}}},[_vm._v(" + 添加一行")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MluR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/userhead.d56b7c6.png";

/***/ }),

/***/ "N3Hy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NG10":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u14842.1d53dda.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__story___ = __webpack_require__("Zsfk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("jsbU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_clickoutside__ = __webpack_require__("Km6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_options__ = __webpack_require__("M7eE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components___ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fonts_font_protal_company2_iconfont_css__ = __webpack_require__("A4jK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_fonts_font_protal_company2_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_fonts_font_protal_company2_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_getData__ = __webpack_require__("i84Q");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);


// import './assets/fonts/font_protal_company/iconfont.css'




__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__components___["a" /* default */]).forEach(function (key) {
  var name = key.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  }); // 首字母大写
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v' + name, __WEBPACK_IMPORTED_MODULE_8__components___["a" /* default */][key]);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$checkPermissions = function (val) {

  // if (!sessionStorage['permissions']) { //todo 调试时打开
  //   return true;
  // }
  return JSON.parse(sessionStorage['permissions']).indexOf(val) > -1;
};

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  /* document.title = sessionStorage.getItem('channelNickname');*/
  if (to.path == '/login') {
    sessionStorage.clear();
    console.log("login", to.path);
    next();
  } else {
    console.log("check");
    //检查登录状态
    __WEBPACK_IMPORTED_MODULE_10__service_getData__["u" /* checkLogin */]().then(function (res) {
      if (res.data.code == 'success') {
        next();
      } else {
        next({ path: '/login' });
      }
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('clickoutside', //自定义点击元素范围外触发的指令
__WEBPACK_IMPORTED_MODULE_6__plugins_clickoutside__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__story___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NPIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp-box flex-direction-box"},[_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","border-bottom":"0","margin-top":"-10px","max-height":"100%"},attrs:{"data":_vm.serveList,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.servesListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.servesListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentFiled.assessmentFiledTheme","label":"考核主题","show-overflow-tooltip":"","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentFiled.assessmentFiledIndex","label":"考核指标","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentFiled.assessmentFiledScore","label":"考核标准分","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentFiled.assessmentFiledStandard","label":"评分标准","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"附件信息","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"disabled":!scope.row.assessmentFiled.assessmentFiledFile,"size":"mini","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.detail(scope.row, scope.$index)}}},[_vm._v("查看")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentCompanyFiled.assessmentCompanyFiledScore","label":"自评分","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentCompanyFiled.assessmentCompanyFiledIndex","label":"自评备注","show-overflow-tooltip":"","align":"center"}})],2),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"附件信息查看","visible":_vm.serverDetailDialog,"append-to-body":true,"width":"750px","center":"","top":"3%","close-on-click-modal":true},on:{"update:visible":function($event){_vm.serverDetailDialog=$event}}},[_c('div',{staticClass:"warp-box flex-direction-box"},[_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","border-bottom":"0","margin-top":"-10px","max-height":"100%"},attrs:{"data":_vm.fileList,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.servesListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.servesListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assessmentCompanyFileName","label":"附件名称","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"附件信息","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.preview(scope.row, scope.$index)}}},[_vm._v("预览")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.download(scope.row, scope.$index)}}},[_vm._v("下载")])]}}])})],2),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin":"10px 0"}},[_c('el-button',{attrs:{"type":"success","size":"mini","disabled":_vm.fileList.length == 0},on:{"click":_vm.allDownload}},[_vm._v("批量下载")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NlpI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_detail_vue__ = __webpack_require__("T6ba");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8d7030be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_detail_vue__ = __webpack_require__("oSCI");
function injectStyle (ssrContext) {
  __webpack_require__("9Bro")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d7030be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_8d7030be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O0c9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PF1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","label-position":"top"}},[_c('h3',{staticClass:"title"},[_vm._v("\n      审核信息：    \n    ")]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('span',[_vm._v("备案审核状态：")]),_vm._v(" "),(_vm.vrInfo.cviState==0)?_c('span',{staticClass:"g-blue"},[_vm._v("备案审核中")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.cviState==1)?_c('span',{staticClass:"g-green"},[_vm._v("备案成功")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.cviState==2)?_c('span',{staticClass:"g-red"},[_vm._v("备案被驳回")]):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('span',[_vm._v("审核时间：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviReviewTime))])])],1),_vm._v(" "),(_vm.vrInfo.cviState==2)?_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('span',[_vm._v("驳回原因：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviRejectPerson))])])],1):_vm._e()],1)],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("\n      基本信息：\n      ")]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n              企业名称：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviCompanyName))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              企业联系人：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviCompanyContactor))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              联系电话：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviTel))])])])],1)],1)],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("防疫信息：")]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              企业员工数：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviStaffNum))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              外地（非本省）员工数：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviNonlocalStaffNum))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              完成防疫登记员工数：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.registerStaff))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              重点疫区（湖北、温台地区）员工数：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviKeyAreaStaffNum))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              企业复工情况：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviIsRework?'已复工':'未复工'))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n              复工（包含预计）时间：\n              "),_c('span',[_vm._v(_vm._s(new Date(_vm.vrInfo.cviReworkTime).format("yyyy-MM-dd")))])])])],1),_vm._v(" "),(_vm.vrInfo.cviIsRework)?_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n              复工人数：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviRealReworkNum))])])])],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n              口罩等物资需求：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.cviMaterialDemand))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n              附件信息：\n              "),_vm._l((_vm.vrInfo.cviFileName),function(item,index){return _c('el-link',{key:index,staticStyle:{"display":"block","margin-left":"70px"},attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.downFile(_vm.vrInfo.cviFileUrl[index],item)}}},[_vm._v("附件"+_vm._s(index+1)+"："),_c('span',{staticStyle:{"color":"#09c","text-decoration":"underline"}},[_vm._v(_vm._s(item))])])})],2)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PFlM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-box"},[_c('div',{ref:"bannerBox",staticClass:"login-banner-box"},[_c('ul',{staticClass:"banner-box",style:({transform: ("translateX(-" + (_vm.activeId*_vm.Uwidth) + "px)"),width:_vm.Uwidth*((_vm.bannerList&&_vm.bannerList.length)?_vm.bannerList.length:1)+'px'})},_vm._l((_vm.bannerList),function(banner,bannerIndex){return _c('li',{key:bannerIndex,staticClass:"banner-item",style:({width:_vm.Uwidth+'px'})},[_c('img',{attrs:{"src":banner.url,"alt":""}})])}),0),_vm._v(" "),_c('ul',{staticClass:"banner-toggle-box"},_vm._l((_vm.bannerList),function(banner,bannerIndex){return _c('li',{staticClass:"banner-toggle-btn",class:{'active':_vm.activeId === bannerIndex},on:{"click":function($event){return _vm.activeBanner(banner,bannerIndex)}}})}),0)]),_vm._v(" "),_c('div',{staticClass:"login-right-box"},[_c('h3',{staticClass:"login-title"},[_vm._v("登录")]),_vm._v(" "),_c('ul',{staticClass:"login-nab flex-box"},[_c('li',{class:_vm.activeNab == 1? 'select-nab':'',on:{"click":function($event){_vm.activeNab = 1;_vm.getImgCode()}}},[_vm._v("手机号登录")]),_vm._v(" "),_c('li',{class:_vm.activeNab == 2? 'select-nab':'',on:{"click":function($event){_vm.activeNab = 2;_vm.getImgCode()}}},[_vm._v("账号密码登录")])]),_vm._v(" "),(_vm.activeNab == 1)?_c('el-form',{ref:"loginInfo",staticClass:"login-container",attrs:{"model":_vm.loginInfo,"rules":_vm.rules,"label-position":"left","label-width":"0px"}},[_c('el-form-item',{attrs:{"prop":"phone"}},[_c('div',{staticClass:"f-input-box"},[_c('div',{staticClass:"wh100 flex-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.phone),expression:"loginInfo.phone"}],staticClass:"input_inner",attrs:{"maxlength":"20","type":"text","placeholder":"手机号"},domProps:{"value":(_vm.loginInfo.phone)},on:{"focus":function($event){return _vm.adminBlur(1)},"blur":function($event){return _vm.adminBlur(2)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"f-line-box"},[(!_vm.adminState)?_c('span',{staticClass:"line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"focus-line",style:({ transform: 'scaleX('+_vm.adminDeg+')'})})])])]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"code"}},[_c('div',{staticClass:"f-input-box"},[_c('div',{staticClass:"f-input-box"},[_c('div',{staticClass:"wh100 flex-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.captchaValue),expression:"loginInfo.captchaValue"}],staticClass:"input_inner",attrs:{"maxlength":"10","type":"text","placeholder":"图形验证码"},domProps:{"value":(_vm.loginInfo.captchaValue)},on:{"focus":function($event){return _vm.imgBlur(1)},"blur":function($event){return _vm.imgBlur(2)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "captchaValue", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"f-line-box"},[(!_vm.imgDeg)?_c('span',{staticClass:"line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"focus-line",style:({ transform: 'scaleX('+_vm.imgDeg+')'})})])]),_vm._v(" "),(_vm.imgCode)?_c('img',{staticClass:"g-pass-btn",staticStyle:{"height":"34px","margin-left":"10px","width":"auto"},attrs:{"src":_vm.imgCode,"alt":""},on:{"click":_vm.getImgCode}}):_vm._e()])]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"phoneCode"}},[_c('div',{staticClass:"f-input-box",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"wh100 flex-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.phoneCode),expression:"loginInfo.phoneCode"}],staticClass:"input_inner",attrs:{"type":"text","placeholder":"请输入验证码"},domProps:{"value":(_vm.loginInfo.phoneCode)},on:{"focus":function($event){return _vm.passwordBlur(1)},"blur":function($event){return _vm.passwordBlur(2)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "phoneCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"f-line-box"},[(!_vm.passwordState)?_c('span',{staticClass:"line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"focus-line",style:({transform:'scaleX('+_vm.passwordDeg+')'})})]),_vm._v(" "),(!_vm.getCoding)?_c('el-button',{staticClass:"g-pass-btn",attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.getCode.apply(null, arguments)}}},[_vm._v("获取验证码")]):_c('el-button',{staticClass:"g-pass-btn",attrs:{"type":"primary","disable":""}},[_vm._v("剩余"+_vm._s(_vm.resend)+"s")])],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"10px"}})])],1):_vm._e(),_vm._v(" "),(_vm.activeNab == 2)?_c('el-form',{ref:"loginInfo",staticClass:"login-container",attrs:{"model":_vm.loginInfo,"rules":_vm.rules,"label-position":"left","label-width":"0px"}},[_c('el-form-item',{attrs:{"prop":"mhManagerAccount"}},[_c('div',{staticClass:"f-input-box"},[_c('div',{staticClass:"wh100 flex-box"},[_c('img',{attrs:{"src":__webpack_require__("BEeY"),"alt":""}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.mhManagerAccount),expression:"loginInfo.mhManagerAccount"}],staticClass:"input_inner",attrs:{"maxlength":"20","type":"text","placeholder":"请输入账号"},domProps:{"value":(_vm.loginInfo.mhManagerAccount)},on:{"focus":function($event){return _vm.adminBlur(1)},"blur":function($event){return _vm.adminBlur(2)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "mhManagerAccount", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"f-line-box"},[(!_vm.adminState)?_c('span',{staticClass:"line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"focus-line",style:({ transform: 'scaleX('+_vm.adminDeg+')'})})])])]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"mhManagerPassword"}},[_c('div',{staticClass:"f-input-box",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"wh100 flex-box"},[_c('img',{attrs:{"src":__webpack_require__("Gt+G"),"alt":""}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.mhManagerPassword),expression:"loginInfo.mhManagerPassword"}],staticClass:"input_inner",attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.loginInfo.mhManagerPassword)},on:{"focus":function($event){return _vm.passwordBlur(1)},"blur":function($event){return _vm.passwordBlur(2)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "mhManagerPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"f-line-box"},[(!_vm.passwordState)?_c('span',{staticClass:"line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"focus-line",style:({transform:'scaleX('+_vm.passwordDeg+')'})})])]),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"10px"}})])],1):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"f-login-btn",attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("登录\n        ")]),_vm._v(" "),_vm._m(1)],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"请选择登录企业","visible":_vm.chooseCompanyDialog,"append-to-body":true,"width":"700px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.chooseCompanyDialog=$event}}},[(_vm.chooseCompanyDialog)?_c('v-switch-company',{attrs:{"companyIcList":_vm.companyIcList},on:{"closeDialog":function($event){_vm.chooseCompanyDialog=false;_vm.$router.push('/workbench');}}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__("PsVU"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forget-password-box"},[_c('span',[_vm._v("若您缺少或遗忘账号信息，请及时联系管理员获取")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PQtR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PsVU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.bdb96d5.png";

/***/ }),

/***/ "QKXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_batch_import_vue__ = __webpack_require__("CAQ3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_fb9f5308_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_batch_import_vue__ = __webpack_require__("UyeE");
function injectStyle (ssrContext) {
  __webpack_require__("F6PB")
  __webpack_require__("ddoJ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb9f5308"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_batch_import_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_fb9f5308_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_batch_import_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QZww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","label-position":"top"}},[(this.activeId==1)?_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                园区通行码：\n              ")]),_vm._v(" "),_c('el-col',[_c('el-row',{attrs:{"type":"flex","align":"bottom"}},[_c('div',{staticStyle:{"width":"74px","height":"74px","margin-right":"10px"}},[_c('img',{staticStyle:{"width":"100%","object-fit":"contain"},attrs:{"src":_vm.imgUrl,"alt":""}})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.dowloadImg.apply(null, arguments)}}},[_vm._v("下 载")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                通行码状态：\n                "),(_vm.healthCode.healthCodeType==1)?_c('span',{staticClass:"green"},[_vm._v("自由通行")]):_vm._e(),_vm._v(" "),(_vm.healthCode.healthCodeType==2)?_c('span',{staticClass:"red"},[_vm._v("受限制")]):_vm._e()]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v("\n                档案编码：\n                "),_c('span',[_vm._v(_vm._s(_vm.healthCode.healthCodeContent))])])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("\n        基本信息：\n        "),_c('span',{staticClass:"title-label-right"},[_vm._v(_vm._s(_vm.vrInfo.erCreateTime)+" 登记")])]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                姓名：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.baseName))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                户籍地址：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.baseProvince)+" - "+_vm._s(_vm.vrInfo.baseCity)+" - "+_vm._s(_vm.vrInfo.baseDistrict))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n                所在企业：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.baseCompanyName))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                手机号码：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.basePhone))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                身份证号码：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.baseIdcrad))])])])],1)],1),_vm._v(" "),_c('el-col',{staticClass:"g-basic-info",staticStyle:{"border-top":"1px solid #eee"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                是否返回工作所在地：\n                "),(_vm.vrInfo.erIsReturn==1)?_c('span',{staticClass:"font-blod"},[_vm._v("已返回")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erIsReturn==2)?_c('span',{staticClass:"font-blod"},[_vm._v("未返回")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erIsReturn==3)?_c('span',{staticClass:"font-blod"},[_vm._v("未离开")]):_vm._e()])]),_vm._v(" "),(_vm.vrInfo.erIsReturn!=3)?_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                返程时间：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erReturnTime?new Date(_vm.vrInfo.erReturnTime).format("yyyy-MM-dd"):''))])])]):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                假期所在地区：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erHolidayProvince)+" - "+_vm._s(_vm.vrInfo.erHolidayCity)+" - "+_vm._s(_vm.vrInfo.erHolidayDistrict))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                假期所在地居住地址：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erHolidayAddress))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("\n                工作地居住地址：\n                "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erLocation))])])])],1)],1)],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("防疫信息：")]),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              假期使用通勤工具：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erIsAirplane==1?'飞机':'')+" "+_vm._s(_vm.vrInfo.erIsBulletTrain==1?'动车':'')+" "+_vm._s(_vm.vrInfo.erIsBus==1?'客车':'')+" "+_vm._s(_vm.vrInfo.erIsPrivateCar==1?'私家车':''))])]),_vm._v(" "),(_vm.vrInfo.erIsAirplane==1)?_c('p',{staticClass:"item"},[_vm._v("\n              航班号:\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erFlightNumber))])]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erIsBulletTrain==1)?_c('p',{staticClass:"item"},[_vm._v("\n              动车班次:\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erTrainService))])]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erIsBus==1)?_c('p',{staticClass:"item"},[_vm._v("\n              客车班次:\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erBusNumber))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              本人是否有发热、乏力、干咳等症状：\n              "),(_vm.vrInfo.erHealth==1)?_c('span',{staticClass:"green"},[_vm._v("无")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erHealth==2)?_c('span',{staticClass:"red"},[_vm._v("有")]):_vm._e()]),_vm._v(" "),(_vm.vrInfo.erHealth==2)?_c('p',{staticClass:"item"},[_vm._v("\n              症状描述：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erHealthRemark))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              家人、同住、邻居是否有发热、乏力、干咳等症状：\n              "),(_vm.vrInfo.erFamilyHealth==1)?_c('span',{staticClass:"green"},[_vm._v("无")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erFamilyHealth==2)?_c('span',{staticClass:"red"},[_vm._v("有")]):_vm._e()]),_vm._v(" "),(_vm.vrInfo.erFamilyHealth==2)?_c('p',{staticClass:"item"},[_vm._v("\n              症状描述：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erFamilyHealthRemark))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              是否有新型冠状感染者（包括疑似病例）接触史：\n              "),(_vm.vrInfo.erContactHistory==1)?_c('span',{staticClass:"green"},[_vm._v("无")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erContactHistory==2)?_c('span',{staticClass:"red"},[_vm._v("有")]):_vm._e()]),_vm._v(" "),(_vm.vrInfo.erContactHistory==2)?_c('p',{staticClass:"item"},[_vm._v("\n              情况描述：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erContactHistoryRemark))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              是否有疫区（湖北、温州等地区）停留史：\n              "),(_vm.vrInfo.erContact==1)?_c('span',{staticClass:"green"},[_vm._v("无")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erContact==2)?_c('span',{staticClass:"red"},[_vm._v("有")]):_vm._e()]),_vm._v(" "),(_vm.vrInfo.erContact==2)?_c('p',{staticClass:"item"},[_vm._v("\n              情况描述：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erContactRemark))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              是否已按工作属地政策需求，完成居家隔离7/14天：\n              "),(_vm.vrInfo.erIsIsolation==2)?_c('span',{staticClass:"red"},[_vm._v("无")]):_vm._e(),_vm._v(" "),(_vm.vrInfo.erIsIsolation==1)?_c('span',{staticClass:"green"},[_vm._v("有")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('p',{staticClass:"item"},[_vm._v("\n              其它备注信息：\n              "),_c('span',[_vm._v(_vm._s(_vm.vrInfo.erOtherRemark))])])])])],1),_vm._v(" "),(this.activeId==1)?_c('h3',{staticClass:"title"},[_vm._v("隔离登记信息：")]):_vm._e(),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.quarantine==null&&this.activeId==1),expression:"quarantine==null&&this.activeId==1"}],staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":20}},[_c('p',{staticClass:"quarantine-condition",staticStyle:{"color":"#008000"}},[_vm._v("未进行隔离登记")])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();_vm.quarantineRegisterAddDialog=true}}},[_vm._v("隔离登记")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.quarantine!=null&&this.activeId==1),expression:"quarantine!=null&&this.activeId==1"}],staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('el-col',{attrs:{"span":13}},[_c('p',{staticClass:"quarantine-condition",staticStyle:{"color":"#FF0000"}},[_vm._v("隔离中")])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.relieveTheIsolation.apply(null, arguments)}}},[_vm._v("解除隔离登记")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.editTheIsolation.apply(null, arguments)}}},[_vm._v("编辑隔离登记")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                隔离方式：\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.quarantineInfo.quarantineWay==1),expression:"quarantineInfo.quarantineWay==1"}]},[_vm._v("自我隔离")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.quarantineInfo.quarantineWay==2),expression:"quarantineInfo.quarantineWay==2"}]},[_vm._v("强制隔离")])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                隔离登记时间：\n                "),_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.quarantineStartTime))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                隔离开始时间：\n                "),_c('span',[_vm._v(_vm._s(new Date(_vm.quarantineInfo.quarantineStartTime).format("yyyy-MM-dd")))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                隔离结束时间：\n                "),_c('span',[_vm._v(_vm._s(new Date(_vm.quarantineInfo.quarantineEndTime).format("yyyy-MM-dd")))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                隔离时间：\n                "),_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.quarantineDays))]),_vm._v("天\n              ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                登记人：\n                "),(_vm.quarantineInfo.companyName)?_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.companyName)+" - "+_vm._s(_vm.quarantineInfo.quarantineAdminName))]):_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.quarantineAdminName))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                监管负责人：\n                "),_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.quarantinePerson))])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                情况描述：\n                "),_c('span',[_vm._v(_vm._s(_vm.quarantineInfo.quarantineDescription))])])])],1)],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"隔离登记","visible":_vm.isolationDialog,"width":"400px","center":"","append-to-body":"","mini":""},on:{"update:visible":function($event){_vm.isolationDialog=$event}}},[_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"info-item"},[_c('p',{staticStyle:{"padding":"15px"}},[_vm._v("该员工已进行隔离登记，是否更新隔离登记记录？")])])])],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRelieve),expression:"isRelieve"}],staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"info-item"},[_c('p',{staticStyle:{"padding":"20px"}},[_vm._v("是否确认解除该员工的隔离登记记录")])])])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.isolationDialog = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEdit),expression:"isEdit"}],attrs:{"type":"primary"},on:{"click":_vm.quarantineRegisterEdit}},[_vm._v("更新隔离登记")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRelieve),expression:"isRelieve"}],attrs:{"type":"primary"},on:{"click":_vm.relieve}},[_vm._v("解除")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"隔离登记","visible":_vm.quarantineRegisterAddDialog,"width":"650px","center":"","top":"3%","append-to-body":""},on:{"update:visible":function($event){_vm.quarantineRegisterAddDialog=$event}}},[(_vm.quarantineRegisterAddDialog)?_c('v-quarantine-register-add',{attrs:{"id":_vm.id,"baseId":_vm.baseId},on:{"init":_vm.init,"closeDialog":function($event){_vm.quarantineRegisterAddDialog= false}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qgp7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_ORDERFLOWADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_ORDERFLOWACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOW_HOUSE_INFO; });
var SAVE_ORDERFLOWADD = 'SAVE_ORDERFLOWADD';
var SAVE_ORDERFLOWACTIVE = 'SAVE_ORDERFLOWACTIVE';
var SHOW_HOUSE_INFO = 'SHOW_HOUSE_INFO';

/***/ }),

/***/ "RNLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_order_info_vue__ = __webpack_require__("zz7O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_aaf1e0de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_order_info_vue__ = __webpack_require__("rESV");
function injectStyle (ssrContext) {
  __webpack_require__("DUfg")
  __webpack_require__("6eFA")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaf1e0de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_order_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_aaf1e0de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_order_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RfWQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rq+b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("uaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sm4__ = __webpack_require__("uiVz");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var isAccountCorrect = function isAccountCorrect(rule, value, callback) {
      var myReg = /^\S+$/;
      if (!value) {
        return callback(new Error('账号不能为空！'));
      }
      if (!myReg.test(value)) {
        return callback(new Error('账号不能包含空白字符！'));
      } else {
        callback();
      }
    };
    var isTypeCorrect = function isTypeCorrect(rule, value, callback) {
      var myReg = /^\S+$/;
      if (!value) {
        return callback(new Error('密码不能为空！'));
      }
      if (!myReg.test(value)) {
        return callback(new Error('密码不能包含空白字符！'));
      } else {
        callback();
      }
    };
    return {
      logining: false,
      adminState: false,
      passwordState: false,
      imgState: false,
      imgDeg: 0,
      adminDeg: 0,
      passwordDeg: 0,
      loginInfo: {
        phone: '',
        captchaValue: '',
        phoneCode: '',
        mhManagerAccount: '',
        mhManagerPassword: ''
      },
      channelId: '',
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }, { pattern: global.phoneRule, message: '手机号格式错误' }],
        phoneCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        mhManagerAccount: [{ required: true, validator: isAccountCorrect, trigger: 'blur' }],
        mhManagerPassword: [{ required: true, validator: isTypeCorrect, trigger: 'blur' }]
      },
      checked: true,
      domain: '',
      bannerList: [{
        url: '../../static/newLogoImg/banner1.png'
      }, {
        url: '../../static/newLogoImg/banner2.png'
      }, {
        url: '../../static/newLogoImg/banner3.png'
      }],
      activeId: 0,
      Uwidth: 440,
      sendCodeTime: null,
      resend: 180,
      getCoding: false,
      companyIcList: [],
      chooseCompanyDialog: false,
      activeNab: 1,
      imgCode: '',
      captchaKey: ''
    };
  },
  beforeCreate: function beforeCreate() {
    sessionStorage.clear();
    localStorage.clear();
  },
  mounted: function mounted() {
    var _this = this;

    this.getImgCode();
    __WEBPACK_IMPORTED_MODULE_1__service_getData__["_10" /* getChannelIdByUrl */](__WEBPACK_IMPORTED_MODULE_2__config_env__["b" /* ossUrl */] + '/').then(function (res) {
      sessionStorage.setItem('channelId', res.data.channelId);
      // sessionStorage.setItem('companyId', res.data.companyId);
      sessionStorage.setItem('logoUrl', res.data.channelLogoUrl);
      sessionStorage.setItem('channelMortarBackUrl', res.data.channelMortarBackUrl);
      _this.channelId = res.data.channelId;
    });
    var bannerBox = this.$refs.bannerBox;
    if (!bannerBox || !bannerBox.offsetWidth) {
      return;
    }
    this.Uwidth = bannerBox.offsetWidth;
    this.setBannerTimeOut();
  },

  methods: {
    getImgCode: function getImgCode() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_50" /* mhManagergCaptcha */]().then(function (res) {
        _this2.imgCode = res.data.data.imageData;
        _this2.captchaKey = res.data.data.captchaKey;
      });
    },
    activeBanner: function activeBanner(row, index) {
      this.activeId = index;
      this.setBannerTimeOut();
    },
    setBannerTimeOut: function setBannerTimeOut() {
      var _this3 = this;

      if (this.bannerTimeOut) {
        clearTimeout(this.bannerTimeOut);
      }
      this.bannerTimeOut = setTimeout(function () {
        _this3.activeId += 1;
        if (_this3.activeId >= 2) {
          _this3.activeId = 0;
        }
        _this3.setBannerTimeOut();
      }, 5000);
    },
    adminBlur: function adminBlur(type) {
      if (type == 1) {
        this.adminState = true;
        this.adminDeg = 1;
      } else {
        this.adminState = false;
        this.adminDeg = 0;
      }
    },
    imgBlur: function imgBlur(type) {
      if (type == 1) {
        this.imgState = true;
        this.imgDeg = 1;
      } else {
        this.imgState = false;
        this.imgDeg = 0;
      }
    },
    passwordBlur: function passwordBlur(type) {
      if (type == 1) {
        this.passwordState = true;
        this.passwordDeg = 1;
      } else {
        this.passwordState = false;
        this.passwordDeg = 0;
      }
    },
    addMouseFun: function addMouseFun() {},
    handleSubmit: function handleSubmit(ev) {
      var _this4 = this;

      if (!this.channelId) {
        this.$router.go(0);
        this.$message({ message: '登录失败', type: 'warning' });
        return;
      }
      if ((!this.loginInfo.phone || !this.loginInfo.phoneCode) && this.activeNab == 1) {
        return;
      }
      if ((!this.loginInfo.mhManagerAccount || !this.loginInfo.mhManagerPassword) && this.activeNab == 2) {
        return;
      }
      this.$refs.loginInfo.validate(function (valid) {
        if (valid) {
          _this4.logining = true;
          var data = {};
          if (_this4.activeNab == 1) {
            data = {
              mhManagerChannelId: _this4.channelId,
              phone: _this4.loginInfo.phone,
              phoneCode: _this4.loginInfo.phoneCode
            };
          } else if (_this4.activeNab == 2) {
            var sm4 = new __WEBPACK_IMPORTED_MODULE_3__config_sm4__["a" /* default */]('qawsedrftgyhujik');
            data = {
              mhManagerChannelId: _this4.channelId,
              mhManagerAccount: encodeURIComponent(sm4.encryptData_ECB(_this4.loginInfo.mhManagerAccount)),
              mhManagerPassword: encodeURIComponent(sm4.encryptData_ECB(_this4.loginInfo.mhManagerPassword)),
              flag: 2
            };
          }
          __WEBPACK_IMPORTED_MODULE_1__service_getData__["_44" /* login */](data).then(function (res) {
            _this4.logining = false;
            if (res.data.code == 'success') {
              _this4.$message({
                message: '登录成功',
                type: 'success'
              });
              //sessionStorage.setItem('logoUrl', res.data.data.logoUrl);
              sessionStorage.setItem('permissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.data.permissions));
              sessionStorage.setItem('allSessionId', res.data.data.allSessionId);
              sessionStorage.setItem('companyId', res.data.data.companyId);
              _this4.userCompanyList();
            } else {
              _this4.$message({
                message: res.data.message,
                type: 'warning'
              });
            }
          }).catch(function (_) {
            _this4.$message.warning('登录失败！');
            _this4.logining = false;
          });
        } else {
          console.log('error submit!!');
          _this4.logining = false;
          return false;
        }
      });
    },
    userCompanyList: function userCompanyList() {
      var _this5 = this;

      //获取账号归属公司
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_86" /* userCompanyList */]().then(function (res) {
        if (res.data.code != 1) {
          return;
        }
        _this5.companyIcList = res.data.data;
        if (_this5.companyIcList.length > 1) {
          _this5.chooseCompanyDialog = true;
          _this5.$store.state.showSwitchCompany = true;
        } else {
          _this5.$router.push('/workbench');
        }
      }).catch(function (_) {});
    },
    getCode: function getCode() {
      //发送验证码
      if (this.getCoding) {
        return;
      }
      if (!this.loginInfo.phone) {
        this.$message.warning('请输入手机号码!');
      } else if (!this.loginInfo.captchaValue) {
        this.$message.warning('请输入图形验证码!');
      } else {
        this.getCoding = true;
        this.sendPhoneMsg();
      }
    },
    sendPhoneMsg: function sendPhoneMsg() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_75" /* sendCodeMsg */]({ phone: this.loginInfo.phone, type: 2, codeState: 0, channelId: this.channelId, captchaKey: this.captchaKey, captchaValue: this.loginInfo.captchaValue }).then(function (res) {
        if (res.data.code != 'success') {
          _this6.$message.error(res.data.message || res.data.Msg);
          _this6.getCoding = false;
          return;
        }
        _this6.resendCode();
        _this6.$message.success('验证码发送成功，请注意查收！');
      }).catch(function (_) {
        _this6.$message.warning('验证码获取失败！');
        _this6.getCoding = false;
      });
    },
    resendCode: function resendCode() {
      var _this7 = this;

      if (this.sendCodeTime) {
        clearTimeout(this.sendCodeTime);
      }
      this.sendCodeTime = setTimeout(function () {
        if (_this7.resend <= 0) {
          _this7.resend = 180;
          _this7.getCoding = false;
          return;
        }
        _this7.resend--;
        _this7.resendCode();
      }, 1000);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("9AUj")))

/***/ }),

/***/ "SJ5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"demo-ruleForm dialog_form",staticStyle:{"max-height":"370px","overflow":"auto"}},[(_vm.activities.length==0)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("暂无操作记录")]):_vm._e(),_vm._v(" "),_c('el-timeline',_vm._l((_vm.activities),function(item,index){return _c('el-timeline-item',{key:index,attrs:{"color":"#2482FD"}},[_c('div',{staticClass:"time-line-box"},[_c('div',{staticClass:"time-line-info"},[_c('div',[_c('i',{staticClass:"el-icon-alarm-clock"}),_vm._v("\n                "+_vm._s(_vm._f("datetime")(item.rlTime))+"\n              ")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"el-icon-user"}),_vm._v(" \n                操作人："+_vm._s(item.rlPerson)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"time-line-content"},[_vm._v("\n              "+_vm._s(item.rlLog)+"\n            ")])])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"text-right box-top-sh",staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.filters.pageIndex,"page-sizes":[10, 20, 50, 100],"background":true,"page-size":_vm.filters.pageSize,"layout":"prev, pager, next, sizes","total":_vm.filters.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"success"},on:{"click":_vm.close}},[_vm._v("确认")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SYVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue__ = __webpack_require__("LFfr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      problemAddDialog: false,
      accountDialog: false,
      detailsDialog: false,
      matterDetailDialog: false,
      matterHandleDialog: false,
      serverDetailDialog: false,
      serveId: "",
      matterCompanyStatus: "",
      matterId: "",
      matterCompanyId: "",
      noticeList: [],
      currUser: {},
      backlogNum: "",
      needCheckNum: "",
      systemNum: "",
      unreadNum: "",
      matterCompaniesList: [],
      matterInfo: {},
      notifyInfo: {},
      handleLoading: false,
      refuseVisible: false,
      formVisible: false,
      confirmPassLoading: false,

      processList: [],
      workflow: {},
      workflowApplication: {},
      fileList: [], //提交的文件列表数组数据
      itemDetailVisible: false, //查看项目详情显隐控制

      detailVisible: false, //查看消息详情显隐控制
      chooseTypeId: 0, //当前所选中消息类型id
      chooseItem: "", //点击详情所选中的项目
      isOnDetail: false, //是否点击详情页，点击删除icon时使用，以便于隐藏对话框
      chooseItemIndex: 0, //当前详情在messageList中的index值,以便于点击详情中下一条消息时计算索引，+1即可
      chooseItemNextTitle: "", //详情页下一个消息标题
      isLastTitle: false, //详情页消息标题是否为最后一个

      matterCompanyFileList: [],
      mhRoleName: "",
      companyName: "",
      mhManagerHeadThumb: "",
      mhManagerName: "",
      asideList: [{
        name: "园区公告",
        id: 1
      }, {
        name: "系统通知",
        id: 2
      }],
      activeId: 1,
      examineList: [],
      shortcutEntry: [],
      editDialog: false,
      messageList: [],
      formData: { //认证通过表单数据
        userName: "",
        userMobile: "",
        userPermission: 1
      },
      getMessage: {
        messageTitle: "",
        messageTypeDes: "",
        messageCreateTime: "",
        getMessage: ""
      },
      notifyId: ''
    };
  },
  created: function created() {},

  components: {
    problemAdd: __WEBPACK_IMPORTED_MODULE_2__vue__["a" /* default */]
  },
  computed: {
    getProgressActive: function getProgressActive() {
      //根据接口返回数据设置步骤条当前状态
      var status = 0;
      for (var i = 0; i < this.processList.length; i++) {
        if (this.processList[i].workflowApplicationProcessStatus) {
          status++;
        }
      }
      return status;
    }
  },
  mounted: function mounted() {
    this.noticeInit();
    /*园区通知*/
    this.message();
    /*工作提醒*/
    this.indexDateInit();
    /*header*/
    this.matterInit();
    /*我的事项*/
    this.getCompanyList();
    /*注册审核*/
    this.findEntranceByChannel();
    /*快捷入口*/
  },

  methods: {
    getColorType: function getColorType(val) {
      switch (val) {
        case 2:
          return "f-green";
        case 3:
          return "f-blue";
        default:
          return val;
      }
    },
    downloadFile: function downloadFile(row, index) {
      if (!row.notifyFileUrl || !row.notifyFileName) {
        this.$message({
          type: "warning",
          message: "下载地址不存在！"
        });
        return;
      }
      if (row.notifyFileId) {
        window.location.href = "/company/notify/downloadFile?notifyFileId=" + row.notifyFileId;
      } else {
        window.location.href = "/company/notify/downloadFile?notifyFileUrl=" + row.notifyFileUrl + "&notifyFileName=" + row.notifyFileName;
      }
    },
    downLoadWorkFile: function downLoadWorkFile(file) {
      window.open('/company/download/downloadWorkflowFileUseName?fileName=' + file.workflowFileName + '&fileUrl=' + file.workflowFileUrl);
    },
    checkUndefined: function checkUndefined(val) {
      switch (val) {
        case undefined:
        case "undefined":
        case null:
        case "null":
        case "":
          return "";
        default:
          return val;
      }
    },
    goJumpPages: function goJumpPages(permissionVal, type) {
      if (this.$checkPermissions(permissionVal)) {
        if (type == 1) {
          this.$router.push('/messageNotification');
        } else if (type == 2) {
          this.$router.push('/fileUploadManage');
        } else if (type == 3) {
          this.$router.push('/peopleManage');
        } else if (type == 4) {
          this.$router.push('/notification');
        }
      } else {
        this.$message.warning("抱歉！你没有该权限！");
      }
    },
    onApplyNow: function onApplyNow(row, index) {
      if (row.entranceType === 1) {
        if (row.permissionVal) {
          if (this.$checkPermissions(row.permissionVal)) {
            if (row.fixedOptionType === 1) {
              this.problemAddDialog = true;
            } else {
              this.$router.push({ path: row.entranceUrl, query: { type: 1 } });
            }
          } else {
            this.$message.warning("抱歉！你没有该权限！");
          }
        }
      } else if (row.entranceType === 2) {
        if (this.$checkPermissions("serve_list")) {
          this.serveId = row.entranceCurrId;
          this.serverDetailDialog = true;
        } else {
          this.$message.warning("抱歉！你没有该权限！");
        }
      } else if (row.entranceType === 3) {
        if (this.$checkPermissions("add_workflow")) {
          this.$store.state.applyItem = row.workflowVO;
          this.$router.push({ path: "/addApplication", query: { type: 1, index: index } });
        } else {
          this.$message.warning("抱歉！你没有该权限！");
        }
      }
    },
    activeNotice: function activeNotice(row, index) {
      this.activeId = row.id;
      if (row.id === 2) {
        this.message();
      } else {
        this.noticeInit();
      }
    },
    onDetail: function onDetail(item) {
      var _this = this;

      if (this.$checkPermissions('message_notify')) {
        this.chooseItem = item;
        console.log(item);
        this.isOnDetail = true;
        __WEBPACK_IMPORTED_MODULE_0__service_getData__["_21" /* getMessage */](item.messageId).then(function (res) {
          if (res.data.code === "success") {
            _this.getMessage = res.data.data.message;
            _this.messageList.forEach(function (listItem) {
              if (listItem.messageId === item.messageId) {
                var index = _this.messageList.indexOf(listItem);
                _this.chooseItemIndex = index;
                if (index < _this.messageList.length - 1) {
                  _this.isLastTitle = false;
                  _this.chooseItemNextTitle = _this.messageList[index + 1].messageTitle;
                } else {
                  _this.isLastTitle = true;
                  _this.chooseItemNextTitle = "没有更多的消息";
                  console.log(_this.isLastTitle);
                }
              }
            });
            _this.detailVisible = true;
          }
        });
      } else {
        this.$message.warning("抱歉！你没有该权限！");
      }
    },
    onDetailClose: function onDetailClose() {
      this.isOnDetail = false;
      this.message();
      this.indexDateInit();
    },
    onDetailDelete: function onDetailDelete() {
      this.onDelete(this.chooseItem);
    },
    onDownLoad: function onDownLoad(url) {
      window.open(url);
    },
    onNextMessage: function onNextMessage() {
      if (this.chooseItemIndex === this.messageList.length - 1) {
        this.$message.info("已经是最后一条消息");
      } else {
        var nextItem = this.messageList[this.chooseItemIndex + 1];
        this.onDetail(nextItem);
      }
    },
    onDelete: function onDelete(item) {
      var _this2 = this;

      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancleButtonText: "取消",
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__service_getData__["G" /* deleteMessage */](item.messageId).then(function (res) {
          if (res.data.code === "success") {
            _this2.$message({
              type: "success",
              message: "删除成功！"
            });
            if (_this2.isOnDetail === true) {
              _this2.isOnDetail = false;
              _this2.detailVisible = false;
            }
            _this2.message();
            _this2.indexDateInit();
          } else {
            _this2.$message.info("删除失败");
          }
        });
      }).catch(function (_) {});
    },
    onItemDetail: function onItemDetail(itemId) {
      // 控制项目具体细节
      // getData.getWorkflowApplication(itemId).then(res => {
      //   if (res.data.code === "success") {
      //     this.processList = res.data.data.processList;
      //     this.workflow = res.data.data.workflow;
      //     this.workflowApplication = res.data.data.workflowApplication;
      //     this.fileList = res.data.data.fileList;
      //     this.itemDetailVisible = true;
      //   } else {
      //     this.$message.info("数据获取失败！");
      //   }
      // });
      this.$router.push(this.getMessage.route);
    },
    onItemDetailClose: function onItemDetailClose() {
      this.processList = [];
      this.workflow = {};
      this.workflowApplication = {};
      this.fileList = [];
      this.itemDetailVisible = false;
    },
    onConfirm: function onConfirm() {
      var _this3 = this;

      this.$confirm("是否确认该申请流程已完成？", "", {
        confirmButtonText: "确定",
        cancleButtonText: "取消",
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__service_getData__["_93" /* workflowApplicationSure */](id).then(function (res) {
          if (res.data.code === "success") {
            _this3.$message({
              type: "success",
              message: "确认成功！"
            });
            _this3.init();
          } else {
            _this3.$message({
              type: "error",
              message: res.data.message
            });
          }
        });
      });
      this.onItemDetailClose();
    },
    cancel: function cancel() {
      this.onItemDetailClose();
    },
    examine: function examine(row, index, type) {
      this.userId = row.userId;
      // this.onConfirmPass();
      this.formData.userName = row.userName;
      this.formData.userMobile = row.userMobile;
      this.userPostionState = row.userPostionState;
      this.formVisible = true;
    },
    noticeInit: function noticeInit() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_42" /* listNotify */](1, 10, "", "").then(function (res) {
        if (res.data.code == "success") {
          _this4.noticeList = res.data.data.list ? res.data.data.list : [];
        }
      });
    },
    indexDateInit: function indexDateInit() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_37" /* indexDate */]().then(function (res) {
        if (res.data.code == "success") {
          var datas = res.data.data;
          _this5.companyName = datas.companyName;
          _this5.mhManagerHeadThumb = _this5.checkUndefined(datas.mhManagerHeadThumb);
          _this5.backlogNum = datas.BacklogNum;
          _this5.needCheckNum = datas.needCheckNum;
          _this5.systemNum = datas.systemNum;
          _this5.unreadNum = datas.unreadNum;
          _this5.mhManagerName = datas.mhManagerName;
          _this5.mhRoleName = datas.mhRoleName;
        }
      });
    },
    message: function message() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_48" /* messageList */](1, 10, 0).then(function (res) {
        if (res.data.code === "success") {
          _this6.messageInfoData = res.data.data;
          _this6.messageList = res.data.data.messageList;
        }
      });
    },
    matterInit: function matterInit() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_41" /* listMatterCompany */](1, 10, "", "", "").then(function (res) {
        if (res.data.code == "success") {
          _this7.matterCompaniesList = res.data.data.matterCompanies ? res.data.data.matterCompanies : [];
        }
      });
    },
    handle: function handle(row, index) {
      // this.matterCompanyStatus = row.matterCompanyStatus;
      // this.matterCompanyId = row.matterCompanyId;
      // this.matterId = row.matterCompanyId;
      // this.matterHandleDialog = true;
      this.$router.push({
        path: "/fileHandle", query: {
          type: 0,
          matterCompanyId: row.matterCompanyId,
          matterId: row.matterCompanyId
        }
      });
    },
    editThing: function editThing(row, index) {
      this.matterCompanyStatus = row.matterCompanyStatus;
      this.matterCompanyId = row.matterCompanyId;
      this.matterId = row.matterCompanyId;
      this.matterDetailDialog = true;
    },
    getfileList: function getfileList(matterCompanyId) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_40" /* listFilesByMatterCompanyId */](matterCompanyId).then(function (res) {
        if (res.data.code == "success") {
          _this8.matterCompanyFileList = res.data.data.matterCompanyFileList;
          _this8.fileList = [];
          _this8.editDialog = true;
        }
      });
    },
    getCompanyList: function getCompanyList() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_52" /* mhUserList */](1, 10, -1, "", "").then(function (res) {
        if (res.data.code == "success") {
          _this9.examineList = res.data.data.list;
        }
      }).catch(function (_) {});
    },
    findEntranceByChannel: function findEntranceByChannel() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_1" /* findEntranceByChannel */]().then(function (res) {
        if (res.data.code === "success") {
          _this10.shortcutEntry = res.data.data.entranceList;
        }
      });
    },
    onConfirmRefuse: function onConfirmRefuse() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_54" /* noPassMhUser */](this.userId).then(function (res) {
        if (res.data.code === "success") {
          _this11.$message.success("驳回成功！");
          _this11.formVisible = false;
          _this11.getCompanyList();
        }
      });
    },
    onConfirmPass: function onConfirmPass() {
      var _this12 = this;

      this.confirmPassLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_63" /* passMhUser */](this.userId, this.formData.userPermission, this.formData.userMobile, this.formData.userName).then(function (res) {
        if (res.data.code === "success") {
          _this12.$message.success("通过成功！");
          _this12.formVisible = false;
          _this12.confirmPassLoading = false;
          _this12.getCompanyList();
        } else {
          _this12.$message.error("通过失败！");
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file, fileList) {
      //console.log(res, file, fileList,'success')
      this.fileList = fileList;
    },
    handleRemove: function handleRemove(file, fileList) {
      //console.log(file, fileList,'resmove')
      this.fileList = fileList;
    },
    beforeAvatarUpload1: function beforeAvatarUpload1(file) {
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    beforeAvatarUpload2: function beforeAvatarUpload2(file) {
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      var is5Length = this.fileList.length + this.matterCompanyFileList.length < 5;
      if (!is5Length) {
        this.$message.error("当前限制选择 5  个文件");
      }
      return isLt5M && is5Length;
    },
    handleExceed: function handleExceed(files, fileList) {
      //console.log(files.length,fileList.length,this.matterCompanyFileList.length,1231)
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 " + files.length + " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 " + (files.length + fileList.length) + " \u4E2A\u6587\u4EF6");
    },
    handleExceed2: function handleExceed2(files, fileList) {
      //console.log(files.length,fileList.length,this.matterCompanyFileList.length,1231)
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 " + files.length + " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 " + (files.length + fileList.length + this.matterCompanyFileList.length) + " \u4E2A\u6587\u4EF6");
    },
    addHandle: function addHandle(type) {
      var _this13 = this;

      this.handleLoading = true;
      if (this.fileList.length == 0 && type == 1) {
        this.$message({
          message: "请先添加文件！",
          type: "error"
        });
        this.handleLoading = false;
        return;
      }
      var datas = [];
      this.fileList.forEach(function (item) {
        datas.push({
          matterCompanyFileName: item.name,
          matterCompanyFileUrl: item.response.data.fileUrl,
          matterCompanyFileMatterCompanyId: _this13.matterInfo.matterCompanyId
        });
      });
      __WEBPACK_IMPORTED_MODULE_0__service_getData__["e" /* addMatterCompanyFile */](datas).then(function (res) {
        _this13.fileList = [];
        if (res.data.code == "success") {
          if (type == 1) {
            _this13.second(type);
          } else {
            _this13.handleLoading = false;
            _this13.editDialog = false;
            _this13.matterInit();
            _this13.indexDateInit();
          }
        } else {
          _this13.$message({
            message: res.data.message,
            type: "error"
          });
          _this13.handleLoading = false;
        }
      });
    },
    second: function second(type) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_34" /* handleMatterCompany */](this.matterInfo.matterCompanyId).then(function (res) {
        if (res.data.code == "success") {
          _this14.$message({
            message: "已经处理！",
            type: "success"
          });
          _this14.handleLoading = false;
          if (type == 1) {
            _this14.accountDialog = false;
          } else {
            _this14.editDialog = false;
          }
          _this14.matterInit();
          _this14.indexDateInit();
        } else {
          _this14.$message({
            message: res.data.message,
            type: "error"
          });
          _this14.handleLoading = false;
        }
      });
    },
    lookDetails: function lookDetails(row, index, type) {
      if (this.$checkPermissions('park_notice_manager')) {
        this.notifyId = row.notifyId;
        this.detailsDialog = true;
      } else {
        this.$message.warning("抱歉！你没有该权限！");
      }
    },
    download: function download(row) {
      if (!row.workflowApplicationFileId && row.workflowApplicationFileId !== 0) {
        this.$message({
          type: "warning",
          message: "下载地址不存在！"
        });
        return;
      }
      window.location.href = "/company/download/downloadWorkflowApplicationFile?workflowApplicationFileId=" + row.workflowApplicationFileId;
    },
    delfile: function delfile(row) {
      var _this15 = this;

      if (this.matterCompanyFileList.length == 1) {
        this.$message({
          type: "warning",
          message: "最后一个文件不能删除!"
        });
        return;
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__service_getData__["F" /* deleteMatterCompanyFile */](row.matterCompanyFileId).then(function (res) {
          if (res.data.code == "success") {
            _this15.$message({
              type: "success",
              message: "删除成功!"
            });
            _this15.getfileList(_this15.matterInfo.matterCompanyId);
          }
        });
      }).catch(function () {
        _this15.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    }
  }
});

/***/ }),

/***/ "Sehe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_handle_vue__ = __webpack_require__("urj3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7be61771_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_handle_vue__ = __webpack_require__("psg1");
function injectStyle (ssrContext) {
  __webpack_require__("+1kW")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7be61771"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_handle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7be61771_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_handle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sva6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("IHPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_mUtils__ = __webpack_require__("yclV");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      confirmDialog: false,
      rejectDialog: false,
      labelListLoading: false,
      matterTypeInfo: {
        typeName: '',
        intoGeneralTable: 1
      },
      labelList: [],
      updateLoading: false,
      submitLoading: false,
      rejectLoading: false,
      rejectInfo: {
        matterRejectReason: ''
      },
      contractFileHeader: {
        allSessionId: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('allSessionId'),
        adminAccount: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('adminAccount'),
        channelId: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('channelId')
      },
      recordInfo: {},
      rules: {
        matterRejectReason: [{ required: true, message: '请填写驳回理由', trigger: ['blur', 'change'] }]
      },
      radioList: [{
        label: '',
        value: 1
      }, {
        label: '',
        value: 2
      }],
      checkboxList: [{
        label: '',
        value: 1
      }, {
        label: '',
        value: 2
      }],
      fileList: [],
      matter: '',
      handleLoading: false,
      matterFileList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['type', 'matterId', 'matterCompanyId'],
  computed: {},
  methods: {
    reset: function reset() {
      this.rejectInfo.matterRejectReason = '';
      this.$refs['rejectInfo'].resetFields();
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      }
      this.$emit('closeDialog');
    },
    init: function init() {
      this.getMatterCompanyDetailDetail();
    },
    getMatterCompanyDetailDetail: function getMatterCompanyDetailDetail() {
      var _this = this;

      this.labelListLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__service_getData__["_47" /* matterCompanyDetailDetail */](this.matterId).then(function (res) {
        _this.labelListLoading = false;
        if (res.data.code != 'success') {
          _this.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this.matterTypeInfo = res.data.data.matter ? res.data.data.matter : {};
        _this.recordInfo = res.data.data.record ? res.data.data.record : {};
        var matterCompany = res.data.data.matterCompany;
        var filedList = matterCompany.matterCompanyValue ? __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](matterCompany.matterCompanyValue) : [];
        filedList = filedList ? filedList : [];
        filedList.forEach(function (item) {
          delete item.matterTypeFiledCreateTime;
          !item.matterCompanyFiledValue ? item.matterCompanyFiledValue = '' : '';
          if (item.matterTypeFiledType === 3 && item.matterTypeFiledValue) {
            var obj = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            obj = obj ? obj : {};
            item.radioValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue : '';
            item.radioList = obj.radioList ? obj.radioList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 4 && item.matterTypeFiledValue) {
            var _obj = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            _obj = _obj ? _obj : {};
            item.checkboxValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue.split(',') : [];
            item.checkboxList = _obj.checkboxList ? _obj.checkboxList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 5) {
            item.fileList = [];
            item.uploadFileList = [];
            if (item.matterCompanyFiledValue) {
              var _obj2 = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterCompanyFiledValue);
              item.fileList = _obj2 ? _obj2 : [];
            }
          }
        });
        _this.labelList = filedList;
        _this.matterFileList = res.data.data.matterFileList;
      }).catch(function (_) {
        _this.labelListLoading = false;
      });
    },
    downloadFile: function downloadFile(row, index) {
      if (!row.matterCompanyFileId) {
        this.$message({
          type: 'warning',
          message: '下载地址不存在！'
        });
        return;
      }
      window.location.href = 'company/matterCompany/downloadFile?matterCompanyFileId=' + row.matterCompanyFileId;
    },
    delFile: function delFile(arr, arr2, index) {
      var _this2 = this;

      this.$confirm('确认删除该文件？').then(function (_) {
        arr.splice(index, 1);
        _this2.$message.success('删除成功！');
        arr2.splice(index, 1);
      }).catch(function (_) {});
    },
    beforeUpdate: function beforeUpdate(file, fileList, row, index) {
      this.matter = row;
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      if (this.type === 1) {
        var is5Length = row.fileList.length + row.uploadFileList.length < 5;
        if (!is5Length) {
          this.$message.error('当前限制选择 5 个文件');
          return false;
        }
      }
      return true;
    },
    remove: function remove(file, fileList) {
      console.log(file, fileList);
      console.log(file, fileList, 'resmove');
      // this.fileList = fileList;
      if (this.matter) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.uploadFileList) === 'object' ? this.matter.uploadFileList = fileList : '';
      } else {
        console.log('data add file fail');
      }
    },
    success: function success(response, file, fileList) {
      if (response.code == 'success') {
        this.$message({
          type: 'success',
          message: '上传文件成功！'
        });
        console.log(response);
        if (this.matter) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.uploadFileList) === 'object' ? this.matter.uploadFileList = fileList : '';
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.fileList) === 'object' ? this.matter.fileList.push({
            matterCompanyFileName: response.data.fileName,
            matterCompanyFileUrl: response.data.fileUrl
          }) : '';
        }
      }
    },
    handleExceed: function handleExceed(files, fileList, row, index) {
      if (this.type === 1) {
        this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + (row ? row.fileList ? row.fileList.length : 0 : 0)) + ' \u4E2A\u6587\u4EF6');
      } else {
        this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
      }
    },
    error: function error(err, file, fileList) {
      this.$message({
        type: 'error',
        message: '上传文件失败！'
      });
      console.log(err, file, fileList);
    },
    checkData: function checkData() {
      var isOk = [];
      this.labelList.forEach(function (item, index) {
        if (item.matterTypeFiledType === 3) {
          if (!item.radioValue) {
            isOk.push(3);
          } else {
            isOk.push(1);
          }
        } else if (item.matterTypeFiledType === 4) {
          if (!item.checkboxValue || item.checkboxValue.length === 0) {
            isOk.push(4);
          } else {
            isOk.push(1);
          }
        } else if (item.matterTypeFiledType === 5) {
          if (!item.fileList || item.fileList.length === 0) {
            isOk.push(5);
          } else {
            isOk.push(1);
          }
        } else {
          if (!item.matterCompanyFiledValue) {
            isOk.push(0);
          } else {
            isOk.push(1);
          }
        }
      });
      if (isOk.indexOf(0) !== -1) {
        this.$message.warning('\u8BF7\u586B\u5199\u5B8C\u6574\u77ED\u6587\u672C\u6216\u8005\u957F\u6587\u672C\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(3) !== -1) {
        this.$message.warning('\u8BF7\u9009\u62E9\u5355\u9009\u9879\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(4) !== -1) {
        this.$message.warning('\u8BF7\u9009\u62E9\u591A\u9009\u9879\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(5) !== -1) {
        this.$message.warning('\u8BF7\u4E0A\u4F20\u6587\u4EF6\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      }
      return true;
    },
    handle: function handle() {
      if (!this.checkData()) {
        return;
      }
      var arr = [];
      arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.labelList)).map(function (item) {
        if (item.matterTypeFiledType === 3) {
          item.matterCompanyFiledValue = item.radioValue;
        } else if (item.matterTypeFiledType === 4) {
          item.matterCompanyFiledValue = item.checkboxValue.join(',');
        } else if (item.matterTypeFiledType === 5) {
          delete item.uploadFileList;
        }
        return item;
      });
      var data = {
        matterCompanyId: this.matterCompanyId,
        filedList: arr
      };
      console.log(data);
      this.handleLoading = true;
      this.type === 1 ? this.handleMatterCompany(data) : this.editMatterCompany(data);
    },
    handleMatterCompany: function handleMatterCompany(data) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_getData__["_34" /* handleMatterCompany */](data).then(function (res) {
        _this3.handleLoading = false;
        if (res.data.code != 'success') {
          _this3.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this3.$message.success('操作成功！');
        _this3.close(1);
      }).catch(function (_) {
        _this3.handleLoading = false;
        _this3.$message.warning('操作失败！');
      });
    },
    editMatterCompany: function editMatterCompany(data) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_getData__["O" /* editMatterCompany */](data).then(function (res) {
        _this4.handleLoading = false;
        if (res.data.code != 'success') {
          _this4.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this4.$message.success('操作成功！');
        _this4.close(1);
      }).catch(function (_) {
        _this4.handleLoading = false;
        _this4.$message.warning('操作失败！');
      });
    },

    //下载
    downFile: function downFile(FileUrl, FileName) {
      //参数名随意
      window.open("/company/download/downloadWorkflowFileUseName?fileUrl=" + FileUrl + "&fileName=" + FileName);
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "TBSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_oss_js__ = __webpack_require__("6Q9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Login_vue__ = __webpack_require__("qzG6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      channelId: sessionStorage.getItem("channelId"),
      adminId: sessionStorage.getItem("adminId"),
      adminAccount: sessionStorage.getItem("adminAccount"),
      allSessionId: sessionStorage.getItem("allSessionId"),
      importTip: "\u8BF7\u5C06Excel\u6E05\u5355\u6587\u4EF6\u62D6\u5230\u6B64\u533A\u57DF\uFF0C\u6216<em>\u70B9\u51FB\u4E0A\u4F20</em><br/>\u7CFB\u7EDF\u5C06\u8BC6\u522B\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u81EA\u52A8\u5BFC\u5165",
      importTipDefalue: "\u8BF7\u5C06Excel\u6E05\u5355\u6587\u4EF6\u62D6\u5230\u6B64\u533A\u57DF\uFF0C\u6216<em>\u70B9\u51FB\u4E0A\u4F20</em><br/>\u7CFB\u7EDF\u5C06\u8BC6\u522B\u6587\u4EF6\u5185\u5BB9\u8FDB\u884C\u81EA\u52A8\u5BFC\u5165",
      importTipSuccess: "<div class=\"tit green\"><i class=\"el-icon-success\"></i>\u5F55\u5165\u6210\u529F\uFF01</div>",
      importTipError: " <div class=\"tit red\"><i class=\"el-icon-error\"></i>\u5F55\u5165\u5F02\u5E38\uFF01</div><div class=\"info\">\u8BF7\u68C0\u67E5\u6587\u4EF6\u662F\u5426\u51FA\u73B0\u9519\u8BEF\u6570\u636E\u6216\u7A7A\u7F3A\u6570\u636E<br/>\u4FEE\u6539\u5B8C\u6210\u540E\u518D\u6B21\u4E0A\u4F20</div>",
      errorList: [],
      isLoading: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  props: [],
  computed: {},
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    download: function download() {
      window.open("https://park-static.oss-cn-hangzhou.aliyuncs.com/%E4%BC%81%E4%B8%9A%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx");
    },
    importSuccess: function importSuccess(res) {
      // if (res.code === 1) {
      //   if (res.errorList.length) {
      //     this.importTip = this.importTipError;
      //     this.errorList = res.errorList;
      //   } else {
      //     this.importTip = this.importTipSuccess;
      //   }

      //   this.$emit("init");
      //   this.$message.success(res.message);
      // } else {
      //   this.$message.error(res.message);
      // }
    },
    importError: function importError() {
      // this.importTip = this.importTipError;
    },
    change: function change() {
      // this.importTip = this.importTipDefalue;
      // this.errorList = [];
    },
    onfilechanges: function onfilechanges(params) {
      var _this = this;

      this.isLoading = true;
      var formdata = new FormData();
      formdata.append("file", params.file);
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_36" /* importUser */](formdata).then(function (res) {
        _this.isLoading = false;
        if (res.data.code === 1) {
          _this.$message.success("文件上传成功！");
          _this.importTip = _this.importTipSuccess;
          _this.$emit("init");
        } else {
          _this.importTip = "<div class=\"tit red\"><i class=\"el-icon-error\"></i>\u5F55\u5165\u5F02\u5E38\uFF01</div><div class=\"info\">" + res.data.message + "</div>";
        }
      });
      return;
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "Tzs3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UYBQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UrRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_input_vue__ = __webpack_require__("o6N2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d04d8340_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_table_input_vue__ = __webpack_require__("Mk83");
function injectStyle (ssrContext) {
  __webpack_require__("N3Hy")
  __webpack_require__("Ax7W")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d04d8340"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_table_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_d04d8340_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_table_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UyeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","label-width":"120px"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-upload',{staticClass:"import-box",attrs:{"drag":"","action":"/company/er/importExcel","show-file-list":false,"on-success":_vm.importSuccess,"on-error":_vm.importError,"before-upload":_vm.change,"headers":{channelId:_vm.channelId,adminAccount:_vm.adminAccount,allSessionId:_vm.allSessionId}}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text",domProps:{"innerHTML":_vm._s(_vm.importTip)}})]),_vm._v(" "),_c('ul',{staticClass:"error-list"},_vm._l((_vm.errorList),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}),0),_vm._v(" "),_c('div',{staticClass:"import-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("请严格按模板进行Excel清单文件编写，\n          "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.download}},[_vm._v("清单模板一键下载")])],1),_vm._v(" "),_c('div',{staticClass:"import-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("请规范填写数据项，否则将会产生导入失败等问题\n        ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.close}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VLSL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W+tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp",staticStyle:{"height":"555px","max-height":"555px"}},[_c('div',{staticClass:"electronic_contract"},[_c('iframe',{attrs:{"src":_vm.billUrl,"frameborder":"0","width":"100%","height":"500"}})]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.close}},[_vm._v("完成查看")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W//h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages flex-direction-box"},[_c('div',{staticClass:"g-companyTop flex-box"},[_c('div',{staticClass:"g-user-info flex-box"},[_c('div',{staticClass:"g-user-img"},[(_vm.mhManagerHeadThumb)?_c('img',{attrs:{"src":_vm.mhManagerHeadThumb,"alt":""}}):_c('img',{attrs:{"src":__webpack_require__("MluR"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"g-user-basic"},[_c('h4',[_vm._v(_vm._s(_vm._f("empty")(_vm.companyName)))]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm._f("empty")(_vm.mhManagerName)))]),_vm._v(_vm._s(_vm._f("empty")(_vm.mhRoleName)))])])]),_vm._v(" "),_c('div',{staticClass:"flex-box g-info-box",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"g-info-item",staticStyle:{"border-left":"0"}},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm._f("empty")(_vm.systemNum)))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("我的申请变更")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","round":""},on:{"click":function($event){return _vm.goJumpPages('message_notify',1)}}},[_vm._v("查看")])],1),_vm._v(" "),_c('div',{staticClass:"g-info-item"},[_c('p',{staticClass:"p1",staticStyle:{"color":"#333"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.backlogNum)))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("我的待办事项")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","round":""},on:{"click":function($event){return _vm.goJumpPages('file_upload_manager',2)}}},[_vm._v("查看")])],1),_vm._v(" "),_c('div',{staticClass:"g-info-item"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm._f("empty")(_vm.needCheckNum)))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("人员注册待审核")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","round":""},on:{"click":function($event){return _vm.goJumpPages('user_manager',3)}}},[_vm._v("查看")])],1),_vm._v(" "),_c('div',{staticClass:"g-info-item"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm._f("empty")(_vm.unreadNum)))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("我的未读通知")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","round":""},on:{"click":function($event){return _vm.goJumpPages('park_notice_manager')}}},[_vm._v("查看")])],1)])]),_vm._v(" "),_c('div',{staticClass:"flex-box g-remindsbox",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"g-reminds-item",staticStyle:{"flex":"40"}},[_c('div',{staticClass:"g-reminds-tit flex-box"},[_vm._m(0),_vm._v(" "),(_vm.$checkPermissions('message_notify'))?_c('p',{staticClass:"tit-right",on:{"click":function($event){return _vm.$router.push('/messageNotification')}}},[_c('img',{staticClass:"img-more-icon",staticStyle:{"width":"20px","height":"21px","margin-right":"5px"},attrs:{"src":__webpack_require__("rziK"),"alt":""}}),_vm._v("\n          查看更多")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"auto","height":"calc(100% - 42px)"}},[(_vm.messageList.length == 0)?_c('div',{staticClass:"g-nodata"},[_c('img',{attrs:{"src":__webpack_require__("UYBQ"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("当前暂无提醒")])]):_c('div',{staticClass:"g-notice-cont",staticStyle:{"flex":"1","overflow-y":"auto","overflow-x":"hidden"}},_vm._l((_vm.messageList),function(item,key){return (key<4)?_c('div',{key:key,staticClass:"g-notice-item flex-box",on:{"click":function($event){return _vm.onDetail(item)}}},[(item.messageIsRead==0)?_c('img',{staticClass:"weiduimg",staticStyle:{"margin-right":"5px"},attrs:{"src":__webpack_require__("vqgf"),"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{class:item.messageIsRead == 1?'g-fullwidth':'g-nowidth'},[_c('div',{staticClass:"flex-box g-notice-tit"},[_c('h4',{staticClass:"ellipsis",class:item.messageIsRead == 1?'g-fullwidth':'g-nowidth',staticStyle:{"margin-top":"0","width":"calc(100% - 130px)"},attrs:{"title":item.messageTitle}},[_vm._v("\n                  "+_vm._s(_vm._f("empty")(item.messageTitle)))]),_vm._v(" "),_c('p',{staticClass:"p-times"},[_vm._v(_vm._s(_vm._f("datetimeType")(item.messageCreateTime,"yyyy-MM-dd hh:mm")))])])])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"g-reminds-item",staticStyle:{"flex":"60","margin-left":"20px"}},[_vm._m(1),_vm._v(" "),(!_vm.shortcutEntry.length)?_c('div',{staticClass:"g-nodata"},[_c('img',{attrs:{"src":__webpack_require__("UYBQ"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("当前暂无快捷入口，请联系园区管理员配置")])]):_c('div',{staticClass:"g-notice-cont",staticStyle:{"height":"calc(100% - 60px)"}},[_c('ul',{staticClass:"wh100 g-worker-list",staticStyle:{"overflow":"auto"}},_vm._l((_vm.shortcutEntry),function(item,index){return _c('li',{key:index,staticClass:"g-worker-item flex-box",staticStyle:{"cursor":"pointer","min-height":"120px","max-height":"calc(50% - 9px)","position":"relative"},on:{"click":function($event){return _vm.onApplyNow(item,index)}}},[(item.entranceIcon)?_c('img',{staticClass:"worker-img",attrs:{"src":item.entranceIcon,"alt":"图片不见了"}}):_c('img',{staticClass:"worker-img",attrs:{"src":__webpack_require__("NG10")}}),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px","overflow":"hidden"}},[_c('h3',{staticClass:"title ellipsis2",attrs:{"title":item.entranceTitle}},[_vm._v(_vm._s(item.entranceTitle))]),_vm._v(" "),(item.entranceType===2)?_c('span',{staticClass:"shortcut-btn"},[_vm._v("查 看")]):(item.fixedOptionType===2)?_c('span',{staticClass:"shortcut-btn"},[_vm._v("查 看")]):_c('span',{staticClass:"shortcut-btn"},[_vm._v("发 起")])]),_vm._v(" "),(item.entranceType!==1)?_c('div',{staticClass:"f-enter-type",class:_vm.getColorType(item.entranceType)},[_vm._v("\n              "+_vm._s(item.entranceType===2?"服务对接":"工作流")+"\n            ")]):_vm._e()])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"flex-box g-remindsbox",staticStyle:{"flex":"1","margin-top":"20px"}},[_c('div',{staticClass:"g-reminds-item flex-direction-box",staticStyle:{"flex":"40"}},[_c('div',{staticClass:"g-reminds-tit flex-box"},[_vm._m(2),_vm._v(" "),(_vm.$checkPermissions('file_upload_manager'))?_c('p',{staticClass:"tit-right",on:{"click":function($event){return _vm.$router.push('/fileUploadManage')}}},[_c('img',{staticClass:"img-more-icon",attrs:{"src":__webpack_require__("rziK"),"alt":""}}),_vm._v("\n          查看更多")]):_vm._e()]),_vm._v(" "),(_vm.matterCompaniesList.length == 0)?_c('div',{staticClass:"g-nodata"},[_c('img',{attrs:{"src":__webpack_require__("UYBQ"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("当前暂无事项")])]):_c('div',{staticClass:"g-remind-cont",staticStyle:{"overflow":"auto","height":"calc(100% - 61px)"}},_vm._l((_vm.matterCompaniesList),function(item,key){return (key<4)?_c('div',{key:key,staticClass:"g-cont-item flex-box",class:(item.matterCompanyStatus == 0||item.matterCompanyStatus == 1)?'c-ingcolor':''},[_c('div',{staticClass:"g-item-left"},[_c('div',{staticClass:"g-something flex-box"},[_c('p',{staticClass:"g-type ellipsis",attrs:{"title":item.matterTypeName}},[_vm._v(_vm._s(_vm._f("empty")(item.matterTypeName)))]),_vm._v(" "),_c('h4',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm._f("empty")(item.matterName)))])]),_vm._v(" "),_c('div',{staticClass:"flex-box g-contact-info"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__("lUoY"),"alt":""}}),_vm._v("\n                "+_vm._s(_vm._f("empty")(item.adminName))+"\n              ")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"el-icon-time"}),_vm._v("\n                "+_vm._s(_vm._f("datetimeType")(item.matterCompanyCreateTime,"yyyy-MM-dd hh:mm"))+"\n              ")])])]),_vm._v(" "),((item.matterCompanyStatus == 0 || item.matterCompanyStatus == 1)&& _vm.$checkPermissions('file_upload_manager'))?_c('el-button',{staticClass:"g-btn1",attrs:{"size":"small"},on:{"click":function($event){return _vm.handle(item,key)}}},[_vm._v("\n            处理\n          ")]):_vm._e(),_vm._v(" "),(item.matterCompanyStatus == 2|| item.matterCompanyStatus == 3)?_c('el-button',{staticClass:"g-btn1",attrs:{"size":"small"},on:{"click":function($event){return _vm.editThing(item,key)}}},[_vm._v("\n            查看记录\n          ")]):_vm._e()],1):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"wh100",staticStyle:{"display":"flex","flex":"60","margin-left":"20px","overflow":"hidden"}},[_c('div',{staticClass:"g-reminds-item flex-direction-box",staticStyle:{"flex":"1"}},[_c('div',{staticClass:"g-reminds-tit flex-box"},[_vm._m(3),_vm._v(" "),(_vm.$checkPermissions('file_upload_manager'))?_c('p',{staticClass:"tit-right",on:{"click":function($event){return _vm.$router.push('/notification')}}},[_c('img',{staticClass:"img-more-icon",staticStyle:{"width":"20px","height":"21px","margin-right":"5px"},attrs:{"src":__webpack_require__("rziK"),"alt":""}}),_vm._v("\n            查看更多")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"auto","height":"calc(100% - 42px)"}},[(_vm.noticeList.length == 0)?_c('div',{staticClass:"g-nodata"},[_c('img',{attrs:{"src":__webpack_require__("UYBQ"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("当前暂无公告")])]):_c('div',{staticClass:"g-notice-cont",staticStyle:{"flex":"1","overflow-y":"auto","overflow-x":"hidden"}},_vm._l((_vm.noticeList),function(item,key){return (key<6)?_c('div',{key:key,staticClass:"g-notice-item",staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","padding-top":"5px"},on:{"click":function($event){return _vm.lookDetails(item,key)}}},[_c('div',{staticClass:"flex-box"},[(item.notifyIsRead==0)?_c('img',{staticClass:"weiduimg",staticStyle:{"margin-right":"4px"},attrs:{"src":__webpack_require__("vqgf"),"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{class:item.notifyIsRead == 1?'g-fullwidth':'g-nowidth'},[_c('div',{staticClass:"flex-box g-notice-tit"},[_c('p',{staticClass:"ellipsis",staticStyle:{"width":"calc(100% - 130px)"},attrs:{"title":item.notifyName}},[_vm._v("\n                      "+_vm._s(item.notifyName))]),_vm._v(" "),_c('p',{staticClass:"p-times"},[_vm._v(_vm._s(_vm._f("datetimeType")(item.notifyCreateTime,"yyyy-MM-dd hh:mm")))])])])])]):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"g-reminds-item flex-direction-box",staticStyle:{"flex":"1","margin-left":"20px"}},[_c('div',{staticClass:"g-reminds-tit flex-box"},[_vm._m(4),_vm._v(" "),(_vm.$checkPermissions('user_manager'))?_c('p',{staticClass:"tit-right",on:{"click":function($event){return _vm.$router.push('/peopleManage')}}},[_c('img',{staticClass:"img-more-icon",attrs:{"src":__webpack_require__("rziK"),"alt":""}}),_vm._v("\n            查看更多")]):_vm._e()]),_vm._v(" "),(_vm.examineList.length == 0)?_c('div',{staticClass:"g-nodata"},[_c('img',{attrs:{"src":__webpack_require__("UYBQ"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("当前暂无注册审核信息")])]):_c('div',{staticClass:"g-remind-cont",staticStyle:{"flex":"1"}},_vm._l((_vm.examineList),function(item,key){return (key<5)?_c('div',{key:key,staticClass:"g-cont-item flex-box g-examine-item",class:item.userConfirmState ===2?'c-ingcolor':''},[_c('div',{staticClass:"g-item-left"},[_c('div',{staticClass:"g-something flex-box",staticStyle:{"justify-content":"space-between","max-width":"450px"}},[_c('p',{staticClass:"text-left ellipsis",staticStyle:{"width":"90px","font-size":"12px"},attrs:{"title":item.userName}},[_c('img',{staticClass:"user-img",attrs:{"src":__webpack_require__("Gvv4"),"alt":""}}),_vm._v("\n                  "+_vm._s(item.userName)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"ellipsis",staticStyle:{"font-size":"12px"},attrs:{"title":item.userMobile}},[_vm._v(_vm._s(item.userMobile))]),_vm._v(" "),_c('p',{staticClass:"text-center",staticStyle:{"font-size":"12px"}},[_vm._v("\n                  "+_vm._s(_vm._f("datetimeType")((item.userRegister && item.userRegister != "null")? Number(item.userRegister): "","yyyy-MM-dd hh:mm"))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"width":"75px"}},[(item.userConfirmState === 2)?_c('div',[(_vm.$checkPermissions('user_manager'))?_c('el-button',{staticClass:"g-examine examine-btn",attrs:{"size":"mini","round":""},on:{"click":function($event){return _vm.examine(item,key,2)}}},[_vm._v("审 核\n                ")]):_vm._e()],1):_c('p',{staticStyle:{"margin-right":"20px","font-size":"12px"}},[(item.userConfirmState===3)?_c('el-button',{staticClass:"examine-btn",attrs:{"size":"mini","round":""}},[_vm._v("已通过\n                ")]):_vm._e()],1)])]):_vm._e()}),0)])])]),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"服务详情","visible":_vm.serverDetailDialog,"append-to-body":true,"width":"750px","center":"","top":"3%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.serverDetailDialog=$event}}},[(_vm.serverDetailDialog)?_c('v-sever-detail',{attrs:{"serveId":_vm.serveId},on:{"closeDialog":function($event){_vm.serverDetailDialog=false}}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"事项处理","visible":_vm.accountDialog,"width":"50%","center":"","top":"3%"},on:{"update:visible":function($event){_vm.accountDialog=$event}}},[_c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"g-thing-tit"},[_c('h4',[_vm._v(_vm._s(_vm.matterInfo.matterName))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',[_vm._v("事项类型：资料上传")]),_vm._v(" "),_c('p',[_vm._v("发起人："+_vm._s(_vm.matterInfo.adminName))]),_vm._v(" "),_c('p',[_vm._v("发起时间："+_vm._s(_vm._f("datetimeType")(_vm.matterInfo.matterCreateTime,"yyyy-MM-dd hh:mm")))])]),_vm._v(" "),_c('div',{staticClass:"thingstate"},[_vm._v("待处理")])]),_vm._v(" "),_c('p',{staticClass:"g-contp"},[_vm._v(_vm._s(_vm.matterInfo.matterDes))])]),_vm._v(" "),_c('div',{staticClass:"g-uploadimgbox"},[_c('el-upload',{staticClass:"upload-demo",attrs:{"drag":"","action":"/company/matterCompany/receiveFile","multiple":"","on-success":_vm.handleAvatarSuccess,"on-remove":_vm.handleRemove,"before-upload":_vm.beforeAvatarUpload1,"on-exceed":_vm.handleExceed,"limit":5,"fileList":_vm.fileList}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])])],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"size":"small","type":"success"},on:{"click":function($event){_vm.accountDialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"success","loading":_vm.handleLoading},on:{"click":function($event){return _vm.addHandle(1)}}},[_vm._v("处理")])],1)])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"事项编辑","visible":_vm.editDialog,"width":"50%","center":"","top":"3%"},on:{"update:visible":function($event){_vm.editDialog=$event}}},[_c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"g-thing-tit"},[_c('h4',[_vm._v(_vm._s(_vm.matterInfo.matterName))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',[_vm._v("事项类型：文件上传")]),_vm._v(" "),_c('p',[_vm._v("发起人："+_vm._s(_vm.matterInfo.adminName))]),_vm._v(" "),_c('p',[_vm._v("发起时间："+_vm._s(_vm._f("date")(_vm.matterInfo.matterCreateTime)))])]),_vm._v(" "),_c('div',{staticClass:"thingstate c-blue"},[_vm._v("已处理")])]),_vm._v(" "),_c('p',{staticClass:"g-contp"},[_vm._v(_vm._s(_vm.matterInfo.matterDes))])]),_vm._v(" "),(_vm.matterCompanyFileList.length > 0)?_c('div',{staticClass:"g-downbox"},_vm._l((_vm.matterCompanyFileList),function(item,key){return _c('div',{key:key,staticClass:"flex-box g-dowm-item"},[_c('p',{staticClass:"g-filename ellipsis"},[_vm._v(_vm._s(item.matterCompanyFileName))]),_vm._v(" "),_c('p',{staticClass:"g-filetime"},[_vm._v(_vm._s(_vm._f("datetime")(item.matterCompanyFileCreateTime)))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download",on:{"click":function($event){return _vm.download(item.matterCompanyFileUrl,item.matterCompanyFileId)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.delfile(item)}}})])}),0):_vm._e(),_vm._v(" "),_c('el-upload',{staticClass:"upload-demo",attrs:{"drag":"","action":"/company/matterCompany/receiveFile","multiple":"","on-success":_vm.handleAvatarSuccess,"on-remove":_vm.handleRemove,"before-upload":_vm.beforeAvatarUpload2,"on-exceed":_vm.handleExceed2,"limit":5 - _vm.matterCompanyFileList.length,"fileList":_vm.fileList}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.editDialog=false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"success","loading":_vm.handleLoading},on:{"click":function($event){return _vm.addHandle(2)}}},[_vm._v("确认")])],1)])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"事项详情","visible":_vm.matterDetailDialog,"append-to-body":true,"width":"700px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.matterDetailDialog=$event}}},[(_vm.matterDetailDialog)?_c('v-form-detail',{attrs:{"type":_vm.matterCompanyStatus,"matterId":_vm.matterId,"matterCompanyId":_vm.matterCompanyId},on:{"closeDialog":function($event){_vm.matterDetailDialog=false},"init":_vm.matterInit}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{staticClass:"append-body",attrs:{"title":"事项处理","visible":_vm.matterHandleDialog,"append-to-body":true,"width":"700px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.matterHandleDialog=$event}}},[(_vm.matterHandleDialog)?_c('v-form-handle',{attrs:{"type":_vm.matterCompanyStatus,"matterId":_vm.matterId,"matterCompanyId":_vm.matterCompanyId},on:{"closeDialog":function($event){_vm.matterHandleDialog=false},"init":_vm.matterInit}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"园区公告详情","visible":_vm.detailsDialog,"width":"750px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.detailsDialog=$event}}},[(_vm.detailsDialog)?_c('v-notification-details',{attrs:{"notifyId":_vm.notifyId},on:{"closeDialog":function($event){_vm.detailsDialog = false},"init":function($event){_vm.indexDateInit();_vm.noticeInit();_vm.detailsDialog = false;}}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{staticClass:"g-message-info",attrs:{"visible":_vm.detailVisible},on:{"update:visible":function($event){_vm.detailVisible=$event},"closed":_vm.onDetailClose}},[_c('i',{staticClass:"iconfont icon-lajixiang",staticStyle:{"margin-left":"10px"},attrs:{"slot":"title"},on:{"click":_vm.onDetailDelete},slot:"title"}),_vm._v(" "),_c('div',{staticClass:"g-wrap"},[_c('div',{staticClass:"g-title"},[_vm._v(_vm._s(_vm.getMessage.messageTitle))]),_vm._v(" "),_c('div',{staticClass:"s-read"},[_vm._v("发件人："+_vm._s(_vm.getMessage.messageTypeDes))]),_vm._v(" "),_c('div',{staticClass:"s-read"},[_vm._v("时间："+_vm._s(_vm.getMessage.messageCreateTime))])]),_vm._v(" "),_c('div',{staticClass:"g-wrap"},[_c('div',[_vm._v("\n        "+_vm._s(_vm.getMessage.messageBody)+" "),_c('span',{staticClass:"f-detail-link",on:{"click":function($event){return _vm.onItemDetail(_vm.getMessage.messageToId)}}},[_vm._v("点击查看详情")])])]),_vm._v(" "),_c('div',{staticClass:"g-wrap"},[(_vm.getMessage.fileList ? (_vm.getMessage.fileList.length === 0 ? true : false) : true)?_c('div',[_vm._v("无附件")]):_vm._l((_vm.getMessage.fileList),function(item,index){return _c('div',{key:index,staticClass:"f-detail-link",on:{"click":function($event){return _vm.onDownLoad(item.messageFileUrl)}}},[_vm._v(_vm._s(item.messageFileName)+"\n      ")])})],2),_vm._v(" "),_c('div',{staticClass:"g-wrap"},[_c('div',[_vm._v("下一条 "),_c('span',{staticClass:"f-detail-link",class:{'f-last-title': _vm.isLastTitle},on:{"click":_vm.onNextMessage}},[_vm._v(_vm._s(_vm.chooseItemNextTitle))])])])]),_vm._v(" "),_c('el-dialog',{staticClass:"g-min-width",attrs:{"visible":_vm.itemDetailVisible,"title":"审批详情"},on:{"update:visible":function($event){_vm.itemDetailVisible=$event},"closed":_vm.onItemDetailClose}},[_c('div',{staticClass:"g-content-wrap"},[_c('div',{staticClass:"c-box-shadow g-padding-size g-overflow"},[_c('el-steps',{attrs:{"direction":"vertical","active":_vm.getProgressActive,"finish-status":"success"}},_vm._l((_vm.processList),function(item,index){return _c('el-step',{key:index},[_c('div',{staticClass:"ellipsis3",attrs:{"slot":"description"},slot:"description"},[(item.workflowApplicationProcessStatus)?_c('div',[_vm._v(_vm._s(item.processRecord.doName))]):_vm._e(),_vm._v(" "),_vm._l((item.operands),function(option){return (!item.workflowApplicationProcessStatus)?_c('div',[_vm._v(_vm._s(option))]):_vm._e()}),_vm._v(" "),(item.workflowApplicationProcessStatus)?_c('div',[_vm._v(_vm._s(item.processRecord.doTime))]):_vm._e(),_vm._v(" "),(item.workflowApplicationProcessStatus)?_c('div',[_vm._v("\n                "+_vm._s(item.processRecord.workflowApplicationProcessRecordDes)+"\n              ")]):_vm._e(),_vm._v(" "),_vm._l((item.processRecord.files),function(itemfile,indexs){return _c('div',{key:indexs,staticClass:"down-item flex-box"},[_c('span',{staticClass:"ellipsis",staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm._f("empty")(itemfile.workflowFileName)))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download icon",on:{"click":function($event){return _vm.downLoadWorkFile(itemfile)}}})])})],2)])}),1)],1),_vm._v(" "),_c('div',{staticClass:"g-right"},[_c('div',{staticClass:"g-right-top"},[_c('div',{staticClass:"flex-box"},[_c('i',{staticClass:"iconfont icon-shenqing"}),_vm._v(" "),_c('h3',{staticClass:"c-title"},[_vm._v(_vm._s(_vm.workflow.workflowType))])]),_vm._v(" "),_c('div',{staticClass:"g-right-top-desc"},[_vm._v("\n            "+_vm._s(_vm.workflow.workflowDes)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"g-right-bottom"},[_c('div',{staticClass:"g-header"},[_c('div',{staticClass:"c-title"},[_vm._v("\n              "+_vm._s(_vm.workflowApplication.workflowApplicationTitle)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"flex-box",staticStyle:{"margin":"10px 0"}},[_c('div',{staticClass:"create-person",staticStyle:{"margin-right":"20px"}},[_vm._v("发起人："+_vm._s(_vm.workflowApplication.managerName))]),_vm._v(" "),_c('div',{staticClass:"company"},[_vm._v("所属企业："+_vm._s(_vm.workflowApplication.companyName))])]),_vm._v(" "),_c('div',{staticClass:"create-time"},[_vm._v("\n              发起时间："+_vm._s(_vm.workflowApplication.workflowApplicationCreateTime)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"g-body"},[_c('div',{staticClass:"content",staticStyle:{"min-height":"100px","overflow":"hidden","width":"100%"}},[_vm._v("\n              "+_vm._s(_vm.workflowApplication.workflowApplicationDes)+"\n            ")]),_vm._v(" "),(_vm.fileList && _vm.fileList.length)?_c('div',{staticClass:"g-footer flex-box",staticStyle:{"width":"100%"}},[_c('div',{staticStyle:{"margin-right":"20px","align-self":"flex-start"}},[_vm._v("附件：")]),_vm._v(" "),_c('div',{staticClass:"g-flex-right"},[((_vm.fileList && _vm.fileList.length > 0) ? (_vm.fileList[0].workflowApplicationFileName ? true : false) : false)?_c('div',{staticClass:"flex-box",staticStyle:{"max-height":"100px","overflow-y":"auto","flex-direction":"column","width":"100%"}},_vm._l((_vm.fileList),function(item,index){return _c('div',{key:index,staticClass:"carry-file"},[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"g-fileName"},[_vm._v(_vm._s(item.workflowApplicationFileName))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download",on:{"click":function($event){return _vm.download(item)}}})])])}),0):_vm._e()])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[(_vm.workflowApplication.workflowApplicationStatus == 1)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onConfirm}},[_vm._v("确 定")]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":_vm.cancel}},[_vm._v("返 回")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"g-form-box",attrs:{"center":"","title":"认证审核","visible":_vm.formVisible,"center":"","width":"500px"},on:{"update:visible":function($event){_vm.formVisible=$event}}},[_c('el-form',{ref:"formData",attrs:{"model":_vm.formData,"size":"mini","label-width":"90px","label-position":"left"}},[_c('div',{staticStyle:{"padding":"25px 25px 30px"}},[_c('div',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("信息填写：")]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('el-form-item',{attrs:{"label":"人员姓名","prop":"userName"}},[_c('el-input',{staticClass:"input-box",attrs:{"auto-complete":"off","placeholder":"请输入人员姓名...","disabled":true},model:{value:(_vm.formData.userName),callback:function ($$v) {_vm.$set(_vm.formData, "userName", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"formData.userName"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-left":"20px"},attrs:{"label":"联系方式","prop":"userMobile"}},[_c('el-input',{staticClass:"input-box",attrs:{"auto-complete":"off","placeholder":"请输入联系方式...","disabled":true},model:{value:(_vm.formData.userMobile),callback:function ($$v) {_vm.$set(_vm.formData, "userMobile", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"formData.userMobile"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员权限"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.formData.userPermission),callback:function ($$v) {_vm.$set(_vm.formData, "userPermission", $$v)},expression:"formData.userPermission"}},[_vm._v("企业员工")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.formData.userPermission),callback:function ($$v) {_vm.$set(_vm.formData, "userPermission", $$v)},expression:"formData.userPermission"}},[_vm._v("企业管理员")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{staticClass:"g-danger",attrs:{"size":"mini"},on:{"click":_vm.onConfirmRefuse}},[_vm._v("驳 回")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary","loading":_vm.confirmPassLoading},on:{"click":_vm.onConfirmPass}},[_vm._v("确 定\n      ")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"g-fail-box",attrs:{"center":"","title":"认证驳回","visible":_vm.refuseVisible,"center":"","width":"300px","top":"20%"},on:{"update:visible":function($event){_vm.refuseVisible=$event}}},[_c('div',{staticStyle:{"padding":"25px 25px 30px"}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("该操作将驳回此申请,是否确认?")])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.refuseVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.onConfirmRefuse}},[_vm._v("确 定")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"问题反馈添加","visible":_vm.problemAddDialog,"width":"750px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.problemAddDialog=$event}}},[(_vm.problemAddDialog)?_c('problem-add',{on:{"closeDialog":function($event){_vm.problemAddDialog=false;}}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tit-left flex-box"},[_c('img',{staticClass:"img-icon",staticStyle:{"width":"20px","height":"21px","margin-right":"10px"},attrs:{"src":__webpack_require__("a/9H"),"alt":""}}),_vm._v("\n          工作提醒\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-reminds-tit flex-box"},[_c('p',{staticClass:"tit-left flex-box"},[_c('img',{staticClass:"img-icon",staticStyle:{"width":"20px","height":"21px","margin-right":"10px"},attrs:{"src":__webpack_require__("6xLt"),"alt":""}}),_vm._v("\n          快捷入口\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tit-left"},[_c('img',{staticClass:"img-icon",attrs:{"src":__webpack_require__("hftE"),"alt":""}}),_vm._v("\n          待办事项\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tit-left flex-box"},[_c('img',{staticClass:"img-icon",staticStyle:{"width":"20px","height":"21px","margin-right":"10px"},attrs:{"src":__webpack_require__("a/9H"),"alt":""}}),_vm._v("\n            园区公告\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tit-left"},[_c('img',{staticClass:"img-icon",staticStyle:{"width":"30px","height":"24px"},attrs:{"src":__webpack_require__("swQV"),"alt":""}}),_vm._v("\n            注册审核")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XjDz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XmDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_approval_vue__ = __webpack_require__("Dcwi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_bb4c8c3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_approval_vue__ = __webpack_require__("pCsO");
function injectStyle (ssrContext) {
  __webpack_require__("Ztxa")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb4c8c3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_bb4c8c3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XzEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      billUrl: ''
    };
  },
  mounted: function mounted() {
    this.init();
  },

  props: ['contractId', 'contractType'],
  methods: {
    close: function close() {
      this.$emit('closeDialog');
    },
    init: function init() {
      var _this = this;

      this.billUrl = '';
      //获取电子合同详情contractType合同类型 (1企业租赁 2企业物业 4公寓租赁 5公寓物业 )
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_0" /* fileTemplate */]({ contractId: this.contractId, contractType: this.contractType }).then(function (res) {
        if (res.data.code != 'success') {
          _this.$message({
            type: 'error',
            message: res.data.msg || res.data.message
          });
          return;
        }
        _this.billUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + res.data.data.data;
      });
    }
  },
  components: {},
  computed: {},
  watch: {
    id: function id(val) {
      if (val) {
        this.init();
      }
    }
  }
});

/***/ }),

/***/ "YNmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"model":_vm.info,"label-width":"140px","rules":_vm.rules,"size":"small"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{attrs:{"span":20,"offset":1}},[_c('el-form-item',{attrs:{"label":"车牌号：","prop":"vaVehicleNumber"}},[(!_vm.vaId || _vm.info.vaVehicleNumber)?_c('v-card-number',{attrs:{"provinceFather":_vm.info.province,"letterFather":_vm.info.letter,"licensePlateNumberFather":_vm.info.licensePlateNumber},on:{"getCarNumber":_vm.getCarNumber},model:{value:(_vm.info.vaVehicleNumber),callback:function ($$v) {_vm.$set(_vm.info, "vaVehicleNumber", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.vaVehicleNumber"}}):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"车主姓名：","prop":"vaVehicleUserId"}},[_c('el-select',{attrs:{"placeholder":"请选择车主姓名","filterable":""},model:{value:(_vm.info.vaVehicleUserId),callback:function ($$v) {_vm.$set(_vm.info, "vaVehicleUserId", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.vaVehicleUserId"}},_vm._l((_vm.carOwnerList),function(item,index){return _c('el-option',{key:item.userId,attrs:{"label":item.userName,"value":item.userId}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"租赁有效期：","prop":"vaVehicleEndTime"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd hh:mm:ss","type":"datetime","placeholder":"请选择租赁有效期","picker-options":_vm.pickerOptions},model:{value:(_vm.info.vaVehicleEndTime),callback:function ($$v) {_vm.$set(_vm.info, "vaVehicleEndTime", $$v)},expression:"info.vaVehicleEndTime"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"可用停车场：","prop":"vaCarParkList"}},[_c('el-select',{attrs:{"placeholder":"请选择可用停车场","filterable":"","multiple":"","collapse-tags":""},on:{"change":_vm.changeCarParkGroup},model:{value:(_vm.info.vaCarParkList),callback:function ($$v) {_vm.$set(_vm.info, "vaCarParkList", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.vaCarParkList"}},_vm._l((_vm.carParkGroupList),function(item,index){return _c('el-option',{key:item.carParkId,attrs:{"label":item.parkingName,"value":item.carParkId}})}),1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.submits.apply(null, arguments)}}},[_vm._v("保存")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("lPSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_index__ = __webpack_require__("L8Y5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Login__ = __webpack_require__("qzG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_newLogin__ = __webpack_require__("b6Wu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_404__ = __webpack_require__("jEQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view___ = __webpack_require__("s+Ew");










var fileUploadManage = function fileUploadManage(r) {
  return __webpack_require__.e/* require.ensure */(28).then((function () {
    return r(__webpack_require__("O4ro"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var fileHandle = function fileHandle(r) {
  return __webpack_require__.e/* require.ensure */(29).then((function () {
    return r(__webpack_require__("86lC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// const spreadInfo = r => require.ensure([], () => r(require('../view/企业资料/宣传信息')), 'spreadInfo');
// const billInfo = r => require.ensure([], () => r(require('../view/企业资料/开票信息')), 'billInfo');

var notification = function notification(r) {
  return __webpack_require__.e/* require.ensure */(26).then((function () {
    return r(__webpack_require__("iZYh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var selfEvaluation = function selfEvaluation(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__("OUTD"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var myApplication = function myApplication(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__("4qfX"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var addApplication = function addApplication(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("MbH0"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var remindBill = function remindBill(r) {
  return __webpack_require__.e/* require.ensure */(24).then((function () {
    return r(__webpack_require__("uada"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var remindOverTime = function remindOverTime(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("OB40"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var balanceRemind = function balanceRemind(r) {
  return __webpack_require__.e/* require.ensure */(25).then((function () {
    return r(__webpack_require__("3wlF"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var peopleManage = function peopleManage(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("IXnq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var visitorManage = function visitorManage(r) {
  return __webpack_require__.e/* require.ensure */(21).then((function () {
    return r(__webpack_require__("8xdw"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var faceManage = function faceManage(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("Ffvz"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var entryManage = function entryManage(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("hkft"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var accountManage = function accountManage(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("qBv6"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var systemManager = function systemManager(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__("a+ke"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var primissionManage = function primissionManage(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("V6fi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var messageNotification = function messageNotification(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("HmE1"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var doloadDataTemplate = function doloadDataTemplate(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__("LkqS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var serviceDocking = function serviceDocking(r) {
  return __webpack_require__.e/* require.ensure */(27).then((function () {
    return r(__webpack_require__("pjCQ"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var problemManage = function problemManage(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("8Gqx"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var fileManage = function fileManage(r) {
  return __webpack_require__.e/* require.ensure */(23).then((function () {
    return r(__webpack_require__("/7H6"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var attendanceRecord = function attendanceRecord(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("AKTH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var preventPlagueManagement = function preventPlagueManagement(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__("uI+f"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var reportPreventPlagueMessage = function reportPreventPlagueMessage(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__("UonH"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var policyDemandSearch = function policyDemandSearch(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__("3ngf"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var registrationReturningWorkers = function registrationReturningWorkers(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__("D7Tq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var applicationForWork = function applicationForWork(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__("i5Gg"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var billApplicationManage = function billApplicationManage(r) {
  return __webpack_require__.e/* require.ensure */(22).then((function () {
    return r(__webpack_require__("doUe"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var parkingRentalApplication = function parkingRentalApplication(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__("dKJq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var companySafeDocument = function companySafeDocument(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("wJku"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    redirect: '/login',
    hidden: true
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_4__view_newLogin__["a" /* default */],
    name: '',
    hidden: true
  }, {
    path: '/newLogin',
    component: __WEBPACK_IMPORTED_MODULE_4__view_newLogin__["a" /* default */],
    name: '',
    hidden: true
  }, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_5__view_404__["a" /* default */],
    name: '',
    hidden: true
  }, {
    path: '/index',
    name: '企业工作台',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    leaf: true,
    iconCls: 'icon-diannao',
    permission: 'work_bench',
    children: [{
      path: '/workbench', component: __WEBPACK_IMPORTED_MODULE_6__view___["a" /* default */], name: '企业工作台'
    }]
  }, {
    path: '/',
    name: '事项管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-biezhen',
    permission: 'matter_manager',
    children: [{
      path: '/fileUploadManage',
      component: fileUploadManage,
      name: '·事项处理',
      meta: { showAddHeader: false },
      permission: 'file_upload_manager'
    }, {
      path: '/fileHandle',
      component: fileHandle,
      name: '·事项处理',
      hidden: true,
      meta: { showAddHeader: false },
      permission: 'file_upload_manager'
    }]
  }, {
    path: '/',
    name: '工作流管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    leaf: false,
    iconCls: 'icon-jurassic_history-record',
    permission: 'workflow_manager',
    children: [{
      path: '/myApplication', component: myApplication, name: '·我的工作流', permission: 'my_ask'
    }, {
      path: '/addApplication', component: addApplication, name: '·工作流发起', permission: 'add_workflow'
    }]
  }, {
    path: '/',
    name: '考核管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    leaf: false,
    iconCls: 'icon-kaohe',
    permission: 'self_evaluation',
    children: [{
      path: '/selfEvaluation', component: selfEvaluation, name: '考核任务自评', permission: 'self_assessment'
    }]
  }, {
    path: '/',
    name: '园企服务',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    leaf: false,
    iconCls: 'icon-woshou',
    permission: 'portal_serve',
    children: [{
      path: '/serviceDocking', component: serviceDocking, name: '·服务对接', permission: 'serve_list'
    }]
  }, {
    path: '/',
    name: '信息反馈',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    leaf: false,
    iconCls: 'icon-yijianfankui',
    permission: 'information_reback',
    children: [{
      path: '/problemManage', component: problemManage, name: '·问题反馈', permission: 'feedback_list'
    }]
  }, {
    path: '/',
    name: '园区通知',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-tongzhi',
    permission: 'park_notify',
    children: [{
      path: '/notification',
      component: notification,
      name: '·园区通知管理',
      meta: { showAddHeader: false },
      permission: 'park_notice_manager'
    }, {
      path: '/messageNotification', component: messageNotification, name: '·消息通知', permission: 'message_notify'
    }]
  }, {
    path: '/',
    name: '文件管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-wenjianguanli-02',
    permission: 'file_manage',
    children: [{
      path: '/fileManage',
      component: fileManage,
      name: '·文件管理',
      meta: { showAddHeader: false },
      permission: 'fileManage'
    }]
  }, {
    path: '/',
    name: '资料模板',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-huabanfuben',
    permission: 'resource_moban',
    children: [{
      path: '/doloadDataTemplate',
      component: doloadDataTemplate,
      name: '·资料模板下载',
      meta: { showAddHeader: false },
      permission: 'resource_download'
    }]
  }, {
    path: '/',
    name: '企业内部管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-neibuguanli',
    permission: 'moblie_manager',
    children: [{
      path: '/peopleManage',
      component: peopleManage,
      name: '·人员管理',
      meta: { showAddHeader: false },
      permission: 'user_manager'
    }, {
      path: '/faceManage',
      component: faceManage,
      name: '·人脸信息管理',
      meta: { showAddHeader: false },
      permission: 'face_info_list'
    }, {
      path: '/entryManage',
      component: entryManage,
      name: '·人员出入明细',
      meta: { showAddHeader: false },
      permission: 'person_pass_list'
    }, {
      path: '/visitorManage',
      component: visitorManage,
      name: '·访客管理',
      meta: { showAddHeader: false },
      permission: 'visitor_manager'
    }, {
      path: '/attendanceRecord',
      component: attendanceRecord,
      name: '·考勤管理',
      meta: { showAddHeader: false },
      permission: 'attendanceRecord'
    }]
  }, {
    path: '/',
    name: '提醒管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-tixing',
    permission: 'remind_manager',
    children: [{
      path: '/remindBill',
      component: remindBill,
      name: '·账单提醒',
      meta: { showAddHeader: false },
      permission: 'account_notify'
    }, {
      path: '/remindOverTime',
      component: remindOverTime,
      name: '·合同到期提醒',
      meta: { showAddHeader: false },
      permission: 'bill_deadline_notify'
    }, {
      path: '/balanceRemind',
      component: balanceRemind,
      name: '·水电余额提醒',
      meta: { showAddHeader: false },
      permission: 'balance_remind'
    }]
  }, {
    path: '/',
    name: '票据申请管理',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-piaoju',
    permission: 'bill_manage',
    children: [{
      path: '/billApplicationManage', component: billApplicationManage, name: '·票据申请管理', meta: { showAddHeader: false }, permission: 'bill_apply'
    }]
  }, {
    path: '/',
    name: '车位租赁申请',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    iconCls: 'icon-peitaosheshixiaotubiao_tingchewei',
    permission: 'parking_rental',
    children: [{
      path: '/parkingRentalApplication',
      component: parkingRentalApplication,
      name: '车位租赁申请',
      meta: { showAddHeader: false },
      permission: 'parking_rental_application'
    }]
  },
  // {
  //   path: '/',
  //   name: '系统管理',
  //   component: index,
  //   hidden: false,
  //   iconCls: 'icon-shezhi',
  //   permission: 'system_manager',
  //   children: [
  //     {
  //       path: '/accountManage', component: accountManage, name: '·账号管理', permission: 'account_manager'
  //     },
  //     {
  //       path: '/systemManager', component: systemManager, name: '·系统管理员', permission: 'system_admin'
  //     },
  //     {
  //       path: '/primissionManage', component: primissionManage, name: '·权限管理', permission: 'permission_manager',
  //     },
  //       ]
  //     },
  // {
  //   path: '/',
  //   name: '防疫管理',
  //   component: index,
  //   hidden: false,
  //   // leaf: true, //只有一个节点
  //   iconCls: 'icon-attchment',
  //   permission: 'prevention_manage',
  //   children: [
  //     {
  //       path: '/preventPlagueManagement', component: preventPlagueManagement, name: '·企业防疫登记', permission: 'file_upload_manager'
  //     },
  //     {
  //       path: '/reportPreventPlagueMessage', component: reportPreventPlagueMessage, name: '·企业复工信息备案', permission: 'file_upload_manager'
  //     },
  //     {
  //       path: '/policyDemandSearch', component: policyDemandSearch, name: '·企业政策需求调查', permission: 'file_upload_manager'
  //     },
  //     {
  //       path: '/registrationReturningWorkers', component: registrationReturningWorkers, name: '·企业复工人员登记', permission: 'file_upload_manager'
  //     },
  //     // {
  //     //   path: '/applicationForWork', component: applicationForWork, name: '·企业复工申请', permission: 'file_upload_manager'
  //     // },
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '租赁信息管理',
  //   component: index,
  //   hidden: false,
  //   // leaf: true, //只有一个节点
  //   iconCls: 'icon-attchment',
  //   permission: 'lease_info',
  //   children: [
  //     {
  //       path: '/siteManage', component: siteManage, name: '·场地管理', permission: 'file_upload_manager'
  //     },
  //     {
  //       path: '/contractManage', component: contractManage, name: '·合同管理', permission: 'file_upload_manager'
  //     },
  //     {
  //       path: '/billManage', component: billManage, name: '·账单管理', permission: 'file_upload_manager'
  //     },
  //   ]
  // },
  {
    path: '/',
    name: '企业安全档案',
    component: __WEBPACK_IMPORTED_MODULE_2__view_index__["a" /* default */],
    hidden: false,
    // leaf: true, //只有一个节点
    iconCls: 'icon-zulin',
    permission: 'company_safe',
    children: [{
      path: '/companySafeDocument', component: companySafeDocument, name: '·企业安全档案', permission: 'safe_ducoment'
    }]
  }]
}));

/***/ }),

/***/ "YggF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {},
      fileList: [],
      submitLoading: false,
      conts: '',
      tableList: [],
      type: 2,
      parkListLoading: false,
      apartmentContracts: [],
      contracts: [],
      propertyContracts: [],
      contractDialog: false,
      contractId: '',
      contractType: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  computed: {},
  props: ['houseResId', 'houseResType'],
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      } else {
        this.$emit('closeDialog');
      }
    },
    lookDetails: function lookDetails(row, index, type) {
      this.contractId = row.contractId;
      this.contractType = type;
      this.contractDialog = true;
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_35" /* houseResAreaDetail */]({ houseResId: this.houseResId, type: this.houseResType }).then(function (res) {
        _this.parkListLoading = false;
        if (res.data.code == "success") {
          _this.info = res.data.data.data.mhHouseResVO;
          _this.apartmentContracts = res.data.data.data.apartmentContracts;
          _this.contracts = res.data.data.data.contracts;
          _this.propertyContracts = res.data.data.data.propertyContracts;
        }
      }).catch(function (_) {
        console.log(_);
        _this.parkListLoading = false;
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "Z+T+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('v-header',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.info.buildName)+" / "+_vm._s(_vm.info.floorName)+" "+_vm._s(_vm.info.houseResName))])]),_vm._v(" "),(_vm.houseResType == 1)?_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"title"},[_vm._v("场地基本信息：")]),_vm._v(" "),_c('div',{staticClass:"g-basic-data"},[_vm._v("\n      场地面积:"+_vm._s(_vm.info.area)+"㎡"),_c('span',[_vm._v("场地状态："+_vm._s(_vm._f("rentState")(_vm.info.rentState)))]),_vm._v("装修："+_vm._s(_vm._f("fixState")(_vm.info.fixState))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("租赁合同信息：")]),_vm._v(" "),_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","overflow":"hidden","max-height":"100%"},attrs:{"data":_vm.contracts,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.parkListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.parkListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhu","label":"租户","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statrtTime","label":"计租日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.statrtTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,1486256432)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"结束日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.endTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,2497505067)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"f-prove-button",attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.lookDetails(scope.row,scope.$index,1)}}},[_vm._v("查看\n          ")])]}}],null,false,949871272)})],2),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("物业合同信息：")]),_vm._v(" "),_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","overflow":"hidden","max-height":"100%"},attrs:{"data":_vm.propertyContracts,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.parkListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.parkListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhu","label":"租户","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statrtTime","label":"计租日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.statrtTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,1486256432)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"结束日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.endTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,2497505067)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"f-prove-button",attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.lookDetails(scope.row,scope.$index,2)}}},[_vm._v("查看\n          ")])]}}],null,false,3627670283)})],2),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_vm._v("确认\n        ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.houseResType == 2)?_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"title"},[_vm._v("场地基本信息")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("公寓合同信息：")]),_vm._v(" "),_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","overflow":"hidden","max-height":"100%"},attrs:{"data":_vm.apartmentContracts,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.parkListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.parkListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhu","label":"租户","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statrtTime","label":"计租日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.statrtTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,1486256432)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"结束日","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm._f("datetimeType")(scope.row.endTime,"yyyy-MM-dd"))+"\n        ")]}}],null,false,2497505067)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"f-prove-button",attrs:{"size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.lookDetails(scope.row,scope.$index,3)}}},[_vm._v("查看\n          ")])]}}],null,false,3076874474)})],2),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("住户信息：")]),_vm._v(" "),_c('el-table',{staticClass:"g-table flex-direction-box",staticStyle:{"width":"100%","overflow":"hidden","max-height":"100%"},attrs:{"data":_vm.apartmentContracts,"stripe":"","size":"mini"}},[_c('template',{slot:"empty"},[(_vm.parkListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.parkListLoading)?_c('span',[_vm._v("暂无数据")]):_vm._e()],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhulianxiren","label":"入住人姓名","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhuPhone","label":"入住人联系方式","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zuhuIdCard","label":"入住人联系方式","show-overflow-tooltip":""}})],2),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_vm._v("确认\n        ")])],1)],1):_vm._e(),_vm._v(" "),_c('el-dialog',{staticClass:"contract-bill",attrs:{"title":"合同详情","visible":_vm.contractDialog,"append-to-body":"","width":"750px","center":"","top":"3%"},on:{"update:visible":function($event){_vm.contractDialog=$event}}},[(_vm.contractDialog)?_c('v-contract-details',{attrs:{"contractId":_vm.contractId,"contractType":_vm.contractType},on:{"closeDialog":function($event){_vm.contractDialog = false},"init":function($event){_vm.init();_vm.contractDialog = false;}}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-basic-data"},[_vm._v("\n      房源面积:479㎡"),_c('span',[_vm._v("房源状态：在租中")]),_vm._v("人才公寓类型：人才驿站"),_c('span',[_vm._v("装修：简装")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z7/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"g-thing-tit flex-box"},[_c('div',{staticClass:"g-widths"},[_c('h4',{},[_vm._v(_vm._s(_vm.notifyInfo.notifyName))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',[_vm._v("发起人："+_vm._s(_vm.notifyInfo.notifyCreateAdminName))]),_vm._v(" "),_c('p',[_vm._v("发起时间："+_vm._s(_vm._f("datetimeType")(_vm.notifyInfo.notifyCreateTime,"yyyy-MM-dd hh:mm")))])])]),_vm._v(" "),_c('el-tag',[_vm._v(_vm._s(_vm._f("notifyType")(_vm.notifyInfo.notifyType)))])],1),_vm._v(" "),_c('p',{staticClass:"g-contp",domProps:{"innerHTML":_vm._s(_vm.notifyInfo.notifyDes)}}),_vm._v(" "),_c('ul',_vm._l((_vm.fileList),function(file,fileIndex){return _c('li',{key:fileIndex,staticClass:"flex-box",staticStyle:{"width":"250px","padding":"5px 15px"}},[_c('p',{staticClass:"ellipsis",staticStyle:{"flex":"1","color":"rgb(0, 102, 255)"},attrs:{"title":file.notifyFileName}},[_vm._v("\n          "+_vm._s(_vm._f("empty")(file.notifyFileName)))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download download-icon icon",staticStyle:{"color":"#1396db"},on:{"click":function($event){return _vm.downloadFile(file,fileIndex)}}})])}),0)]),_vm._v(" "),(_vm.notifyInfo.notifyNecessityReply)?_c('div',{staticClass:"dialog_form"},[_c('el-form',[(_vm.notifyInfo.notifyIsRead === 0)?_c('el-form-item',{attrs:{"label":"回复内容:"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"placeholder":"请输入内容","maxlength":"100"},model:{value:(_vm.conts),callback:function ($$v) {_vm.conts=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"conts"}})],1):_c('el-form-item',{attrs:{"label":"回复内容:"}},[_vm._v("\n        "+_vm._s(_vm.notifyInfo.notifyCompanyReply)+"\n      ")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{staticClass:"f-search-btn",attrs:{"size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_vm._v("返回\n      ")]),_vm._v(" "),(_vm.notifyInfo.notifyIsRead === 0)?_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success","loading":_vm.submitLoading},on:{"click":function($event){$event.stopPropagation();return _vm.submits()}}},[_vm._v("我已确认\n      ")]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zsfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("Y9Nk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("bSIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("GMIA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action__ = __webpack_require__("2+ao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("2mXc");







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
window.Promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a;
var channel = function () {
  if ('pgy-back.zhihuipk.com'.indexOf(window.location.hostname) >= 0) {
    return 2;
  } else if ('test-pk-ht.hzqisheng.cn'.indexOf(window.location.hostname) >= 0) {
    return 1;
  } else {
    return 1;
  }
}();
var state = {
  channelId: channel,
  localpath: '',
  houseDialog: false,
  buildSearch: '',
  houseSearch: '',
  costSearch: '',
  finalState: 1,
  houseResId: '',
  housingAddDialog: false,
  costMonth: '',
  feeTypeId: '',
  freeType: '',
  costDetailDialog: false,
  costEdit: {},
  tenantSearch: '',
  adminName: '',
  applyItem: {}
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */]
}));

/***/ }),

/***/ "Ztlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ztxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a/9H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "aLBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      approvalInfo: {
        baseIds: []
      },
      submitLoading: false,
      checkAll: false,
      checkedStaff: [],
      staffs: [],
      isIndeterminate: true,
      num: "",
      isDisabled: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__service_getData__["_90" /* viralInfoPersonToAdd */]().then(function (res) {
      if (res.data.code != 1) {
        _this.$message.error(res.data.message);
        return;
      }

      _this.staffs = res.data.data.downList;
      _this.num = res.data.data.num;
    }).catch(function (_) {
      console.log(_);
    });
  },

  props: ["approvalTitle", "erAuditId"],
  computed: {},
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedStaff = val ? this.staffs : [];
      this.approvalInfo.baseIds = this.checkedStaff.map(function (item) {
        return item.baseId;
      });
      this.approvalInfo.baseIds = this.approvalInfo.baseIds.join(",");
      console.log(this.approvalInfo.baseIds);
      this.isIndeterminate = false;
      if (this.checkedStaff.length > this.num) {
        this.isDisabled = true;
        this.$message.error("选择人数不可大于可新增人数!");
      } else {
        this.isDisabled = false;
      }
    },
    handlecheckedStaffChange: function handlecheckedStaffChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.staffs.length;
      this.approvalInfo.baseIds = this.checkedStaff.map(function (item) {
        return item.baseId;
      });
      this.approvalInfo.baseIds = this.approvalInfo.baseIds.join(",");
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.staffs.length;
      if (this.checkedStaff.length > this.num) {
        this.isDisabled = true;
        this.$message.error("选择人数不可大于可新增人数!");
      } else {
        this.isDisabled = false;
      }
    },
    submit: function submit() {
      var _this2 = this;

      console.log(this.approvalInfo);
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_87" /* viralInfoPersonAdd */](this.approvalInfo.baseIds).then(function (res) {
        if (res.data.code != 1) {
          _this2.$message.error(res.data.message);
          return;
        }
        _this2.$message({
          type: "success",
          message: "新增登记成功！"
        });
        _this2.close(1);
      }).catch(function (_) {
        _this2.$message({
          type: "warning",
          message: "新增登记失败！"
        });
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "b/am":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('el-form',{ref:"info",attrs:{"size":"small","label-width":"120px"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-upload',{staticClass:"import-box",attrs:{"drag":"","action":"/patrol/importApprove/importExcel","http-request":_vm.onfilechanges,"show-file-list":false,"on-success":_vm.importSuccess,"on-error":_vm.importError,"before-upload":_vm.change,"headers":{
              channelId: _vm.channelId,
              adminId: _vm.adminId,
              adminAccount: _vm.adminAccount,
              allSessionId: _vm.allSessionId,
            }}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text",domProps:{"innerHTML":_vm._s(_vm.importTip)}})]),_vm._v(" "),_c('div',{staticClass:"import-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("请严格按模板进行Excel清单文件编写，\n            "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.download}},[_vm._v("清单模板一键下载")])],1),_vm._v(" "),_c('div',{staticClass:"import-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("请规范填写数据项，否则将会产生导入失败等问题\n          ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.close}},[_vm._v("确认")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b6Wu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_newLogin_vue__ = __webpack_require__("Rq+b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a00bc47c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_newLogin_vue__ = __webpack_require__("PFlM");
function injectStyle (ssrContext) {
  __webpack_require__("O0c9")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a00bc47c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_newLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_a00bc47c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_newLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__left_navbar__ = __webpack_require__("wG2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upload_file__ = __webpack_require__("3SWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_handle_vue__ = __webpack_require__("Sehe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_detail_vue__ = __webpack_require__("NlpI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sever_detail_vue__ = __webpack_require__("edYn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visitor_register_detail__ = __webpack_require__("i4TM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switch_company__ = __webpack_require__("MQnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notification_details__ = __webpack_require__("7JM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prevent_plague_add__ = __webpack_require__("D2CD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prevent_plague_details__ = __webpack_require__("1L/r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rework_details__ = __webpack_require__("oDp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__quarantine_register_add__ = __webpack_require__("JWIG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__approval_vue__ = __webpack_require__("XmDY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__batch_import__ = __webpack_require__("QKXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__add_register_vue__ = __webpack_require__("AI8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__file_details__ = __webpack_require__("uh6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__meter_batch_import__ = __webpack_require__("INaB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__evaluationResult__ = __webpack_require__("ImgG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__site_details__ = __webpack_require__("1WKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contract_details__ = __webpack_require__("7SwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__bill_details__ = __webpack_require__("4DAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__look_bill__ = __webpack_require__("t5Kn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__electronic_contract__ = __webpack_require__("iB7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__create_invoice__ = __webpack_require__("wYzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__bill_examine_details__ = __webpack_require__("biVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__bill_order_info__ = __webpack_require__("RNLd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__parking_rental_application__ = __webpack_require__("LvU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__card_number_vue__ = __webpack_require__("j8Tp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__parking_rental_details__ = __webpack_require__("I989");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__add_remind_staff__ = __webpack_require__("iC9F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__company_business_info__ = __webpack_require__("hF0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__checkChangeRecords__ = __webpack_require__("J89O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__form_input__ = __webpack_require__("vnwZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__table_input__ = __webpack_require__("UrRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__file_upload__ = __webpack_require__("I/3Z");
/**
 * Created by Administrator on 2017/12/7.
 */








































//考勤
// import attendanceSetting from './考勤/attendanceSetting'

/* harmony default export */ __webpack_exports__["a"] = ({
  leftNavBar: __WEBPACK_IMPORTED_MODULE_0__left_navbar__["a" /* default */], uploadFile: __WEBPACK_IMPORTED_MODULE_1__upload_file__["a" /* default */], header: __WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */], formHandle: __WEBPACK_IMPORTED_MODULE_3__form_handle_vue__["a" /* default */], formDetail: __WEBPACK_IMPORTED_MODULE_4__form_detail_vue__["a" /* default */], severDetail: __WEBPACK_IMPORTED_MODULE_5__sever_detail_vue__["a" /* default */], visitorRegisterDetail: __WEBPACK_IMPORTED_MODULE_6__visitor_register_detail__["a" /* default */], notificationDetails: __WEBPACK_IMPORTED_MODULE_8__notification_details__["a" /* default */], preventPlagueAdd: __WEBPACK_IMPORTED_MODULE_9__prevent_plague_add__["a" /* default */], preventPlagueDetails: __WEBPACK_IMPORTED_MODULE_10__prevent_plague_details__["a" /* default */], reworkDetails: __WEBPACK_IMPORTED_MODULE_11__rework_details__["a" /* default */], quarantineRegisterAdd: __WEBPACK_IMPORTED_MODULE_12__quarantine_register_add__["a" /* default */], approval: __WEBPACK_IMPORTED_MODULE_13__approval_vue__["a" /* default */], batchImport: __WEBPACK_IMPORTED_MODULE_14__batch_import__["a" /* default */], addRegister: __WEBPACK_IMPORTED_MODULE_15__add_register_vue__["a" /* default */], fileDetails: __WEBPACK_IMPORTED_MODULE_16__file_details__["a" /* default */],
  meterBatchImport: __WEBPACK_IMPORTED_MODULE_17__meter_batch_import__["a" /* default */], evaluationResult: __WEBPACK_IMPORTED_MODULE_18__evaluationResult__["a" /* default */], siteDetails: __WEBPACK_IMPORTED_MODULE_19__site_details__["a" /* default */], contractDetails: __WEBPACK_IMPORTED_MODULE_20__contract_details__["a" /* default */], billDetails: __WEBPACK_IMPORTED_MODULE_21__bill_details__["a" /* default */], lookBill: __WEBPACK_IMPORTED_MODULE_22__look_bill__["a" /* default */], electronicContract: __WEBPACK_IMPORTED_MODULE_23__electronic_contract__["a" /* default */],
  createInvoice: __WEBPACK_IMPORTED_MODULE_24__create_invoice__["a" /* default */], billExamineDetails: __WEBPACK_IMPORTED_MODULE_25__bill_examine_details__["a" /* default */], billOrderInfo: __WEBPACK_IMPORTED_MODULE_26__bill_order_info__["a" /* default */], switchCompany: __WEBPACK_IMPORTED_MODULE_7__switch_company__["a" /* default */], parkingRentalApplication: __WEBPACK_IMPORTED_MODULE_27__parking_rental_application__["a" /* default */], cardNumber: __WEBPACK_IMPORTED_MODULE_28__card_number_vue__["a" /* default */], parkingRentalDetails: __WEBPACK_IMPORTED_MODULE_29__parking_rental_details__["a" /* default */],
  addRemindStaff: __WEBPACK_IMPORTED_MODULE_30__add_remind_staff__["a" /* default */], companyBusinessInfo: __WEBPACK_IMPORTED_MODULE_31__company_business_info__["a" /* default */], checkChangeRecords: __WEBPACK_IMPORTED_MODULE_32__checkChangeRecords__["a" /* default */], formInput: __WEBPACK_IMPORTED_MODULE_33__form_input__["a" /* default */], tableInput: __WEBPACK_IMPORTED_MODULE_34__table_input__["a" /* default */], fileUpload: __WEBPACK_IMPORTED_MODULE_35__file_upload__["a" /* default */]
});

/***/ }),

/***/ "bRA7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "biVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_examine_details_vue__ = __webpack_require__("fytT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3c567064_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_examine_details_vue__ = __webpack_require__("l6+f");
function injectStyle (ssrContext) {
  __webpack_require__("vGBH")
  __webpack_require__("0b/P")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c567064"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_bill_examine_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3c567064_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_bill_examine_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c0HD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "cg1N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ct6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","model":_vm.vrInfo,"rules":_vm.rules}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"姓名：","prop":"baseName","label-width":"100px"}},[_c('el-input',{attrs:{"disabled":!!_vm.id,"placeholder":"请填写您的真实姓名"},model:{value:(_vm.vrInfo.baseName),callback:function ($$v) {_vm.$set(_vm.vrInfo, "baseName", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.baseName"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"所在企业：","prop":"baseCompanyName","label-width":"100px"}},[_c('el-select',{attrs:{"disabled":"","filterable":"","clearable":"","placeholder":"请选择企业"},model:{value:(_vm.vrInfo.baseCompanyName),callback:function ($$v) {_vm.$set(_vm.vrInfo, "baseCompanyName", $$v)},expression:"vrInfo.baseCompanyName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"手机号码：","prop":"basePhone","label-width":"100px"}},[_c('el-input',{attrs:{"placeholder":"请填写您手机号码"},model:{value:(_vm.vrInfo.basePhone),callback:function ($$v) {_vm.$set(_vm.vrInfo, "basePhone", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.basePhone"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"户籍地址：","prop":"erAddDistrict","label-width":"100px"}},[_c('el-cascader',{attrs:{"props":{label:'n',value:'n',children:'c'},"options":_vm.district},model:{value:(_vm.vrInfo.erAddDistrict),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erAddDistrict", $$v)},expression:"vrInfo.erAddDistrict"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"身份证号：","prop":"baseIdcrad","label-width":"100px"}},[_c('el-input',{attrs:{"placeholder":"请填写您的身份证号"},model:{value:(_vm.vrInfo.baseIdcrad),callback:function ($$v) {_vm.$set(_vm.vrInfo, "baseIdcrad", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.baseIdcrad"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"180px","label":"是否已返回工作所在地：","prop":"erIsReturn"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erIsReturn),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erIsReturn", $$v)},expression:"vrInfo.erIsReturn"}},[_vm._v("已返回")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erIsReturn),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erIsReturn", $$v)},expression:"vrInfo.erIsReturn"}},[_vm._v("未返回")]),_vm._v(" "),_c('el-radio',{attrs:{"label":3},model:{value:(_vm.vrInfo.erIsReturn),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erIsReturn", $$v)},expression:"vrInfo.erIsReturn"}},[_vm._v("未离开")])],1)],1)],1),_vm._v(" "),(_vm.vrInfo.erIsReturn!=3)?_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('el-form-item',{attrs:{"label":"返程时间：","prop":"erReturnTime","label-width":"100px"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd hh:mm:ss","type":"date","placeholder":"选择日期"},model:{value:(_vm.vrInfo.erReturnTime),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erReturnTime", $$v)},expression:"vrInfo.erReturnTime"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label":"假期所在地区：","prop":"erAddHolidayDistrict","label-width":"120px"}},[_c('el-cascader',{attrs:{"props":{label:'n',value:'n',children:'c'},"options":_vm.district},model:{value:(_vm.vrInfo.erAddHolidayDistrict),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erAddHolidayDistrict", $$v)},expression:"vrInfo.erAddHolidayDistrict"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"假期所在地区详细地址：","prop":"erHolidayAddress"}},[_c('el-input',{attrs:{"maxlength":"30","placeholder":"请详细填写您假期居住地地址"},model:{value:(_vm.vrInfo.erHolidayAddress),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erHolidayAddress", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erHolidayAddress"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"工作地居住地址：","prop":"erLocation"}},[_c('el-input',{attrs:{"maxlength":"30","placeholder":"请详细填写您返工后居住地地址"},model:{value:(_vm.vrInfo.erLocation),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erLocation", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erLocation"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"140px","label":"假期使用通勤工具：","prop":"vrTraffic"}},[_c('el-checkbox-group',[_c('label',{staticClass:"el-checkbox",class:_vm.vrInfo.erIsAirplane==1?'is-checked':'',on:{"click":function($event){return _vm.changeTraffic('erIsAirplane')}}},[_c('span',{staticClass:"el-checkbox__input",class:_vm.vrInfo.erIsAirplane==1?'is-checked':''},[_c('span',{staticClass:"el-checkbox__inner"})]),_vm._v(" "),_c('span',{staticClass:"el-checkbox__label"},[_vm._v("飞机")])]),_vm._v(" "),_c('label',{staticClass:"el-checkbox",class:_vm.vrInfo.erIsBulletTrain==1?'is-checked':'',on:{"click":function($event){return _vm.changeTraffic('erIsBulletTrain')}}},[_c('span',{staticClass:"el-checkbox__input",class:_vm.vrInfo.erIsBulletTrain==1?'is-checked':''},[_c('span',{staticClass:"el-checkbox__inner"})]),_vm._v(" "),_c('span',{staticClass:"el-checkbox__label"},[_vm._v("动车")])]),_vm._v(" "),_c('label',{staticClass:"el-checkbox",class:_vm.vrInfo.erIsBus==1?'is-checked':'',on:{"click":function($event){return _vm.changeTraffic('erIsBus')}}},[_c('span',{staticClass:"el-checkbox__input",class:_vm.vrInfo.erIsBus==1?'is-checked':''},[_c('span',{staticClass:"el-checkbox__inner"})]),_vm._v(" "),_c('span',{staticClass:"el-checkbox__label"},[_vm._v("客车")])]),_vm._v(" "),_c('label',{staticClass:"el-checkbox",class:_vm.vrInfo.erIsPrivateCar==1?'is-checked':'',on:{"click":function($event){return _vm.changeTraffic('erIsPrivateCar')}}},[_c('span',{staticClass:"el-checkbox__input",class:_vm.vrInfo.erIsPrivateCar==1?'is-checked':''},[_c('span',{staticClass:"el-checkbox__inner"})]),_vm._v(" "),_c('span',{staticClass:"el-checkbox__label"},[_vm._v("私家车")])])])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[(_vm.vrInfo.erIsAirplane==1)?_c('el-form-item',{attrs:{"label":"飞机航班号：","prop":"erFlightNumber","label-width":"110px"}},[_c('el-input',{attrs:{"maxlength":"20","placeholder":"例如CZ34987号航班"},model:{value:(_vm.vrInfo.erFlightNumber),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erFlightNumber", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erFlightNumber"}})],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[(_vm.vrInfo.erIsBulletTrain==1)?_c('el-form-item',{attrs:{"label":"动车班次：","prop":"erTrainService","label-width":"110px"}},[_c('el-input',{attrs:{"maxlength":"20","placeholder":"例如G3107列车 1月20号班次"},model:{value:(_vm.vrInfo.erTrainService),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erTrainService", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erTrainService"}})],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[(_vm.vrInfo.erIsBus==1)?_c('el-form-item',{attrs:{"label":"客车班次：","prop":"erBusNumber","label-width":"110px"}},[_c('el-input',{attrs:{"maxlength":"20","placeholder":"请描述客车路线以及乘车时间"},model:{value:(_vm.vrInfo.erBusNumber),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erBusNumber", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erBusNumber"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"260px","label":"本人是否有发热、乏力、干咳等症状：","prop":"erHealth"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erHealth),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erHealth", $$v)},expression:"vrInfo.erHealth"}},[_vm._v("无")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erHealth),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erHealth", $$v)},expression:"vrInfo.erHealth"}},[_vm._v("有")])],1)],1),_vm._v(" "),(_vm.vrInfo.erHealth==2)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"症状描述：","prop":"erHealthRemark","label-width":"100px"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"50","placeholder":"请详细描述症状，如具体体温等信息"},model:{value:(_vm.vrInfo.erHealthRemark),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erHealthRemark", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erHealthRemark"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"350px","label":"家人 / 同住 / 邻居是否有发热、乏力、干咳等症状？：","prop":"erFamilyHealth"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erFamilyHealth),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erFamilyHealth", $$v)},expression:"vrInfo.erFamilyHealth"}},[_vm._v("无")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erFamilyHealth),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erFamilyHealth", $$v)},expression:"vrInfo.erFamilyHealth"}},[_vm._v("有")])],1)],1),_vm._v(" "),(_vm.vrInfo.erFamilyHealth==2)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"症状描述：","prop":"erFamilyHealthRemark","label-width":"100px"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"50","placeholder":"请详细描述具体人员，病症情况，病患接触情况等"},model:{value:(_vm.vrInfo.erFamilyHealthRemark),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erFamilyHealthRemark", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erFamilyHealthRemark"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"近一个月内是否前往过湖北省、浙江温州市等地区（含转车、转机停留）：","prop":"erContact"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erContact),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContact", $$v)},expression:"vrInfo.erContact"}},[_vm._v("无")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erContact),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContact", $$v)},expression:"vrInfo.erContact"}},[_vm._v("有")])],1)],1),_vm._v(" "),(_vm.vrInfo.erContact==2)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"详情描述：","prop":"erContactRemark","label-width":"100px"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"50","placeholder":"请详细描述症状，如具体体温等信息"},model:{value:(_vm.vrInfo.erContactRemark),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContactRemark", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erContactRemark"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"320px","label":"是否有新型冠状感染者（包括疑似病例）接触史：","prop":"erContactHistory"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erContactHistory),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContactHistory", $$v)},expression:"vrInfo.erContactHistory"}},[_vm._v("无")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erContactHistory),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContactHistory", $$v)},expression:"vrInfo.erContactHistory"}},[_vm._v("有")])],1)],1),_vm._v(" "),(_vm.vrInfo.erContactHistory==2)?_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"详情描述：","prop":"erContactHistoryRemark","label-width":"100px"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"50","placeholder":"请详细描述接触地区以及停留时间等信息"},model:{value:(_vm.vrInfo.erContactHistoryRemark),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erContactHistoryRemark", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erContactHistoryRemark"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"info-item"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"340px","label":"是否已按工作属地政策需求，完成居家隔离7/14天：","prop":"erIsIsolation"}},[_c('el-radio',{attrs:{"label":2},model:{value:(_vm.vrInfo.erIsIsolation),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erIsIsolation", $$v)},expression:"vrInfo.erIsIsolation"}},[_vm._v("无")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1},model:{value:(_vm.vrInfo.erIsIsolation),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erIsIsolation", $$v)},expression:"vrInfo.erIsIsolation"}},[_vm._v("有")])],1)],1)],1)])],1),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-form-item',{attrs:{"label":"其它备注信息：","prop":"erOtherRemark"}},[_c('el-input',{attrs:{"type":"textarea","maxlength":"50"},model:{value:(_vm.vrInfo.erOtherRemark),callback:function ($$v) {_vm.$set(_vm.vrInfo, "erOtherRemark", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"vrInfo.erOtherRemark"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cu18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d6Zr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['baseInfo'],
  name: '',
  components: {},
  data: function data() {
    return {
      baseData: {}
    };
  },
  mounted: function mounted() {},

  watch: {},
  methods: {
    init: function init() {}
  }
});

/***/ }),

/***/ "ddoJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eYLq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ec3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"title"},[_vm._v("基础信息：")]),_vm._v(" "),_c('el-row',{staticClass:"g-row"},[_c('el-col',{attrs:{"span":12}},[_vm._v("合同编号："+_vm._s(_vm.info.contractNumber))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v("合同类型："+_vm._s(_vm._f("contractType")(_vm.contractType)))])],1),_vm._v(" "),(_vm.contractType<3)?_c('div',{staticClass:"title"},[_vm._v("场地信息：")]):_c('div',{staticClass:"title"},[_vm._v("房源及入住人信息：")]),_vm._v(" "),_c('div',{staticClass:"g-basic-data"},[_vm._v("\n      "+_vm._s(_vm.info.build)),_c('span',[_vm._v(_vm._s(_vm.info.floor))]),_vm._v(_vm._s(_vm.info.room)),_c('span',[_vm._v(_vm._s(_vm.info.area)+"(m²)")])]),_vm._v(" "),(_vm.contractType>2)?_c('div',{staticClass:"g-basic-data",staticStyle:{"border-top":"1px solid #ccc"}},[_vm._v("\n      "+_vm._s(_vm.info.zuhulianxiren)),_c('span',[_vm._v(_vm._s(_vm.info.zuhuPhone))]),_c('span')]):_vm._e(),_vm._v(" "),(_vm.contractType == 1 || _vm.contractType == 3)?_c('div',{staticClass:"title"},[_vm._v("租赁条款摘要：")]):_vm._e(),_vm._v(" "),(_vm.contractType == 2 || _vm.contractType == 4)?_c('div',{staticClass:"title"},[_vm._v("物业合同信息：")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g-contract"},[(_vm.info.hetongzuqi)?_c('p',[_vm._v("• "+_vm._s(_vm.info.hetongzuqi))]):_vm._e(),_vm._v(" "),(_vm.info.hetongmianji)?_c('p',[_vm._v("• "+_vm._s(_vm.info.hetongmianji))]):_vm._e(),_vm._v(" "),_vm._l((_vm.info.heyuezujin),function(item,index){return (_vm.info.heyuezujin)?_c('p',{key:'heyue'+index},[_vm._v("• "+_vm._s(item))]):_vm._e()}),_vm._v(" "),_vm._l((_vm.info.mianzutiaokuan),function(item,index){return (_vm.info.mianzutiaokuan)?_c('p',{key:'mianzu'+index},[_vm._v("• "+_vm._s(item))]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"10px"}},[_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success"},on:{"click":function($event){_vm.electronicContractDialog = true;}}},[_vm._v("查看电子合同")]),_vm._v(" "),_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success"},on:{"click":function($event){_vm.contractBillDialog = true;}}},[_vm._v("查看账单明细")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"electronic-contract",attrs:{"title":"电子合同查看","append-to-body":"","visible":_vm.electronicContractDialog,"width":"50%","center":"","top":"3%"},on:{"update:visible":function($event){_vm.electronicContractDialog=$event}}},[(_vm.electronicContractDialog)?_c('v-electronic-contract',{attrs:{"contractId":_vm.contractId,"contractType":_vm.contractType>2?_vm.contractType+1:_vm.contractType},on:{"closeDialog":function($event){_vm.electronicContractDialog=false}}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{staticClass:"contract-bill",attrs:{"title":"合同账单明细","append-to-body":"","visible":_vm.contractBillDialog,"width":"50%","center":"","top":"3%"},on:{"update:visible":function($event){_vm.contractBillDialog=$event}}},[(_vm.contractBillDialog)?_c('v-bill-details',{attrs:{"contractId":_vm.contractId,"contractType":_vm.contractType == 1||_vm.contractType == 3 ? 1 : 2},on:{"closeDialog":function($event){_vm.contractBillDialog=false}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "edYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sever_detail_vue__ = __webpack_require__("rG00");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c4596e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sever_detail_vue__ = __webpack_require__("fPdv");
function injectStyle (ssrContext) {
  __webpack_require__("Fiv5")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4596e2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_sever_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c4596e2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_sever_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f3Wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__("EP0S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__("yXCo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip_utils__ = __webpack_require__("6Nr5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jszip_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_env__ = __webpack_require__("uaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fileAddDialog: false,
      confirmDialog: false,
      serverAddDialog: false,
      serverEditDialog: false,
      serverDetailDialog: false,
      confirmLoading: false,
      assessmentCompanyFiledId: "",
      fileName: "",
      filters: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 10,
        totalCount: 10,
        serveType: ""
      },
      matterList: [],
      matterInfo: {},
      accountDialog: false,
      fileList: [{}],
      serveList: [],
      //   new Array(5).fill(2).map((e, i) => {
      //     return {
      //       number: i,
      //       serveType: i,
      //       serveCompanyName: i,
      //       serveContactName: i,
      //       serveContactTelephone: i,
      //       self: i,
      //       connect: i,
      //     };
      //   }),
      servesListLoading: false,
      permission: {}
    };
  },

  props: ["assessmentCompanyId"],
  created: function created() {},

  components: {},
  mounted: function mounted() {
    this.init();
  },

  methods: {
    allDownload: function allDownload() {
      var _this2 = this;

      //   window.open(
      //     `/garden/assessmentCompany/downForZip?assessmentCompanyFiledId=${this.assessmentCompanyFiledId}&requestUrl=${ossUrl}&fileName=${this.fileName}`
      //   );

      var zip = new __WEBPACK_IMPORTED_MODULE_3_jszip___default.a();
      var progress = 0;
      this.fileList.forEach(function (e, i) {
        var _this = _this2;
        __WEBPACK_IMPORTED_MODULE_4_jszip_utils___default.a.getBinaryContent(e.assessmentCompanyFileUrl, function (err, binData) {
          zip.file(e.assessmentCompanyFileName, binData, { binary: true });
          ++progress;
          if (progress === _this.fileList.length) {
            zip.generateAsync({ type: "blob" }).then(function (content) {
              Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(content, "downForZip.zip");
            });
          }
        });
      });
    },
    init: function init() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["o" /* assessmentdetail */]({ assessmentCompanyId: this.assessmentCompanyId }).then(function (res) {
        if (res.data.code != "success") {
          _this3.$message.error(res.data.message || res.data.msg);
          return;
        }
        _this3.serveList = res.data.data.data;
        _this3.submitLoading = false;
      });
    },
    detail: function detail(row, index) {
      var _this4 = this;

      this.assessmentCompanyFiledId = row.assessmentCompanyFiled.assessmentCompanyFiledId;
      this.fileName = row.assessmentFiled.assessmentFiledTheme;
      __WEBPACK_IMPORTED_MODULE_0__service_getData__["n" /* assessmentFileList */]({
        assessmentCompanyFiledId: row.assessmentCompanyFiled.assessmentCompanyFiledId
      }).then(function (res) {
        if (res.data.code != "success") {
          _this4.$message.error(res.data.message || res.data.msg);
          return;
        }
        _this4.fileList = res.data.data.files;
        _this4.serverDetailDialog = true;
      });
    },
    preview: function preview(row, index) {
      var type = __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["c" /* fileUrl */](row.assessmentCompanyFileUrl);
      if (type == "word" || type == "excel") {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + row.assessmentCompanyFileUrl);
      }
      if (type == "pdf" || type == "image" || type == "txt") {
        window.open("" + row.assessmentCompanyFileUrl);
      }
      if (type == "package") {
        this.$message.error("该文件格式附件不支持在线预览，请下载后查看");
      }
    },
    download: function download(row, index) {
      var type = __WEBPACK_IMPORTED_MODULE_1__config_mUtils__["c" /* fileUrl */](row.assessmentCompanyFileUrl);
      Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(row.assessmentCompanyFileUrl, row.assessmentCompanyFileName);
      return;
      if (type == "word" || type == "excel" || type == "txt" || type == "package" || type == "image") {
        Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(row.assessmentCompanyFileUrl, row.assessmentCompanyFileName);
      }

      if (type == "pdf") {
        //   var oReq = new XMLHttpRequest();
        //   var URLToPDF = row.assessmentCompanyFileUrl;
        //   oReq.open("GET", URLToPDF, true);
        //   oReq.responseType = "blob";
        //   oReq.onload = function () {
        //     var file = new Blob([oReq.response], {
        //       type: "application/pdf",
        //     });
        //     saveAs(file, row.assessmentCompanyFileName);
        //   };
        //   oReq.send();
        this.handlePdfLink(row.assessmentCompanyFileUrl, row.assessmentCompanyFileName);
      }
      //   if (type == "image") {
      //     const image = new Image();
      //     image.setAttribute("crossOrigin", "Anonymous");
      //     image.src = row.assessmentCompanyFileUrl;
      //     const url = global.image2base64(image);
      //     const a = document.createElement("a");
      //     a.setAttribute("href", "" + url); //a.href='文件链接'
      //     a.setAttribute("download", row.assessmentCompanyFileName); //a.download='文件名'
      //     a.click();
      //   }
    },
    handlePdfLink: function handlePdfLink(url, filename) {
      var oReq = new XMLHttpRequest();
      var URLToPDF = url;
      oReq.open("GET", URLToPDF, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "application/pdf"
        });
        Object(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(file, filename);
      };
      oReq.send();
    }
  },
  watch: {}
});

/***/ }),

/***/ "fPdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('div',{staticClass:"dialog-form"},[_c('h3',{staticClass:"title",staticStyle:{"padding-left":"20px"}},[_vm._v(_vm._s(_vm.serveInfo.serveType))]),_vm._v(" "),_c('div',{staticClass:"f-content"},[_vm._v("\n      "+_vm._s(_vm.serveInfo.serveDes)+"\n    ")]),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"20px","box-sizing":"border-box"}},[_c('el-col',[_c('div',{staticClass:"f-form-item"},[_c('div',{staticClass:"f-form-item-label"},[_vm._v("企业名称")]),_vm._v(" "),_c('div',{staticClass:"f-form-item-content"},[_vm._v(_vm._s(_vm.serveInfo.serveCompanyName))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"f-form-item"},[_c('div',{staticClass:"f-form-item-label"},[_vm._v("联系人：")]),_vm._v(" "),_c('div',{staticClass:"f-form-item-content"},[_vm._v(_vm._s(_vm.serveInfo.serveContactName))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"f-form-item"},[_c('div',{staticClass:"f-form-item-label"},[_vm._v("联系方式：")]),_vm._v(" "),_c('div',{staticClass:"f-form-item-content"},[_vm._v(_vm._s(_vm.serveInfo.serveContactTelephone))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"f-form-item"},[_c('div',{staticClass:"f-form-item-label"},[_vm._v("联系地址：")]),_vm._v(" "),_c('div',{staticClass:"f-form-item-content"},[_vm._v(_vm._s(_vm.serveInfo.serveContactAddress))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"f-form-item"},[_c('div',{staticClass:"f-form-item-label"},[_vm._v("企业简介：")]),_vm._v(" "),_c('div',{staticClass:"f-form-item-content"},[_vm._v("\n            "+_vm._s(_vm.serveInfo.serveCompanyDes)+"\n          ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.close}},[_vm._v("确     认")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fytT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {},
      activities: [],
      noteCreateName: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['noteId'],
  computed: {},
  methods: {
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_60" /* noteNoteDetail */]({ noteId: this.noteId }).then(function (res) {
        if (res.data.code === 1) {
          _this.info = res.data.data.note;
          _this.info.noteFile = res.data.data.note.noteFile ? JSON.parse(res.data.data.note.noteFile) : '';
          _this.noteCreateName = res.data.data.noteCreateName;
          _this.activities = res.data.data.records.map(function (item) {
            var state = "";
            var color = "";
            var content = "";
            var icon = "";
            var time = "";
            content = "" + item.noteRecordName;
            time = new Date(item.noteRecordTime).format('yyyy-MM-dd hh:mm:ss');
            if (item.noteRecordOperation == 2) {
              state = "审批通过";
              color = '#409EFF';
              icon = 'el-icon-check';
            } else if (item.noteRecordOperation == 3) {
              state = "审批驳回";
              color = '#F56C6C';
              icon = 'el-icon-close';
            } else if (item.noteRecordOperation == 1) {
              state = "发起";
              color = '#409EFF';
              icon = 'el-icon-check';
            } else {
              content = "" + item.noteRecordName;
              time = "";
            }
            item.content = content;
            item.timestamp = time;
            item.icon = icon;
            item.color = color;
            item.state = state;
            return item;
          });
        } else {
          _this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_61" /* noteSure */](this.noteId).then(function (res) {
        if (res.data.code === 1) {
          _this2.$message({
            message: '确认成功',
            type: "success"
          });
          _this2.close(1);
        } else {
          _this2.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    openFile: function openFile(url) {
      window.open(url);
    },
    downLoad: function downLoad(file) {
      window.open('/company/download/downloadWorkflowFileUseName?fileName=' + file.fileName + '&fileUrl=' + file.exportFile);
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "g6ak":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g7e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","model":_vm.approvalInfo,"label-width":"120px"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_vm._v("\n              您还可以新增："+_vm._s(_vm.num)+" 人\n        ")])],1)],1),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("\n      选择员工：\n      "),_c('el-checkbox',{staticClass:"title-label-right",attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}},[_vm._v("全选")])],1),_vm._v(" "),_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-checkbox-group',{on:{"change":_vm.handlecheckedStaffChange},model:{value:(_vm.checkedStaff),callback:function ($$v) {_vm.checkedStaff=$$v},expression:"checkedStaff"}},_vm._l((_vm.staffs),function(item,index){return _c('el-checkbox',{key:index,staticStyle:{"display":"block"},attrs:{"label":item}},[_c('span',{staticClass:"g-text"},[_vm._v(" "+_vm._s(item.baseName))]),_vm._v(" "),_c('span',{staticClass:"g-text"},[_vm._v(" "+_vm._s(item.basePhone))]),_vm._v(" "),(item.healthCodeType==1)?_c('span',{staticClass:"g-green"},[_vm._v("自由通行")]):_vm._e(),_vm._v(" "),(item.healthCodeType==2)?_c('span',{staticClass:"g-red"},[_vm._v("受限制")]):_vm._e()])}),1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.submitLoading,"disabled":_vm.isDisabled},on:{"click":_vm.submit}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gTve":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* ydui-district v1.1.0 by YDCSS (c) 2017 Licensed ISC */
!function () {
  var district = [{ "v": "1", "n": "北京", "c": [{ "v": "2816", "n": "密云区", "c": [{ "v": "6667", "n": "城区" }, { "v": "2862", "n": "城区以外" }] }, { "v": "72", "n": "朝阳区", "c": [{ "v": "2819", "n": "三环到四环之间" }, { "v": "2839", "n": "四环到五环之间" }, { "v": "2840", "n": "五环到六环之间" }, { "v": "4137", "n": "管庄" }, { "v": "4139", "n": "北苑" }, { "v": "4211", "n": "定福庄" }, { "v": "2799", "n": "三环以内" }] }, { "v": "2901", "n": "昌平区", "c": [{ "v": "4135", "n": "六环以内" }, { "v": "4136", "n": "城区" }, { "v": "2906", "n": "城区以外" }] }, { "v": "2953", "n": "平谷区", "c": [{ "v": "6666", "n": "城区" }, { "v": "2954", "n": "城区以外" }] }, { "v": "2800", "n": "海淀区", "c": [{ "v": "2848", "n": "三环以内" }, { "v": "2849", "n": "三环到四环之间" }, { "v": "2850", "n": "四环到五环之间" }, { "v": "2851", "n": "五环到六环之间" }, { "v": "2852", "n": "六环以外" }, { "v": "4134", "n": "西三旗" }, { "v": "4209", "n": "西二旗" }] }, { "v": "2801", "n": "西城区", "c": [{ "v": "2827", "n": "内环到二环里" }, { "v": "2853", "n": "二环到三环" }] }, { "v": "2802", "n": "东城区", "c": [{ "v": "2821", "n": "内环到三环里" }] }, { "v": "2803", "n": "崇文区", "c": [{ "v": "2829", "n": "一环到二环" }, { "v": "2842", "n": "二环到三环" }] }, { "v": "2804", "n": "宣武区", "c": [{ "v": "2828", "n": "内环到三环里" }] }, { "v": "2805", "n": "丰台区", "c": [{ "v": "2832", "n": "四环到五环之间" }, { "v": "2854", "n": "二环到三环" }, { "v": "2855", "n": "三环到四环之间" }, { "v": "34544", "n": "五环到六环之间" }, { "v": "34545", "n": "六环之外" }] }, { "v": "2806", "n": "石景山区", "c": [{ "v": "2831", "n": "四环到五环内" }, { "v": "4187", "n": "石景山城区" }, { "v": "4188", "n": "八大处科技园区" }] }, { "v": "2807", "n": "门头沟", "c": [{ "v": "51552", "n": "城区" }, { "v": "51553", "n": "龙泉镇" }, { "v": "51554", "n": "永定镇" }, { "v": "51555", "n": "大台镇" }, { "v": "51556", "n": "潭柘寺镇" }, { "v": "51557", "n": "王平镇" }, { "v": "51558", "n": "军庄镇" }, { "v": "51559", "n": "妙峰山镇" }, { "v": "51560", "n": "雁翅镇" }, { "v": "51561", "n": "斋堂镇" }, { "v": "51562", "n": "清水镇" }] }, { "v": "2808", "n": "房山区", "c": [{ "v": "51529", "n": "大安山乡" }, { "v": "51530", "n": "大石窝镇" }, { "v": "51531", "n": "窦店镇" }, { "v": "51532", "n": "佛子庄乡" }, { "v": "51534", "n": "韩村河镇" }, { "v": "51535", "n": "河北镇" }, { "v": "51536", "n": "良乡镇" }, { "v": "51537", "n": "琉璃河镇" }, { "v": "51538", "n": "南窖乡" }, { "v": "51539", "n": "蒲洼乡" }, { "v": "51540", "n": "青龙湖镇" }, { "v": "51541", "n": "十渡镇" }, { "v": "51542", "n": "石楼镇" }, { "v": "51543", "n": "史家营乡" }, { "v": "51544", "n": "霞云岭乡" }, { "v": "51545", "n": "新镇" }, { "v": "51546", "n": "阎村镇" }, { "v": "51547", "n": "燕山地区" }, { "v": "51548", "n": "张坊镇" }, { "v": "51549", "n": "长沟镇" }, { "v": "51550", "n": "长阳镇" }, { "v": "51551", "n": "周口店镇" }, { "v": "51528", "n": "城区" }] }, { "v": "2809", "n": "通州区", "c": [{ "v": "51216", "n": "六环内（马驹桥镇）" }, { "v": "51228", "n": "中仓街道" }, { "v": "51229", "n": "新华街道" }, { "v": "51230", "n": "玉桥街道" }, { "v": "51231", "n": "北苑街道" }, { "v": "51217", "n": "六环外（马驹桥镇）" }, { "v": "51218", "n": "永顺镇" }, { "v": "51219", "n": "梨园镇" }, { "v": "51220", "n": "宋庄镇" }, { "v": "51221", "n": "漷县镇" }, { "v": "51222", "n": "张家湾镇" }, { "v": "51223", "n": "西集镇" }, { "v": "51224", "n": "永乐店镇" }, { "v": "51225", "n": "潞城镇" }, { "v": "51226", "n": "台湖镇" }, { "v": "51227", "n": "于家务乡" }, { "v": "51232", "n": "次渠镇" }] }, { "v": "3065", "n": "延庆县", "c": [{ "v": "51505", "n": "延庆镇" }, { "v": "51506", "n": "城区" }, { "v": "51507", "n": "康庄镇" }, { "v": "51508", "n": "八达岭镇" }, { "v": "51509", "n": "永宁镇" }, { "v": "51510", "n": "旧县镇" }, { "v": "51511", "n": "张山营镇" }, { "v": "51512", "n": "四海镇" }, { "v": "51513", "n": "千家店镇" }, { "v": "51514", "n": "沈家营镇" }, { "v": "51515", "n": "大榆树镇" }, { "v": "51516", "n": "井庄镇" }, { "v": "51517", "n": "大庄科乡" }, { "v": "51518", "n": "刘斌堡乡" }, { "v": "51519", "n": "香营乡" }, { "v": "51520", "n": "珍珠泉乡" }] }, { "v": "2810", "n": "大兴区", "c": [{ "v": "4194", "n": "四环至五环之间" }, { "v": "6501", "n": "五环至六环之间" }, { "v": "4205", "n": "六环以外" }, { "v": "51081", "n": "亦庄经济开发区" }] }, { "v": "2812", "n": "顺义区", "c": [{ "v": "51125", "n": "北石槽镇" }, { "v": "51126", "n": "北务镇" }, { "v": "51127", "n": "北小营镇" }, { "v": "51128", "n": "大孙各庄镇" }, { "v": "51129", "n": "高丽营镇" }, { "v": "51130", "n": "光明街道" }, { "v": "51131", "n": "后沙峪地区" }, { "v": "51132", "n": "空港街道" }, { "v": "51133", "n": "李桥镇" }, { "v": "51134", "n": "李遂镇" }, { "v": "51135", "n": "龙湾屯镇" }, { "v": "51136", "n": "马坡地区" }, { "v": "51137", "n": "木林镇" }, { "v": "51138", "n": "南彩镇" }, { "v": "51139", "n": "南法信地区" }, { "v": "51140", "n": "牛栏山地区" }, { "v": "51141", "n": "仁和地区" }, { "v": "51142", "n": "胜利街道" }, { "v": "51143", "n": "石园街道" }, { "v": "51144", "n": "双丰街道" }, { "v": "51145", "n": "天竺地区" }, { "v": "51146", "n": "旺泉街道" }, { "v": "51147", "n": "杨镇地区" }, { "v": "51148", "n": "张镇" }, { "v": "51149", "n": "赵全营镇" }] }, { "v": "2814", "n": "怀柔区", "c": [{ "v": "6115", "n": "城区以内" }, { "v": "2847", "n": "郊区" }] }] }, { "v": "2", "n": "上海", "c": [{ "v": "2817", "n": "静安区", "c": [{ "v": "51973", "n": "城区" }] }, { "v": "2820", "n": "闸北区", "c": [{ "v": "51972", "n": "城区" }] }, { "v": "2822", "n": "虹口区", "c": [{ "v": "51979", "n": "城区" }] }, { "v": "2823", "n": "杨浦区", "c": [{ "v": "51974", "n": "城区" }] }, { "v": "2824", "n": "宝山区", "c": [{ "v": "51911", "n": "罗店镇" }, { "v": "51921", "n": "城区" }, { "v": "51912", "n": "大场镇" }, { "v": "51913", "n": "杨行镇" }, { "v": "51914", "n": "月浦镇" }, { "v": "51915", "n": "罗泾镇" }, { "v": "51916", "n": "顾村镇" }, { "v": "51917", "n": "高境镇" }, { "v": "51918", "n": "庙行镇" }, { "v": "51919", "n": "淞南镇" }, { "v": "51920", "n": "宝山城市工业园区" }] }, { "v": "2825", "n": "闵行区", "c": [{ "v": "51931", "n": "城区" }, { "v": "51932", "n": "莘庄镇" }, { "v": "51933", "n": "七宝镇" }, { "v": "51934", "n": "浦江镇" }, { "v": "51935", "n": "梅陇镇" }, { "v": "51936", "n": "虹桥镇" }, { "v": "51937", "n": "马桥镇" }, { "v": "51938", "n": "吴泾镇" }, { "v": "51939", "n": "华漕镇" }, { "v": "51940", "n": "颛桥镇" }] }, { "v": "2826", "n": "嘉定区", "c": [{ "v": "51941", "n": "城区" }, { "v": "51942", "n": "南翔镇" }, { "v": "51943", "n": "马陆镇" }, { "v": "51944", "n": "华亭镇" }, { "v": "51945", "n": "江桥镇" }, { "v": "51946", "n": "菊园新区" }, { "v": "51947", "n": "安亭镇" }, { "v": "51948", "n": "徐行镇" }, { "v": "51949", "n": "外冈镇" }, { "v": "51950", "n": "嘉定工业区" }] }, { "v": "2830", "n": "浦东新区", "c": [{ "v": "51800", "n": "城区" }, { "v": "51801", "n": "川沙新镇" }, { "v": "51822", "n": "祝桥镇" }, { "v": "51823", "n": "新场镇" }, { "v": "51802", "n": "高桥镇" }, { "v": "51824", "n": "惠南镇" }, { "v": "51803", "n": "北蔡镇" }, { "v": "51804", "n": "合庆镇" }, { "v": "51805", "n": "唐镇" }, { "v": "51806", "n": "曹路镇" }, { "v": "51807", "n": "金桥镇" }, { "v": "51808", "n": "高行镇" }, { "v": "51809", "n": "高东镇" }, { "v": "51810", "n": "张江镇" }, { "v": "51811", "n": "三林镇" }, { "v": "51812", "n": "南汇新城镇" }, { "v": "51825", "n": "康桥镇" }, { "v": "51826", "n": "宣桥镇" }, { "v": "51827", "n": "书院镇" }, { "v": "51828", "n": "大团镇" }, { "v": "51829", "n": "周浦镇" }, { "v": "51830", "n": "芦潮港镇" }, { "v": "51831", "n": "泥城镇" }, { "v": "51832", "n": "航头镇" }, { "v": "51833", "n": "万祥镇" }, { "v": "51834", "n": "老港镇" }] }, { "v": "2833", "n": "青浦区", "c": [{ "v": "51959", "n": "城区" }, { "v": "51952", "n": "赵巷镇" }, { "v": "51953", "n": "徐泾镇" }, { "v": "51954", "n": "华新镇" }, { "v": "51955", "n": "重固镇" }, { "v": "51956", "n": "白鹤镇" }, { "v": "51957", "n": "练塘镇" }, { "v": "51958", "n": "金泽镇" }, { "v": "51951", "n": "朱家角镇" }] }, { "v": "2834", "n": "松江区", "c": [{ "v": "51982", "n": "城区" }, { "v": "51983", "n": "泗泾镇" }, { "v": "51984", "n": "佘山镇" }, { "v": "51985", "n": "车墩镇" }, { "v": "51986", "n": "新桥镇" }, { "v": "51987", "n": "洞泾镇" }, { "v": "51988", "n": "九亭镇" }, { "v": "51989", "n": "泖港镇" }, { "v": "51990", "n": "石湖荡镇" }, { "v": "51991", "n": "新浜镇" }, { "v": "51992", "n": "叶榭镇" }, { "v": "51993", "n": "小昆山镇" }] }, { "v": "2835", "n": "金山区", "c": [{ "v": "51960", "n": "城区" }, { "v": "51961", "n": "金山工业区" }, { "v": "51962", "n": "朱泾镇" }, { "v": "51963", "n": "枫泾镇" }, { "v": "51964", "n": "张堰镇" }, { "v": "51965", "n": "亭林镇" }, { "v": "51966", "n": "吕巷镇" }, { "v": "51967", "n": "廊下镇" }, { "v": "51968", "n": "金山卫镇" }, { "v": "51970", "n": "漕泾镇" }, { "v": "51971", "n": "山阳镇" }] }, { "v": "2837", "n": "奉贤区", "c": [{ "v": "51928", "n": "南桥镇" }, { "v": "51929", "n": "奉城镇" }, { "v": "51930", "n": "四团镇" }, { "v": "51994", "n": "柘林镇" }, { "v": "51995", "n": "庄行镇" }, { "v": "51996", "n": "金汇镇" }, { "v": "51997", "n": "青村镇" }, { "v": "51998", "n": "海湾镇" }] }, { "v": "2841", "n": "普陀区", "c": [{ "v": "51980", "n": "城区" }] }, { "v": "78", "n": "黄浦区", "c": [{ "v": "51978", "n": "城区" }] }, { "v": "2919", "n": "崇明县", "c": [{ "v": "50779", "n": "堡镇" }, { "v": "50780", "n": "庙镇" }, { "v": "50781", "n": "陈家镇" }, { "v": "50782", "n": "城桥镇" }, { "v": "50783", "n": "东平镇" }, { "v": "50784", "n": "港西镇" }, { "v": "50785", "n": "港沿镇" }, { "v": "50786", "n": "建设镇" }, { "v": "50787", "n": "绿华镇" }, { "v": "50788", "n": "三星镇" }, { "v": "50789", "n": "竖新镇" }, { "v": "50790", "n": "向化镇" }, { "v": "50791", "n": "新海镇" }, { "v": "50792", "n": "新河镇" }, { "v": "50793", "n": "中兴镇" }, { "v": "50794", "n": "长兴乡" }, { "v": "50795", "n": "横沙乡" }, { "v": "50796", "n": "新村乡" }] }, { "v": "2813", "n": "徐汇区", "c": [{ "v": "51976", "n": "城区" }] }, { "v": "2815", "n": "长宁区", "c": [{ "v": "51975", "n": "城区" }] }] }, { "v": "3", "n": "天津", "c": [{ "v": "51035", "n": "东丽区", "c": [{ "v": "39620", "n": "全境" }] }, { "v": "51036", "n": "和平区", "c": [{ "v": "2984", "n": "全境" }] }, { "v": "51037", "n": "河北区", "c": [{ "v": "2987", "n": "全境" }] }, { "v": "51038", "n": "河东区", "c": [{ "v": "3000", "n": "全境" }] }, { "v": "51039", "n": "河西区", "c": [{ "v": "2985", "n": "全境" }] }, { "v": "51040", "n": "红桥区", "c": [{ "v": "2986", "n": "全境" }] }, { "v": "51041", "n": "蓟县", "c": [{ "v": "98", "n": "全境" }] }, { "v": "51042", "n": "静海县", "c": [{ "v": "36157", "n": "全境" }] }, { "v": "51043", "n": "南开区", "c": [{ "v": "2907", "n": "全境" }] }, { "v": "51044", "n": "塘沽区", "c": [{ "v": "25708", "n": "全境" }] }, { "v": "51045", "n": "西青区", "c": [{ "v": "25712", "n": "杨柳青,中北,精武,大寺镇,环外海泰及外环内" }, { "v": "25711", "n": "其它地区" }] }, { "v": "51046", "n": "武清区", "c": [{ "v": "22846", "n": "杨村镇、下朱庄内" }, { "v": "22847", "n": "其它地区" }] }, { "v": "51047", "n": "津南区", "c": [{ "v": "36171", "n": "双港，辛庄" }, { "v": "25704", "n": "咸水沽镇、海河教育园，海河科技园" }, { "v": "36172", "n": "其他地区" }] }, { "v": "51048", "n": "汉沽区", "c": [{ "v": "23672", "n": "汉沽区街里、汉沽开发区" }, { "v": "23673", "n": "其它地区" }] }, { "v": "51049", "n": "大港区", "c": [{ "v": "8545", "n": "大港油田" }, { "v": "8546", "n": "主城区内" }, { "v": "8547", "n": "主城区外" }] }, { "v": "51050", "n": "北辰区", "c": [{ "v": "36167", "n": "外环外双街镇，河北工大新校，屈店工业园" }, { "v": "6646", "n": "外环内" }, { "v": "36168", "n": "外环外其它地区" }] }, { "v": "51051", "n": "宝坻区", "c": [{ "v": "22848", "n": "城关镇、马家店开发区、天宝工业园" }, { "v": "22849", "n": "其它地区" }] }, { "v": "51052", "n": "宁河县", "c": [{ "v": "23674", "n": "芦台镇、经济开发区、贸易开发区" }, { "v": "23675", "n": "其它地区" }] }] }, { "v": "4", "n": "重庆", "c": [{ "v": "48131", "n": "璧山县", "c": [{ "v": "48185", "n": "县城内" }, { "v": "48188", "n": "青杠镇" }, { "v": "48189", "n": "来凤镇" }, { "v": "48190", "n": "丁家镇" }, { "v": "48191", "n": "大路镇" }, { "v": "48192", "n": "八塘镇" }, { "v": "48193", "n": "七塘镇" }, { "v": "48194", "n": "河边镇" }, { "v": "48195", "n": "福禄镇" }, { "v": "48196", "n": "大兴镇" }, { "v": "48197", "n": "正兴镇" }, { "v": "48198", "n": "广普镇" }, { "v": "48199", "n": "三合镇" }, { "v": "48200", "n": "健龙镇" }] }, { "v": "48132", "n": "荣昌县", "c": [{ "v": "48163", "n": "县城内" }, { "v": "48166", "n": "广顺镇" }, { "v": "48167", "n": "安富镇" }, { "v": "48168", "n": "峰高镇" }, { "v": "48169", "n": "双河镇" }, { "v": "48170", "n": "直升镇" }, { "v": "48171", "n": "路孔镇" }, { "v": "48172", "n": "清江镇" }, { "v": "48173", "n": "仁义镇" }, { "v": "48174", "n": "河包镇" }, { "v": "48175", "n": "古昌镇" }, { "v": "48176", "n": "吴家镇" }, { "v": "48177", "n": "观胜镇" }, { "v": "48178", "n": "铜鼓镇" }, { "v": "48179", "n": "清流镇" }, { "v": "48180", "n": "盘龙镇" }, { "v": "48181", "n": "远觉镇" }, { "v": "48182", "n": "清升镇" }, { "v": "48183", "n": "荣隆镇" }, { "v": "48184", "n": "龙集镇" }] }, { "v": "48133", "n": "铜梁县", "c": [{ "v": "48134", "n": "县城内" }, { "v": "48138", "n": "土桥镇" }, { "v": "48139", "n": "二坪镇" }, { "v": "48140", "n": "水口镇" }, { "v": "48141", "n": "安居镇" }, { "v": "48142", "n": "白羊镇" }, { "v": "48143", "n": "平滩镇" }, { "v": "48144", "n": "石鱼镇" }, { "v": "48145", "n": "福果镇" }, { "v": "48146", "n": "维新镇" }, { "v": "48147", "n": "高楼镇" }, { "v": "48148", "n": "大庙镇" }, { "v": "48149", "n": "围龙镇" }, { "v": "48150", "n": "华兴镇" }, { "v": "48151", "n": "永嘉镇" }, { "v": "48152", "n": "安溪镇" }, { "v": "48153", "n": "西河镇" }, { "v": "48154", "n": "太平镇" }, { "v": "48155", "n": "旧县镇" }, { "v": "48156", "n": "虎峰镇" }, { "v": "48157", "n": "少云镇" }, { "v": "48158", "n": "蒲吕镇" }, { "v": "48159", "n": "侣俸镇" }, { "v": "48160", "n": "小林乡" }, { "v": "48161", "n": "双山乡" }, { "v": "48162", "n": "庆隆乡" }] }, { "v": "50950", "n": "江北区", "c": [{ "v": "88", "n": "内环以内" }, { "v": "50957", "n": "寸滩镇" }, { "v": "50958", "n": "郭家沱镇" }, { "v": "50959", "n": "铁山坪镇" }, { "v": "50960", "n": "鱼嘴镇" }, { "v": "50961", "n": "复盛镇" }, { "v": "50962", "n": "五宝镇" }, { "v": "51198", "n": "大石坝镇" }] }, { "v": "50951", "n": "南岸区", "c": [{ "v": "52496", "n": "城区" }, { "v": "4298", "n": "内环以内" }, { "v": "50963", "n": "茶园新区" }, { "v": "50964", "n": "鸡冠石镇" }, { "v": "50965", "n": "长生桥镇" }, { "v": "50966", "n": "峡口镇" }, { "v": "50967", "n": "广阳镇" }, { "v": "50968", "n": "迎龙镇" }] }, { "v": "50952", "n": "九龙坡区", "c": [{ "v": "106", "n": "内环以内" }, { "v": "50969", "n": "白市驿镇" }, { "v": "50970", "n": "铜罐驿镇" }, { "v": "50971", "n": "华岩镇" }, { "v": "50972", "n": "巴福镇" }, { "v": "50973", "n": "含谷镇" }, { "v": "50974", "n": "金凤镇" }, { "v": "50975", "n": "石板镇" }, { "v": "50976", "n": "陶家镇" }, { "v": "50977", "n": "西彭镇" }, { "v": "50978", "n": "走马镇" }] }, { "v": "50953", "n": "沙坪坝区", "c": [{ "v": "50979", "n": "内环以内" }, { "v": "50980", "n": "陈家桥镇" }, { "v": "50981", "n": "歌乐山镇" }, { "v": "50982", "n": "青木关镇" }, { "v": "50983", "n": "回龙坝镇" }, { "v": "50984", "n": "大学城" }, { "v": "50985", "n": "虎溪镇" }, { "v": "50986", "n": "西永镇" }, { "v": "50987", "n": "土主镇" }, { "v": "50988", "n": "井口镇" }, { "v": "50989", "n": "曾家镇" }, { "v": "50990", "n": "凤凰镇" }, { "v": "50991", "n": "中梁镇" }] }, { "v": "50954", "n": "大渡口区", "c": [{ "v": "50992", "n": "茄子溪镇" }, { "v": "50993", "n": "建胜镇" }, { "v": "50994", "n": "跳磴镇" }, { "v": "111", "n": "内环以内" }] }, { "v": "50995", "n": "綦江区", "c": [{ "v": "52497", "n": "城区" }, { "v": "51000", "n": "三江镇" }, { "v": "51001", "n": "安稳镇" }, { "v": "51002", "n": "打通镇" }, { "v": "51003", "n": "丁山镇" }, { "v": "51004", "n": "东溪镇" }, { "v": "51005", "n": "扶欢镇" }, { "v": "51006", "n": "赶水镇" }, { "v": "51007", "n": "郭扶镇" }, { "v": "51008", "n": "横山镇" }, { "v": "51009", "n": "隆盛镇" }, { "v": "51010", "n": "三角镇" }, { "v": "51011", "n": "石壕镇" }, { "v": "51012", "n": "石角镇" }, { "v": "51013", "n": "新盛镇" }, { "v": "51014", "n": "永城镇" }, { "v": "51015", "n": "永新镇" }, { "v": "51016", "n": "中峰镇" }, { "v": "51017", "n": "篆塘镇" }, { "v": "51018", "n": "丛林镇" }, { "v": "51019", "n": "关坝镇" }, { "v": "51020", "n": "黑山镇" }, { "v": "51021", "n": "金桥镇" }, { "v": "51022", "n": "南桐镇" }, { "v": "51023", "n": "青年镇" }, { "v": "51024", "n": "石林镇" }, { "v": "51025", "n": "万东镇" }] }, { "v": "48201", "n": "合川区", "c": [{ "v": "52489", "n": "城区" }, { "v": "48298", "n": "草街镇" }, { "v": "48299", "n": "盐井镇" }, { "v": "48300", "n": "云门镇" }, { "v": "48301", "n": "大石镇" }, { "v": "48302", "n": "沙鱼镇" }, { "v": "48303", "n": "官渡镇" }, { "v": "48304", "n": "涞滩镇" }, { "v": "48305", "n": "肖家镇" }, { "v": "48306", "n": "古楼镇" }, { "v": "48307", "n": "三庙镇" }, { "v": "48308", "n": "二郎镇" }, { "v": "48309", "n": "龙凤镇" }, { "v": "48310", "n": "隆兴镇" }, { "v": "48311", "n": "铜溪镇" }, { "v": "48312", "n": "双凤镇" }, { "v": "48313", "n": "狮滩镇" }, { "v": "48314", "n": "清平镇" }, { "v": "48315", "n": "土场镇" }, { "v": "48316", "n": "小沔镇" }, { "v": "48317", "n": "三汇镇" }, { "v": "48318", "n": "香龙镇" }, { "v": "48319", "n": "钱塘镇" }, { "v": "48320", "n": "龙市镇" }, { "v": "48321", "n": "燕窝镇" }, { "v": "48322", "n": "太和镇" }, { "v": "48323", "n": "渭沱镇" }, { "v": "48324", "n": "双槐镇" }] }, { "v": "48202", "n": "巴南区", "c": [{ "v": "52490", "n": "城区" }, { "v": "48355", "n": "南泉镇" }, { "v": "48356", "n": "一品镇" }, { "v": "48357", "n": "南彭镇" }, { "v": "48358", "n": "惠民镇" }, { "v": "48359", "n": "麻柳嘴镇" }, { "v": "48360", "n": "天星寺镇" }, { "v": "48361", "n": "双河口镇" }, { "v": "48362", "n": "界石镇" }, { "v": "48363", "n": "安澜镇" }, { "v": "48364", "n": "跳石镇" }, { "v": "48365", "n": "木洞镇" }, { "v": "48366", "n": "丰盛镇" }, { "v": "48367", "n": "二圣镇" }, { "v": "48368", "n": "东泉镇" }, { "v": "48369", "n": "姜家镇" }, { "v": "48370", "n": "接龙镇" }, { "v": "48371", "n": "石滩镇" }, { "v": "48372", "n": "石龙镇" }] }, { "v": "48203", "n": "北碚区", "c": [{ "v": "52491", "n": "城区" }, { "v": "48240", "n": "东阳镇" }, { "v": "48242", "n": "蔡家岗镇" }, { "v": "48243", "n": "童家溪镇" }, { "v": "48244", "n": "施家梁镇" }, { "v": "48245", "n": "金刀峡镇" }, { "v": "48246", "n": "澄江镇" }, { "v": "48247", "n": "水土镇" }, { "v": "48248", "n": "歇马镇" }, { "v": "48249", "n": "天府镇" }, { "v": "48250", "n": "复兴镇" }, { "v": "48251", "n": "静观镇" }, { "v": "48252", "n": "柳荫镇" }, { "v": "48253", "n": "三圣镇" }] }, { "v": "48204", "n": "江津区", "c": [{ "v": "52492", "n": "城区" }, { "v": "53556", "n": "双福镇" }, { "v": "48213", "n": "四面山镇" }, { "v": "48214", "n": "支坪镇" }, { "v": "48215", "n": "白沙镇" }, { "v": "48216", "n": "珞璜镇" }, { "v": "48217", "n": "柏林镇" }, { "v": "48218", "n": "蔡家镇" }, { "v": "48219", "n": "慈云镇" }, { "v": "48220", "n": "杜市镇" }, { "v": "48221", "n": "广兴镇" }, { "v": "48222", "n": "嘉平镇" }, { "v": "48223", "n": "贾嗣镇" }, { "v": "48224", "n": "李市镇" }, { "v": "48225", "n": "龙华镇" }, { "v": "48226", "n": "石蟆镇" }, { "v": "48227", "n": "石门镇" }, { "v": "48228", "n": "塘河镇" }, { "v": "48229", "n": "吴滩镇" }, { "v": "48230", "n": "西湖镇" }, { "v": "48231", "n": "夏坝镇" }, { "v": "48232", "n": "先锋镇" }, { "v": "48233", "n": "永兴镇" }, { "v": "48234", "n": "油溪镇" }, { "v": "48235", "n": "中山镇" }, { "v": "48236", "n": "朱杨镇" }] }, { "v": "48205", "n": "渝北区", "c": [{ "v": "52493", "n": "城区" }, { "v": "48332", "n": "礼嘉镇" }, { "v": "48337", "n": "两路镇" }, { "v": "48338", "n": "王家镇" }, { "v": "48339", "n": "悦来镇" }, { "v": "48340", "n": "玉峰山镇" }, { "v": "48341", "n": "茨竹镇" }, { "v": "48342", "n": "大盛镇" }, { "v": "48343", "n": "大塆镇" }, { "v": "48344", "n": "古路镇" }, { "v": "48345", "n": "龙兴镇" }, { "v": "48346", "n": "洛碛镇" }, { "v": "48347", "n": "木耳镇" }, { "v": "48348", "n": "石船镇" }, { "v": "48349", "n": "统景镇" }, { "v": "48350", "n": "兴隆镇" }] }, { "v": "48206", "n": "长寿区", "c": [{ "v": "52494", "n": "城区" }, { "v": "48281", "n": "长寿湖镇" }, { "v": "48282", "n": "邻封镇" }, { "v": "48283", "n": "但渡镇" }, { "v": "48284", "n": "云集镇" }, { "v": "48285", "n": "双龙镇" }, { "v": "48286", "n": "龙河镇" }, { "v": "48287", "n": "石堰镇" }, { "v": "48288", "n": "云台镇" }, { "v": "48289", "n": "海棠镇" }, { "v": "48290", "n": "葛兰镇" }, { "v": "48291", "n": "新市镇" }, { "v": "48292", "n": "八颗镇" }, { "v": "48293", "n": "洪湖镇" }, { "v": "48294", "n": "万顺镇" }] }, { "v": "48207", "n": "永川区", "c": [{ "v": "52495", "n": "城区" }, { "v": "48257", "n": "双竹镇" }, { "v": "48258", "n": "三教镇" }, { "v": "48259", "n": "大安镇" }, { "v": "48260", "n": "陈食镇" }, { "v": "48261", "n": "板桥镇" }, { "v": "48262", "n": "宝峰镇" }, { "v": "48263", "n": "临江镇" }, { "v": "48264", "n": "红炉镇" }, { "v": "48265", "n": "吉安镇" }, { "v": "48266", "n": "金龙镇" }, { "v": "48267", "n": "来苏镇" }, { "v": "48268", "n": "青峰镇" }, { "v": "48270", "n": "双石镇" }, { "v": "48271", "n": "松溉镇" }, { "v": "48272", "n": "五间镇" }, { "v": "48273", "n": "仙龙镇" }, { "v": "48274", "n": "永荣镇" }, { "v": "48275", "n": "朱沱镇" }, { "v": "48276", "n": "何埂镇" }] }, { "v": "51026", "n": "渝中区", "c": [{ "v": "103", "n": "全境" }] }, { "v": "51027", "n": "高新区", "c": [{ "v": "50956", "n": "全境" }] }, { "v": "51028", "n": "北部新区", "c": [{ "v": "50955", "n": "全境" }] }, { "v": "126", "n": "大足区", "c": [{ "v": "52487", "n": "城区" }, { "v": "13520", "n": "龙滩子镇" }, { "v": "13521", "n": "龙水镇" }, { "v": "13522", "n": "智凤镇" }, { "v": "13523", "n": "宝顶镇" }, { "v": "13524", "n": "中敖镇" }, { "v": "13525", "n": "三驱镇" }, { "v": "13526", "n": "宝兴镇" }, { "v": "13527", "n": "玉龙镇" }, { "v": "13528", "n": "石马镇" }, { "v": "13529", "n": "拾万镇" }, { "v": "13530", "n": "回龙镇" }, { "v": "13531", "n": "金山镇" }, { "v": "13532", "n": "万古镇" }, { "v": "13533", "n": "国梁镇" }, { "v": "13534", "n": "雍溪镇" }, { "v": "13535", "n": "珠溪镇" }, { "v": "13536", "n": "龙石镇" }, { "v": "13537", "n": "邮亭镇" }, { "v": "13538", "n": "铁山镇" }, { "v": "13539", "n": "高升镇" }, { "v": "13540", "n": "季家镇" }, { "v": "13541", "n": "古龙镇" }, { "v": "13542", "n": "高坪镇" }, { "v": "13543", "n": "双路镇" }, { "v": "13544", "n": "通桥镇" }] }, { "v": "113", "n": "万州区", "c": [{ "v": "52484", "n": "城区" }, { "v": "9786", "n": "白土镇" }, { "v": "9787", "n": "白羊镇" }, { "v": "9788", "n": "大周镇" }, { "v": "9789", "n": "弹子镇" }, { "v": "9790", "n": "分水镇" }, { "v": "9791", "n": "甘宁镇" }, { "v": "9792", "n": "高峰镇" }, { "v": "9793", "n": "高梁镇" }, { "v": "9794", "n": "后山镇" }, { "v": "9795", "n": "李河镇" }, { "v": "9796", "n": "龙驹镇" }, { "v": "9797", "n": "龙沙镇" }, { "v": "9798", "n": "罗田镇" }, { "v": "9799", "n": "孙家镇" }, { "v": "9800", "n": "太安镇" }, { "v": "9801", "n": "太龙镇" }, { "v": "9802", "n": "天城镇" }, { "v": "9803", "n": "武陵镇" }, { "v": "9804", "n": "响水镇" }, { "v": "9805", "n": "小周镇" }, { "v": "9806", "n": "新田镇" }, { "v": "9807", "n": "新乡镇" }, { "v": "9808", "n": "熊家镇" }, { "v": "9809", "n": "余家镇" }, { "v": "9810", "n": "长岭镇" }, { "v": "9811", "n": "长坪镇" }, { "v": "9812", "n": "长滩镇" }, { "v": "9813", "n": "走马镇" }, { "v": "9814", "n": "瀼渡镇" }, { "v": "9815", "n": "茨竹乡" }, { "v": "9816", "n": "柱山乡" }, { "v": "9817", "n": "燕山乡" }, { "v": "9818", "n": "溪口乡" }, { "v": "9819", "n": "普子乡" }, { "v": "9820", "n": "地宝乡" }, { "v": "9821", "n": "铁峰乡" }, { "v": "9822", "n": "黄柏乡" }, { "v": "9823", "n": "九池乡" }, { "v": "9824", "n": "梨树乡" }, { "v": "9825", "n": "郭村乡" }, { "v": "9826", "n": "恒合乡" }] }, { "v": "114", "n": "涪陵区", "c": [{ "v": "52485", "n": "城区" }, { "v": "9898", "n": "李渡镇" }, { "v": "9899", "n": "白涛镇" }, { "v": "9900", "n": "百胜镇" }, { "v": "9901", "n": "堡子镇" }, { "v": "9902", "n": "焦石镇" }, { "v": "9903", "n": "蔺市镇" }, { "v": "9904", "n": "龙桥镇" }, { "v": "9905", "n": "龙潭镇" }, { "v": "9906", "n": "马武镇" }, { "v": "9907", "n": "南沱镇" }, { "v": "9908", "n": "青羊镇" }, { "v": "9909", "n": "清溪镇" }, { "v": "9910", "n": "石沱镇" }, { "v": "9911", "n": "新妙镇" }, { "v": "9912", "n": "义和镇" }, { "v": "9913", "n": "增福乡" }, { "v": "9914", "n": "珍溪镇" }, { "v": "9915", "n": "镇安镇" }, { "v": "9916", "n": "致韩镇" }, { "v": "9917", "n": "土地坡乡" }, { "v": "9918", "n": "武陵山乡" }, { "v": "9919", "n": "中峰乡" }, { "v": "9920", "n": "梓里乡" }, { "v": "9921", "n": "丛林乡" }, { "v": "9922", "n": "大木乡" }, { "v": "9923", "n": "惠民乡" }, { "v": "9924", "n": "酒店乡" }, { "v": "9925", "n": "聚宝乡" }, { "v": "9926", "n": "卷洞乡" }, { "v": "9927", "n": "两汇乡" }, { "v": "9928", "n": "罗云乡" }, { "v": "9929", "n": "明家乡" }, { "v": "9930", "n": "仁义乡" }, { "v": "9931", "n": "山窝乡" }, { "v": "9932", "n": "石和乡" }, { "v": "9933", "n": "石龙乡" }, { "v": "9934", "n": "太和乡" }, { "v": "9935", "n": "天台乡" }, { "v": "9936", "n": "同乐乡" }, { "v": "9937", "n": "新村乡" }] }, { "v": "115", "n": "梁平县", "c": [{ "v": "39680", "n": "县城内" }, { "v": "9938", "n": "梁山镇" }, { "v": "9939", "n": "柏家镇" }, { "v": "9940", "n": "碧山镇" }, { "v": "9941", "n": "大观镇" }, { "v": "9942", "n": "福禄镇" }, { "v": "9943", "n": "合兴镇" }, { "v": "9944", "n": "和林镇" }, { "v": "9945", "n": "虎城镇" }, { "v": "9946", "n": "回龙镇" }, { "v": "9947", "n": "金带镇" }, { "v": "9948", "n": "聚奎镇" }, { "v": "9949", "n": "礼让镇" }, { "v": "9950", "n": "龙门镇" }, { "v": "9951", "n": "明达镇" }, { "v": "9952", "n": "蟠龙镇" }, { "v": "9953", "n": "屏锦镇" }, { "v": "9954", "n": "仁贤镇" }, { "v": "9955", "n": "石安镇" }, { "v": "9956", "n": "文化镇" }, { "v": "9957", "n": "新盛镇" }, { "v": "9958", "n": "荫平镇" }, { "v": "9959", "n": "袁驿镇" }, { "v": "9960", "n": "云龙镇" }, { "v": "9961", "n": "竹山镇" }, { "v": "9962", "n": "安胜乡" }, { "v": "9963", "n": "铁门乡" }, { "v": "9964", "n": "紫照乡" }, { "v": "9965", "n": "曲水乡" }, { "v": "9966", "n": "龙胜乡" }, { "v": "9967", "n": "城北乡" }, { "v": "9968", "n": "城东乡" }, { "v": "9969", "n": "复平乡" }] }, { "v": "119", "n": "南川区", "c": [{ "v": "52486", "n": "城区" }, { "v": "9984", "n": "头渡镇" }, { "v": "9985", "n": "兴隆镇" }, { "v": "9986", "n": "冷水关乡" }, { "v": "9987", "n": "德隆乡" }, { "v": "9988", "n": "峰岩乡" }, { "v": "9989", "n": "福寿乡" }, { "v": "9990", "n": "古花乡" }, { "v": "9991", "n": "河图乡" }, { "v": "9992", "n": "民主乡" }, { "v": "9993", "n": "木凉乡" }, { "v": "9994", "n": "乾丰乡" }, { "v": "9995", "n": "庆元乡" }, { "v": "9996", "n": "石莲乡" }, { "v": "9997", "n": "石溪乡" }, { "v": "9998", "n": "铁村乡" }, { "v": "9999", "n": "土溪乡" }, { "v": "10000", "n": "鱼泉乡" }, { "v": "10001", "n": "中桥乡" }, { "v": "9973", "n": "太平场镇" }, { "v": "9974", "n": "大观镇" }, { "v": "9975", "n": "大有镇" }, { "v": "9976", "n": "合溪镇" }, { "v": "9977", "n": "金山镇" }, { "v": "9978", "n": "鸣玉镇" }, { "v": "9979", "n": "南平镇" }, { "v": "9980", "n": "三泉镇" }, { "v": "9981", "n": "神童镇" }, { "v": "9982", "n": "石墙镇" }, { "v": "9983", "n": "水江镇" }] }, { "v": "123", "n": "潼南县", "c": [{ "v": "39688", "n": "县城内" }, { "v": "9756", "n": "柏梓镇" }, { "v": "9757", "n": "宝龙镇" }, { "v": "9758", "n": "崇龛镇" }, { "v": "9759", "n": "古溪镇" }, { "v": "9760", "n": "龙形镇" }, { "v": "9761", "n": "米心镇" }, { "v": "9762", "n": "群力镇" }, { "v": "9763", "n": "上和镇" }, { "v": "9764", "n": "双江镇" }, { "v": "9765", "n": "太安镇" }, { "v": "9766", "n": "塘坝镇" }, { "v": "9767", "n": "卧佛镇" }, { "v": "9768", "n": "五桂镇" }, { "v": "9769", "n": "小渡镇" }, { "v": "9770", "n": "新胜镇" }, { "v": "9771", "n": "玉溪镇" }, { "v": "9772", "n": "别口乡" }, { "v": "9773", "n": "田家乡" }, { "v": "9774", "n": "寿桥乡" }] }, { "v": "128", "n": "黔江区", "c": [{ "v": "52488", "n": "城区" }, { "v": "10005", "n": "正阳镇" }, { "v": "10006", "n": "舟白镇" }, { "v": "10007", "n": "阿蓬江镇" }, { "v": "10008", "n": "小南海镇" }, { "v": "10009", "n": "鹅池镇" }, { "v": "10010", "n": "冯家镇" }, { "v": "10011", "n": "黑溪镇" }, { "v": "10012", "n": "黄溪镇" }, { "v": "10013", "n": "金溪镇" }, { "v": "10014", "n": "黎水镇" }, { "v": "10015", "n": "邻鄂镇" }, { "v": "10016", "n": "马喇镇" }, { "v": "10017", "n": "石会镇" }, { "v": "10018", "n": "石家镇" }, { "v": "10019", "n": "濯水镇" }, { "v": "10020", "n": "白石乡" }, { "v": "10021", "n": "白土乡" }, { "v": "10022", "n": "金洞乡" }, { "v": "10023", "n": "蓬东乡" }, { "v": "10024", "n": "沙坝乡" }, { "v": "10025", "n": "杉岭乡" }, { "v": "10026", "n": "水市乡" }, { "v": "10027", "n": "水田乡" }, { "v": "10028", "n": "太极乡" }, { "v": "10029", "n": "五里乡" }, { "v": "10030", "n": "新华乡" }, { "v": "10031", "n": "中塘乡" }] }, { "v": "132", "n": "开县", "c": [{ "v": "51202", "n": "白桥镇" }, { "v": "51203", "n": "大德镇" }, { "v": "51204", "n": "金峰镇" }, { "v": "51205", "n": "谭家镇" }, { "v": "51206", "n": "天和镇" }, { "v": "51207", "n": "白泉乡" }, { "v": "39699", "n": "县城内" }, { "v": "9831", "n": "九龙山镇" }, { "v": "9832", "n": "大进镇" }, { "v": "9833", "n": "敦好镇" }, { "v": "9834", "n": "高桥镇" }, { "v": "9835", "n": "郭家镇" }, { "v": "9836", "n": "和谦镇" }, { "v": "9837", "n": "河堰镇" }, { "v": "9838", "n": "厚坝镇" }, { "v": "9839", "n": "临江镇" }, { "v": "9840", "n": "南门镇" }, { "v": "9841", "n": "南雅镇" }, { "v": "9842", "n": "渠口镇" }, { "v": "9843", "n": "铁桥镇" }, { "v": "52083", "n": "岳溪镇" }, { "v": "9844", "n": "温泉镇" }, { "v": "9845", "n": "义和镇" }, { "v": "9846", "n": "长沙镇" }, { "v": "9847", "n": "赵家镇" }, { "v": "9848", "n": "镇安镇" }, { "v": "9849", "n": "中和镇" }, { "v": "9850", "n": "竹溪镇" }, { "v": "9851", "n": "三汇口乡" }, { "v": "9852", "n": "白桥乡" }, { "v": "9853", "n": "大德乡" }, { "v": "9854", "n": "关面乡" }, { "v": "9855", "n": "金峰乡" }, { "v": "9856", "n": "麻柳乡" }, { "v": "9857", "n": "满月乡" }, { "v": "9858", "n": "谭家乡" }, { "v": "9859", "n": "天和乡" }, { "v": "9860", "n": "巫山镇" }, { "v": "9861", "n": "五通乡" }, { "v": "9862", "n": "紫水乡" }] }, { "v": "133", "n": "云阳县", "c": [{ "v": "39701", "n": "县城内" }, { "v": "10091", "n": "云阳镇" }, { "v": "10092", "n": "巴阳镇" }, { "v": "10093", "n": "凤鸣镇" }, { "v": "10094", "n": "高阳镇" }, { "v": "10095", "n": "故陵镇" }, { "v": "10096", "n": "红狮镇" }, { "v": "10097", "n": "黄石镇" }, { "v": "10098", "n": "江口镇" }, { "v": "10099", "n": "龙角镇" }, { "v": "10100", "n": "路阳镇" }, { "v": "10101", "n": "南溪镇" }, { "v": "10102", "n": "农坝镇" }, { "v": "10103", "n": "盘龙镇" }, { "v": "10104", "n": "平安镇" }, { "v": "10105", "n": "渠马镇" }, { "v": "10106", "n": "人和镇" }, { "v": "10107", "n": "桑坪镇" }, { "v": "10108", "n": "沙市镇" }, { "v": "10109", "n": "双土镇" }, { "v": "10110", "n": "鱼泉镇" }, { "v": "10111", "n": "云安镇" }, { "v": "10112", "n": "洞鹿乡" }, { "v": "10113", "n": "后叶乡" }, { "v": "10114", "n": "龙洞乡" }, { "v": "10115", "n": "毛坝乡" }, { "v": "10116", "n": "泥溪乡" }, { "v": "10117", "n": "票草乡" }, { "v": "10118", "n": "普安乡" }, { "v": "10119", "n": "栖霞乡" }, { "v": "10120", "n": "清水乡" }, { "v": "10121", "n": "上坝乡" }, { "v": "10122", "n": "石门乡" }, { "v": "10123", "n": "双龙乡" }, { "v": "10124", "n": "水口乡" }, { "v": "10125", "n": "外郎乡" }, { "v": "10126", "n": "新津乡" }, { "v": "10127", "n": "堰坪乡" }, { "v": "10128", "n": "养鹿乡" }, { "v": "10129", "n": "耀灵乡" }, { "v": "10130", "n": "云硐乡" }] }, { "v": "134", "n": "忠县", "c": [{ "v": "39702", "n": "县城内" }, { "v": "10131", "n": "忠州镇" }, { "v": "10132", "n": "拔山镇" }, { "v": "10133", "n": "白石镇" }, { "v": "10134", "n": "东溪镇" }, { "v": "10135", "n": "复兴镇" }, { "v": "10136", "n": "官坝镇" }, { "v": "10137", "n": "花桥镇" }, { "v": "10138", "n": "黄金镇" }, { "v": "10139", "n": "金鸡镇" }, { "v": "10140", "n": "马灌镇" }, { "v": "10141", "n": "任家镇" }, { "v": "10142", "n": "汝溪镇" }, { "v": "10143", "n": "三汇镇" }, { "v": "10144", "n": "石宝镇" }, { "v": "10145", "n": "石黄镇" }, { "v": "10146", "n": "双桂镇" }, { "v": "10147", "n": "乌杨镇" }, { "v": "10148", "n": "新生镇" }, { "v": "10149", "n": "洋渡镇" }, { "v": "10150", "n": "野鹤镇" }, { "v": "10151", "n": "永丰镇" }, { "v": "10152", "n": "金声乡" }, { "v": "10153", "n": "磨子乡" }, { "v": "10154", "n": "善广乡" }, { "v": "10155", "n": "石子乡" }, { "v": "10156", "n": "涂井乡" }, { "v": "10157", "n": "兴峰乡" }, { "v": "19915", "n": "新立镇" }] }, { "v": "139", "n": "垫江县", "c": [{ "v": "39712", "n": "县城内" }, { "v": "10283", "n": "桂溪镇" }, { "v": "10284", "n": "澄溪镇" }, { "v": "10285", "n": "高安镇" }, { "v": "10286", "n": "高峰镇" }, { "v": "10287", "n": "鹤游镇" }, { "v": "10288", "n": "普顺镇" }, { "v": "10289", "n": "沙坪镇" }, { "v": "10290", "n": "太平镇" }, { "v": "10291", "n": "五洞镇" }, { "v": "10292", "n": "新民镇" }, { "v": "10293", "n": "砚台镇" }, { "v": "10294", "n": "永安镇" }, { "v": "10295", "n": "周嘉镇" }, { "v": "10296", "n": "白家乡" }, { "v": "10297", "n": "包家乡" }, { "v": "10298", "n": "曹回乡" }, { "v": "10299", "n": "大石乡" }, { "v": "10300", "n": "杠家乡" }, { "v": "32060", "n": "坪山镇" }, { "v": "10301", "n": "黄沙乡" }, { "v": "10302", "n": "裴兴乡" }, { "v": "10303", "n": "三溪乡" }, { "v": "10304", "n": "沙河乡" }, { "v": "10305", "n": "永平乡" }, { "v": "10306", "n": "长龙乡" }] }, { "v": "4164", "n": "城口县", "c": [{ "v": "39717", "n": "县城内" }, { "v": "10406", "n": "葛城镇" }, { "v": "10407", "n": "巴山镇" }, { "v": "10408", "n": "高观镇" }, { "v": "10409", "n": "庙坝镇" }, { "v": "10410", "n": "明通镇" }, { "v": "10411", "n": "坪坝镇" }, { "v": "10412", "n": "修齐镇" }, { "v": "10413", "n": "北屏乡" }, { "v": "10414", "n": "东安乡" }, { "v": "10415", "n": "高楠乡" }, { "v": "10416", "n": "高燕乡" }, { "v": "10417", "n": "河鱼乡" }, { "v": "10418", "n": "厚坪乡" }, { "v": "10419", "n": "鸡鸣乡" }, { "v": "10420", "n": "岚天乡" }, { "v": "10421", "n": "蓼子乡" }, { "v": "10422", "n": "龙田乡" }, { "v": "10423", "n": "明中乡" }, { "v": "10424", "n": "双河乡" }, { "v": "10425", "n": "咸宜乡" }, { "v": "10426", "n": "沿河乡" }, { "v": "10427", "n": "治平乡" }, { "v": "10428", "n": "周溪乡" }, { "v": "10429", "n": "左岚乡" }] }, { "v": "129", "n": "武隆县", "c": [{ "v": "39692", "n": "县城内" }, { "v": "10032", "n": "仙女山镇" }, { "v": "10033", "n": "巷口镇" }, { "v": "10034", "n": "白马镇" }, { "v": "10035", "n": "火炉镇" }, { "v": "10036", "n": "江口镇" }, { "v": "10037", "n": "平桥镇" }, { "v": "10038", "n": "桐梓镇" }, { "v": "10039", "n": "土坎镇" }, { "v": "10040", "n": "鸭江镇" }, { "v": "10041", "n": "羊角镇" }, { "v": "10042", "n": "长坝镇" }, { "v": "10043", "n": "白云乡" }, { "v": "10044", "n": "沧沟乡" }, { "v": "10045", "n": "凤来乡" }, { "v": "10046", "n": "浩口乡" }, { "v": "10047", "n": "和顺乡" }, { "v": "10048", "n": "后坪乡" }, { "v": "10049", "n": "黄莺乡" }, { "v": "10050", "n": "接龙乡" }, { "v": "10051", "n": "庙垭乡" }, { "v": "10052", "n": "石桥乡" }, { "v": "10053", "n": "双河乡" }, { "v": "10054", "n": "铁矿乡" }, { "v": "10055", "n": "土地乡" }, { "v": "10056", "n": "文复乡" }, { "v": "10057", "n": "赵家乡" }] }, { "v": "130", "n": "丰都县", "c": [{ "v": "39694", "n": "县城内" }, { "v": "10059", "n": "南天湖镇" }, { "v": "10060", "n": "许明寺镇" }, { "v": "10061", "n": "包鸾镇" }, { "v": "10062", "n": "董家镇" }, { "v": "10063", "n": "高家镇" }, { "v": "10064", "n": "虎威镇" }, { "v": "10065", "n": "江池镇" }, { "v": "10066", "n": "龙河镇" }, { "v": "10067", "n": "名山镇" }, { "v": "10068", "n": "三元镇" }, { "v": "10069", "n": "社坛镇" }, { "v": "10070", "n": "十直镇" }, { "v": "10071", "n": "树人镇" }, { "v": "10072", "n": "双路镇" }, { "v": "10073", "n": "武平镇" }, { "v": "10074", "n": "兴义镇" }, { "v": "10075", "n": "湛普镇" }, { "v": "10076", "n": "镇江镇" }, { "v": "10077", "n": "太平坝乡" }, { "v": "10078", "n": "双龙场乡" }, { "v": "10079", "n": "保合乡" }, { "v": "10080", "n": "崇兴乡" }, { "v": "10081", "n": "都督乡" }, { "v": "10082", "n": "暨龙乡" }, { "v": "10083", "n": "栗子乡" }, { "v": "10084", "n": "龙孔乡" }, { "v": "10085", "n": "青龙乡" }, { "v": "10086", "n": "仁沙乡" }, { "v": "10087", "n": "三坝乡" }, { "v": "10088", "n": "三建乡" }] }, { "v": "131", "n": "奉节县", "c": [{ "v": "51706", "n": "永乐镇" }, { "v": "39698", "n": "县城内" }, { "v": "10377", "n": "永安镇" }, { "v": "10378", "n": "白帝镇" }, { "v": "10379", "n": "草堂镇" }, { "v": "10380", "n": "大树镇" }, { "v": "10381", "n": "汾河镇" }, { "v": "10382", "n": "公平镇" }, { "v": "10383", "n": "甲高镇" }, { "v": "10384", "n": "康乐镇" }, { "v": "10385", "n": "青龙镇" }, { "v": "10386", "n": "吐祥镇" }, { "v": "10387", "n": "新民镇" }, { "v": "10388", "n": "兴隆镇" }, { "v": "10389", "n": "羊市镇" }, { "v": "10390", "n": "朱衣镇" }, { "v": "10391", "n": "竹园镇" }, { "v": "10392", "n": "安坪乡" }, { "v": "10393", "n": "冯坪乡" }, { "v": "10394", "n": "鹤峰乡" }, { "v": "10395", "n": "红土乡" }, { "v": "10396", "n": "康坪乡" }, { "v": "10397", "n": "龙桥乡" }, { "v": "10398", "n": "平安乡" }, { "v": "10399", "n": "石岗乡" }, { "v": "10400", "n": "太和乡" }, { "v": "10401", "n": "五马乡" }, { "v": "10402", "n": "新政乡" }, { "v": "10403", "n": "岩湾乡" }, { "v": "10404", "n": "云雾乡" }, { "v": "10405", "n": "长安乡" }] }, { "v": "135", "n": "巫溪县", "c": [{ "v": "39704", "n": "县城内" }, { "v": "10158", "n": "城厢镇" }, { "v": "10159", "n": "凤凰镇" }, { "v": "10160", "n": "古路镇" }, { "v": "10161", "n": "尖山镇" }, { "v": "10162", "n": "宁厂镇" }, { "v": "10163", "n": "上磺镇" }, { "v": "10164", "n": "文峰镇" }, { "v": "10165", "n": "下堡镇" }, { "v": "10166", "n": "徐家镇" }, { "v": "10167", "n": "朝阳洞乡" }, { "v": "10168", "n": "大河乡" }, { "v": "10169", "n": "峰灵乡" }, { "v": "10170", "n": "花台乡" }, { "v": "10171", "n": "兰英乡" }, { "v": "10172", "n": "菱角乡" }, { "v": "10173", "n": "蒲莲乡" }, { "v": "10174", "n": "胜利乡" }, { "v": "10175", "n": "双阳乡" }, { "v": "10176", "n": "塘坊乡" }, { "v": "10177", "n": "天星乡" }, { "v": "10178", "n": "天元乡" }, { "v": "10179", "n": "田坝乡" }, { "v": "10180", "n": "通城乡" }, { "v": "10181", "n": "土城乡" }, { "v": "10182", "n": "乌龙乡" }, { "v": "10183", "n": "鱼鳞乡" }, { "v": "10184", "n": "长桂乡" }, { "v": "10185", "n": "中岗乡" }, { "v": "10186", "n": "中梁乡" }] }, { "v": "136", "n": "巫山县", "c": [{ "v": "39706", "n": "县城内" }, { "v": "10187", "n": "巫峡镇" }, { "v": "10188", "n": "大昌镇" }, { "v": "10189", "n": "福田镇" }, { "v": "10190", "n": "官渡镇" }, { "v": "10191", "n": "官阳镇" }, { "v": "10192", "n": "龙溪镇" }, { "v": "10193", "n": "骡坪镇" }, { "v": "10194", "n": "庙堂乡" }, { "v": "10195", "n": "庙宇镇" }, { "v": "10196", "n": "双龙镇" }, { "v": "10197", "n": "铜鼓镇" }, { "v": "10198", "n": "抱龙镇" }, { "v": "10199", "n": "大溪乡" }, { "v": "10200", "n": "当阳乡" }, { "v": "10201", "n": "邓家乡" }, { "v": "10202", "n": "笃坪乡" }, { "v": "10203", "n": "红椿乡" }, { "v": "10204", "n": "建平乡" }, { "v": "10205", "n": "金坪乡" }, { "v": "10206", "n": "两坪乡" }, { "v": "10207", "n": "龙井乡" }, { "v": "10208", "n": "培石乡" }, { "v": "10209", "n": "平河乡" }, { "v": "10210", "n": "曲尺乡" }, { "v": "10211", "n": "三溪乡" }, { "v": "10212", "n": "竹贤乡" }] }, { "v": "137", "n": "石柱县", "c": [{ "v": "10240", "n": "王家乡" }, { "v": "10241", "n": "洗新乡" }, { "v": "10242", "n": "新乐乡" }, { "v": "10243", "n": "中益乡" }, { "v": "39710", "n": "县城内" }, { "v": "10213", "n": "南宾镇" }, { "v": "10214", "n": "黄水镇" }, { "v": "10215", "n": "临溪镇" }, { "v": "10216", "n": "龙沙镇" }, { "v": "10217", "n": "马武镇" }, { "v": "10218", "n": "沙子镇" }, { "v": "10219", "n": "王场镇" }, { "v": "10220", "n": "西沱镇" }, { "v": "10221", "n": "下路镇" }, { "v": "10222", "n": "沿溪镇" }, { "v": "10223", "n": "渔池镇" }, { "v": "10224", "n": "悦崃镇" }, { "v": "10225", "n": "大歇乡" }, { "v": "10226", "n": "枫木乡" }, { "v": "10227", "n": "河嘴乡" }, { "v": "10228", "n": "黄鹤乡" }, { "v": "10229", "n": "金铃乡" }, { "v": "10230", "n": "金竹乡" }, { "v": "10231", "n": "冷水乡" }, { "v": "10232", "n": "黎场乡" }, { "v": "10233", "n": "六塘乡" }, { "v": "10234", "n": "龙潭乡" }, { "v": "10235", "n": "桥头乡" }, { "v": "10236", "n": "三河乡" }, { "v": "10237", "n": "三益乡" }, { "v": "10238", "n": "石家乡" }, { "v": "10239", "n": "万朝乡" }] }, { "v": "138", "n": "彭水县", "c": [{ "v": "10245", "n": "保家镇" }, { "v": "10246", "n": "高谷镇" }, { "v": "10247", "n": "黄家镇" }, { "v": "10248", "n": "连湖镇" }, { "v": "10249", "n": "龙射镇" }, { "v": "10250", "n": "鹿角镇" }, { "v": "10251", "n": "普子镇" }, { "v": "10252", "n": "桑柘镇" }, { "v": "10253", "n": "万足镇" }, { "v": "10254", "n": "郁山镇" }, { "v": "10255", "n": "梅子垭乡" }, { "v": "10256", "n": "鞍子乡" }, { "v": "10257", "n": "大垭乡" }, { "v": "10258", "n": "棣棠乡" }, { "v": "10259", "n": "靛水乡" }, { "v": "10260", "n": "朗溪乡" }, { "v": "10261", "n": "联合乡" }, { "v": "10262", "n": "龙塘乡" }, { "v": "10263", "n": "龙溪乡" }, { "v": "10264", "n": "芦塘乡" }, { "v": "10265", "n": "鹿鸣乡" }, { "v": "10266", "n": "平安乡" }, { "v": "10267", "n": "迁乔乡" }, { "v": "10268", "n": "乔梓乡" }, { "v": "10269", "n": "润溪乡" }, { "v": "10270", "n": "三义乡" }, { "v": "10271", "n": "善感乡" }, { "v": "39711", "n": "县城内" }, { "v": "10272", "n": "石柳乡" }, { "v": "10273", "n": "石盘乡" }, { "v": "10274", "n": "双龙乡" }, { "v": "10275", "n": "太原乡" }, { "v": "10276", "n": "桐楼乡" }, { "v": "10277", "n": "小厂乡" }, { "v": "10278", "n": "新田乡" }, { "v": "10279", "n": "岩东乡" }, { "v": "10280", "n": "长滩乡" }, { "v": "10281", "n": "诸佛乡" }, { "v": "10282", "n": "走马乡" }] }, { "v": "140", "n": "酉阳县", "c": [{ "v": "39714", "n": "县城内" }, { "v": "10307", "n": "钟多镇" }, { "v": "10308", "n": "苍岭镇" }, { "v": "10309", "n": "车田乡" }, { "v": "10310", "n": "大溪镇" }, { "v": "10311", "n": "丁市镇" }, { "v": "10312", "n": "泔溪镇" }, { "v": "10313", "n": "龚滩镇" }, { "v": "10314", "n": "黑水镇" }, { "v": "10315", "n": "后溪镇" }, { "v": "10316", "n": "李溪镇" }, { "v": "10317", "n": "龙潭镇" }, { "v": "10318", "n": "麻旺镇" }, { "v": "10319", "n": "小河镇" }, { "v": "10320", "n": "兴隆镇" }, { "v": "10321", "n": "酉酬镇" }, { "v": "10322", "n": "南腰界乡" }, { "v": "10323", "n": "后坪坝乡" }, { "v": "10324", "n": "板溪乡" }, { "v": "10325", "n": "官清乡" }, { "v": "10326", "n": "花田乡" }, { "v": "10327", "n": "江丰乡" }, { "v": "10328", "n": "可大乡" }, { "v": "10329", "n": "浪坪乡" }, { "v": "10330", "n": "两罾乡" }, { "v": "10331", "n": "毛坝乡" }, { "v": "10332", "n": "庙溪乡" }, { "v": "10333", "n": "木叶乡" }, { "v": "10334", "n": "楠木乡" }, { "v": "10335", "n": "偏柏乡" }, { "v": "10336", "n": "清泉乡" }, { "v": "10337", "n": "双泉乡" }, { "v": "10338", "n": "天馆乡" }, { "v": "10339", "n": "铜鼓乡" }, { "v": "10340", "n": "涂市乡" }, { "v": "10341", "n": "万木乡" }, { "v": "10342", "n": "五福乡" }, { "v": "10343", "n": "宜居乡" }, { "v": "10344", "n": "腴地乡" }, { "v": "10345", "n": "板桥乡" }] }, { "v": "141", "n": "秀山县", "c": [{ "v": "39716", "n": "县城内" }, { "v": "10346", "n": "清溪场镇" }, { "v": "10347", "n": "中和镇" }, { "v": "10348", "n": "隘口镇" }, { "v": "10349", "n": "峨溶镇" }, { "v": "10350", "n": "官庄镇" }, { "v": "10351", "n": "洪安镇" }, { "v": "10352", "n": "兰桥镇" }, { "v": "10353", "n": "龙池镇" }, { "v": "10354", "n": "梅江镇" }, { "v": "10355", "n": "平凯镇" }, { "v": "10356", "n": "溶溪镇" }, { "v": "10357", "n": "石堤镇" }, { "v": "10358", "n": "石耶镇" }, { "v": "10359", "n": "雅江镇" }, { "v": "10360", "n": "巴家乡" }, { "v": "10361", "n": "保安乡" }, { "v": "10362", "n": "岑溪乡" }, { "v": "10363", "n": "大溪乡" }, { "v": "10364", "n": "干川乡" }, { "v": "10365", "n": "膏田乡" }, { "v": "10366", "n": "官舟乡" }, { "v": "10367", "n": "海洋乡" }, { "v": "10368", "n": "里仁乡" }, { "v": "10369", "n": "妙泉乡" }, { "v": "10370", "n": "平马乡" }, { "v": "10371", "n": "宋农乡" }, { "v": "10372", "n": "溪口乡" }, { "v": "10373", "n": "孝溪乡" }, { "v": "10374", "n": "涌洞乡" }, { "v": "10375", "n": "中平乡" }, { "v": "10376", "n": "钟灵乡" }] }] }, { "v": "5", "n": "河北", "c": [{ "v": "258", "n": "唐山市", "c": [{ "v": "41497", "n": "路北区" }, { "v": "41499", "n": "路南区" }, { "v": "41500", "n": "迁安市" }, { "v": "41502", "n": "丰润区" }, { "v": "3202", "n": "古冶区" }, { "v": "3203", "n": "开平区" }, { "v": "2756", "n": "遵化市" }, { "v": "2757", "n": "丰南区" }, { "v": "2759", "n": "迁西县" }, { "v": "2760", "n": "滦南县" }, { "v": "2762", "n": "玉田县" }, { "v": "2763", "n": "曹妃甸区" }, { "v": "2764", "n": "乐亭县" }, { "v": "2765", "n": "滦县" }] }, { "v": "264", "n": "沧州市", "c": [{ "v": "265", "n": "沧县" }, { "v": "266", "n": "泊头市" }, { "v": "268", "n": "河间市" }, { "v": "269", "n": "献县" }, { "v": "270", "n": "肃宁县" }, { "v": "271", "n": "青县" }, { "v": "272", "n": "东光县" }, { "v": "273", "n": "吴桥县" }, { "v": "276", "n": "南皮县" }, { "v": "277", "n": "盐山县" }, { "v": "278", "n": "海兴县" }, { "v": "279", "n": "孟村县" }, { "v": "49576", "n": "运河区" }, { "v": "49577", "n": "新华区" }, { "v": "49578", "n": "任丘市" }, { "v": "49579", "n": "黄骅市" }] }, { "v": "274", "n": "廊坊市", "c": [{ "v": "49707", "n": "三河市" }, { "v": "3207", "n": "广阳区" }, { "v": "4097", "n": "开发区" }, { "v": "284", "n": "固安县" }, { "v": "3206", "n": "安次区" }, { "v": "285", "n": "永清县" }, { "v": "286", "n": "香河县" }, { "v": "287", "n": "大城县" }, { "v": "288", "n": "文安县" }, { "v": "289", "n": "大厂县" }, { "v": "49708", "n": "霸州市" }] }, { "v": "275", "n": "衡水市", "c": [{ "v": "291", "n": "冀州市" }, { "v": "292", "n": "深州市" }, { "v": "293", "n": "饶阳县" }, { "v": "294", "n": "枣强县" }, { "v": "41510", "n": "桃城区" }, { "v": "295", "n": "故城县" }, { "v": "296", "n": "阜城县" }, { "v": "297", "n": "安平县" }, { "v": "298", "n": "武邑县" }, { "v": "299", "n": "景县" }, { "v": "300", "n": "武强县" }] }, { "v": "142", "n": "石家庄市", "c": [{ "v": "42540", "n": "藁城市" }, { "v": "42541", "n": "鹿泉市" }, { "v": "42542", "n": "正定县" }, { "v": "42543", "n": "新华区" }, { "v": "42544", "n": "桥西区" }, { "v": "42545", "n": "桥东区" }, { "v": "42546", "n": "裕华区" }, { "v": "42547", "n": "长安区" }, { "v": "143", "n": "辛集市" }, { "v": "145", "n": "晋州市" }, { "v": "146", "n": "新乐市" }, { "v": "4158", "n": "平山县" }, { "v": "3182", "n": "井陉矿区" }, { "v": "153", "n": "井陉县" }, { "v": "154", "n": "栾城县" }, { "v": "156", "n": "行唐县" }, { "v": "157", "n": "灵寿县" }, { "v": "158", "n": "高邑县" }, { "v": "159", "n": "赵县" }, { "v": "160", "n": "赞皇县" }, { "v": "161", "n": "深泽县" }, { "v": "162", "n": "无极县" }, { "v": "163", "n": "元氏县" }] }, { "v": "148", "n": "邯郸市", "c": [{ "v": "34049", "n": "丛台区" }, { "v": "34050", "n": "邯山区" }, { "v": "34051", "n": "复兴区" }, { "v": "34052", "n": "武安市" }, { "v": "3077", "n": "临漳县" }, { "v": "3187", "n": "永年县" }, { "v": "167", "n": "邯郸县" }, { "v": "168", "n": "峰峰矿区" }, { "v": "169", "n": "曲周县" }, { "v": "170", "n": "馆陶县" }, { "v": "171", "n": "魏县" }, { "v": "172", "n": "成安县" }, { "v": "173", "n": "大名县" }, { "v": "174", "n": "涉县" }, { "v": "175", "n": "鸡泽县" }, { "v": "176", "n": "邱县" }, { "v": "177", "n": "广平县" }, { "v": "178", "n": "肥乡县" }, { "v": "180", "n": "磁县" }] }, { "v": "164", "n": "邢台市", "c": [{ "v": "257", "n": "宁晋县" }, { "v": "3098", "n": "威县" }, { "v": "47712", "n": "桥西区" }, { "v": "47713", "n": "桥东区" }, { "v": "183", "n": "邢台县" }, { "v": "184", "n": "南宫市" }, { "v": "185", "n": "沙河市" }, { "v": "186", "n": "柏乡县" }, { "v": "187", "n": "任县" }, { "v": "188", "n": "清河县" }, { "v": "189", "n": "隆尧县" }, { "v": "190", "n": "临城县" }, { "v": "191", "n": "广宗县" }, { "v": "192", "n": "临西县" }, { "v": "193", "n": "内丘县" }, { "v": "194", "n": "平乡县" }, { "v": "195", "n": "巨鹿县" }, { "v": "196", "n": "新河县" }, { "v": "197", "n": "南和县" }] }, { "v": "199", "n": "保定市", "c": [{ "v": "47213", "n": "涿州市" }, { "v": "47214", "n": "定州市" }, { "v": "47215", "n": "徐水县" }, { "v": "47216", "n": "高碑店市" }, { "v": "3190", "n": "新市区" }, { "v": "3191", "n": "北市区" }, { "v": "3192", "n": "南市区" }, { "v": "203", "n": "安国市" }, { "v": "3193", "n": "安新县" }, { "v": "205", "n": "满城县" }, { "v": "206", "n": "清苑县" }, { "v": "207", "n": "涞水县" }, { "v": "208", "n": "阜平县" }, { "v": "210", "n": "定兴县" }, { "v": "211", "n": "唐县" }, { "v": "212", "n": "高阳县" }, { "v": "213", "n": "容城县" }, { "v": "214", "n": "涞源县" }, { "v": "215", "n": "望都县" }, { "v": "217", "n": "易县" }, { "v": "218", "n": "曲阳县" }, { "v": "219", "n": "蠡县" }, { "v": "220", "n": "顺平县" }, { "v": "221", "n": "博野县" }, { "v": "222", "n": "雄县" }] }, { "v": "224", "n": "张家口市", "c": [{ "v": "230", "n": "怀安县" }, { "v": "3156", "n": "沽源县" }, { "v": "4046", "n": "宣化区" }, { "v": "225", "n": "宣化县" }, { "v": "226", "n": "康保县" }, { "v": "227", "n": "张北县" }, { "v": "228", "n": "阳原县" }, { "v": "229", "n": "赤城县" }, { "v": "232", "n": "崇礼县" }, { "v": "233", "n": "尚义县" }, { "v": "234", "n": "蔚县" }, { "v": "235", "n": "涿鹿县" }, { "v": "236", "n": "万全县" }, { "v": "238", "n": "下花园区" }, { "v": "34298", "n": "桥西区" }, { "v": "34299", "n": "桥东区" }, { "v": "231", "n": "怀来县" }] }, { "v": "239", "n": "承德市", "c": [{ "v": "3197", "n": "双滦区" }, { "v": "3198", "n": "鹰手营子矿区" }, { "v": "2767", "n": "隆化县" }, { "v": "241", "n": "兴隆县" }, { "v": "242", "n": "平泉市" }, { "v": "243", "n": "滦平县" }, { "v": "245", "n": "丰宁县" }, { "v": "246", "n": "围场县" }, { "v": "247", "n": "宽城县" }, { "v": "48379", "n": "双桥区" }, { "v": "3092", "n": "承德县" }] }, { "v": "248", "n": "秦皇岛市", "c": [{ "v": "261", "n": "卢龙县" }, { "v": "262", "n": "青龙县" }, { "v": "263", "n": "昌黎县" }, { "v": "2990", "n": "北戴河区" }, { "v": "48377", "n": "海港区" }, { "v": "48378", "n": "山海关区" }, { "v": "4093", "n": "抚宁县" }] }] }, { "v": "6", "n": "山西", "c": [{ "v": "3074", "n": "长治市", "c": [{ "v": "3075", "n": "长治县" }, { "v": "3109", "n": "潞城市" }, { "v": "3222", "n": "郊区" }, { "v": "3223", "n": "襄垣县" }, { "v": "3224", "n": "屯留县" }, { "v": "3225", "n": "平顺县" }, { "v": "3226", "n": "黎城县" }, { "v": "3227", "n": "壶关县" }, { "v": "3228", "n": "长子县" }, { "v": "3229", "n": "武乡县" }, { "v": "3230", "n": "沁县" }, { "v": "3231", "n": "沁源县" }, { "v": "32505", "n": "城区" }] }, { "v": "303", "n": "太原市", "c": [{ "v": "36780", "n": "小店区" }, { "v": "36781", "n": "迎泽区" }, { "v": "36782", "n": "晋源区" }, { "v": "36783", "n": "万柏林区" }, { "v": "36784", "n": "尖草坪区" }, { "v": "36785", "n": "杏花岭区" }, { "v": "305", "n": "古交市" }, { "v": "304", "n": "阳曲县" }, { "v": "306", "n": "娄烦县" }, { "v": "307", "n": "清徐县" }] }, { "v": "309", "n": "大同市", "c": [{ "v": "310", "n": "大同县" }, { "v": "311", "n": "天镇县" }, { "v": "312", "n": "灵丘县" }, { "v": "313", "n": "阳高县" }, { "v": "314", "n": "左云县" }, { "v": "315", "n": "浑源县" }, { "v": "316", "n": "广灵县" }, { "v": "32061", "n": "城区" }, { "v": "3214", "n": "新荣区" }, { "v": "3216", "n": "南郊区" }, { "v": "3217", "n": "矿区" }] }, { "v": "318", "n": "阳泉市", "c": [{ "v": "319", "n": "盂县" }, { "v": "320", "n": "平定县" }, { "v": "321", "n": "郊区" }, { "v": "44144", "n": "城区" }, { "v": "3219", "n": "矿区" }] }, { "v": "325", "n": "晋城市", "c": [{ "v": "3073", "n": "城区" }, { "v": "326", "n": "高平市" }, { "v": "327", "n": "阳城县" }, { "v": "328", "n": "沁水县" }, { "v": "329", "n": "陵川县" }, { "v": "2967", "n": "泽州县" }] }, { "v": "330", "n": "朔州市", "c": [{ "v": "3118", "n": "平鲁区" }, { "v": "331", "n": "山阴县" }, { "v": "332", "n": "右玉县" }, { "v": "333", "n": "应县" }, { "v": "334", "n": "怀仁县" }, { "v": "335", "n": "朔城区" }] }, { "v": "336", "n": "晋中市", "c": [{ "v": "338", "n": "介休市" }, { "v": "339", "n": "昔阳县" }, { "v": "341", "n": "祁县" }, { "v": "342", "n": "左权县" }, { "v": "343", "n": "寿阳县" }, { "v": "344", "n": "太谷县" }, { "v": "345", "n": "和顺县" }, { "v": "346", "n": "灵石县" }, { "v": "347", "n": "平遥县" }, { "v": "348", "n": "榆社县" }, { "v": "44145", "n": "榆次区" }] }, { "v": "350", "n": "忻州市", "c": [{ "v": "351", "n": "原平市" }, { "v": "352", "n": "代县" }, { "v": "353", "n": "神池县" }, { "v": "354", "n": "五寨县" }, { "v": "358", "n": "五台县" }, { "v": "359", "n": "偏关县" }, { "v": "360", "n": "宁武县" }, { "v": "361", "n": "静乐县" }, { "v": "362", "n": "繁峙县" }, { "v": "363", "n": "河曲县" }, { "v": "364", "n": "保德县" }, { "v": "365", "n": "定襄县" }, { "v": "366", "n": "忻府区" }, { "v": "367", "n": "岢岚县" }] }, { "v": "368", "n": "吕梁市", "c": [{ "v": "369", "n": "离石区" }, { "v": "370", "n": "孝义市" }, { "v": "371", "n": "汾阳市" }, { "v": "372", "n": "文水县" }, { "v": "373", "n": "中阳县" }, { "v": "374", "n": "兴县" }, { "v": "375", "n": "临县" }, { "v": "376", "n": "方山县" }, { "v": "377", "n": "柳林县" }, { "v": "378", "n": "岚县" }, { "v": "3235", "n": "交口县" }, { "v": "3236", "n": "交城县" }, { "v": "3237", "n": "石楼县" }] }, { "v": "379", "n": "临汾市", "c": [{ "v": "3136", "n": "曲沃县" }, { "v": "380", "n": "侯马市" }, { "v": "381", "n": "霍州市" }, { "v": "382", "n": "汾西县" }, { "v": "383", "n": "吉县" }, { "v": "384", "n": "安泽县" }, { "v": "386", "n": "浮山县" }, { "v": "387", "n": "大宁县" }, { "v": "388", "n": "古县" }, { "v": "389", "n": "隰县" }, { "v": "390", "n": "襄汾县" }, { "v": "391", "n": "翼城县" }, { "v": "392", "n": "永和县" }, { "v": "393", "n": "乡宁县" }, { "v": "395", "n": "洪洞县" }, { "v": "396", "n": "蒲县" }, { "v": "32206", "n": "尧都区" }] }, { "v": "398", "n": "运城市", "c": [{ "v": "32360", "n": "盐湖区" }, { "v": "399", "n": "河津市" }, { "v": "400", "n": "永济市" }, { "v": "402", "n": "新绛县" }, { "v": "403", "n": "平陆县" }, { "v": "404", "n": "垣曲县" }, { "v": "405", "n": "绛县" }, { "v": "406", "n": "稷山县" }, { "v": "407", "n": "芮城县" }, { "v": "408", "n": "夏县" }, { "v": "409", "n": "临猗县" }, { "v": "410", "n": "万荣县" }, { "v": "3233", "n": "闻喜县" }] }] }, { "v": "7", "n": "河南", "c": [{ "v": "517", "n": "商丘市", "c": [{ "v": "518", "n": "永城市" }, { "v": "519", "n": "宁陵县" }, { "v": "520", "n": "虞城县" }, { "v": "521", "n": "民权县" }, { "v": "522", "n": "夏邑县" }, { "v": "523", "n": "柘城县" }, { "v": "524", "n": "睢县" }, { "v": "34751", "n": "睢阳区" }, { "v": "34752", "n": "梁园区" }] }, { "v": "527", "n": "周口市", "c": [{ "v": "529", "n": "项城市" }, { "v": "530", "n": "商水县" }, { "v": "531", "n": "淮阳县" }, { "v": "532", "n": "太康县" }, { "v": "533", "n": "鹿邑县" }, { "v": "534", "n": "西华县" }, { "v": "535", "n": "扶沟县" }, { "v": "536", "n": "沈丘县" }, { "v": "537", "n": "郸城县" }, { "v": "35108", "n": "川汇区" }, { "v": "34926", "n": "东新区" }, { "v": "34927", "n": "经济开发区" }] }, { "v": "538", "n": "驻马店市", "c": [{ "v": "540", "n": "确山县" }, { "v": "541", "n": "新蔡县" }, { "v": "542", "n": "上蔡县" }, { "v": "543", "n": "泌阳县" }, { "v": "544", "n": "西平县" }, { "v": "545", "n": "遂平县" }, { "v": "546", "n": "汝南县" }, { "v": "547", "n": "平舆县" }, { "v": "548", "n": "正阳县" }, { "v": "35189", "n": "驿城区" }] }, { "v": "549", "n": "信阳市", "c": [{ "v": "551", "n": "潢川县" }, { "v": "552", "n": "淮滨县" }, { "v": "553", "n": "息县" }, { "v": "554", "n": "新县" }, { "v": "556", "n": "固始县" }, { "v": "557", "n": "罗山县" }, { "v": "558", "n": "光山县" }, { "v": "3119", "n": "商城县" }, { "v": "34548", "n": "平桥区" }, { "v": "34549", "n": "浉河区" }] }, { "v": "412", "n": "郑州市", "c": [{ "v": "3547", "n": "二七区" }, { "v": "3548", "n": "中原区" }, { "v": "4337", "n": "郑东新区" }, { "v": "3546", "n": "管城区" }, { "v": "3545", "n": "金水区" }, { "v": "47300", "n": "经济开发区" }, { "v": "47301", "n": "高新技术开发区" }, { "v": "46820", "n": "新郑市" }, { "v": "46821", "n": "巩义市" }, { "v": "46822", "n": "荥阳市" }, { "v": "46823", "n": "中牟县" }, { "v": "415", "n": "新密市" }, { "v": "416", "n": "登封市" }, { "v": "3544", "n": "惠济区" }, { "v": "2782", "n": "上街区" }] }, { "v": "420", "n": "开封市", "c": [{ "v": "45533", "n": "金明区" }, { "v": "45534", "n": "龙亭区" }, { "v": "45535", "n": "顺河区" }, { "v": "45536", "n": "鼓楼区" }, { "v": "45537", "n": "禹王台区" }, { "v": "3127", "n": "通许县" }, { "v": "421", "n": "开封县" }, { "v": "422", "n": "杞县" }, { "v": "423", "n": "兰考县" }, { "v": "425", "n": "尉氏县" }] }, { "v": "427", "n": "洛阳市", "c": [{ "v": "3556", "n": "涧西区" }, { "v": "3559", "n": "西工区" }, { "v": "45532", "n": "洛龙区" }, { "v": "4150", "n": "嵩县" }, { "v": "428", "n": "偃师市" }, { "v": "429", "n": "孟津县" }, { "v": "430", "n": "汝阳县" }, { "v": "431", "n": "伊川县" }, { "v": "432", "n": "洛宁县" }, { "v": "434", "n": "宜阳县" }, { "v": "435", "n": "栾川县" }, { "v": "436", "n": "新安县" }, { "v": "45531", "n": "伊滨区" }, { "v": "3555", "n": "吉利区" }, { "v": "3557", "n": "瀍河区" }, { "v": "3558", "n": "老城区" }] }, { "v": "438", "n": "平顶山市", "c": [{ "v": "35965", "n": "湛河区" }, { "v": "35966", "n": "卫东区" }, { "v": "35967", "n": "新华区" }, { "v": "439", "n": "汝州市" }, { "v": "440", "n": "舞钢市" }, { "v": "441", "n": "郏县" }, { "v": "442", "n": "叶县" }, { "v": "443", "n": "鲁山县" }, { "v": "444", "n": "宝丰县" }, { "v": "3560", "n": "石龙区" }] }, { "v": "446", "n": "焦作市", "c": [{ "v": "447", "n": "沁阳市" }, { "v": "448", "n": "孟州市" }, { "v": "449", "n": "修武县" }, { "v": "450", "n": "温县" }, { "v": "451", "n": "武陟县" }, { "v": "452", "n": "博爱县" }, { "v": "453", "n": "山阳区" }, { "v": "3566", "n": "解放区" }, { "v": "37371", "n": "马村区" }, { "v": "37372", "n": "中站区" }] }, { "v": "454", "n": "鹤壁市", "c": [{ "v": "35591", "n": "淇滨区" }, { "v": "455", "n": "浚县" }, { "v": "456", "n": "淇县" }, { "v": "457", "n": "鹤山区" }, { "v": "3567", "n": "山城区" }] }, { "v": "458", "n": "新乡市", "c": [{ "v": "37456", "n": "牧野区" }, { "v": "37457", "n": "红旗区" }, { "v": "37458", "n": "卫滨区" }, { "v": "459", "n": "卫辉市" }, { "v": "460", "n": "辉县市" }, { "v": "461", "n": "新乡县" }, { "v": "462", "n": "获嘉县" }, { "v": "463", "n": "原阳县" }, { "v": "464", "n": "长垣县" }, { "v": "465", "n": "延津县" }, { "v": "466", "n": "封丘县" }, { "v": "3570", "n": "凤泉区" }] }, { "v": "468", "n": "安阳市", "c": [{ "v": "35470", "n": "龙安区" }, { "v": "35471", "n": "殷都区" }, { "v": "35472", "n": "文峰区" }, { "v": "35473", "n": "开发区" }, { "v": "35474", "n": "北关区" }, { "v": "469", "n": "林州市" }, { "v": "470", "n": "安阳县" }, { "v": "471", "n": "滑县" }, { "v": "472", "n": "汤阴县" }, { "v": "473", "n": "内黄县" }] }, { "v": "475", "n": "濮阳市", "c": [{ "v": "476", "n": "濮阳县" }, { "v": "477", "n": "南乐县" }, { "v": "478", "n": "台前县" }, { "v": "479", "n": "清丰县" }, { "v": "480", "n": "范县" }, { "v": "481", "n": "华龙区" }] }, { "v": "2780", "n": "济源市", "c": [{ "v": "52305", "n": "城区" }, { "v": "35178", "n": "五龙口镇" }, { "v": "35179", "n": "下冶镇" }, { "v": "35180", "n": "轵城镇" }, { "v": "35181", "n": "王屋镇" }, { "v": "35182", "n": "思礼镇" }, { "v": "35183", "n": "邵原镇" }, { "v": "35184", "n": "坡头镇" }, { "v": "35185", "n": "梨林镇" }, { "v": "35186", "n": "克井镇" }, { "v": "35187", "n": "大峪镇" }, { "v": "35188", "n": "承留镇" }] }, { "v": "482", "n": "许昌市", "c": [{ "v": "488", "n": "魏都区" }, { "v": "483", "n": "禹州市" }, { "v": "484", "n": "长葛市" }, { "v": "485", "n": "建安区" }, { "v": "486", "n": "鄢陵县" }, { "v": "487", "n": "襄城县" }] }, { "v": "489", "n": "漯河市", "c": [{ "v": "490", "n": "郾城区" }, { "v": "492", "n": "临颍县" }, { "v": "493", "n": "召陵区" }, { "v": "494", "n": "舞阳县" }, { "v": "3576", "n": "源汇区" }] }, { "v": "495", "n": "三门峡市", "c": [{ "v": "3113", "n": "渑池县" }, { "v": "35637", "n": "湖滨区" }, { "v": "496", "n": "义马市" }, { "v": "497", "n": "灵宝市" }, { "v": "498", "n": "陕县" }, { "v": "499", "n": "卢氏县" }] }, { "v": "502", "n": "南阳市", "c": [{ "v": "512", "n": "社旗县" }, { "v": "515", "n": "西峡县" }, { "v": "35751", "n": "卧龙区" }, { "v": "35752", "n": "宛城区" }, { "v": "503", "n": "邓州市" }, { "v": "504", "n": "桐柏县" }, { "v": "505", "n": "方城县" }, { "v": "506", "n": "淅川县" }, { "v": "507", "n": "镇平县" }, { "v": "508", "n": "唐河县" }, { "v": "509", "n": "南召县" }, { "v": "510", "n": "内乡县" }, { "v": "511", "n": "新野县" }] }] }, { "v": "8", "n": "辽宁", "c": [{ "v": "560", "n": "沈阳市", "c": [{ "v": "567", "n": "苏家屯区" }, { "v": "569", "n": "新民市" }, { "v": "570", "n": "法库县" }, { "v": "571", "n": "辽中县" }, { "v": "572", "n": "康平县" }, { "v": "50819", "n": "皇姑区" }, { "v": "50820", "n": "铁西区" }, { "v": "50821", "n": "大东区" }, { "v": "50822", "n": "沈河区" }, { "v": "50823", "n": "东陵区" }, { "v": "50824", "n": "于洪区" }, { "v": "50825", "n": "和平区" }, { "v": "50826", "n": "浑南新区" }, { "v": "50827", "n": "沈北新区" }] }, { "v": "573", "n": "大连市", "c": [{ "v": "4468", "n": "中山区" }, { "v": "3261", "n": "沙河口区" }, { "v": "3263", "n": "西岗区" }, { "v": "5909", "n": "甘井子区" }, { "v": "6561", "n": "高新园区" }, { "v": "6627", "n": "大连开发区" }, { "v": "46824", "n": "金州区" }, { "v": "46825", "n": "旅顺口区" }, { "v": "574", "n": "普兰店市" }, { "v": "575", "n": "瓦房店市" }, { "v": "576", "n": "庄河市" }, { "v": "577", "n": "长海县" }] }, { "v": "579", "n": "鞍山市", "c": [{ "v": "3264", "n": "铁东区" }, { "v": "3266", "n": "立山区" }, { "v": "580", "n": "台安县" }, { "v": "581", "n": "海城市" }, { "v": "583", "n": "岫岩县" }, { "v": "37581", "n": "铁西区" }, { "v": "37582", "n": "千山区" }] }, { "v": "584", "n": "抚顺市", "c": [{ "v": "3268", "n": "望花区" }, { "v": "3269", "n": "东洲区" }, { "v": "3270", "n": "新抚区" }, { "v": "3271", "n": "顺城区" }, { "v": "585", "n": "抚顺县" }, { "v": "586", "n": "新宾县" }, { "v": "587", "n": "清原县" }] }, { "v": "589", "n": "本溪市", "c": [{ "v": "591", "n": "桓仁县" }, { "v": "41341", "n": "本溪县" }, { "v": "41342", "n": "平山区" }, { "v": "41343", "n": "溪湖区" }, { "v": "41344", "n": "明山区" }, { "v": "3275", "n": "南芬区" }] }, { "v": "593", "n": "丹东市", "c": [{ "v": "20171", "n": "元宝区" }, { "v": "20172", "n": "振兴区" }, { "v": "20173", "n": "振安区" }, { "v": "20174", "n": "东港市" }, { "v": "20175", "n": "凤城市" }, { "v": "596", "n": "宽甸县" }] }, { "v": "598", "n": "锦州市", "c": [{ "v": "4913", "n": "凌河区" }, { "v": "4912", "n": "古塔区" }, { "v": "4914", "n": "太和区" }, { "v": "599", "n": "义县" }, { "v": "600", "n": "凌海市" }, { "v": "601", "n": "北镇市" }, { "v": "602", "n": "黑山县" }, { "v": "6790", "n": "经济技术开发区" }] }, { "v": "604", "n": "葫芦岛市", "c": [{ "v": "3300", "n": "龙港区" }, { "v": "20524", "n": "连山区" }, { "v": "20525", "n": "兴城市" }, { "v": "606", "n": "绥中县" }, { "v": "607", "n": "建昌县" }, { "v": "608", "n": "南票区" }] }, { "v": "609", "n": "营口市", "c": [{ "v": "3283", "n": "西市区" }, { "v": "6628", "n": "站前区" }, { "v": "610", "n": "大石桥市" }, { "v": "611", "n": "盖州市" }, { "v": "3282", "n": "老边区" }, { "v": "20183", "n": "鲅鱼圈区" }] }, { "v": "613", "n": "盘锦市", "c": [{ "v": "614", "n": "盘山县" }, { "v": "615", "n": "大洼县" }, { "v": "20661", "n": "兴隆台区" }, { "v": "20662", "n": "双台子区" }] }, { "v": "617", "n": "阜新市", "c": [{ "v": "618", "n": "阜新县" }, { "v": "619", "n": "彰武县" }, { "v": "20658", "n": "海州区" }, { "v": "20659", "n": "太平区" }, { "v": "20660", "n": "细河区" }, { "v": "3286", "n": "清河门区" }, { "v": "3288", "n": "新邱区" }] }, { "v": "621", "n": "辽阳市", "c": [{ "v": "623", "n": "辽阳县" }, { "v": "43963", "n": "白塔区" }, { "v": "43964", "n": "文圣区" }, { "v": "43965", "n": "灯塔市" }, { "v": "3290", "n": "太子河区" }, { "v": "3291", "n": "弓长岭区" }, { "v": "3292", "n": "宏伟区" }] }, { "v": "632", "n": "朝阳市", "c": [{ "v": "633", "n": "凌源市" }, { "v": "634", "n": "北票市" }, { "v": "635", "n": "喀喇沁左翼县" }, { "v": "636", "n": "朝阳县" }, { "v": "20348", "n": "双塔区" }, { "v": "637", "n": "建平县" }, { "v": "3299", "n": "龙城区" }] }, { "v": "6858", "n": "铁岭市", "c": [{ "v": "6859", "n": "银州区" }, { "v": "6860", "n": "清河区" }, { "v": "6862", "n": "开原市" }, { "v": "6863", "n": "铁岭县" }, { "v": "6864", "n": "西丰县" }, { "v": "6865", "n": "昌图县" }, { "v": "44027", "n": "调兵山市" }] }] }, { "v": "9", "n": "吉林", "c": [{ "v": "639", "n": "长春市", "c": [{ "v": "3172", "n": "德惠市" }, { "v": "640", "n": "榆树市" }, { "v": "641", "n": "九台市" }, { "v": "642", "n": "农安县" }, { "v": "38630", "n": "朝阳区" }, { "v": "38631", "n": "南关区" }, { "v": "38632", "n": "宽城区" }, { "v": "38633", "n": "二道区" }, { "v": "3306", "n": "双阳区" }, { "v": "38634", "n": "绿园区" }, { "v": "38635", "n": "净月区" }, { "v": "38636", "n": "汽车产业开发区" }, { "v": "38637", "n": "高新技术开发区" }, { "v": "38638", "n": "经济技术开发区" }] }, { "v": "644", "n": "吉林市", "c": [{ "v": "24069", "n": "昌邑区" }, { "v": "24070", "n": "龙潭区" }, { "v": "24071", "n": "船营区" }, { "v": "24072", "n": "丰满区" }, { "v": "645", "n": "舒兰市" }, { "v": "646", "n": "桦甸市" }, { "v": "647", "n": "蛟河市" }, { "v": "648", "n": "磐石市" }, { "v": "649", "n": "永吉县" }] }, { "v": "651", "n": "四平市", "c": [{ "v": "6641", "n": "铁东区" }, { "v": "6642", "n": "铁西区" }, { "v": "652", "n": "公主岭市" }, { "v": "653", "n": "双辽市" }, { "v": "654", "n": "梨树县" }, { "v": "656", "n": "伊通县" }] }, { "v": "657", "n": "通化市", "c": [{ "v": "3311", "n": "东昌区" }, { "v": "658", "n": "梅河口市" }, { "v": "659", "n": "集安市" }, { "v": "660", "n": "通化县" }, { "v": "661", "n": "辉南县" }, { "v": "662", "n": "柳河县" }, { "v": "663", "n": "二道江区" }] }, { "v": "664", "n": "白山市", "c": [{ "v": "24074", "n": "浑江区" }, { "v": "665", "n": "临江市" }, { "v": "669", "n": "江源区" }, { "v": "671", "n": "靖宇县" }, { "v": "672", "n": "抚松县" }, { "v": "673", "n": "长白县" }] }, { "v": "674", "n": "松原市", "c": [{ "v": "24075", "n": "宁江区" }, { "v": "24076", "n": "前郭县" }, { "v": "675", "n": "乾安县" }, { "v": "676", "n": "长岭县" }, { "v": "677", "n": "扶余县" }] }, { "v": "681", "n": "白城市", "c": [{ "v": "682", "n": "大安市" }, { "v": "683", "n": "洮南市" }, { "v": "684", "n": "通榆县" }, { "v": "685", "n": "镇赉县" }, { "v": "686", "n": "洮北区" }] }, { "v": "687", "n": "延边州", "c": [{ "v": "24073", "n": "延吉市" }, { "v": "3312", "n": "图们市" }, { "v": "3313", "n": "敦化市" }, { "v": "3314", "n": "珲春市" }, { "v": "3315", "n": "龙井市" }, { "v": "3316", "n": "和龙市" }, { "v": "3317", "n": "汪清县" }, { "v": "3318", "n": "安图县" }] }, { "v": "2992", "n": "辽源市", "c": [{ "v": "2993", "n": "龙山区" }, { "v": "2994", "n": "西安区" }, { "v": "2995", "n": "东丰县" }, { "v": "2996", "n": "东辽县" }] }] }, { "v": "10", "n": "黑龙江", "c": [{ "v": "773", "n": "七台河市", "c": [{ "v": "774", "n": "勃利县" }, { "v": "3364", "n": "桃山区" }, { "v": "3365", "n": "新兴区" }, { "v": "3366", "n": "茄子河区" }, { "v": "53287", "n": "金沙新区" }] }, { "v": "776", "n": "黑河市", "c": [{ "v": "777", "n": "北安市" }, { "v": "778", "n": "五大连池市" }, { "v": "779", "n": "逊克县" }, { "v": "780", "n": "孙吴县" }, { "v": "3096", "n": "嫩江县" }, { "v": "3371", "n": "爱辉区" }] }, { "v": "782", "n": "绥化市", "c": [{ "v": "6712", "n": "北林区" }, { "v": "784", "n": "安达市" }, { "v": "785", "n": "肇东市" }, { "v": "786", "n": "海伦市" }, { "v": "787", "n": "绥棱县" }, { "v": "788", "n": "兰西县" }, { "v": "789", "n": "明水县" }, { "v": "790", "n": "青冈县" }, { "v": "791", "n": "庆安县" }, { "v": "792", "n": "望奎县" }] }, { "v": "793", "n": "大兴安岭地区", "c": [{ "v": "4114", "n": "加格达奇区" }, { "v": "4115", "n": "松岭区" }, { "v": "4116", "n": "呼中区" }, { "v": "794", "n": "呼玛县" }, { "v": "795", "n": "塔河县" }, { "v": "796", "n": "漠河县" }, { "v": "11432", "n": "新林区" }] }, { "v": "698", "n": "哈尔滨市", "c": [{ "v": "699", "n": "阿城区" }, { "v": "700", "n": "尚志市" }, { "v": "701", "n": "双城市" }, { "v": "702", "n": "五常市" }, { "v": "704", "n": "方正县" }, { "v": "705", "n": "宾县" }, { "v": "706", "n": "依兰县" }, { "v": "707", "n": "巴彦县" }, { "v": "708", "n": "通河县" }, { "v": "709", "n": "木兰县" }, { "v": "710", "n": "延寿县" }, { "v": "45814", "n": "呼兰区" }, { "v": "45815", "n": "松北区" }, { "v": "45816", "n": "道里区" }, { "v": "45817", "n": "南岗区" }, { "v": "45818", "n": "道外区" }, { "v": "45819", "n": "香坊区" }, { "v": "45820", "n": "平房区" }] }, { "v": "712", "n": "齐齐哈尔市", "c": [{ "v": "33404", "n": "建华区" }, { "v": "33405", "n": "龙沙区" }, { "v": "33406", "n": "铁锋区" }, { "v": "713", "n": "梅里斯区" }, { "v": "714", "n": "昂昂溪区" }, { "v": "715", "n": "富拉尔基区" }, { "v": "716", "n": "碾子山区" }, { "v": "717", "n": "讷河市" }, { "v": "718", "n": "富裕县" }, { "v": "719", "n": "拜泉县" }, { "v": "720", "n": "甘南县" }, { "v": "721", "n": "依安县" }, { "v": "722", "n": "克山县" }, { "v": "723", "n": "龙江县" }, { "v": "724", "n": "克东县" }, { "v": "725", "n": "泰来县" }] }, { "v": "727", "n": "鹤岗市", "c": [{ "v": "3334", "n": "兴山区" }, { "v": "3335", "n": "向阳区" }, { "v": "3336", "n": "工农区" }, { "v": "3337", "n": "南山区" }, { "v": "3338", "n": "兴安区" }, { "v": "3339", "n": "东山区" }, { "v": "728", "n": "萝北县" }, { "v": "729", "n": "绥滨县" }] }, { "v": "731", "n": "双鸭山市", "c": [{ "v": "3340", "n": "尖山区" }, { "v": "3341", "n": "岭东区" }, { "v": "3342", "n": "四方台区" }, { "v": "3343", "n": "宝山区" }, { "v": "733", "n": "集贤县" }, { "v": "734", "n": "宝清县" }, { "v": "735", "n": "友谊县" }, { "v": "736", "n": "饶河县" }] }, { "v": "737", "n": "鸡西市", "c": [{ "v": "3329", "n": "恒山区" }, { "v": "3330", "n": "滴道区" }, { "v": "3331", "n": "梨树区" }, { "v": "3332", "n": "城子河区" }, { "v": "3333", "n": "麻山区" }, { "v": "33163", "n": "鸡冠区" }, { "v": "739", "n": "密山市" }, { "v": "740", "n": "虎林市" }, { "v": "741", "n": "鸡东县" }] }, { "v": "742", "n": "大庆市", "c": [{ "v": "744", "n": "萨尔图区" }, { "v": "745", "n": "龙凤区" }, { "v": "746", "n": "让胡路区" }, { "v": "747", "n": "红岗区" }, { "v": "748", "n": "大同区" }, { "v": "749", "n": "林甸县" }, { "v": "750", "n": "肇州县" }, { "v": "751", "n": "肇源县" }, { "v": "752", "n": "杜尔伯特县" }] }, { "v": "753", "n": "伊春市", "c": [{ "v": "3344", "n": "伊春区" }, { "v": "3345", "n": "南岔区" }, { "v": "3346", "n": "友好区" }, { "v": "3347", "n": "西林区" }, { "v": "3348", "n": "翠峦区" }, { "v": "3349", "n": "新青区" }, { "v": "3350", "n": "美溪区" }, { "v": "3351", "n": "金山屯区" }, { "v": "3352", "n": "五营区" }, { "v": "3353", "n": "乌马河区" }, { "v": "3354", "n": "汤旺河区" }, { "v": "3355", "n": "带岭区" }, { "v": "3356", "n": "乌伊岭区" }, { "v": "3357", "n": "红星区" }, { "v": "3358", "n": "上甘岭区" }, { "v": "754", "n": "铁力市" }, { "v": "755", "n": "嘉荫县" }] }, { "v": "757", "n": "牡丹江市", "c": [{ "v": "3367", "n": "爱民区" }, { "v": "3368", "n": "东安区" }, { "v": "3369", "n": "阳明区" }, { "v": "3370", "n": "西安区" }, { "v": "4148", "n": "绥芬河市" }, { "v": "758", "n": "海林市" }, { "v": "760", "n": "宁安市" }, { "v": "761", "n": "穆棱市" }, { "v": "762", "n": "林口县" }, { "v": "763", "n": "东宁县" }] }, { "v": "765", "n": "佳木斯市", "c": [{ "v": "768", "n": "桦川县" }, { "v": "769", "n": "抚远县" }, { "v": "770", "n": "桦南县" }, { "v": "771", "n": "汤原县" }, { "v": "33269", "n": "前进区" }, { "v": "33270", "n": "向阳区" }, { "v": "33271", "n": "东风区" }, { "v": "33272", "n": "郊区" }, { "v": "766", "n": "同江市" }, { "v": "767", "n": "富锦市" }] }] }, { "v": "11", "n": "内蒙古", "c": [{ "v": "799", "n": "呼和浩特市", "c": [{ "v": "3240", "n": "玉泉区" }, { "v": "3241", "n": "赛罕区" }, { "v": "801", "n": "土默特左旗" }, { "v": "802", "n": "和林格尔县" }, { "v": "803", "n": "武川县" }, { "v": "804", "n": "托克托县" }, { "v": "3133", "n": "清水河县" }, { "v": "32652", "n": "回民区" }, { "v": "32653", "n": "新城区" }] }, { "v": "805", "n": "包头市", "c": [{ "v": "807", "n": "固阳县" }, { "v": "808", "n": "土默特右旗" }, { "v": "809", "n": "达茂联合旗" }, { "v": "38251", "n": "东河区" }, { "v": "38252", "n": "九原区" }, { "v": "38253", "n": "青山区" }, { "v": "38254", "n": "昆都仑区" }, { "v": "3245", "n": "石拐区" }, { "v": "3246", "n": "白云矿区" }] }, { "v": "810", "n": "乌海市", "c": [{ "v": "811", "n": "海勃湾区" }, { "v": "3248", "n": "海南区" }, { "v": "3249", "n": "乌达区" }] }, { "v": "812", "n": "赤峰市", "c": [{ "v": "814", "n": "宁城县" }, { "v": "815", "n": "敖汉旗" }, { "v": "816", "n": "喀喇沁旗" }, { "v": "817", "n": "翁牛特旗" }, { "v": "818", "n": "巴林右旗" }, { "v": "819", "n": "林西县" }, { "v": "820", "n": "克什克腾旗" }, { "v": "821", "n": "巴林左旗" }, { "v": "822", "n": "阿鲁科尔沁旗" }, { "v": "3199", "n": "元宝山区" }, { "v": "32937", "n": "红山区" }, { "v": "3251", "n": "松山区" }] }, { "v": "823", "n": "乌兰察布市", "c": [{ "v": "824", "n": "集宁区" }, { "v": "825", "n": "丰镇市" }, { "v": "826", "n": "兴和县" }, { "v": "827", "n": "卓资县" }, { "v": "828", "n": "商都县" }, { "v": "829", "n": "凉城县" }, { "v": "830", "n": "化德县" }, { "v": "831", "n": "察哈尔右翼前旗" }, { "v": "832", "n": "察哈尔右翼中旗" }, { "v": "833", "n": "察哈尔右翼后旗" }, { "v": "834", "n": "四子王旗" }] }, { "v": "835", "n": "锡林郭勒盟", "c": [{ "v": "836", "n": "锡林浩特市" }, { "v": "837", "n": "二连浩特市" }, { "v": "838", "n": "多伦县" }, { "v": "839", "n": "阿巴嘎旗" }, { "v": "840", "n": "西乌珠穆沁旗" }, { "v": "841", "n": "东乌珠穆沁旗" }, { "v": "842", "n": "苏尼特右旗" }, { "v": "843", "n": "苏尼特左旗" }, { "v": "844", "n": "太仆寺旗" }, { "v": "845", "n": "正镶白旗" }, { "v": "846", "n": "正蓝旗" }, { "v": "847", "n": "镶黄旗" }] }, { "v": "848", "n": "呼伦贝尔市", "c": [{ "v": "849", "n": "海拉尔区" }, { "v": "850", "n": "满洲里市" }, { "v": "851", "n": "牙克石市" }, { "v": "852", "n": "扎兰屯市" }, { "v": "853", "n": "根河市" }, { "v": "854", "n": "额尔古纳市" }, { "v": "855", "n": "陈巴尔虎旗" }, { "v": "856", "n": "阿荣旗" }, { "v": "857", "n": "新巴尔虎左旗" }, { "v": "858", "n": "新巴尔虎右旗" }, { "v": "859", "n": "鄂伦春旗" }, { "v": "860", "n": "莫力达瓦旗" }, { "v": "861", "n": "鄂温克族旗" }] }, { "v": "870", "n": "鄂尔多斯市", "c": [{ "v": "871", "n": "东胜区" }, { "v": "872", "n": "准格尔旗" }, { "v": "874", "n": "伊金霍洛旗" }, { "v": "875", "n": "乌审旗" }, { "v": "876", "n": "杭锦旗" }, { "v": "877", "n": "鄂托克旗" }, { "v": "878", "n": "鄂托克前旗" }, { "v": "879", "n": "达拉特旗" }, { "v": "18374", "n": "康巴什新区" }] }, { "v": "880", "n": "巴彦淖尔市", "c": [{ "v": "881", "n": "临河区" }, { "v": "882", "n": "五原县" }, { "v": "883", "n": "磴口县" }, { "v": "884", "n": "杭锦后旗" }, { "v": "885", "n": "乌拉特中旗" }, { "v": "888", "n": "乌拉特后旗 " }, { "v": "890", "n": "乌拉特前旗" }] }, { "v": "891", "n": "阿拉善盟", "c": [{ "v": "892", "n": "阿拉善右旗" }, { "v": "893", "n": "阿拉善左旗" }, { "v": "894", "n": "额济纳旗" }] }, { "v": "895", "n": "兴安盟", "c": [{ "v": "896", "n": "乌兰浩特市" }, { "v": "897", "n": "阿尔山市" }, { "v": "898", "n": "突泉县" }, { "v": "899", "n": "扎赉特旗" }, { "v": "900", "n": "科尔沁右翼前旗" }, { "v": "901", "n": "科尔沁右翼中旗" }] }, { "v": "902", "n": "通辽市", "c": [{ "v": "32769", "n": "科尔沁区" }, { "v": "3142", "n": "霍林郭勒市" }, { "v": "3252", "n": "开鲁县" }, { "v": "3253", "n": "库伦旗" }, { "v": "3254", "n": "奈曼旗" }, { "v": "3255", "n": "扎鲁特旗" }, { "v": "3256", "n": "科尔沁左翼中旗" }, { "v": "3258", "n": "科尔沁左翼后旗" }] }] }, { "v": "12", "n": "江苏", "c": [{ "v": "904", "n": "南京市", "c": [{ "v": "3373", "n": "玄武区" }, { "v": "3375", "n": "秦淮区" }, { "v": "3376", "n": "建邺区" }, { "v": "3377", "n": "鼓楼区" }, { "v": "3378", "n": "栖霞区" }, { "v": "905", "n": "江宁区" }, { "v": "908", "n": "六合区" }, { "v": "3379", "n": "雨花台区" }, { "v": "907", "n": "高淳区" }, { "v": "3024", "n": "溧水区" }, { "v": "50647", "n": "浦口区" }] }, { "v": "911", "n": "徐州市", "c": [{ "v": "3388", "n": "贾汪区" }, { "v": "4223", "n": "金山桥开发区" }, { "v": "4224", "n": "铜山经济技术开发区" }, { "v": "4228", "n": "八段工业园区" }, { "v": "23686", "n": "鼓楼区" }, { "v": "23687", "n": "邳州市" }, { "v": "23688", "n": "泉山区" }, { "v": "23689", "n": "新沂市" }, { "v": "23690", "n": "云龙区" }, { "v": "914", "n": "铜山区" }, { "v": "915", "n": "睢宁县" }, { "v": "916", "n": "沛县" }, { "v": "917", "n": "丰县" }] }, { "v": "919", "n": "连云港市", "c": [{ "v": "23684", "n": "海州区" }, { "v": "920", "n": "赣榆区" }, { "v": "4248", "n": "连云区" }, { "v": "921", "n": "灌云县" }, { "v": "922", "n": "东海县" }, { "v": "923", "n": "灌南县" }] }, { "v": "925", "n": "淮安市", "c": [{ "v": "4305", "n": "经济开发区" }, { "v": "926", "n": "淮安区" }, { "v": "929", "n": "洪泽县" }, { "v": "930", "n": "金湖县" }, { "v": "931", "n": "盱眙县" }, { "v": "36560", "n": "清河区" }, { "v": "36561", "n": "淮阴区" }, { "v": "36562", "n": "清浦区" }, { "v": "36563", "n": "涟水县" }] }, { "v": "933", "n": "宿迁市", "c": [{ "v": "3407", "n": "宿城区" }, { "v": "8558", "n": "沭阳县" }, { "v": "8559", "n": "泗阳县" }, { "v": "934", "n": "宿豫区" }, { "v": "937", "n": "泗洪县" }, { "v": "40649", "n": "宿迁经济开发区" }] }, { "v": "939", "n": "盐城市", "c": [{ "v": "23681", "n": "射阳县" }, { "v": "23682", "n": "亭湖区" }, { "v": "23683", "n": "盐都区" }, { "v": "940", "n": "东台市" }, { "v": "941", "n": "大丰区" }, { "v": "945", "n": "建湖县" }, { "v": "946", "n": "响水县" }, { "v": "948", "n": "阜宁县" }, { "v": "949", "n": "滨海县" }] }, { "v": "951", "n": "扬州市", "c": [{ "v": "955", "n": "广陵区" }, { "v": "956", "n": "邗江区" }, { "v": "957", "n": "宝应县" }, { "v": "42218", "n": "仪征市" }, { "v": "42219", "n": "高邮市" }, { "v": "42220", "n": "江都区" }] }, { "v": "959", "n": "泰州市", "c": [{ "v": "3406", "n": "海陵区" }, { "v": "3405", "n": "高港区" }, { "v": "960", "n": "泰兴市" }, { "v": "962", "n": "靖江市" }, { "v": "963", "n": "兴化市" }, { "v": "40174", "n": "姜堰区" }] }, { "v": "965", "n": "南通市", "c": [{ "v": "3394", "n": "港闸区" }, { "v": "3395", "n": "崇川区" }, { "v": "967", "n": "通州区" }, { "v": "4385", "n": "南通经济技术开发区" }, { "v": "970", "n": "如东县" }, { "v": "2774", "n": "海安县" }, { "v": "38364", "n": "如皋市" }, { "v": "38365", "n": "海门市" }, { "v": "38366", "n": "启东市" }] }, { "v": "972", "n": "镇江市", "c": [{ "v": "3403", "n": "润州区" }, { "v": "3404", "n": "京口区" }, { "v": "976", "n": "丹徒区" }, { "v": "4916", "n": "镇江新区" }, { "v": "38517", "n": "丹阳市" }, { "v": "38518", "n": "句容市" }, { "v": "973", "n": "扬中市" }, { "v": "51180", "n": "丹徒新区" }] }, { "v": "978", "n": "常州市", "c": [{ "v": "3392", "n": "钟楼区" }, { "v": "3393", "n": "天宁区" }, { "v": "4459", "n": "武进区" }, { "v": "2927", "n": "新北区" }, { "v": "980", "n": "金坛区" }, { "v": "981", "n": "溧阳市" }] }, { "v": "984", "n": "无锡市", "c": [{ "v": "3381", "n": "崇安区" }, { "v": "3382", "n": "南长区" }, { "v": "3383", "n": "北塘区" }, { "v": "3384", "n": "锡山区" }, { "v": "3385", "n": "惠山区" }, { "v": "4029", "n": "新区" }, { "v": "13989", "n": "江阴市" }, { "v": "15943", "n": "宜兴市" }, { "v": "40035", "n": "滨湖区" }, { "v": "53561", "n": "新吴区" }, { "v": "53562", "n": "梁溪区" }] }, { "v": "988", "n": "苏州市", "c": [{ "v": "993", "n": "常熟市" }, { "v": "994", "n": "张家港市" }, { "v": "4346", "n": "太仓市" }, { "v": "3082", "n": "相城区" }, { "v": "3083", "n": "金阊区" }, { "v": "3085", "n": "虎丘区" }, { "v": "3087", "n": "平江区" }, { "v": "3088", "n": "沧浪区" }, { "v": "3444", "n": "工业园区" }, { "v": "3742", "n": "高新区" }, { "v": "39628", "n": "吴江区" }, { "v": "40034", "n": "吴中区" }, { "v": "53563", "n": "姑苏区" }, { "v": "47821", "n": "昆山市" }] }] }, { "v": "13", "n": "山东", "c": [{ "v": "1025", "n": "东营市", "c": [{ "v": "1026", "n": "河口区" }, { "v": "1027", "n": "广饶县" }, { "v": "1028", "n": "利津县" }, { "v": "1029", "n": "垦利区" }, { "v": "36884", "n": "东营区" }] }, { "v": "1032", "n": "潍坊市", "c": [{ "v": "28921", "n": "潍城区" }, { "v": "28922", "n": "奎文区" }, { "v": "28923", "n": "高新区" }, { "v": "28924", "n": "寒亭区" }, { "v": "28925", "n": "寿光市" }, { "v": "1033", "n": "青州市" }, { "v": "1034", "n": "诸城市" }, { "v": "1036", "n": "安丘市" }, { "v": "1037", "n": "高密市" }, { "v": "1038", "n": "昌邑市" }, { "v": "1039", "n": "昌乐县" }, { "v": "1041", "n": "临朐县" }, { "v": "3530", "n": "坊子区" }] }, { "v": "1042", "n": "烟台市", "c": [{ "v": "3528", "n": "莱山区" }, { "v": "3126", "n": "芝罘区" }, { "v": "51029", "n": "开发区" }, { "v": "46504", "n": "福山区" }, { "v": "46505", "n": "牟平区" }, { "v": "46506", "n": "龙口市" }, { "v": "46507", "n": "莱州市" }, { "v": "1044", "n": "莱阳市" }, { "v": "1047", "n": "招远市" }, { "v": "1048", "n": "蓬莱市" }, { "v": "1049", "n": "栖霞市" }, { "v": "1050", "n": "海阳市" }, { "v": "1051", "n": "长岛县" }] }, { "v": "1053", "n": "威海市", "c": [{ "v": "28928", "n": "荣成市" }, { "v": "28929", "n": "文登市" }, { "v": "1054", "n": "乳山市" }, { "v": "28926", "n": "环翠区" }] }, { "v": "1058", "n": "莱芜市", "c": [{ "v": "1059", "n": "莱城区" }, { "v": "3539", "n": "钢城区" }] }, { "v": "1060", "n": "德州市", "c": [{ "v": "3542", "n": "德城区" }, { "v": "1069", "n": "临邑县" }, { "v": "25879", "n": "齐河县" }, { "v": "1061", "n": "乐陵市" }, { "v": "1062", "n": "禹城市" }, { "v": "1063", "n": "陵县" }, { "v": "1064", "n": "宁津县" }, { "v": "1066", "n": "武城县" }, { "v": "1067", "n": "庆云县" }, { "v": "1068", "n": "平原县" }, { "v": "1071", "n": "夏津县" }] }, { "v": "1072", "n": "临沂市", "c": [{ "v": "52023", "n": "兰陵县" }, { "v": "28930", "n": "兰山区" }, { "v": "28931", "n": "河东区" }, { "v": "1073", "n": "沂南县" }, { "v": "1074", "n": "沂水县" }, { "v": "1076", "n": "费县" }, { "v": "1077", "n": "平邑县" }, { "v": "1078", "n": "蒙阴县" }, { "v": "1079", "n": "临沭县" }, { "v": "2926", "n": "莒南县" }, { "v": "2974", "n": "郯城县" }, { "v": "3540", "n": "罗庄区" }] }, { "v": "1081", "n": "聊城市", "c": [{ "v": "25880", "n": "东昌府区" }, { "v": "1082", "n": "临清市" }, { "v": "1084", "n": "阳谷县" }, { "v": "1085", "n": "茌平县" }, { "v": "1086", "n": "莘县" }, { "v": "1087", "n": "东阿县" }, { "v": "1088", "n": "冠县" }, { "v": "4043", "n": "高唐县" }] }, { "v": "1090", "n": "滨州市", "c": [{ "v": "25877", "n": "北海新区" }, { "v": "25878", "n": "滨城区" }, { "v": "1092", "n": "邹平县" }, { "v": "1093", "n": "沾化县" }, { "v": "1094", "n": "惠民县" }, { "v": "1095", "n": "博兴县" }, { "v": "1096", "n": "阳信县" }, { "v": "2772", "n": "无棣县" }] }, { "v": "1099", "n": "菏泽市", "c": [{ "v": "3543", "n": "牡丹区" }, { "v": "1101", "n": "单县" }, { "v": "1102", "n": "曹县" }, { "v": "1103", "n": "定陶县" }, { "v": "1104", "n": "巨野县" }, { "v": "1105", "n": "成武县" }, { "v": "1106", "n": "东明县" }, { "v": "1107", "n": "郓城县" }, { "v": "2773", "n": "鄄城县" }] }, { "v": "1108", "n": "日照市", "c": [{ "v": "4113", "n": "岚山区" }, { "v": "4196", "n": "新市区" }, { "v": "2934", "n": "五莲县" }, { "v": "28920", "n": "东港区" }, { "v": "3068", "n": "莒县" }] }, { "v": "2900", "n": "济宁市", "c": [{ "v": "2908", "n": "梁山县" }, { "v": "2910", "n": "兖州市" }, { "v": "2912", "n": "微山县" }, { "v": "2913", "n": "汶上县" }, { "v": "2914", "n": "泗水县" }, { "v": "2915", "n": "嘉祥县" }, { "v": "2916", "n": "鱼台县" }, { "v": "2917", "n": "金乡县" }, { "v": "25713", "n": "邹城市" }, { "v": "25714", "n": "市中区" }, { "v": "25715", "n": "曲阜市" }, { "v": "25728", "n": "高新区" }, { "v": "3533", "n": "任城区" }] }, { "v": "1112", "n": "泰安市", "c": [{ "v": "3132", "n": "东平县" }, { "v": "46665", "n": "岱岳区" }, { "v": "46666", "n": "泰山区" }, { "v": "46667", "n": "肥城市" }, { "v": "46668", "n": "新泰市" }, { "v": "3535", "n": "宁阳县" }] }, { "v": "1000", "n": "济南市", "c": [{ "v": "4277", "n": "高新区" }, { "v": "1002", "n": "长清区" }, { "v": "40488", "n": "历城区" }, { "v": "40489", "n": "天桥区" }, { "v": "40490", "n": "槐荫区" }, { "v": "40491", "n": "历下区" }, { "v": "40492", "n": "市中区" }, { "v": "40493", "n": "章丘市" }, { "v": "1003", "n": "平阴县" }, { "v": "1004", "n": "济阳县" }, { "v": "1005", "n": "商河县" }] }, { "v": "1007", "n": "青岛市", "c": [{ "v": "3519", "n": "四方区" }, { "v": "3520", "n": "市北区" }, { "v": "3521", "n": "市南区" }, { "v": "5505", "n": "黄岛区" }, { "v": "4909", "n": "李沧区" }, { "v": "37916", "n": "即墨市" }, { "v": "37917", "n": "城阳区" }, { "v": "37918", "n": "崂山区" }, { "v": "37919", "n": "胶州市" }, { "v": "37920", "n": "平度市" }, { "v": "1014", "n": "莱西市" }] }, { "v": "1016", "n": "淄博市", "c": [{ "v": "2969", "n": "临淄区" }, { "v": "47166", "n": "张店区" }, { "v": "2924", "n": "周村区" }, { "v": "2962", "n": "淄川区" }, { "v": "2968", "n": "博山区" }, { "v": "1019", "n": "高青县" }, { "v": "1020", "n": "沂源县" }, { "v": "1021", "n": "桓台县" }] }, { "v": "1022", "n": "枣庄市", "c": [{ "v": "28932", "n": "滕州市" }, { "v": "3522", "n": "山亭区" }, { "v": "3523", "n": "台儿庄区" }, { "v": "3524", "n": "峄城区" }, { "v": "3525", "n": "薛城区" }, { "v": "3526", "n": "市中区" }] }] }, { "v": "14", "n": "安徽", "c": [{ "v": "1114", "n": "铜陵市", "c": [{ "v": "52830", "n": "铜官区" }, { "v": "52832", "n": "枞阳县" }, { "v": "19784", "n": "郊区" }, { "v": "19786", "n": "义安区" }] }, { "v": "1116", "n": "合肥市", "c": [{ "v": "3431", "n": "包河区" }, { "v": "3432", "n": "蜀山区" }, { "v": "3433", "n": "瑶海区" }, { "v": "3434", "n": "庐阳区" }, { "v": "6118", "n": "滨湖新区" }, { "v": "4173", "n": "经济技术开发区" }, { "v": "4192", "n": "高新技术开发区" }, { "v": "6120", "n": "新站综合开发试验区" }, { "v": "36173", "n": "肥西县" }, { "v": "6119", "n": "政务文化新区" }, { "v": "49709", "n": "巢湖市" }, { "v": "49710", "n": "长丰县" }, { "v": "1119", "n": "肥东县" }, { "v": "1190", "n": "庐江县" }, { "v": "6117", "n": "北城新区" }] }, { "v": "1121", "n": "淮南市", "c": [{ "v": "4960", "n": "淮南高新技术开发区" }, { "v": "3447", "n": "田家庵区" }, { "v": "3448", "n": "大通区" }, { "v": "3449", "n": "谢家集区" }, { "v": "3450", "n": "八公山区" }, { "v": "52831", "n": "寿县" }, { "v": "1122", "n": "凤台县" }, { "v": "3451", "n": "潘集区" }] }, { "v": "1124", "n": "淮北市", "c": [{ "v": "19223", "n": "杜集区" }, { "v": "19224", "n": "烈山区" }, { "v": "19225", "n": "濉溪县" }, { "v": "19226", "n": "相山区" }] }, { "v": "1127", "n": "芜湖市", "c": [{ "v": "3438", "n": "镜湖区" }, { "v": "4172", "n": "弋江区" }, { "v": "1189", "n": "无为县" }, { "v": "1128", "n": "芜湖县" }, { "v": "1129", "n": "繁昌县" }, { "v": "1130", "n": "南陵县" }, { "v": "49137", "n": "鸠江区" }, { "v": "49138", "n": "三山区" }] }, { "v": "1132", "n": "蚌埠市", "c": [{ "v": "3442", "n": "蚌山区" }, { "v": "1133", "n": "怀远县" }, { "v": "1134", "n": "固镇县" }, { "v": "1135", "n": "五河县" }, { "v": "18549", "n": "淮上区" }, { "v": "18550", "n": "龙子湖区" }, { "v": "18551", "n": "禹会区" }] }, { "v": "1137", "n": "马鞍山市", "c": [{ "v": "6963", "n": "博望区" }, { "v": "49253", "n": "花山区" }, { "v": "49254", "n": "雨山区" }, { "v": "1138", "n": "当涂县" }, { "v": "1187", "n": "含山县" }, { "v": "1188", "n": "和县" }] }, { "v": "1140", "n": "安庆市", "c": [{ "v": "1141", "n": "桐城市" }, { "v": "1142", "n": "宿松县" }, { "v": "1144", "n": "太湖县" }, { "v": "1145", "n": "怀宁县" }, { "v": "1146", "n": "岳西县" }, { "v": "1147", "n": "望江县" }, { "v": "1148", "n": "潜山县" }, { "v": "18375", "n": "大观区" }, { "v": "18376", "n": "宜秀区" }, { "v": "18377", "n": "迎江区" }] }, { "v": "1151", "n": "黄山市", "c": [{ "v": "19227", "n": "徽州区" }, { "v": "19228", "n": "屯溪区" }, { "v": "1153", "n": "休宁县" }, { "v": "1154", "n": "歙县" }, { "v": "1155", "n": "黟县" }, { "v": "1156", "n": "祁门县" }, { "v": "3464", "n": "黄山区" }] }, { "v": "1159", "n": "滁州市", "c": [{ "v": "18715", "n": "琅琊区" }, { "v": "18716", "n": "天长市" }, { "v": "1161", "n": "明光市" }, { "v": "1162", "n": "全椒县" }, { "v": "1163", "n": "来安县" }, { "v": "3467", "n": "南谯区" }, { "v": "1164", "n": "定远县" }, { "v": "1165", "n": "凤阳县" }] }, { "v": "1167", "n": "阜阳市", "c": [{ "v": "4832", "n": "经济开发区" }, { "v": "1168", "n": "界首市" }, { "v": "1169", "n": "太和县" }, { "v": "1170", "n": "阜南县" }, { "v": "1171", "n": "颍上县" }, { "v": "1172", "n": "临泉县" }, { "v": "19158", "n": "颍泉区" }, { "v": "19159", "n": "颍州区" }, { "v": "19160", "n": "颍东区" }] }, { "v": "1174", "n": "亳州市", "c": [{ "v": "1176", "n": "利辛县" }, { "v": "1177", "n": "蒙城县" }, { "v": "1178", "n": "涡阳县" }, { "v": "18627", "n": "谯城区" }] }, { "v": "2971", "n": "宣城市", "c": [{ "v": "3128", "n": "旌德县" }, { "v": "3147", "n": "宁国市" }, { "v": "3477", "n": "郎溪县" }, { "v": "3478", "n": "广德县" }, { "v": "3479", "n": "绩溪县" }, { "v": "2972", "n": "泾县" }, { "v": "19684", "n": "宣州区" }] }, { "v": "1180", "n": "宿州市", "c": [{ "v": "6006", "n": "经济开发区" }, { "v": "19575", "n": "埇桥区" }, { "v": "1181", "n": "灵璧县" }, { "v": "1182", "n": "泗县" }, { "v": "1183", "n": "萧县" }, { "v": "1184", "n": "砀山县" }] }, { "v": "1201", "n": "池州市", "c": [{ "v": "18714", "n": "贵池区" }, { "v": "1202", "n": "东至县" }, { "v": "1203", "n": "石台县" }, { "v": "1204", "n": "青阳县" }] }, { "v": "1206", "n": "六安市", "c": [{ "v": "1208", "n": "霍山县" }, { "v": "1209", "n": "金寨县" }, { "v": "1210", "n": "霍邱县" }, { "v": "1211", "n": "舒城县" }, { "v": "18912", "n": "金安区" }, { "v": "18913", "n": "裕安区" }] }] }, { "v": "15", "n": "浙江", "c": [{ "v": "1280", "n": "丽水市", "c": [{ "v": "1281", "n": "龙泉市" }, { "v": "1282", "n": "缙云县" }, { "v": "1283", "n": "遂昌县" }, { "v": "1284", "n": "松阳县" }, { "v": "1285", "n": "景宁县" }, { "v": "1286", "n": "云和县" }, { "v": "1288", "n": "青田县" }, { "v": "22043", "n": "莲都区" }, { "v": "3045", "n": "庆元县" }] }, { "v": "1290", "n": "台州市", "c": [{ "v": "1291", "n": "临海市" }, { "v": "1294", "n": "三门县" }, { "v": "1295", "n": "天台县" }, { "v": "1296", "n": "仙居县" }, { "v": "22046", "n": "黄岩区" }, { "v": "22047", "n": "椒江区" }, { "v": "22048", "n": "路桥区" }, { "v": "22049", "n": "温岭市" }, { "v": "22050", "n": "玉环县" }] }, { "v": "1298", "n": "舟山市", "c": [{ "v": "1300", "n": "岱山县" }, { "v": "1301", "n": "嵊泗县" }, { "v": "42565", "n": "普陀区" }, { "v": "42566", "n": "定海区" }] }, { "v": "1158", "n": "宁波市", "c": [{ "v": "3412", "n": "海曙区" }, { "v": "3413", "n": "江东区" }, { "v": "4253", "n": "高新科技开发区" }, { "v": "1224", "n": "慈溪市" }, { "v": "46341", "n": "北仑区" }, { "v": "46342", "n": "镇海区" }, { "v": "46343", "n": "鄞州区" }, { "v": "46344", "n": "江北区" }, { "v": "46345", "n": "余姚市" }, { "v": "1226", "n": "奉化市" }, { "v": "1227", "n": "宁海县" }, { "v": "1228", "n": "象山县" }] }, { "v": "1213", "n": "杭州市", "c": [{ "v": "3408", "n": "上城区" }, { "v": "3409", "n": "临平区" }, { "v": "3410", "n": "拱墅区" }, { "v": "3411", "n": "西湖区" }, { "v": "2963", "n": "钱塘区" }, { "v": "1214", "n": "余杭区" }, { "v": "1215", "n": "萧山区" }, { "v": "3038", "n": "滨江区" }, { "v": "49711", "n": "临安区" }, { "v": "1217", "n": "富阳区" }, { "v": "1218", "n": "桐庐县" }, { "v": "1219", "n": "建德市" }, { "v": "1220", "n": "淳安县" }] }, { "v": "1233", "n": "温州市", "c": [{ "v": "3416", "n": "龙湾区" }, { "v": "4342", "n": "茶山高教园区" }, { "v": "42321", "n": "瑞安市" }, { "v": "42322", "n": "乐清市" }, { "v": "42323", "n": "鹿城区" }, { "v": "42324", "n": "瓯海区" }, { "v": "42325", "n": "永嘉县" }, { "v": "1237", "n": "文成县" }, { "v": "1238", "n": "平阳县" }, { "v": "1239", "n": "泰顺县" }, { "v": "1240", "n": "洞头区" }, { "v": "1241", "n": "苍南县" }] }, { "v": "1243", "n": "嘉兴市", "c": [{ "v": "4429", "n": "桐乡市" }, { "v": "4430", "n": "平湖市" }, { "v": "4431", "n": "嘉善县" }, { "v": "3418", "n": "南湖区" }, { "v": "3419", "n": "秀洲区" }, { "v": "1244", "n": "海宁市" }, { "v": "1248", "n": "海盐县" }] }, { "v": "1250", "n": "湖州市", "c": [{ "v": "4130", "n": "南浔区" }, { "v": "44189", "n": "吴兴区" }, { "v": "1251", "n": "长兴县" }, { "v": "1252", "n": "德清县" }, { "v": "1253", "n": "安吉县" }] }, { "v": "1255", "n": "绍兴市", "c": [{ "v": "15944", "n": "柯桥区" }, { "v": "44188", "n": "越城区" }, { "v": "1257", "n": "诸暨市" }, { "v": "1258", "n": "上虞区" }, { "v": "1259", "n": "嵊州市" }, { "v": "1260", "n": "新昌县" }] }, { "v": "1262", "n": "金华市", "c": [{ "v": "1263", "n": "金东区" }, { "v": "1265", "n": "婺城区" }, { "v": "1264", "n": "兰溪市" }, { "v": "1269", "n": "武义县" }, { "v": "1270", "n": "浦江县" }, { "v": "1271", "n": "磐安县" }, { "v": "1266", "n": "义乌市" }, { "v": "1268", "n": "永康市" }, { "v": "1267", "n": "东阳市" }] }, { "v": "1273", "n": "衢州市", "c": [{ "v": "22044", "n": "柯城区" }, { "v": "22045", "n": "衢江区" }, { "v": "1275", "n": "江山市" }, { "v": "1276", "n": "常山县" }, { "v": "1277", "n": "开化县" }, { "v": "1278", "n": "龙游县" }] }] }, { "v": "16", "n": "福建", "c": [{ "v": "1303", "n": "福州市", "c": [{ "v": "3483", "n": "台江区" }, { "v": "3484", "n": "鼓楼区" }, { "v": "48712", "n": "晋安区" }, { "v": "48713", "n": "仓山区" }, { "v": "48714", "n": "马尾区" }, { "v": "48715", "n": "福清市" }, { "v": "48716", "n": "闽侯县" }, { "v": "1305", "n": "长乐市" }, { "v": "1308", "n": "平潭县" }, { "v": "1309", "n": "连江县" }, { "v": "1312", "n": "罗源县" }, { "v": "1313", "n": "永泰县" }, { "v": "1314", "n": "闽清县" }] }, { "v": "1315", "n": "厦门市", "c": [{ "v": "1316", "n": "思明区" }, { "v": "3486", "n": "湖里区" }, { "v": "3489", "n": "翔安区" }, { "v": "46763", "n": "海沧区" }, { "v": "46764", "n": "集美区" }, { "v": "46765", "n": "同安区" }] }, { "v": "1317", "n": "三明市", "c": [{ "v": "1319", "n": "永安市" }, { "v": "1320", "n": "明溪县" }, { "v": "1321", "n": "将乐县" }, { "v": "1322", "n": "大田县" }, { "v": "1323", "n": "宁化县" }, { "v": "1324", "n": "建宁县" }, { "v": "1325", "n": "沙县" }, { "v": "1326", "n": "尤溪县" }, { "v": "1327", "n": "清流县" }, { "v": "1328", "n": "泰宁县" }, { "v": "22463", "n": "梅列区" }, { "v": "22464", "n": "三元区" }] }, { "v": "1329", "n": "莆田市", "c": [{ "v": "1331", "n": "仙游县" }, { "v": "46146", "n": "城厢区" }, { "v": "46147", "n": "荔城区" }, { "v": "3492", "n": "秀屿区" }, { "v": "3022", "n": "涵江区" }] }, { "v": "1332", "n": "泉州市", "c": [{ "v": "3117", "n": "泉港区" }, { "v": "1334", "n": "石狮市" }, { "v": "1336", "n": "南安市" }, { "v": "1337", "n": "惠安县" }, { "v": "1338", "n": "安溪县" }, { "v": "1339", "n": "德化县" }, { "v": "1340", "n": "永春县" }, { "v": "3495", "n": "金门县" }, { "v": "3498", "n": "洛江区" }, { "v": "42930", "n": "鲤城区" }, { "v": "42931", "n": "丰泽区" }, { "v": "42932", "n": "晋江市" }] }, { "v": "1341", "n": "漳州市", "c": [{ "v": "3499", "n": "芗城区" }, { "v": "3500", "n": "龙文区" }, { "v": "1343", "n": "龙海市" }, { "v": "1344", "n": "平和县" }, { "v": "1345", "n": "南靖县" }, { "v": "1346", "n": "诏安县" }, { "v": "1347", "n": "漳浦县" }, { "v": "1348", "n": "华安县" }, { "v": "1349", "n": "云霄县" }, { "v": "1350", "n": "东山县" }, { "v": "1351", "n": "长泰县" }] }, { "v": "1352", "n": "南平市", "c": [{ "v": "1354", "n": "建瓯市" }, { "v": "1355", "n": "邵武市" }, { "v": "1356", "n": "武夷山市" }, { "v": "1357", "n": "建阳市" }, { "v": "1358", "n": "松溪县" }, { "v": "1359", "n": "顺昌县" }, { "v": "1360", "n": "浦城县" }, { "v": "1361", "n": "政和县" }, { "v": "2956", "n": "光泽县" }, { "v": "22465", "n": "延平区" }] }, { "v": "1362", "n": "龙岩市", "c": [{ "v": "44319", "n": "新罗区" }, { "v": "1364", "n": "漳平市" }, { "v": "1365", "n": "长汀县" }, { "v": "1366", "n": "武平县" }, { "v": "1367", "n": "永定县" }, { "v": "1368", "n": "上杭县" }, { "v": "1369", "n": "连城县" }] }, { "v": "1370", "n": "宁德市", "c": [{ "v": "46145", "n": "蕉城区" }, { "v": "46164", "n": "东侨开发区" }, { "v": "1372", "n": "福安市" }, { "v": "1373", "n": "福鼎市" }, { "v": "1374", "n": "寿宁县" }, { "v": "1375", "n": "霞浦县" }, { "v": "1376", "n": "柘荣县" }, { "v": "1377", "n": "屏南县" }, { "v": "1378", "n": "古田县" }, { "v": "1379", "n": "周宁县" }] }] }, { "v": "17", "n": "湖北", "c": [{ "v": "3154", "n": "神农架林区", "c": [{ "v": "23610", "n": "松柏镇" }, { "v": "23611", "n": "阳日镇" }, { "v": "23612", "n": "木鱼镇" }, { "v": "23613", "n": "红坪镇" }, { "v": "23614", "n": "新华镇" }, { "v": "23615", "n": "宋洛乡" }, { "v": "23616", "n": "九湖乡" }, { "v": "23617", "n": "下谷坪乡" }] }, { "v": "1381", "n": "武汉市", "c": [{ "v": "3583", "n": "硚口区" }, { "v": "3079", "n": "武昌区" }, { "v": "4424", "n": "武汉经济技术开发区" }, { "v": "1386", "n": "江岸区" }, { "v": "3582", "n": "江汉区" }, { "v": "50712", "n": "蔡甸区" }, { "v": "50713", "n": "江夏区" }, { "v": "50714", "n": "新洲区" }, { "v": "50715", "n": "黄陂区" }, { "v": "50716", "n": "汉阳区" }, { "v": "50717", "n": "青山区" }, { "v": "50718", "n": "洪山区" }, { "v": "50719", "n": "汉南区" }, { "v": "50720", "n": "东西湖区" }] }, { "v": "2922", "n": "潜江市", "c": [{ "v": "23585", "n": "园林" }, { "v": "23586", "n": "杨市" }, { "v": "23587", "n": "周矶" }, { "v": "23588", "n": "广华" }, { "v": "23589", "n": "泰丰" }, { "v": "23590", "n": "竹根滩镇" }, { "v": "23591", "n": "高石碑镇" }, { "v": "23592", "n": "积玉口镇" }, { "v": "23593", "n": "渔洋镇" }, { "v": "23594", "n": "王场镇" }, { "v": "23595", "n": "熊口镇" }, { "v": "23596", "n": "老新镇" }, { "v": "23597", "n": "浩口镇" }, { "v": "23598", "n": "张金镇" }, { "v": "23599", "n": "龙湾镇" }, { "v": "23600", "n": "江汉石油管理局" }, { "v": "23601", "n": "潜江经济开发区" }, { "v": "23602", "n": "西大垸管理区" }, { "v": "23603", "n": "运粮湖管理区" }, { "v": "23604", "n": "周矶管理区" }, { "v": "23605", "n": "后湖管理区" }, { "v": "23606", "n": "熊口管理区" }, { "v": "23607", "n": "总口管理区" }, { "v": "23608", "n": "高场原种场" }, { "v": "23609", "n": "浩口原种场" }] }, { "v": "1387", "n": "黄石市", "c": [{ "v": "1389", "n": "黄石港区" }, { "v": "43272", "n": "下陆区" }, { "v": "43273", "n": "西塞山区" }, { "v": "1392", "n": "铁山区" }, { "v": "1393", "n": "大冶市" }, { "v": "1394", "n": "阳新县" }, { "v": "43291", "n": "经济技术开发区" }] }, { "v": "1396", "n": "襄阳市", "c": [{ "v": "1397", "n": "老河口市" }, { "v": "1398", "n": "枣阳市" }, { "v": "1399", "n": "宜城市" }, { "v": "1401", "n": "南漳县" }, { "v": "1402", "n": "保康县" }, { "v": "1403", "n": "谷城县" }, { "v": "23282", "n": "樊城区" }, { "v": "23283", "n": "襄城区" }, { "v": "23284", "n": "襄州区" }] }, { "v": "1405", "n": "十堰市", "c": [{ "v": "1406", "n": "丹江口市" }, { "v": "1407", "n": "房县" }, { "v": "1408", "n": "竹山县" }, { "v": "1409", "n": "竹溪县" }, { "v": "1410", "n": "郧县" }, { "v": "1411", "n": "郧西县" }, { "v": "23429", "n": "茅箭区" }, { "v": "23430", "n": "张湾区" }] }, { "v": "1413", "n": "荆州市", "c": [{ "v": "3593", "n": "沙市区" }, { "v": "4078", "n": "荆州区" }, { "v": "1414", "n": "江陵县" }, { "v": "1415", "n": "洪湖市" }, { "v": "1416", "n": "石首市" }, { "v": "1417", "n": "松滋市" }, { "v": "1418", "n": "监利县" }, { "v": "1419", "n": "公安县" }] }, { "v": "1421", "n": "宜昌市", "c": [{ "v": "3597", "n": "伍家岗区" }, { "v": "3598", "n": "西陵区" }, { "v": "3594", "n": "宜都市" }, { "v": "3595", "n": "猇亭区" }, { "v": "3596", "n": "点军区" }, { "v": "1423", "n": "当阳市" }, { "v": "1424", "n": "枝江市" }, { "v": "1425", "n": "夷陵区" }, { "v": "1426", "n": "秭归县" }, { "v": "1427", "n": "兴山县" }, { "v": "1428", "n": "远安县" }, { "v": "1429", "n": "五峰土家族自治县" }, { "v": "1430", "n": "长阳土家族自治县" }] }, { "v": "1432", "n": "孝感市", "c": [{ "v": "1435", "n": "汉川市" }, { "v": "1437", "n": "云梦县" }, { "v": "1438", "n": "大悟县" }, { "v": "1439", "n": "孝昌县" }, { "v": "45215", "n": "孝南区" }, { "v": "45216", "n": "应城市" }, { "v": "45217", "n": "安陆市" }] }, { "v": "1441", "n": "黄冈市", "c": [{ "v": "41908", "n": "黄州区" }, { "v": "41909", "n": "蕲春县" }, { "v": "41910", "n": "麻城市" }, { "v": "41911", "n": "武穴市" }, { "v": "41912", "n": "浠水县" }, { "v": "1444", "n": "红安县" }, { "v": "1445", "n": "罗田县" }, { "v": "1447", "n": "黄梅县" }, { "v": "1448", "n": "英山县" }, { "v": "1449", "n": "团风县" }] }, { "v": "2980", "n": "天门市", "c": [{ "v": "23618", "n": "侨乡街道开发区" }, { "v": "23619", "n": "竟陵街道" }, { "v": "23620", "n": "杨林街道" }, { "v": "23621", "n": "佛子山镇" }, { "v": "23622", "n": "多宝镇" }, { "v": "23623", "n": "拖市镇" }, { "v": "23624", "n": "张港镇" }, { "v": "23625", "n": "蒋场镇" }, { "v": "23626", "n": "汪场镇" }, { "v": "23627", "n": "渔薪镇" }, { "v": "23628", "n": "黄潭镇" }, { "v": "23629", "n": "岳口镇" }, { "v": "23630", "n": "横林镇" }, { "v": "23631", "n": "彭市镇" }, { "v": "23632", "n": "麻洋镇" }, { "v": "23633", "n": "多祥镇" }, { "v": "23634", "n": "干驿镇" }, { "v": "23635", "n": "马湾镇" }, { "v": "23636", "n": "卢市镇" }, { "v": "23637", "n": "小板镇" }, { "v": "23638", "n": "九真镇" }, { "v": "23639", "n": "皂市镇" }, { "v": "23640", "n": "胡市镇" }, { "v": "23641", "n": "石河镇" }, { "v": "23642", "n": "净潭乡" }, { "v": "23643", "n": "蒋湖农场" }, { "v": "23644", "n": "白茅湖农场" }, { "v": "23645", "n": "沉湖管委会" }] }, { "v": "2983", "n": "仙桃市", "c": [{ "v": "52306", "n": "城区" }, { "v": "23649", "n": "郑场镇" }, { "v": "23650", "n": "毛嘴镇" }, { "v": "23651", "n": "豆河镇" }, { "v": "23652", "n": "三伏潭镇" }, { "v": "23653", "n": "胡场镇" }, { "v": "23654", "n": "长埫口镇" }, { "v": "23655", "n": "西流河镇" }, { "v": "23656", "n": "沙湖镇" }, { "v": "23657", "n": "杨林尾镇" }, { "v": "23658", "n": "彭场镇" }, { "v": "23659", "n": "张沟镇" }, { "v": "23660", "n": "郭河镇" }, { "v": "23661", "n": "沔城镇" }, { "v": "23662", "n": "通海口镇" }, { "v": "23663", "n": "陈场镇" }, { "v": "23664", "n": "工业园区" }, { "v": "23665", "n": "九合垸原种场" }, { "v": "23666", "n": "沙湖原种场" }, { "v": "23667", "n": "排湖渔场" }, { "v": "23668", "n": "五湖渔场" }, { "v": "23669", "n": "赵西垸林场" }, { "v": "23670", "n": "刘家垸林场" }, { "v": "23671", "n": "畜禽良种场" }] }, { "v": "1458", "n": "咸宁市", "c": [{ "v": "43387", "n": "咸安区" }, { "v": "43388", "n": "赤壁市" }, { "v": "1461", "n": "嘉鱼县" }, { "v": "1462", "n": "通山县" }, { "v": "1463", "n": "崇阳县" }, { "v": "1464", "n": "通城县" }] }, { "v": "1466", "n": "恩施州", "c": [{ "v": "1467", "n": "恩施市" }, { "v": "1468", "n": "利川市" }, { "v": "1469", "n": "建始县" }, { "v": "1470", "n": "来凤县" }, { "v": "1471", "n": "巴东县" }, { "v": "1472", "n": "鹤峰县" }, { "v": "1473", "n": "宣恩县" }, { "v": "1474", "n": "咸丰县" }] }, { "v": "1475", "n": "鄂州市", "c": [{ "v": "3601", "n": "梁子湖区" }, { "v": "3602", "n": "华容区" }, { "v": "41907", "n": "鄂城区" }] }, { "v": "1477", "n": "荆门市", "c": [{ "v": "3600", "n": "东宝区" }, { "v": "3599", "n": "掇刀区" }, { "v": "2973", "n": "钟祥市" }, { "v": "1478", "n": "京山县" }, { "v": "3055", "n": "沙洋县" }] }, { "v": "1479", "n": "随州市", "c": [{ "v": "3164", "n": "曾都区" }, { "v": "3163", "n": "广水市" }, { "v": "7357", "n": "随县" }] }] }, { "v": "18", "n": "湖南", "c": [{ "v": "1540", "n": "张家界市", "c": [{ "v": "1541", "n": "慈利县" }, { "v": "1542", "n": "桑植县" }, { "v": "1543", "n": "武陵源区" }, { "v": "3622", "n": "永定区" }] }, { "v": "1544", "n": "郴州市", "c": [{ "v": "1545", "n": "资兴市" }, { "v": "1546", "n": "宜章县" }, { "v": "1547", "n": "安仁县" }, { "v": "1548", "n": "汝城县" }, { "v": "1549", "n": "嘉禾县" }, { "v": "1550", "n": "临武县" }, { "v": "1551", "n": "桂东县" }, { "v": "1552", "n": "永兴县" }, { "v": "1553", "n": "桂阳县" }, { "v": "29465", "n": "北湖区" }, { "v": "29466", "n": "苏仙区" }] }, { "v": "1555", "n": "益阳市", "c": [{ "v": "1556", "n": "南县" }, { "v": "1557", "n": "桃江县" }, { "v": "1558", "n": "安化县" }, { "v": "29463", "n": "赫山区" }, { "v": "29464", "n": "资阳区" }, { "v": "1565", "n": "沅江市" }] }, { "v": "1560", "n": "永州市", "c": [{ "v": "29454", "n": "冷水滩区" }, { "v": "1563", "n": "祁阳县" }, { "v": "1564", "n": "双牌县" }, { "v": "1566", "n": "道县" }, { "v": "1567", "n": "江永县" }, { "v": "1568", "n": "江华县" }, { "v": "1569", "n": "宁远县" }, { "v": "1570", "n": "新田县" }, { "v": "1571", "n": "蓝山县" }, { "v": "1572", "n": "东安县" }, { "v": "1573", "n": "零陵区" }] }, { "v": "1574", "n": "怀化市", "c": [{ "v": "29455", "n": "鹤城区" }, { "v": "1575", "n": "洪江市" }, { "v": "1576", "n": "会同县" }, { "v": "1578", "n": "溆浦县" }, { "v": "3626", "n": "中方县" }, { "v": "1579", "n": "辰溪县" }, { "v": "1580", "n": "靖州县" }, { "v": "1581", "n": "通道县" }, { "v": "1582", "n": "芷江县" }, { "v": "1583", "n": "新晃县" }, { "v": "1584", "n": "麻阳县" }, { "v": "3070", "n": "沅陵县" }] }, { "v": "1586", "n": "娄底市", "c": [{ "v": "29456", "n": "娄星区" }, { "v": "1588", "n": "冷水江市" }, { "v": "1589", "n": "涟源市" }, { "v": "1590", "n": "新化县" }, { "v": "1591", "n": "双峰县" }] }, { "v": "1592", "n": "湘西州", "c": [{ "v": "1593", "n": "吉首市" }, { "v": "1594", "n": "古丈县" }, { "v": "1595", "n": "龙山县" }, { "v": "1596", "n": "永顺县" }, { "v": "1597", "n": "泸溪县" }, { "v": "1598", "n": "凤凰县" }, { "v": "1599", "n": "花垣县" }, { "v": "1600", "n": "保靖县" }] }, { "v": "1482", "n": "长沙市", "c": [{ "v": "3606", "n": "芙蓉区" }, { "v": "48936", "n": "岳麓区" }, { "v": "48937", "n": "雨花区" }, { "v": "48938", "n": "开福区" }, { "v": "48939", "n": "天心区" }, { "v": "48941", "n": "浏阳市" }, { "v": "48942", "n": "长沙县" }, { "v": "48943", "n": "宁乡县" }, { "v": "1485", "n": "望城区" }] }, { "v": "1488", "n": "株洲市", "c": [{ "v": "29444", "n": "天元区" }, { "v": "29445", "n": "石峰区" }, { "v": "29446", "n": "芦淞区" }, { "v": "29447", "n": "荷塘区" }, { "v": "1489", "n": "醴陵市" }, { "v": "1490", "n": "株洲县" }, { "v": "1491", "n": "攸县" }, { "v": "1492", "n": "茶陵县" }, { "v": "1493", "n": "炎陵县" }] }, { "v": "1495", "n": "湘潭市", "c": [{ "v": "29448", "n": "雨湖区" }, { "v": "29449", "n": "岳塘区" }, { "v": "1496", "n": "湘乡市" }, { "v": "1497", "n": "湘潭县" }, { "v": "1498", "n": "韶山市" }] }, { "v": "1501", "n": "衡阳市", "c": [{ "v": "29450", "n": "蒸湘区" }, { "v": "29451", "n": "石鼓区" }, { "v": "29452", "n": "珠晖区" }, { "v": "29453", "n": "雁峰区" }, { "v": "1502", "n": "常宁市" }, { "v": "1503", "n": "衡阳县" }, { "v": "1504", "n": "耒阳市" }, { "v": "1505", "n": "衡东县" }, { "v": "1506", "n": "衡南县" }, { "v": "1507", "n": "衡山县" }, { "v": "1508", "n": "祁东县" }, { "v": "1509", "n": "南岳区" }] }, { "v": "1511", "n": "邵阳市", "c": [{ "v": "29457", "n": "大祥区" }, { "v": "29458", "n": "双清区" }, { "v": "29459", "n": "北塔区" }, { "v": "1512", "n": "武冈市" }, { "v": "1513", "n": "邵东县" }, { "v": "1514", "n": "洞口县" }, { "v": "1515", "n": "新邵县" }, { "v": "1516", "n": "绥宁县" }, { "v": "1517", "n": "新宁县" }, { "v": "1518", "n": "邵阳县" }, { "v": "1519", "n": "隆回县" }, { "v": "1520", "n": "城步县" }] }, { "v": "1522", "n": "岳阳市", "c": [{ "v": "29460", "n": "岳阳楼区" }, { "v": "3619", "n": "君山区" }, { "v": "3620", "n": "云溪区" }, { "v": "1523", "n": "临湘市" }, { "v": "1524", "n": "汨罗市" }, { "v": "1525", "n": "岳阳县" }, { "v": "1526", "n": "湘阴县" }, { "v": "1527", "n": "华容县" }, { "v": "1528", "n": "平江县" }] }, { "v": "1530", "n": "常德市", "c": [{ "v": "1536", "n": "汉寿县" }, { "v": "1537", "n": "石门县" }, { "v": "1538", "n": "安乡县" }, { "v": "29461", "n": "鼎城区" }, { "v": "29462", "n": "武陵区" }, { "v": "1532", "n": "津市市" }, { "v": "1533", "n": "澧县" }, { "v": "1534", "n": "临澧县" }, { "v": "1535", "n": "桃源县" }] }] }, { "v": "19", "n": "广东", "c": [{ "v": "1601", "n": "广州市", "c": [{ "v": "3633", "n": "天河区" }, { "v": "3634", "n": "海珠区" }, { "v": "3635", "n": "荔湾区" }, { "v": "3637", "n": "越秀区" }, { "v": "36953", "n": "番禺区" }, { "v": "50256", "n": "花都区" }, { "v": "50258", "n": "白云区" }, { "v": "50259", "n": "南沙区" }, { "v": "50283", "n": "黄埔区" }, { "v": "50284", "n": "增城区" }, { "v": "50285", "n": "从化区" }, { "v": "51091", "n": "广州大学城" }] }, { "v": "1607", "n": "深圳市", "c": [{ "v": "3638", "n": "罗湖区" }, { "v": "3639", "n": "福田区" }, { "v": "3155", "n": "南山区" }, { "v": "4773", "n": "宝安区" }, { "v": "6675", "n": "光明新区" }, { "v": "40152", "n": "龙岗区" }, { "v": "6736", "n": "坪山新区" }, { "v": "47387", "n": "盐田区" }, { "v": "47388", "n": "龙华新区" }, { "v": "6737", "n": "大鹏新区" }] }, { "v": "1609", "n": "珠海市", "c": [{ "v": "41653", "n": "斗门区" }, { "v": "41654", "n": "金湾区" }, { "v": "41655", "n": "香洲区" }] }, { "v": "1611", "n": "汕头市", "c": [{ "v": "19916", "n": "龙湖区" }, { "v": "19917", "n": "金平区" }, { "v": "19918", "n": "澄海区" }, { "v": "19919", "n": "潮阳区" }, { "v": "19920", "n": "潮南区" }, { "v": "19921", "n": "濠江区" }, { "v": "1614", "n": "南澳县" }] }, { "v": "1617", "n": "韶关市", "c": [{ "v": "3643", "n": "武江区" }, { "v": "3644", "n": "浈江区" }, { "v": "1618", "n": "南雄市" }, { "v": "1619", "n": "乐昌市" }, { "v": "1620", "n": "仁化县" }, { "v": "1621", "n": "始兴县" }, { "v": "1622", "n": "翁源县" }, { "v": "1624", "n": "新丰县" }, { "v": "1625", "n": "乳源瑶族自治县" }, { "v": "1626", "n": "曲江区" }] }, { "v": "1627", "n": "河源市", "c": [{ "v": "1628", "n": "和平县" }, { "v": "1629", "n": "龙川县" }, { "v": "1630", "n": "紫金县" }, { "v": "1631", "n": "连平县" }, { "v": "37864", "n": "源城区" }, { "v": "37865", "n": "东源县" }] }, { "v": "1634", "n": "梅州市", "c": [{ "v": "1642", "n": "梅江区" }, { "v": "1635", "n": "兴宁市" }, { "v": "1636", "n": "梅县" }, { "v": "1637", "n": "蕉岭县" }, { "v": "1638", "n": "大埔县" }, { "v": "1639", "n": "丰顺县" }, { "v": "1640", "n": "五华县" }, { "v": "1641", "n": "平远县" }] }, { "v": "1643", "n": "惠州市", "c": [{ "v": "36174", "n": "惠阳区" }, { "v": "36175", "n": "大亚湾区" }, { "v": "36176", "n": "惠城区" }, { "v": "36177", "n": "惠东县" }, { "v": "36178", "n": "博罗县" }, { "v": "1647", "n": "龙门县" }] }, { "v": "1650", "n": "汕尾市", "c": [{ "v": "20051", "n": "城区" }, { "v": "20052", "n": "陆丰市" }, { "v": "1653", "n": "陆河县" }, { "v": "3037", "n": "海丰县" }] }, { "v": "1655", "n": "东莞市", "c": [{ "v": "4760", "n": "长安镇" }, { "v": "4255", "n": "莞城区" }, { "v": "4256", "n": "南城区" }, { "v": "4866", "n": "寮步镇" }, { "v": "4871", "n": "大岭山镇" }, { "v": "5905", "n": "横沥镇" }, { "v": "4886", "n": "常平镇" }, { "v": "4910", "n": "厚街镇" }, { "v": "4911", "n": "万江区" }, { "v": "4932", "n": "樟木头镇" }, { "v": "5457", "n": "塘厦镇" }, { "v": "5473", "n": "凤岗镇" }, { "v": "4980", "n": "大朗镇" }, { "v": "3041", "n": "东坑镇" }, { "v": "5869", "n": "清溪镇" }, { "v": "3105", "n": "企石镇" }, { "v": "3171", "n": "茶山镇" }, { "v": "36102", "n": "东城区" }, { "v": "39462", "n": "虎门镇" }, { "v": "39461", "n": "黄江镇" }, { "v": "3104", "n": "石排镇" }, { "v": "3078", "n": "道滘镇" }, { "v": "3097", "n": "沙田镇" }, { "v": "3100", "n": "高埗镇" }, { "v": "3102", "n": "石龙镇" }, { "v": "3111", "n": "石碣镇" }, { "v": "3116", "n": "洪梅镇" }, { "v": "3120", "n": "麻涌镇" }, { "v": "4147", "n": "松山湖" }, { "v": "3134", "n": "桥头镇" }, { "v": "3151", "n": "望牛墩镇" }, { "v": "2950", "n": "中堂镇" }, { "v": "4087", "n": "谢岗镇" }] }, { "v": "1657", "n": "中山市", "c": [{ "v": "52093", "n": "城区" }, { "v": "4852", "n": "火炬开发区" }, { "v": "2902", "n": "小榄镇" }, { "v": "2957", "n": "古镇" }, { "v": "3016", "n": "三乡镇" }, { "v": "8540", "n": "民众镇" }, { "v": "3067", "n": "东凤镇" }, { "v": "4102", "n": "板芙镇" }, { "v": "4127", "n": "神湾镇" }, { "v": "3112", "n": "横栏镇" }, { "v": "4141", "n": "港口镇" }, { "v": "3143", "n": "三角镇" }, { "v": "4190", "n": "大涌镇" }, { "v": "3176", "n": "南头镇" }, { "v": "3743", "n": "沙溪镇" }, { "v": "3001", "n": "坦洲镇" }, { "v": "3007", "n": "黄圃镇" }, { "v": "4042", "n": "五桂山镇" }, { "v": "2777", "n": "南朗镇" }, { "v": "39653", "n": "沙朗镇" }, { "v": "4076", "n": "阜沙镇" }, { "v": "4080", "n": "东升镇" }] }, { "v": "1659", "n": "江门市", "c": [{ "v": "37258", "n": "台山市" }, { "v": "37259", "n": "新会区" }, { "v": "37260", "n": "鹤山市" }, { "v": "37261", "n": "江海区" }, { "v": "37262", "n": "蓬江区" }, { "v": "37263", "n": "开平市" }, { "v": "37264", "n": "恩平市" }] }, { "v": "1666", "n": "佛山市", "c": [{ "v": "1669", "n": "顺德区" }, { "v": "36264", "n": "禅城区" }, { "v": "36265", "n": "高明区" }, { "v": "36266", "n": "三水区" }, { "v": "36267", "n": "南海区" }] }, { "v": "1672", "n": "阳江市", "c": [{ "v": "19827", "n": "江城区" }, { "v": "19828", "n": "阳东县" }, { "v": "1673", "n": "阳春市" }, { "v": "1674", "n": "阳西县" }] }, { "v": "1677", "n": "湛江市", "c": [{ "v": "19377", "n": "赤坎区" }, { "v": "19378", "n": "霞山区" }, { "v": "19379", "n": "经济技术开发区" }, { "v": "19380", "n": "麻章区" }, { "v": "19381", "n": "遂溪县" }, { "v": "19382", "n": "廉江市" }, { "v": "3646", "n": "坡头区" }, { "v": "1679", "n": "雷州市" }, { "v": "1680", "n": "吴川市" }, { "v": "1682", "n": "徐闻县" }] }, { "v": "1684", "n": "茂名市", "c": [{ "v": "19465", "n": "茂南区" }, { "v": "19466", "n": "电白县" }, { "v": "19467", "n": "高州市" }, { "v": "19468", "n": "化州市" }, { "v": "19469", "n": "茂港区" }, { "v": "1687", "n": "信宜市" }] }, { "v": "1690", "n": "肇庆市", "c": [{ "v": "4781", "n": "端州区" }, { "v": "39723", "n": "四会市" }, { "v": "39725", "n": "高要市" }, { "v": "1693", "n": "广宁县" }, { "v": "1694", "n": "德庆县" }, { "v": "1695", "n": "怀集县" }, { "v": "1696", "n": "封开县" }, { "v": "1697", "n": "鼎湖区" }] }, { "v": "1698", "n": "云浮市", "c": [{ "v": "19829", "n": "云城区" }, { "v": "19830", "n": "罗定市" }, { "v": "1700", "n": "云安县" }, { "v": "1701", "n": "新兴县" }, { "v": "1702", "n": "郁南县" }] }, { "v": "1704", "n": "清远市", "c": [{ "v": "1795", "n": "连州市" }, { "v": "1796", "n": "佛冈县" }, { "v": "1797", "n": "阳山县" }, { "v": "1798", "n": "清新县" }, { "v": "1799", "n": "连山县" }, { "v": "1800", "n": "连南县" }, { "v": "37734", "n": "清城区" }, { "v": "37735", "n": "英德市" }] }, { "v": "1705", "n": "潮州市", "c": [{ "v": "19991", "n": "湘桥区" }, { "v": "4238", "n": "枫溪区" }, { "v": "19992", "n": "潮安区" }, { "v": "1707", "n": "饶平县" }] }, { "v": "1709", "n": "揭阳市", "c": [{ "v": "5484", "n": "东山区" }, { "v": "5864", "n": "普宁市" }, { "v": "20093", "n": "榕城区" }, { "v": "20094", "n": "揭东县" }, { "v": "1712", "n": "揭西县" }, { "v": "1713", "n": "惠来县" }] }] }, { "v": "20", "n": "广西", "c": [{ "v": "1792", "n": "贺州市", "c": [{ "v": "23040", "n": "八步区" }, { "v": "1803", "n": "钟山县" }, { "v": "1804", "n": "昭平县" }, { "v": "1805", "n": "富川县" }, { "v": "22850", "n": "平桂管理区" }] }, { "v": "1806", "n": "百色市", "c": [{ "v": "1807", "n": "右江区" }, { "v": "1808", "n": "平果县" }, { "v": "1809", "n": "乐业县" }, { "v": "1810", "n": "田阳县" }, { "v": "1811", "n": "西林县" }, { "v": "1812", "n": "田林县" }, { "v": "1813", "n": "德保县" }, { "v": "1814", "n": "靖西县" }, { "v": "1815", "n": "田东县" }, { "v": "1816", "n": "那坡县" }, { "v": "1817", "n": "隆林县" }, { "v": "3678", "n": "凌云县" }] }, { "v": "1818", "n": "河池市", "c": [{ "v": "1820", "n": "宜州市" }, { "v": "1821", "n": "天峨县" }, { "v": "1822", "n": "凤山县" }, { "v": "1823", "n": "南丹县" }, { "v": "1824", "n": "东兰县" }, { "v": "1825", "n": "巴马县" }, { "v": "1826", "n": "环江县" }, { "v": "3152", "n": "大化县" }, { "v": "3679", "n": "都安县" }, { "v": "3680", "n": "金城江区" }, { "v": "2991", "n": "罗城县" }] }, { "v": "3168", "n": "崇左市", "c": [{ "v": "3169", "n": "江州区" }, { "v": "3681", "n": "凭祥市" }, { "v": "3682", "n": "扶绥县" }, { "v": "3683", "n": "大新县" }, { "v": "3684", "n": "天等县" }, { "v": "3685", "n": "宁明县" }, { "v": "3686", "n": "龙州县" }] }, { "v": "1715", "n": "南宁市", "c": [{ "v": "43114", "n": "良庆区" }, { "v": "43115", "n": "江南区" }, { "v": "43116", "n": "兴宁区" }, { "v": "43117", "n": "青秀区" }, { "v": "43118", "n": "西乡塘区" }, { "v": "3650", "n": "横县" }, { "v": "3651", "n": "上林县" }, { "v": "3652", "n": "隆安县" }, { "v": "3653", "n": "马山县" }, { "v": "1716", "n": "武鸣区" }, { "v": "1724", "n": "邕宁区" }, { "v": "3005", "n": "宾阳县" }] }, { "v": "1720", "n": "柳州市", "c": [{ "v": "3659", "n": "融安县" }, { "v": "3660", "n": "三江县" }, { "v": "3661", "n": "融水县" }, { "v": "22906", "n": "鱼峰区" }, { "v": "22907", "n": "城中区" }, { "v": "22908", "n": "柳南区" }, { "v": "22909", "n": "柳北区" }, { "v": "1721", "n": "柳江县" }, { "v": "1722", "n": "柳城县" }, { "v": "1725", "n": "鹿寨县" }] }, { "v": "1726", "n": "桂林市", "c": [{ "v": "3670", "n": "象山区" }, { "v": "3666", "n": "恭城县" }, { "v": "22883", "n": "秀峰区" }, { "v": "22884", "n": "叠彩区" }, { "v": "22885", "n": "七星区" }, { "v": "4457", "n": "雁山区" }, { "v": "1727", "n": "阳朔县" }, { "v": "1728", "n": "临桂县" }, { "v": "1729", "n": "灵川县" }, { "v": "1730", "n": "全州县" }, { "v": "1731", "n": "平乐县" }, { "v": "1732", "n": "兴安县" }, { "v": "1733", "n": "灌阳县" }, { "v": "1734", "n": "荔浦县" }, { "v": "1735", "n": "资源县" }, { "v": "1736", "n": "永福县" }, { "v": "1738", "n": "龙胜县" }] }, { "v": "1740", "n": "梧州市", "c": [{ "v": "53521", "n": "龙圩区" }, { "v": "1741", "n": "岑溪市" }, { "v": "1742", "n": "苍梧县" }, { "v": "1743", "n": "藤县" }, { "v": "1744", "n": "蒙山县" }, { "v": "23037", "n": "万秀区" }, { "v": "23038", "n": "蝶山区" }, { "v": "23039", "n": "长洲区" }] }, { "v": "1746", "n": "北海市", "c": [{ "v": "22851", "n": "海城区" }, { "v": "22852", "n": "银海区" }, { "v": "1747", "n": "合浦县" }, { "v": "1748", "n": "铁山港区" }] }, { "v": "1749", "n": "防城港市", "c": [{ "v": "25190", "n": "防城区" }, { "v": "25191", "n": "港口区" }, { "v": "1750", "n": "东兴市" }, { "v": "1751", "n": "上思县" }] }, { "v": "1753", "n": "钦州市", "c": [{ "v": "25189", "n": "钦南区" }, { "v": "2999", "n": "钦北区" }, { "v": "1754", "n": "浦北县" }, { "v": "1755", "n": "灵山县" }] }, { "v": "1757", "n": "贵港市", "c": [{ "v": "25192", "n": "港南区" }, { "v": "25193", "n": "港北区" }, { "v": "1758", "n": "桂平市" }, { "v": "1759", "n": "平南县" }, { "v": "1760", "n": "覃塘区" }] }, { "v": "1761", "n": "玉林市", "c": [{ "v": "25188", "n": "玉州区" }, { "v": "1762", "n": "北流市" }, { "v": "1763", "n": "容县" }, { "v": "1764", "n": "博白县" }, { "v": "1765", "n": "陆川县" }, { "v": "1766", "n": "兴业县" }] }, { "v": "3044", "n": "来宾市", "c": [{ "v": "3046", "n": "兴宾区" }, { "v": "3047", "n": "合山市" }, { "v": "3048", "n": "忻城县" }, { "v": "3049", "n": "武宣县" }, { "v": "3050", "n": "象州县" }, { "v": "3051", "n": "金秀县" }] }] }, { "v": "21", "n": "江西", "c": [{ "v": "1827", "n": "南昌市", "c": [{ "v": "3505", "n": "青云谱区" }, { "v": "3506", "n": "西湖区" }, { "v": "3507", "n": "东湖区" }, { "v": "4101", "n": "昌北区" }, { "v": "1828", "n": "南昌县" }, { "v": "1829", "n": "进贤县" }, { "v": "1830", "n": "安义县" }, { "v": "40846", "n": "青山湖区" }, { "v": "40847", "n": "红谷滩新区" }, { "v": "3502", "n": "新建县" }, { "v": "3504", "n": "湾里区" }, { "v": "4039", "n": "高新区" }] }, { "v": "1832", "n": "景德镇市", "c": [{ "v": "3508", "n": "珠山区" }, { "v": "1833", "n": "乐平市" }, { "v": "1834", "n": "浮梁县" }, { "v": "24947", "n": "昌江区" }] }, { "v": "1836", "n": "萍乡市", "c": [{ "v": "1837", "n": "湘东区" }, { "v": "1838", "n": "莲花县" }, { "v": "1839", "n": "上栗县" }, { "v": "1840", "n": "芦溪县" }, { "v": "18317", "n": "安源区" }] }, { "v": "1842", "n": "新余市", "c": [{ "v": "1843", "n": "分宜县" }, { "v": "26455", "n": "渝水区" }] }, { "v": "1845", "n": "九江市", "c": [{ "v": "25482", "n": "浔阳区" }, { "v": "23679", "n": "八里湖新区" }, { "v": "23678", "n": "经济技术开发区" }, { "v": "1852", "n": "修水县" }, { "v": "1847", "n": "瑞昌市" }, { "v": "1850", "n": "彭泽县" }, { "v": "1853", "n": "湖口县" }, { "v": "4161", "n": "共青城市" }, { "v": "1846", "n": "柴桑区" }, { "v": "25481", "n": "濂溪区" }, { "v": "1854", "n": "德安县" }, { "v": "1855", "n": "都昌县" }, { "v": "1851", "n": "永修县" }, { "v": "1849", "n": "武宁县" }, { "v": "1848", "n": "庐山市" }, { "v": "23680", "n": "庐山风景名胜区" }] }, { "v": "1857", "n": "鹰潭市", "c": [{ "v": "51245", "n": "龙虎山风景旅游区" }, { "v": "1858", "n": "余江县" }, { "v": "1859", "n": "贵溪市" }, { "v": "1860", "n": "月湖区" }] }, { "v": "1861", "n": "上饶市", "c": [{ "v": "1863", "n": "德兴市" }, { "v": "1864", "n": "广丰县" }, { "v": "1865", "n": "鄱阳县" }, { "v": "1866", "n": "婺源县" }, { "v": "1867", "n": "余干县" }, { "v": "1868", "n": "横峰县" }, { "v": "1869", "n": "弋阳县" }, { "v": "1870", "n": "铅山县" }, { "v": "1871", "n": "玉山县" }, { "v": "1872", "n": "万年县" }, { "v": "26449", "n": "信州区" }, { "v": "26450", "n": "上饶县" }] }, { "v": "1874", "n": "宜春市", "c": [{ "v": "1875", "n": "丰城市" }, { "v": "1876", "n": "樟树市" }, { "v": "26452", "n": "袁州区" }, { "v": "1877", "n": "高安市" }, { "v": "1878", "n": "铜鼓县" }, { "v": "1879", "n": "靖安县" }, { "v": "1880", "n": "宜丰县" }, { "v": "1881", "n": "奉新县" }, { "v": "1882", "n": "万载县" }, { "v": "1883", "n": "上高县" }] }, { "v": "1885", "n": "抚州市", "c": [{ "v": "1887", "n": "南丰县" }, { "v": "1888", "n": "乐安县" }, { "v": "1889", "n": "金溪县" }, { "v": "1890", "n": "南城县" }, { "v": "1891", "n": "东乡县" }, { "v": "1892", "n": "资溪县" }, { "v": "1893", "n": "宜黄县" }, { "v": "1894", "n": "崇仁县" }, { "v": "1895", "n": "黎川县" }, { "v": "1896", "n": "广昌县" }, { "v": "24946", "n": "临川区" }] }, { "v": "1898", "n": "吉安市", "c": [{ "v": "26453", "n": "青原区" }, { "v": "26454", "n": "吉州区" }, { "v": "1899", "n": "井冈山市" }, { "v": "1900", "n": "吉安县" }, { "v": "1901", "n": "永丰县" }, { "v": "1902", "n": "永新县" }, { "v": "1903", "n": "新干县" }, { "v": "1904", "n": "泰和县" }, { "v": "1905", "n": "峡江县" }, { "v": "1906", "n": "遂川县" }, { "v": "1907", "n": "安福县" }, { "v": "1908", "n": "吉水县" }, { "v": "1909", "n": "万安县" }] }, { "v": "1911", "n": "赣州市", "c": [{ "v": "26451", "n": "章贡区" }, { "v": "1912", "n": "南康市" }, { "v": "1913", "n": "瑞金市" }, { "v": "1914", "n": "石城县" }, { "v": "1915", "n": "安远县" }, { "v": "1916", "n": "赣县" }, { "v": "1917", "n": "宁都县" }, { "v": "1918", "n": "寻乌县" }, { "v": "1919", "n": "兴国县" }, { "v": "1920", "n": "定南县" }, { "v": "1921", "n": "上犹县" }, { "v": "1922", "n": "于都县" }, { "v": "1923", "n": "龙南县" }, { "v": "1924", "n": "崇义县" }, { "v": "1925", "n": "大余县" }, { "v": "1926", "n": "信丰县" }, { "v": "1927", "n": "全南县" }, { "v": "1928", "n": "会昌县" }] }] }, { "v": "22", "n": "四川", "c": [{ "v": "2058", "n": "眉山市", "c": [{ "v": "2060", "n": "仁寿县" }, { "v": "2061", "n": "彭山区" }, { "v": "2062", "n": "洪雅县" }, { "v": "2063", "n": "丹棱县" }, { "v": "2064", "n": "青神县" }, { "v": "41029", "n": "东坡区" }] }, { "v": "2065", "n": "资阳市", "c": [{ "v": "3905", "n": "雁江区" }, { "v": "2068", "n": "安岳县" }, { "v": "2069", "n": "乐至县" }, { "v": "44342", "n": "简阳市" }] }, { "v": "2070", "n": "阿坝州", "c": [{ "v": "2071", "n": "马尔康县" }, { "v": "2072", "n": "九寨沟县" }, { "v": "2073", "n": "红原县" }, { "v": "2075", "n": "阿坝县" }, { "v": "2076", "n": "理县" }, { "v": "2077", "n": "若尔盖县" }, { "v": "2078", "n": "金川县" }, { "v": "2079", "n": "小金县" }, { "v": "2080", "n": "黑水县" }, { "v": "2081", "n": "松潘县" }, { "v": "2082", "n": "壤塘县" }, { "v": "2083", "n": "茂县" }, { "v": "27498", "n": "汶川县" }] }, { "v": "2084", "n": "甘孜州", "c": [{ "v": "2085", "n": "康定县" }, { "v": "2086", "n": "泸定县" }, { "v": "2087", "n": "九龙县" }, { "v": "2088", "n": "丹巴县" }, { "v": "2089", "n": "道孚县" }, { "v": "2090", "n": "炉霍县" }, { "v": "2091", "n": "色达县" }, { "v": "2092", "n": "甘孜县" }, { "v": "2093", "n": "新龙县" }, { "v": "2094", "n": "白玉县" }, { "v": "2095", "n": "德格县" }, { "v": "2096", "n": "石渠县" }, { "v": "2097", "n": "雅江县" }, { "v": "2098", "n": "理塘县" }, { "v": "2099", "n": "巴塘县" }, { "v": "2100", "n": "稻城县" }, { "v": "2101", "n": "乡城县" }, { "v": "2102", "n": "得荣县" }] }, { "v": "2103", "n": "凉山州", "c": [{ "v": "2105", "n": "美姑县" }, { "v": "2106", "n": "昭觉县" }, { "v": "2107", "n": "会理县" }, { "v": "2108", "n": "会东县" }, { "v": "2109", "n": "普格县" }, { "v": "2110", "n": "宁南县" }, { "v": "2111", "n": "德昌县" }, { "v": "2112", "n": "冕宁县" }, { "v": "2113", "n": "盐源县" }, { "v": "2114", "n": "金阳县" }, { "v": "2115", "n": "布拖县" }, { "v": "2116", "n": "雷波县" }, { "v": "2117", "n": "越西县" }, { "v": "2118", "n": "喜德县" }, { "v": "2119", "n": "甘洛县" }, { "v": "2120", "n": "木里县" }, { "v": "27500", "n": "西昌市" }] }, { "v": "1930", "n": "成都市", "c": [{ "v": "50947", "n": "武侯区" }, { "v": "50946", "n": "金牛区" }, { "v": "50944", "n": "青羊区" }, { "v": "50948", "n": "成华区" }, { "v": "50949", "n": "高新区" }, { "v": "50945", "n": "锦江区" }, { "v": "49322", "n": "郫县" }, { "v": "49324", "n": "双流县" }, { "v": "4284", "n": "高新西区" }, { "v": "49316", "n": "龙泉驿区" }, { "v": "49314", "n": "新都区" }, { "v": "49315", "n": "温江区" }, { "v": "49321", "n": "都江堰市" }, { "v": "49318", "n": "彭州市" }, { "v": "49317", "n": "青白江区" }, { "v": "49319", "n": "崇州市" }, { "v": "49327", "n": "金堂县" }, { "v": "49323", "n": "新津县" }, { "v": "49320", "n": "邛崃市" }, { "v": "49325", "n": "大邑县" }, { "v": "49326", "n": "蒲江县" }] }, { "v": "1946", "n": "自贡市", "c": [{ "v": "1949", "n": "自流井区" }, { "v": "3895", "n": "沿滩区" }, { "v": "1947", "n": "荣县" }, { "v": "1948", "n": "富顺县" }, { "v": "43224", "n": "大安区" }, { "v": "43225", "n": "贡井区" }] }, { "v": "1950", "n": "攀枝花市", "c": [{ "v": "1953", "n": "仁和区" }, { "v": "3896", "n": "西区" }, { "v": "27502", "n": "东区" }, { "v": "1951", "n": "米易县" }, { "v": "1952", "n": "盐边县" }] }, { "v": "1954", "n": "泸州市", "c": [{ "v": "3898", "n": "纳溪区" }, { "v": "39014", "n": "江阳区" }, { "v": "39015", "n": "龙马潭区" }, { "v": "1955", "n": "泸县" }, { "v": "1956", "n": "合江县" }, { "v": "1957", "n": "叙永县" }, { "v": "1958", "n": "古蔺县" }] }, { "v": "1960", "n": "绵阳市", "c": [{ "v": "38573", "n": "江油市" }, { "v": "38574", "n": "涪城区" }, { "v": "38575", "n": "游仙区" }, { "v": "38576", "n": "高新区" }, { "v": "38577", "n": "经开区" }, { "v": "1970", "n": "盐亭县" }, { "v": "1971", "n": "三台县" }, { "v": "1972", "n": "平武县" }, { "v": "1973", "n": "北川县" }, { "v": "1974", "n": "安县" }, { "v": "1975", "n": "梓潼县" }] }, { "v": "1962", "n": "德阳市", "c": [{ "v": "39010", "n": "广汉市" }, { "v": "39011", "n": "什邡市" }, { "v": "39012", "n": "旌阳区" }, { "v": "39013", "n": "绵竹市" }, { "v": "1965", "n": "罗江县" }, { "v": "1966", "n": "中江县" }] }, { "v": "1977", "n": "广元市", "c": [{ "v": "3901", "n": "昭化区" }, { "v": "3902", "n": "朝天区" }, { "v": "27499", "n": "利州区" }, { "v": "1978", "n": "青川县" }, { "v": "1979", "n": "旺苍县" }, { "v": "1980", "n": "剑阁县" }, { "v": "1981", "n": "苍溪县" }] }, { "v": "1983", "n": "遂宁市", "c": [{ "v": "4961", "n": "船山区" }, { "v": "1984", "n": "射洪县" }, { "v": "1985", "n": "蓬溪县" }, { "v": "1986", "n": "大英县" }, { "v": "1987", "n": "安居区" }] }, { "v": "1988", "n": "内江市", "c": [{ "v": "3121", "n": "东兴区" }, { "v": "1989", "n": "资中县" }, { "v": "1990", "n": "隆昌县" }, { "v": "1991", "n": "威远县" }, { "v": "1992", "n": "市中区" }] }, { "v": "1993", "n": "乐山市", "c": [{ "v": "36983", "n": "市中区" }, { "v": "36984", "n": "峨眉山市" }, { "v": "1994", "n": "五通桥区" }, { "v": "1995", "n": "沙湾区" }, { "v": "1996", "n": "金口河区" }, { "v": "1998", "n": "夹江县" }, { "v": "1999", "n": "井研县" }, { "v": "2000", "n": "犍为县" }, { "v": "2001", "n": "沐川县" }, { "v": "2002", "n": "峨边县" }, { "v": "2003", "n": "马边县" }] }, { "v": "2005", "n": "宜宾市", "c": [{ "v": "2006", "n": "宜宾县" }, { "v": "2007", "n": "南溪区" }, { "v": "2008", "n": "江安县" }, { "v": "2009", "n": "长宁县" }, { "v": "2010", "n": "兴文县" }, { "v": "2011", "n": "珙县" }, { "v": "36315", "n": "翠屏区" }, { "v": "2012", "n": "高县" }, { "v": "2013", "n": "屏山县" }, { "v": "2015", "n": "筠连县" }] }, { "v": "2016", "n": "广安市", "c": [{ "v": "52607", "n": "前锋区" }, { "v": "2017", "n": "岳池县" }, { "v": "2018", "n": "武胜县" }, { "v": "2019", "n": "邻水县" }, { "v": "2020", "n": "广安区" }, { "v": "2021", "n": "华蓥市" }] }, { "v": "2022", "n": "南充市", "c": [{ "v": "43226", "n": "顺庆区" }, { "v": "43227", "n": "高坪区" }, { "v": "43228", "n": "嘉陵区" }, { "v": "43229", "n": "西充县" }, { "v": "43230", "n": "阆中市" }, { "v": "36936", "n": "南部县" }, { "v": "2028", "n": "仪陇县" }, { "v": "2029", "n": "蓬安县" }, { "v": "2030", "n": "营山县" }] }, { "v": "2033", "n": "达州市", "c": [{ "v": "2034", "n": "通川区" }, { "v": "2035", "n": "达川区" }, { "v": "2036", "n": "大竹县" }, { "v": "2037", "n": "渠县" }, { "v": "2038", "n": "万源市" }, { "v": "2039", "n": "宣汉县" }, { "v": "2040", "n": "开江县" }] }, { "v": "2042", "n": "巴中市", "c": [{ "v": "3904", "n": "巴州区" }, { "v": "52623", "n": "恩阳区" }, { "v": "2044", "n": "南江县" }, { "v": "2045", "n": "平昌县" }, { "v": "2046", "n": "通江县" }] }, { "v": "2047", "n": "雅安市", "c": [{ "v": "2049", "n": "芦山县" }, { "v": "2052", "n": "石棉县" }, { "v": "2053", "n": "名山区" }, { "v": "2054", "n": "天全县" }, { "v": "2055", "n": "荥经县" }, { "v": "2056", "n": "汉源县" }, { "v": "2057", "n": "宝兴县" }, { "v": "41028", "n": "雨城区" }] }] }, { "v": "23", "n": "海南", "c": [{ "v": "3115", "n": "琼海市", "c": [{ "v": "3720", "n": "嘉积镇" }, { "v": "3721", "n": "万泉镇" }, { "v": "3722", "n": "石壁镇" }, { "v": "3723", "n": "中原镇" }, { "v": "3724", "n": "博鳌镇" }, { "v": "3725", "n": "阳江镇" }, { "v": "3727", "n": "龙江镇" }, { "v": "3728", "n": "潭门镇" }, { "v": "3729", "n": "塔洋镇" }, { "v": "3730", "n": "长坡镇" }, { "v": "3731", "n": "大路镇" }, { "v": "3732", "n": "会山镇" }, { "v": "12747", "n": "彬村山华侨农场" }, { "v": "12748", "n": "东太农场" }, { "v": "12749", "n": "东红农场" }, { "v": "12750", "n": "东升农场" }, { "v": "12751", "n": "南俸农场" }] }, { "v": "3137", "n": "万宁市", "c": [{ "v": "53111", "n": "兴隆镇" }, { "v": "53112", "n": "南林农场" }, { "v": "3768", "n": "万城镇" }, { "v": "3769", "n": "龙滚镇" }, { "v": "3770", "n": "和乐镇" }, { "v": "3771", "n": "后安镇" }, { "v": "3772", "n": "大茂镇" }, { "v": "3773", "n": "东澳镇" }, { "v": "3774", "n": "礼纪镇" }, { "v": "3775", "n": "长丰镇" }, { "v": "3776", "n": "山根镇" }, { "v": "3777", "n": "北大镇" }, { "v": "3778", "n": "南桥镇" }, { "v": "3779", "n": "三更罗镇" }, { "v": "12775", "n": "六连林场" }, { "v": "12776", "n": "东兴农场" }, { "v": "12777", "n": "东和农场" }, { "v": "12778", "n": "新中农场" }, { "v": "12779", "n": "兴隆华侨农场" }] }, { "v": "2121", "n": "海口市", "c": [{ "v": "22466", "n": "秀英区" }, { "v": "22467", "n": "龙华区" }, { "v": "22468", "n": "琼山区" }, { "v": "22469", "n": "美兰区" }] }, { "v": "3173", "n": "东方市", "c": [{ "v": "3780", "n": "八所镇" }, { "v": "3781", "n": "东河镇" }, { "v": "3782", "n": "大田镇" }, { "v": "3783", "n": "感城镇" }, { "v": "3784", "n": "板桥镇" }, { "v": "3785", "n": "三家镇" }, { "v": "3786", "n": "四更镇" }, { "v": "3787", "n": "新龙镇" }, { "v": "3788", "n": "天安乡" }, { "v": "3789", "n": "江边乡" }, { "v": "12780", "n": "广坝农场" }, { "v": "12781", "n": "东方华侨农场" }] }, { "v": "3690", "n": "三亚市", "c": [{ "v": "4182", "n": "崖城镇" }, { "v": "3693", "n": "海棠湾镇" }, { "v": "3694", "n": "吉阳镇" }, { "v": "3695", "n": "凤凰镇" }, { "v": "3696", "n": "天涯镇" }, { "v": "3697", "n": "育才镇" }, { "v": "22470", "n": "河西区" }, { "v": "22471", "n": "河东区" }, { "v": "22503", "n": "南田农场" }, { "v": "22504", "n": "南新农场" }, { "v": "22505", "n": "南岛农场" }, { "v": "22506", "n": "立才农场" }, { "v": "22507", "n": "南滨农场" }] }, { "v": "3698", "n": "文昌市", "c": [{ "v": "3752", "n": "文城镇" }, { "v": "3753", "n": "重兴镇" }, { "v": "3754", "n": "蓬莱镇" }, { "v": "3755", "n": "会文镇" }, { "v": "3756", "n": "东路镇" }, { "v": "3757", "n": "潭牛镇" }, { "v": "3758", "n": "东阁镇" }, { "v": "3759", "n": "文教镇" }, { "v": "3760", "n": "东郊镇" }, { "v": "3761", "n": "龙楼镇" }, { "v": "3762", "n": "昌洒镇" }, { "v": "3763", "n": "翁田镇" }, { "v": "3764", "n": "抱罗镇" }, { "v": "3765", "n": "冯坡镇" }, { "v": "3766", "n": "锦山镇" }, { "v": "3767", "n": "铺前镇" }, { "v": "12762", "n": "公坡镇" }, { "v": "12763", "n": "迈号镇" }, { "v": "12764", "n": "清谰镇" }, { "v": "12765", "n": "南阳镇" }, { "v": "12766", "n": "新桥镇" }, { "v": "12767", "n": "头苑镇" }, { "v": "12768", "n": "宝芳乡" }, { "v": "12769", "n": "龙马乡" }, { "v": "12770", "n": "湖山乡" }, { "v": "12771", "n": "东路农场" }, { "v": "12772", "n": "南阳农场" }, { "v": "12773", "n": "罗豆农场" }, { "v": "12774", "n": "橡胶研究所" }] }, { "v": "3699", "n": "五指山市", "c": [{ "v": "3712", "n": "通什镇" }, { "v": "3713", "n": "南圣镇" }, { "v": "3714", "n": "毛阳镇" }, { "v": "3715", "n": "番阳镇" }, { "v": "3716", "n": "畅好乡" }, { "v": "3717", "n": "毛道乡" }, { "v": "3719", "n": "水满乡" }, { "v": "12746", "n": "畅好农场" }] }, { "v": "3701", "n": "临高县", "c": [{ "v": "39884", "n": "城区" }, { "v": "3790", "n": "临城镇" }, { "v": "3791", "n": "波莲镇" }, { "v": "3792", "n": "东英镇" }, { "v": "3793", "n": "博厚镇" }, { "v": "3794", "n": "皇桐镇" }, { "v": "3795", "n": "多文镇" }, { "v": "3796", "n": "和舍镇" }, { "v": "3797", "n": "南宝镇" }, { "v": "3798", "n": "新盈镇" }, { "v": "3799", "n": "调楼镇" }, { "v": "3800", "n": "加来镇" }, { "v": "12791", "n": "红华农场" }, { "v": "12792", "n": "加来农场" }] }, { "v": "3702", "n": "澄迈县", "c": [{ "v": "39886", "n": "城区" }, { "v": "3801", "n": "金江镇" }, { "v": "3802", "n": "老城镇" }, { "v": "3803", "n": "瑞溪镇" }, { "v": "3804", "n": "永发镇" }, { "v": "3805", "n": "加乐镇" }, { "v": "3806", "n": "文儒镇" }, { "v": "3807", "n": "中兴镇" }, { "v": "3808", "n": "仁兴镇" }, { "v": "3809", "n": "福山镇" }, { "v": "3810", "n": "桥头镇" }, { "v": "12787", "n": "大丰镇" }, { "v": "12788", "n": "红光农场" }, { "v": "12789", "n": "西达农场" }, { "v": "12790", "n": "金安农场" }] }, { "v": "3703", "n": "定安县", "c": [{ "v": "4498", "n": "黄竹镇" }, { "v": "39887", "n": "城区" }, { "v": "3811", "n": "定城镇" }, { "v": "3812", "n": "新竹镇" }, { "v": "3813", "n": "龙湖镇" }, { "v": "3814", "n": "雷鸣镇" }, { "v": "3815", "n": "龙门镇" }, { "v": "3816", "n": "龙河镇" }, { "v": "3817", "n": "岭口镇" }, { "v": "3818", "n": "翰林镇" }, { "v": "3819", "n": "富文镇" }, { "v": "12782", "n": "金鸡岭农场" }, { "v": "12783", "n": "中瑞农场" }, { "v": "12784", "n": "南海农场" }] }, { "v": "3704", "n": "屯昌县", "c": [{ "v": "39889", "n": "县城内" }, { "v": "3820", "n": "屯城镇" }, { "v": "3821", "n": "新兴镇" }, { "v": "3822", "n": "枫木镇" }, { "v": "3823", "n": "乌坡镇" }, { "v": "3824", "n": "南吕镇" }, { "v": "3825", "n": "南坤镇" }, { "v": "12785", "n": "中建农场" }, { "v": "3826", "n": "坡心镇" }, { "v": "12786", "n": "中坤农场" }, { "v": "3827", "n": "西昌镇" }] }, { "v": "3705", "n": "昌江县", "c": [{ "v": "12800", "n": "红林农场" }, { "v": "39890", "n": "城区" }, { "v": "3828", "n": "石碌镇" }, { "v": "3829", "n": "叉河镇" }, { "v": "3830", "n": "十月田镇" }, { "v": "3831", "n": "乌烈镇" }, { "v": "3832", "n": "昌化镇" }, { "v": "3833", "n": "海尾镇" }, { "v": "12796", "n": "七叉镇" }, { "v": "12797", "n": "王下乡" }, { "v": "12798", "n": "海南矿业公司" }, { "v": "12799", "n": "霸王岭林场" }] }, { "v": "3706", "n": "白沙县", "c": [{ "v": "3840", "n": "南开乡" }, { "v": "3841", "n": "阜龙乡" }, { "v": "3842", "n": "青松乡" }, { "v": "3843", "n": "金波乡" }, { "v": "3844", "n": "荣邦乡" }, { "v": "39892", "n": "城区" }, { "v": "12793", "n": "白沙农场" }, { "v": "3834", "n": "牙叉镇" }, { "v": "12794", "n": "龙江农场" }, { "v": "3835", "n": "七坊镇" }, { "v": "12795", "n": "邦溪农场" }, { "v": "3836", "n": "邦溪镇" }, { "v": "3837", "n": "打安镇" }, { "v": "3838", "n": "细水乡" }, { "v": "3839", "n": "元门乡" }] }, { "v": "3707", "n": "琼中县", "c": [{ "v": "12813", "n": "吊罗山乡" }, { "v": "12814", "n": "黎母山林业公司" }, { "v": "12815", "n": "阳江农场" }, { "v": "12816", "n": "乌石农场" }, { "v": "12817", "n": "加钗农场" }, { "v": "12818", "n": "长征农场" }, { "v": "3878", "n": "营根镇" }, { "v": "3879", "n": "湾岭镇" }, { "v": "3880", "n": "黎母山镇" }, { "v": "3881", "n": "和平镇" }, { "v": "3882", "n": "长征镇" }, { "v": "3883", "n": "红毛镇" }, { "v": "3884", "n": "中平镇" }, { "v": "3885", "n": "上安乡" }, { "v": "3886", "n": "什运乡" }, { "v": "39893", "n": "城区" }] }, { "v": "3708", "n": "陵水县", "c": [{ "v": "53109", "n": "东华镇" }, { "v": "53110", "n": "南平镇" }, { "v": "12806", "n": "吊罗山林业公司" }, { "v": "12807", "n": "岭门农场" }, { "v": "12808", "n": "南平农场" }, { "v": "3858", "n": "椰林镇" }, { "v": "3859", "n": "光坡镇" }, { "v": "3860", "n": "三才镇" }, { "v": "3861", "n": "英州镇" }, { "v": "3862", "n": "隆广镇" }, { "v": "3863", "n": "文罗镇" }, { "v": "3864", "n": "本号镇" }, { "v": "3865", "n": "新村镇" }, { "v": "3866", "n": "黎安镇" }, { "v": "3867", "n": "提蒙乡" }, { "v": "3868", "n": "群英乡" }, { "v": "39895", "n": "城区" }] }, { "v": "3709", "n": "保亭县", "c": [{ "v": "12809", "n": "保亭研究所" }, { "v": "12810", "n": "新星农场" }, { "v": "12811", "n": "金江农场" }, { "v": "12812", "n": "三道农场" }, { "v": "3869", "n": "保城镇" }, { "v": "3870", "n": "什玲镇" }, { "v": "3871", "n": "加茂镇" }, { "v": "3872", "n": "响水镇" }, { "v": "3873", "n": "新政镇" }, { "v": "3874", "n": "三道镇" }, { "v": "3875", "n": "六弓乡" }, { "v": "3876", "n": "南林乡" }, { "v": "3877", "n": "毛感乡" }] }, { "v": "3710", "n": "乐东县", "c": [{ "v": "12801", "n": "尖峰岭林业公司" }, { "v": "12802", "n": "莺歌海盐场" }, { "v": "12803", "n": "山荣农场" }, { "v": "12804", "n": "乐光农场" }, { "v": "3845", "n": "抱由镇" }, { "v": "12805", "n": "保国农场" }, { "v": "3846", "n": "万冲镇" }, { "v": "3847", "n": "大安镇" }, { "v": "3849", "n": "志仲镇" }, { "v": "3851", "n": "千家镇" }, { "v": "3852", "n": "九所镇" }, { "v": "3853", "n": "利国镇" }, { "v": "3854", "n": "黄流镇" }, { "v": "3855", "n": "佛罗镇" }, { "v": "3856", "n": "尖峰镇" }, { "v": "3857", "n": "莺歌海镇" }, { "v": "39897", "n": "城区" }] }, { "v": "3711", "n": "三沙市", "c": [{ "v": "12819", "n": "中沙群岛" }, { "v": "3887", "n": "西沙群岛" }, { "v": "3888", "n": "南沙群岛" }] }, { "v": "3034", "n": "儋州市", "c": [{ "v": "12824", "n": "热作学院" }, { "v": "3125", "n": "那大镇" }, { "v": "4214", "n": "富克镇" }, { "v": "3733", "n": "和庆镇" }, { "v": "3734", "n": "南丰镇" }, { "v": "3735", "n": "大成镇" }, { "v": "3736", "n": "雅星镇" }, { "v": "3737", "n": "兰洋镇" }, { "v": "3738", "n": "光村镇" }, { "v": "3739", "n": "木棠镇" }, { "v": "3740", "n": "海头镇" }, { "v": "3741", "n": "峨蔓镇" }, { "v": "3744", "n": "三都镇" }, { "v": "3745", "n": "王五镇" }, { "v": "3746", "n": "白马井镇" }, { "v": "3747", "n": "中和镇" }, { "v": "3748", "n": "排浦镇" }, { "v": "3749", "n": "东成镇" }, { "v": "3750", "n": "新州镇" }, { "v": "3751", "n": "洋浦经济开发区" }, { "v": "12752", "n": "西培农场" }, { "v": "12753", "n": "西联农场" }, { "v": "12754", "n": "蓝洋农场" }, { "v": "12755", "n": "八一农场" }, { "v": "12756", "n": "西华农场" }, { "v": "12757", "n": "西庆农场" }, { "v": "12758", "n": "西流农场" }, { "v": "12759", "n": "新盈农场" }, { "v": "12760", "n": "龙山农场" }, { "v": "12761", "n": "红岭农场" }] }] }, { "v": "24", "n": "贵州", "c": [{ "v": "2144", "n": "贵阳市", "c": [{ "v": "3906", "n": "南明区" }, { "v": "21037", "n": "云岩区" }, { "v": "21038", "n": "花溪区" }, { "v": "21039", "n": "小河区" }, { "v": "3909", "n": "白云区" }, { "v": "2145", "n": "清镇市" }, { "v": "2146", "n": "开阳县" }, { "v": "2147", "n": "修文县" }, { "v": "2148", "n": "息烽县" }, { "v": "2149", "n": "乌当区" }, { "v": "24463", "n": "观山湖区" }] }, { "v": "2150", "n": "六盘水市", "c": [{ "v": "2151", "n": "盘县" }, { "v": "2152", "n": "六枝特区" }, { "v": "2153", "n": "水城县" }, { "v": "2154", "n": "钟山区" }] }, { "v": "2155", "n": "遵义市", "c": [{ "v": "21035", "n": "红花岗区" }, { "v": "21036", "n": "汇川区" }, { "v": "2156", "n": "赤水市" }, { "v": "2157", "n": "仁怀市" }, { "v": "2158", "n": "播州区" }, { "v": "2159", "n": "桐梓县" }, { "v": "2160", "n": "绥阳县" }, { "v": "2161", "n": "习水县" }, { "v": "2162", "n": "凤冈县" }, { "v": "2163", "n": "正安县" }, { "v": "2164", "n": "湄潭县" }, { "v": "2165", "n": "余庆县" }, { "v": "2166", "n": "道真县" }, { "v": "2167", "n": "务川县" }] }, { "v": "2169", "n": "铜仁市", "c": [{ "v": "2170", "n": "碧江区" }, { "v": "2171", "n": "德江县" }, { "v": "2172", "n": "江口县" }, { "v": "2173", "n": "思南县" }, { "v": "2174", "n": "万山区" }, { "v": "2175", "n": "石阡县" }, { "v": "2176", "n": "玉屏侗族自治县" }, { "v": "2177", "n": "松桃苗族自治县" }, { "v": "2178", "n": "印江土家族苗族自治县" }, { "v": "2179", "n": "沿河土家族自治县" }] }, { "v": "2180", "n": "毕节市", "c": [{ "v": "8891", "n": "七星关区" }, { "v": "2182", "n": "黔西县" }, { "v": "2183", "n": "大方县" }, { "v": "2184", "n": "织金县" }, { "v": "2185", "n": "金沙县" }, { "v": "2186", "n": "赫章县" }, { "v": "2187", "n": "纳雍县" }, { "v": "2188", "n": "威宁彝族回族苗族自治县" }] }, { "v": "2189", "n": "安顺市", "c": [{ "v": "2190", "n": "西秀区" }, { "v": "2191", "n": "普定县" }, { "v": "2192", "n": "平坝县" }, { "v": "2193", "n": "镇宁布依族苗族自治县" }, { "v": "2194", "n": "关岭布依族苗族自治县" }, { "v": "2195", "n": "紫云苗族布依族自治县" }] }, { "v": "2196", "n": "黔西南州", "c": [{ "v": "2197", "n": "兴义市" }, { "v": "2198", "n": "望谟县" }, { "v": "2199", "n": "兴仁县" }, { "v": "2200", "n": "普安县" }, { "v": "2201", "n": "册亨县" }, { "v": "2202", "n": "晴隆县" }, { "v": "2203", "n": "贞丰县" }, { "v": "2204", "n": "安龙县" }] }, { "v": "2205", "n": "黔东南州", "c": [{ "v": "2206", "n": "凯里市" }, { "v": "2207", "n": "施秉市" }, { "v": "2208", "n": "从江县" }, { "v": "2209", "n": "锦屏县" }, { "v": "2210", "n": "镇远县" }, { "v": "2211", "n": "麻江县" }, { "v": "2212", "n": "台江县" }, { "v": "2213", "n": "天柱县" }, { "v": "2214", "n": "黄平县" }, { "v": "2215", "n": "榕江县" }, { "v": "2216", "n": "剑河县" }, { "v": "2217", "n": "三穗县" }, { "v": "2218", "n": "雷山县" }, { "v": "2219", "n": "黎平县" }, { "v": "2220", "n": "岑巩县" }, { "v": "2221", "n": "丹寨县" }] }, { "v": "2222", "n": "黔南州", "c": [{ "v": "2223", "n": "都匀市" }, { "v": "2224", "n": "福泉市" }, { "v": "2225", "n": "贵定县" }, { "v": "2226", "n": "惠水县" }, { "v": "2227", "n": "罗甸县" }, { "v": "2228", "n": "瓮安县" }, { "v": "2229", "n": "荔波县" }, { "v": "2230", "n": "龙里县" }, { "v": "2231", "n": "平塘县" }, { "v": "2232", "n": "长顺县" }, { "v": "2233", "n": "独山县" }, { "v": "2234", "n": "三都县" }] }] }, { "v": "25", "n": "云南", "c": [{ "v": "2304", "n": "丽江市", "c": [{ "v": "2305", "n": "玉龙县" }, { "v": "2306", "n": "华坪县" }, { "v": "2307", "n": "永胜县" }, { "v": "2308", "n": "宁蒗县" }, { "v": "21033", "n": "古城区" }] }, { "v": "2309", "n": "文山州", "c": [{ "v": "2310", "n": "文山市" }, { "v": "2311", "n": "麻栗坡县" }, { "v": "2312", "n": "砚山县" }, { "v": "2313", "n": "广南县" }, { "v": "2314", "n": "马关县" }, { "v": "2315", "n": "富宁县" }, { "v": "2316", "n": "西畴县" }, { "v": "2317", "n": "丘北县" }] }, { "v": "4108", "n": "迪庆州", "c": [{ "v": "6823", "n": "香格里拉县" }, { "v": "6824", "n": "德钦县" }, { "v": "6825", "n": "维西县" }] }, { "v": "2318", "n": "红河州", "c": [{ "v": "2319", "n": "个旧市" }, { "v": "2320", "n": "开远市" }, { "v": "2321", "n": "弥勒县" }, { "v": "2322", "n": "红河县" }, { "v": "2323", "n": "绿春县" }, { "v": "2324", "n": "蒙自市" }, { "v": "2325", "n": "泸西县" }, { "v": "2326", "n": "建水县" }, { "v": "2327", "n": "元阳县" }, { "v": "2328", "n": "石屏县" }, { "v": "2329", "n": "金平县" }, { "v": "2330", "n": "屏边县" }, { "v": "2331", "n": "河口县" }] }, { "v": "2332", "n": "西双版纳州", "c": [{ "v": "2333", "n": "景洪市" }, { "v": "2334", "n": "勐海县" }, { "v": "2335", "n": "勐腊县" }] }, { "v": "2336", "n": "楚雄州", "c": [{ "v": "2338", "n": "元谋县" }, { "v": "2339", "n": "南华县" }, { "v": "2340", "n": "牟定县" }, { "v": "2341", "n": "武定县" }, { "v": "2342", "n": "大姚县" }, { "v": "2343", "n": "双柏县" }, { "v": "2344", "n": "禄丰县" }, { "v": "2345", "n": "永仁县" }, { "v": "3917", "n": "姚安县" }, { "v": "20817", "n": "楚雄市" }] }, { "v": "2347", "n": "大理州", "c": [{ "v": "2349", "n": "剑川县" }, { "v": "2350", "n": "弥渡县" }, { "v": "2351", "n": "云龙县" }, { "v": "2352", "n": "洱源县" }, { "v": "2353", "n": "鹤庆县" }, { "v": "2354", "n": "宾川县" }, { "v": "2355", "n": "祥云县" }, { "v": "2356", "n": "永平县" }, { "v": "2357", "n": "巍山县" }, { "v": "2358", "n": "漾濞县" }, { "v": "2359", "n": "南涧县" }, { "v": "20818", "n": "大理市" }] }, { "v": "2360", "n": "德宏州", "c": [{ "v": "2361", "n": "芒市" }, { "v": "2362", "n": "瑞丽市" }, { "v": "2363", "n": "盈江县" }, { "v": "2364", "n": "梁河县" }, { "v": "2365", "n": "陇川县" }] }, { "v": "2366", "n": "怒江州", "c": [{ "v": "2367", "n": "泸水县" }, { "v": "2368", "n": "福贡县" }, { "v": "2369", "n": "兰坪县" }, { "v": "2370", "n": "贡山县" }] }, { "v": "2235", "n": "昆明市", "c": [{ "v": "2246", "n": "盘龙区" }, { "v": "3912", "n": "五华区" }, { "v": "3914", "n": "西山区" }, { "v": "3913", "n": "官渡区" }, { "v": "27497", "n": "呈贡区" }, { "v": "2236", "n": "东川区" }, { "v": "2237", "n": "安宁市" }, { "v": "2238", "n": "富民县" }, { "v": "2239", "n": "嵩明县" }, { "v": "2241", "n": "晋宁县" }, { "v": "2242", "n": "宜良县" }, { "v": "2243", "n": "禄劝县" }, { "v": "2244", "n": "石林县" }, { "v": "2245", "n": "寻甸县" }] }, { "v": "2247", "n": "曲靖市", "c": [{ "v": "21034", "n": "麒麟区" }, { "v": "2249", "n": "马龙县" }, { "v": "2250", "n": "宣威市" }, { "v": "2251", "n": "富源县" }, { "v": "2252", "n": "会泽县" }, { "v": "2253", "n": "陆良县" }, { "v": "2254", "n": "师宗县" }, { "v": "2255", "n": "罗平县" }, { "v": "2256", "n": "沾益县" }] }, { "v": "2258", "n": "玉溪市", "c": [{ "v": "2259", "n": "红塔区" }, { "v": "2260", "n": "华宁县" }, { "v": "2261", "n": "澄江县" }, { "v": "2262", "n": "易门县" }, { "v": "2263", "n": "通海县" }, { "v": "2264", "n": "江川县" }, { "v": "2265", "n": "元江县" }, { "v": "2266", "n": "新平县" }, { "v": "2267", "n": "峨山县" }] }, { "v": "2270", "n": "昭通市", "c": [{ "v": "3002", "n": "鲁甸县" }, { "v": "3003", "n": "绥江县" }, { "v": "2271", "n": "昭阳区" }, { "v": "2272", "n": "镇雄县" }, { "v": "2273", "n": "永善县" }, { "v": "2274", "n": "大关县" }, { "v": "2275", "n": "盐津县" }, { "v": "2276", "n": "彝良县" }, { "v": "2277", "n": "水富县" }, { "v": "2278", "n": "巧家县" }, { "v": "2279", "n": "威信县" }] }, { "v": "2281", "n": "普洱市", "c": [{ "v": "2958", "n": "孟连县" }, { "v": "2282", "n": "思茅区" }, { "v": "2283", "n": "宁洱县" }, { "v": "2284", "n": "景东县" }, { "v": "2285", "n": "镇沅县" }, { "v": "2286", "n": "景谷县" }, { "v": "2287", "n": "墨江县" }, { "v": "2288", "n": "澜沧县" }, { "v": "2289", "n": "西盟县" }, { "v": "2290", "n": "江城县" }] }, { "v": "2291", "n": "临沧市", "c": [{ "v": "3915", "n": "双江县" }, { "v": "3916", "n": "沧源县" }, { "v": "2292", "n": "临翔区" }, { "v": "2293", "n": "镇康县" }, { "v": "2294", "n": "凤庆县" }, { "v": "2295", "n": "云县" }, { "v": "2296", "n": "永德县" }, { "v": "2297", "n": "耿马县" }] }, { "v": "2298", "n": "保山市", "c": [{ "v": "2299", "n": "隆阳区" }, { "v": "2300", "n": "施甸县" }, { "v": "2301", "n": "昌宁县" }, { "v": "2302", "n": "龙陵县" }, { "v": "2303", "n": "腾冲县" }] }] }, { "v": "26", "n": "西藏", "c": [{ "v": "3107", "n": "那曲地区", "c": [{ "v": "53091", "n": "双湖县" }, { "v": "3108", "n": "索县" }, { "v": "3961", "n": "那曲县" }, { "v": "3962", "n": "嘉黎县" }, { "v": "3963", "n": "比如县" }, { "v": "3964", "n": "聂荣县" }, { "v": "3965", "n": "安多县" }, { "v": "3966", "n": "申扎县" }, { "v": "3967", "n": "班戈县" }, { "v": "3968", "n": "巴青县" }, { "v": "3969", "n": "尼玛县" }] }, { "v": "3129", "n": "山南地区", "c": [{ "v": "3130", "n": "贡嘎县" }, { "v": "3934", "n": "扎囊县" }, { "v": "3935", "n": "乃东县" }, { "v": "3936", "n": "桑日县" }, { "v": "3937", "n": "琼结县" }, { "v": "3938", "n": "曲松县" }, { "v": "3939", "n": "措美县" }, { "v": "3940", "n": "洛扎县" }, { "v": "3941", "n": "加查县" }, { "v": "3942", "n": "隆子县" }, { "v": "3943", "n": "错那县" }, { "v": "3944", "n": "浪卡子县" }] }, { "v": "3138", "n": "昌都地区", "c": [{ "v": "3139", "n": "昌都县" }, { "v": "3924", "n": "江达县" }, { "v": "3925", "n": "贡觉县" }, { "v": "3926", "n": "类乌齐县" }, { "v": "3927", "n": "丁青县" }, { "v": "3928", "n": "察雅县" }, { "v": "3929", "n": "八宿县" }, { "v": "3930", "n": "左贡县" }, { "v": "3931", "n": "芒康县" }, { "v": "3932", "n": "洛隆县" }, { "v": "3933", "n": "边坝县" }] }, { "v": "3144", "n": "日喀则地区", "c": [{ "v": "3160", "n": "聂拉木县" }, { "v": "3166", "n": "昂仁县" }, { "v": "3945", "n": "日喀则市" }, { "v": "3946", "n": "南木林县" }, { "v": "3947", "n": "江孜县" }, { "v": "3948", "n": "定日县" }, { "v": "3949", "n": "萨迦县　" }, { "v": "3950", "n": "拉孜县" }, { "v": "3951", "n": "谢通门县" }, { "v": "3952", "n": "白朗县" }, { "v": "3953", "n": "仁布县" }, { "v": "3954", "n": "康马县" }, { "v": "3955", "n": "定结县" }, { "v": "3956", "n": "仲巴县" }, { "v": "3957", "n": "亚东县" }, { "v": "3958", "n": "吉隆县" }, { "v": "3959", "n": "萨嘎县" }, { "v": "3960", "n": "岗巴县" }] }, { "v": "3970", "n": "阿里地区", "c": [{ "v": "3972", "n": "噶尔县" }, { "v": "3973", "n": "普兰县" }, { "v": "3974", "n": "札达县　" }, { "v": "3975", "n": "日土县" }, { "v": "3976", "n": "革吉县" }, { "v": "3977", "n": "改则县" }, { "v": "3978", "n": "措勤县" }] }, { "v": "3971", "n": "林芝地区", "c": [{ "v": "3979", "n": "林芝县" }, { "v": "3980", "n": "工布江达县" }, { "v": "3981", "n": "米林县" }, { "v": "3982", "n": "墨脱县" }, { "v": "3983", "n": "波密县" }, { "v": "3984", "n": "察隅县" }, { "v": "3985", "n": "朗县" }] }, { "v": "2951", "n": "拉萨市", "c": [{ "v": "2952", "n": "城关区" }, { "v": "3123", "n": "林周县" }, { "v": "3918", "n": "当雄县" }, { "v": "3919", "n": "尼木县" }, { "v": "3920", "n": "曲水县" }, { "v": "3921", "n": "堆龙德庆县" }, { "v": "3922", "n": "达孜县" }, { "v": "3923", "n": "墨竹工卡县" }] }] }, { "v": "27", "n": "陕西", "c": [{ "v": "2376", "n": "西安市", "c": [{ "v": "51881", "n": "新城区" }, { "v": "4343", "n": "雁塔区" }, { "v": "50230", "n": "未央区" }, { "v": "50231", "n": "长安区" }, { "v": "50232", "n": "灞桥区" }, { "v": "50233", "n": "碑林区" }, { "v": "50235", "n": "莲湖区" }, { "v": "50236", "n": "临潼区" }, { "v": "50237", "n": "阎良区" }, { "v": "52075", "n": "西安武警工程学院" }, { "v": "2380", "n": "高陵县" }, { "v": "2381", "n": "蓝田县" }, { "v": "2382", "n": "户县" }, { "v": "2383", "n": "周至县" }] }, { "v": "2386", "n": "铜川市", "c": [{ "v": "2387", "n": "印台区" }, { "v": "2388", "n": "宜君县" }, { "v": "2389", "n": "王益区" }, { "v": "3989", "n": "耀州区" }] }, { "v": "2390", "n": "宝鸡市", "c": [{ "v": "2401", "n": "渭滨区" }, { "v": "3990", "n": "金台区" }, { "v": "2392", "n": "岐山县" }, { "v": "2393", "n": "太白县" }, { "v": "2394", "n": "凤翔县" }, { "v": "2395", "n": "陇县" }, { "v": "2396", "n": "麟游县" }, { "v": "2397", "n": "千阳县" }, { "v": "2398", "n": "扶风县" }, { "v": "2399", "n": "凤县" }, { "v": "2400", "n": "眉县" }, { "v": "40650", "n": "陈仓区" }] }, { "v": "2402", "n": "咸阳市", "c": [{ "v": "44320", "n": "秦都区" }, { "v": "44321", "n": "渭城区" }, { "v": "2403", "n": "兴平市" }, { "v": "2404", "n": "礼泉县" }, { "v": "2405", "n": "泾阳县" }, { "v": "2406", "n": "永寿县" }, { "v": "2407", "n": "三原县" }, { "v": "2408", "n": "彬县" }, { "v": "2409", "n": "旬邑县" }, { "v": "2411", "n": "长武县" }, { "v": "2412", "n": "乾县" }, { "v": "2413", "n": "武功县" }, { "v": "2414", "n": "淳化县" }, { "v": "44514", "n": "杨陵区" }] }, { "v": "2416", "n": "渭南市", "c": [{ "v": "2417", "n": "韩城市" }, { "v": "2418", "n": "华阴市" }, { "v": "2419", "n": "蒲城县" }, { "v": "2420", "n": "华县" }, { "v": "2421", "n": "潼关县" }, { "v": "2422", "n": "大荔县" }, { "v": "2423", "n": "澄城县" }, { "v": "2424", "n": "合阳县" }, { "v": "2425", "n": "白水县" }, { "v": "2426", "n": "富平县" }, { "v": "38094", "n": "临渭区" }] }, { "v": "2428", "n": "延安市", "c": [{ "v": "31523", "n": "宝塔区" }, { "v": "2429", "n": "安塞县" }, { "v": "2430", "n": "洛川县" }, { "v": "2431", "n": "子长县" }, { "v": "2432", "n": "黄陵县" }, { "v": "2433", "n": "延长县" }, { "v": "2434", "n": "宜川县" }, { "v": "2435", "n": "延川县" }, { "v": "2436", "n": "甘泉县" }, { "v": "2437", "n": "富县" }, { "v": "2438", "n": "志丹县" }, { "v": "2439", "n": "黄龙县" }, { "v": "2440", "n": "吴起县" }] }, { "v": "2442", "n": "汉中市", "c": [{ "v": "53107", "n": "经济开发区南区" }, { "v": "31864", "n": "汉台区" }, { "v": "2443", "n": "南郑县" }, { "v": "2444", "n": "城固县" }, { "v": "2445", "n": "洋县" }, { "v": "2446", "n": "佛坪县" }, { "v": "2447", "n": "留坝县" }, { "v": "2448", "n": "镇巴县" }, { "v": "2449", "n": "西乡县" }, { "v": "2450", "n": "勉县" }, { "v": "2451", "n": "略阳县" }, { "v": "2452", "n": "宁强县" }] }, { "v": "2454", "n": "榆林市", "c": [{ "v": "2456", "n": "清涧县" }, { "v": "2457", "n": "绥德县" }, { "v": "2459", "n": "佳县" }, { "v": "2460", "n": "神木市" }, { "v": "2461", "n": "府谷县" }, { "v": "2462", "n": "子洲县" }, { "v": "2464", "n": "横山县" }, { "v": "2465", "n": "米脂县" }, { "v": "2466", "n": "吴堡县" }, { "v": "2467", "n": "定边县" }, { "v": "31680", "n": "榆阳区" }, { "v": "4081", "n": "靖边县" }] }, { "v": "2468", "n": "商洛市", "c": [{ "v": "2469", "n": "商州区" }, { "v": "2470", "n": "镇安县" }, { "v": "2471", "n": "山阳县" }, { "v": "2472", "n": "洛南县" }, { "v": "2473", "n": "商南县" }, { "v": "2474", "n": "丹凤县" }, { "v": "2475", "n": "柞水县" }] }, { "v": "2476", "n": "安康市", "c": [{ "v": "3993", "n": "汉滨区" }, { "v": "2478", "n": "紫阳县" }, { "v": "2479", "n": "岚皋县" }, { "v": "2480", "n": "旬阳县" }, { "v": "2481", "n": "镇坪县" }, { "v": "2482", "n": "平利县" }, { "v": "2483", "n": "宁陕县" }, { "v": "2484", "n": "汉阴县" }, { "v": "2485", "n": "石泉县" }, { "v": "2486", "n": "白河县" }] }] }, { "v": "28", "n": "甘肃", "c": [{ "v": "2564", "n": "甘南州", "c": [{ "v": "2565", "n": "合作市" }, { "v": "2566", "n": "夏河县" }, { "v": "2567", "n": "碌曲县" }, { "v": "2568", "n": "舟曲县" }, { "v": "2569", "n": "玛曲县" }, { "v": "2570", "n": "迭部县" }, { "v": "2571", "n": "临潭县" }, { "v": "2572", "n": "卓尼县" }] }, { "v": "3080", "n": "定西市", "c": [{ "v": "3081", "n": "岷县" }, { "v": "4002", "n": "安定区" }, { "v": "4003", "n": "通渭县" }, { "v": "4004", "n": "临洮县" }, { "v": "4005", "n": "漳县" }, { "v": "4006", "n": "渭源县" }, { "v": "4007", "n": "陇西县" }] }, { "v": "2573", "n": "临夏州", "c": [{ "v": "2574", "n": "临夏县" }, { "v": "2575", "n": "康乐县" }, { "v": "2576", "n": "永靖县" }, { "v": "2577", "n": "和政县" }, { "v": "2578", "n": "东乡族自治县" }, { "v": "2579", "n": "积石山县" }, { "v": "3175", "n": "临夏市" }, { "v": "4008", "n": "广河县" }] }, { "v": "2487", "n": "兰州市", "c": [{ "v": "21646", "n": "七里河区" }, { "v": "21647", "n": "安宁区" }, { "v": "21648", "n": "城关区" }, { "v": "3995", "n": "西固区" }, { "v": "3997", "n": "红古区" }, { "v": "2488", "n": "永登县" }, { "v": "2489", "n": "榆中县" }, { "v": "2490", "n": "皋兰县" }] }, { "v": "2492", "n": "金昌市", "c": [{ "v": "2493", "n": "永昌县" }, { "v": "2494", "n": "金川区" }] }, { "v": "2495", "n": "白银市", "c": [{ "v": "2496", "n": "白银区" }, { "v": "2497", "n": "平川区" }, { "v": "2498", "n": "靖远县" }, { "v": "2499", "n": "景泰县" }, { "v": "2500", "n": "会宁县" }] }, { "v": "2501", "n": "天水市", "c": [{ "v": "21644", "n": "麦积区" }, { "v": "21645", "n": "秦州区" }, { "v": "2504", "n": "甘谷县" }, { "v": "2505", "n": "武山县" }, { "v": "2506", "n": "清水县" }, { "v": "2507", "n": "秦安县" }, { "v": "2508", "n": "张家川县" }] }, { "v": "2509", "n": "嘉峪关市", "c": [{ "v": "16899", "n": "长城区" }, { "v": "16923", "n": "镜铁区" }, { "v": "2970", "n": "雄关区" }] }, { "v": "2518", "n": "平凉市", "c": [{ "v": "3998", "n": "静宁县" }, { "v": "3023", "n": "崆峒区" }, { "v": "2519", "n": "华亭县" }, { "v": "2520", "n": "崇信县" }, { "v": "2521", "n": "泾川县" }, { "v": "2522", "n": "灵台县" }, { "v": "2524", "n": "庄浪县" }] }, { "v": "2525", "n": "庆阳市", "c": [{ "v": "4001", "n": "庆城县" }, { "v": "2526", "n": "西峰区" }, { "v": "2528", "n": "镇原县" }, { "v": "2529", "n": "合水县" }, { "v": "2530", "n": "华池县" }, { "v": "2531", "n": "环县" }, { "v": "2532", "n": "宁县" }, { "v": "2533", "n": "正宁县" }] }, { "v": "2534", "n": "陇南市", "c": [{ "v": "2535", "n": "成县" }, { "v": "2536", "n": "礼县" }, { "v": "2537", "n": "康县" }, { "v": "2538", "n": "武都区" }, { "v": "2539", "n": "文县" }, { "v": "2540", "n": "两当县" }, { "v": "2541", "n": "徽县" }, { "v": "2542", "n": "宕昌县" }, { "v": "2543", "n": "西和县" }] }, { "v": "2544", "n": "武威市", "c": [{ "v": "2545", "n": "凉州区" }, { "v": "2546", "n": "古浪县" }, { "v": "2547", "n": "天祝县" }, { "v": "2548", "n": "民勤县" }] }, { "v": "2549", "n": "张掖市", "c": [{ "v": "2550", "n": "甘州区" }, { "v": "2551", "n": "山丹县" }, { "v": "2552", "n": "临泽县" }, { "v": "2553", "n": "高台县" }, { "v": "2554", "n": "肃南县" }, { "v": "2555", "n": "民乐县" }] }, { "v": "2556", "n": "酒泉市", "c": [{ "v": "2560", "n": "金塔县" }, { "v": "2562", "n": "阿克塞县" }, { "v": "2563", "n": "肃北县" }, { "v": "3999", "n": "瓜州县" }, { "v": "4000", "n": "肃州区" }, { "v": "2558", "n": "玉门市" }, { "v": "2559", "n": "敦煌市" }] }] }, { "v": "29", "n": "青海", "c": [{ "v": "2580", "n": "西宁市", "c": [{ "v": "2581", "n": "湟中县" }, { "v": "2582", "n": "湟源县" }, { "v": "2583", "n": "大通县" }, { "v": "21652", "n": "城中区" }, { "v": "21653", "n": "城东区" }, { "v": "21654", "n": "城西区" }, { "v": "21655", "n": "城北区" }] }, { "v": "2585", "n": "海东地区", "c": [{ "v": "2586", "n": "平安县" }, { "v": "2587", "n": "乐都县" }, { "v": "2588", "n": "民和县" }, { "v": "2589", "n": "互助县" }, { "v": "2590", "n": "化隆县" }, { "v": "2591", "n": "循化县" }] }, { "v": "2592", "n": "海北州", "c": [{ "v": "2593", "n": "海晏县" }, { "v": "2594", "n": "祁连县" }, { "v": "2595", "n": "刚察县" }, { "v": "2596", "n": "门源县" }] }, { "v": "2597", "n": "黄南州", "c": [{ "v": "2598", "n": "尖扎县" }, { "v": "2599", "n": "同仁县" }, { "v": "2600", "n": "泽库县" }, { "v": "2602", "n": "河南县" }] }, { "v": "2603", "n": "海南州", "c": [{ "v": "4012", "n": "共和县" }, { "v": "4013", "n": "同德县" }, { "v": "4014", "n": "贵德县" }, { "v": "4015", "n": "兴海县" }, { "v": "4016", "n": "贵南县" }] }, { "v": "2605", "n": "果洛州", "c": [{ "v": "2606", "n": "玛沁县" }, { "v": "2607", "n": "甘德县" }, { "v": "2608", "n": "达日县" }, { "v": "2609", "n": "班玛县" }, { "v": "2610", "n": "久治县" }, { "v": "2611", "n": "玛多县" }] }, { "v": "2612", "n": "玉树州", "c": [{ "v": "2613", "n": "玉树县" }, { "v": "2614", "n": "称多县" }, { "v": "2615", "n": "囊谦县" }, { "v": "2616", "n": "杂多县" }, { "v": "2617", "n": "治多县" }, { "v": "2618", "n": "曲麻莱县" }] }, { "v": "2620", "n": "海西州", "c": [{ "v": "2621", "n": "德令哈市" }, { "v": "2622", "n": "乌兰县" }, { "v": "2623", "n": "天峻县" }, { "v": "2624", "n": "都兰县" }, { "v": "2625", "n": "大柴旦行委" }, { "v": "2626", "n": "冷湖行委" }, { "v": "2627", "n": "茫崖行委" }, { "v": "3021", "n": "格尔木市" }] }] }, { "v": "30", "n": "宁夏", "c": [{ "v": "2628", "n": "银川市", "c": [{ "v": "2629", "n": "灵武市" }, { "v": "2630", "n": "永宁县" }, { "v": "2631", "n": "贺兰县" }, { "v": "21649", "n": "兴庆区" }, { "v": "21650", "n": "金凤区" }, { "v": "21651", "n": "西夏区" }] }, { "v": "2632", "n": "石嘴山市", "c": [{ "v": "2633", "n": "平罗县" }, { "v": "2635", "n": "惠农区" }, { "v": "2636", "n": "大武口区" }] }, { "v": "2637", "n": "吴忠市", "c": [{ "v": "2638", "n": "青铜峡市" }, { "v": "2641", "n": "同心县" }, { "v": "2642", "n": "盐池县" }, { "v": "2643", "n": "红寺堡开发区" }, { "v": "2966", "n": "利通区" }] }, { "v": "2644", "n": "固原市", "c": [{ "v": "2647", "n": "西吉县" }, { "v": "2648", "n": "隆德县" }, { "v": "2649", "n": "泾源县" }, { "v": "2650", "n": "彭阳县" }, { "v": "2651", "n": "原州区" }] }, { "v": "3071", "n": "中卫市", "c": [{ "v": "3072", "n": "中宁县" }, { "v": "3148", "n": "海原县" }, { "v": "4020", "n": "沙坡头区" }] }] }, { "v": "31", "n": "新疆", "c": [{ "v": "4110", "n": "五家渠市", "c": [{ "v": "4122", "n": "五家渠市" }] }, { "v": "15945", "n": "阿拉尔市", "c": [{ "v": "15948", "n": "阿拉尔市" }] }, { "v": "15946", "n": "图木舒克市", "c": [{ "v": "15947", "n": "图木舒克市" }] }, { "v": "2652", "n": "乌鲁木齐市", "c": [{ "v": "36684", "n": "天山区" }, { "v": "4024", "n": "头屯河区" }, { "v": "4025", "n": "达坂城区" }, { "v": "4026", "n": "米东区" }, { "v": "36685", "n": "新市区" }, { "v": "36686", "n": "沙依巴克区" }, { "v": "36687", "n": "水磨沟区" }, { "v": "2653", "n": "乌鲁木齐县" }] }, { "v": "2654", "n": "克拉玛依市", "c": [{ "v": "2655", "n": "克拉玛依区" }, { "v": "2930", "n": "独山子区" }, { "v": "4027", "n": "乌尔禾区" }, { "v": "3006", "n": "白碱滩区" }] }, { "v": "2656", "n": "石河子市", "c": [{ "v": "2657", "n": "石河子市" }] }, { "v": "2658", "n": "吐鲁番地区", "c": [{ "v": "2659", "n": "吐鲁番市" }, { "v": "2660", "n": "托克逊县" }, { "v": "2661", "n": "鄯善县" }] }, { "v": "53090", "n": "铁门关市", "c": [{ "v": "53108", "n": "铁门关市" }] }, { "v": "2662", "n": "哈密地区", "c": [{ "v": "2663", "n": "哈密市" }, { "v": "2664", "n": "巴里坤县" }, { "v": "2665", "n": "伊吾县" }] }, { "v": "2666", "n": "和田地区", "c": [{ "v": "14848", "n": "和田县" }, { "v": "2667", "n": "和田市" }, { "v": "2669", "n": "墨玉县" }, { "v": "2670", "n": "洛浦县" }, { "v": "2671", "n": "策勒县" }, { "v": "2672", "n": "于田县" }, { "v": "2673", "n": "民丰县" }, { "v": "2674", "n": "皮山县" }] }, { "v": "2675", "n": "阿克苏地区", "c": [{ "v": "2676", "n": "阿克苏市" }, { "v": "2678", "n": "温宿县" }, { "v": "2679", "n": "沙雅县" }, { "v": "2680", "n": "拜城县" }, { "v": "2681", "n": "阿瓦提县" }, { "v": "2682", "n": "库车县" }, { "v": "2683", "n": "柯坪县" }, { "v": "2684", "n": "新和县" }, { "v": "2685", "n": "乌什县" }] }, { "v": "2686", "n": "喀什地区", "c": [{ "v": "2687", "n": "喀什市" }, { "v": "2688", "n": "巴楚县" }, { "v": "2689", "n": "泽普县" }, { "v": "2690", "n": "伽师县" }, { "v": "2691", "n": "叶城县" }, { "v": "2692", "n": "岳普湖县" }, { "v": "2693", "n": "疏附县" }, { "v": "2694", "n": "疏勒县" }, { "v": "2695", "n": "英吉沙县" }, { "v": "2696", "n": "麦盖提县" }, { "v": "2697", "n": "莎车县" }, { "v": "2698", "n": "塔什库尔干县" }] }, { "v": "2699", "n": "克孜勒苏柯尔克孜自治州", "c": [{ "v": "2700", "n": "阿图什市" }, { "v": "2701", "n": "阿合奇县" }, { "v": "2702", "n": "乌恰县" }, { "v": "2703", "n": "阿克陶县" }] }, { "v": "2704", "n": "巴音郭楞州", "c": [{ "v": "2705", "n": "库尔勒市" }, { "v": "2706", "n": "尉犁县" }, { "v": "2707", "n": "和静县" }, { "v": "2708", "n": "博湖县" }, { "v": "2709", "n": "和硕县" }, { "v": "2710", "n": "轮台县" }, { "v": "2711", "n": "若羌县" }, { "v": "2712", "n": "且末县" }, { "v": "2713", "n": "焉耆县" }] }, { "v": "2714", "n": "昌吉州", "c": [{ "v": "2715", "n": "昌吉市" }, { "v": "2716", "n": "阜康市" }, { "v": "2718", "n": "奇台县" }, { "v": "2719", "n": "玛纳斯县" }, { "v": "2720", "n": "吉木萨尔县" }, { "v": "2721", "n": "呼图壁县" }, { "v": "2722", "n": "木垒县" }] }, { "v": "2723", "n": "博尔塔拉州", "c": [{ "v": "52790", "n": "阿拉山口市" }, { "v": "2724", "n": "博乐市" }, { "v": "2725", "n": "精河县" }, { "v": "2726", "n": "温泉县" }] }, { "v": "2727", "n": "伊犁州", "c": [{ "v": "4499", "n": "伊宁县" }, { "v": "2728", "n": "伊宁市" }, { "v": "2729", "n": "特克斯县" }, { "v": "2730", "n": "尼勒克县" }, { "v": "2731", "n": "昭苏县" }, { "v": "2732", "n": "新源县" }, { "v": "2733", "n": "霍城县" }, { "v": "2734", "n": "察布查尔县" }, { "v": "2735", "n": "巩留县" }, { "v": "4028", "n": "奎屯市" }] }, { "v": "2736", "n": "塔城地区", "c": [{ "v": "2737", "n": "塔城市" }, { "v": "2738", "n": "乌苏市" }, { "v": "2739", "n": "额敏县" }, { "v": "2740", "n": "裕民县" }, { "v": "2741", "n": "沙湾县" }, { "v": "2742", "n": "托里县" }, { "v": "2743", "n": "和布克赛尔县" }] }, { "v": "2744", "n": "阿勒泰地区", "c": [{ "v": "6822", "n": "北屯市" }, { "v": "2745", "n": "阿勒泰市" }, { "v": "2746", "n": "富蕴县" }, { "v": "2747", "n": "青河县" }, { "v": "2748", "n": "吉木乃县" }, { "v": "2749", "n": "布尔津县" }, { "v": "2750", "n": "福海县" }, { "v": "2751", "n": "哈巴河县" }] }] }, { "v": "32", "n": "台湾", "c": [{ "v": "2768", "n": "台湾", "c": [{ "v": "53504", "n": "金门" }, { "v": "53505", "n": "连江" }, { "v": "53506", "n": "苗栗" }, { "v": "53507", "n": "南投" }, { "v": "53508", "n": "澎湖" }, { "v": "53509", "n": "屏东" }, { "v": "53510", "n": "台东" }, { "v": "53511", "n": "台中" }, { "v": "53512", "n": "台南" }, { "v": "53513", "n": "台北" }, { "v": "53514", "n": "桃园" }, { "v": "53515", "n": "云林" }, { "v": "53516", "n": "新北" }, { "v": "53497", "n": "彰化" }, { "v": "53498", "n": "嘉义" }, { "v": "53499", "n": "新竹" }, { "v": "53500", "n": "花莲" }, { "v": "53501", "n": "宜兰" }, { "v": "53502", "n": "高雄" }, { "v": "53503", "n": "基隆" }] }] }, { "v": "84", "n": "钓鱼岛", "c": [{ "v": "1310", "n": "钓鱼岛", "c": [{ "v": "53263", "n": "钓鱼岛县1" }, { "v": "53281", "n": "钓鱼岛全区" }, { "v": "53262", "n": "钓鱼岛县" }] }] }, { "v": "52993", "n": "港澳", "c": [{ "v": "52994", "n": "香港特别行政区", "c": [{ "v": "52996", "n": "中西区" }, { "v": "52997", "n": "东区" }, { "v": "52998", "n": "九龙城区" }, { "v": "52999", "n": "观塘区" }, { "v": "53000", "n": "深水埗区" }, { "v": "53001", "n": "湾仔区" }, { "v": "53002", "n": "黄大仙区" }, { "v": "53003", "n": "油尖旺区" }, { "v": "53004", "n": "离岛区" }, { "v": "53005", "n": "葵青区" }, { "v": "53006", "n": "北区" }, { "v": "53007", "n": "西贡区" }, { "v": "53008", "n": "沙田区" }, { "v": "53009", "n": "屯门区" }, { "v": "53010", "n": "大埔区" }, { "v": "53011", "n": "荃湾区" }, { "v": "53012", "n": "元朗区" }, { "v": "53013", "n": "香港" }, { "v": "53014", "n": "九龙" }, { "v": "53015", "n": "新界" }] }, { "v": "52995", "n": "澳门特别行政区", "c": [{ "v": "53016", "n": "澳门特别行政区" }, { "v": "53017", "n": "澳门半岛" }, { "v": "53018", "n": "凼仔" }, { "v": "53019", "n": "路凼城" }, { "v": "53020", "n": "路环" }] }] }, { "v": "53021", "n": "海外", "c": [{ "v": "53022", "n": "海外", "c": [{ "v": "53023", "n": "海外" }] }] }];if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (district),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    window.YDUI_DISTRICT = district;
  }
}();

/***/ }),

/***/ "h/+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"loginInfo",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.loginInfo,"rules":_vm.rules2,"label-position":"left","label-width":"0px"}},[_c('h3',{staticClass:"title"},[_vm._v("系统登录")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"mhManagerAccount"}},[_c('el-input',{attrs:{"type":"text","placeholder":"账号"},model:{value:(_vm.loginInfo.mhManagerAccount),callback:function ($$v) {_vm.$set(_vm.loginInfo, "mhManagerAccount", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"loginInfo.mhManagerAccount"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"mhManagerPassword"}},[_c('el-input',{attrs:{"type":"password","placeholder":"密码"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit2.apply(null, arguments)}},model:{value:(_vm.loginInfo.mhManagerPassword),callback:function ($$v) {_vm.$set(_vm.loginInfo, "mhManagerPassword", $$v)},expression:"loginInfo.mhManagerPassword"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"100%"}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleSubmit2('loginInfo')}}},[_vm._v("登录\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hDPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        vaStatus: ''
      },
      activities: [],
      noteCreateName: '',
      createInvoiceDialog: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['vaId'],
  computed: {},
  methods: {
    edit: function edit() {
      this.createInvoiceDialog = true;
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_29" /* getVehicleDetail */]({ vaId: this.vaId }).then(function (res) {
        if (res.data.code === 1) {
          _this.info = res.data.data.vehicleApproveForm;
        } else {
          _this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_61" /* noteSure */](this.vaId).then(function (res) {
        if (res.data.code === 1) {
          _this2.$message({
            message: '确认成功',
            type: "success"
          });
          _this2.close(1);
        } else {
          _this2.$message({
            message: res.data.message,
            type: "error"
          });
        }
      });
    },
    openFile: function openFile(url) {
      window.open(url);
    },
    downLoad: function downLoad(file) {
      window.open('/company/download/downloadWorkflowFileUseName?fileName=' + file.fileName + '&fileUrl=' + file.exportFile);
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "hF0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_company_business_info_vue__ = __webpack_require__("d6Zr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_38cae7e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_company_business_info_vue__ = __webpack_require__("Hefa");
function injectStyle (ssrContext) {
  __webpack_require__("+3+F")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38cae7e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_company_business_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_38cae7e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_company_business_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hftE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "i13J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i4TM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_visitor_register_detail_vue__ = __webpack_require__("kkNK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_43dcd5fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_visitor_register_detail_vue__ = __webpack_require__("9Iod");
function injectStyle (ssrContext) {
  __webpack_require__("cu18")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43dcd5fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_visitor_register_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_43dcd5fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_visitor_register_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i84Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return assessmentscore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return assessmentdetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return assessmentFileList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return mhManagergCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return listNotify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return findNotify; });
/* unused harmony export changePassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return resourceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return listMatterCompany; });
/* unused harmony export findMatterById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return handleMatterCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return matterCompanyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return editMatterCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return matterCompanyDetailDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getAllType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addMatterCompanyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return listFilesByMatterCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return deleteMatterCompanyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return indexDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return checkLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return sendCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return changeMoblie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getChannelIdByUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return workflowList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getWorkflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return addWorkflowApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return myWorkflowApplicationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return revocationWorkflowApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getWorkflowApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return companyContractReminds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return companyBillList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return messageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return deleteMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return mhUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addMhUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return passMhUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return noPassMhUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addMhRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return findMhRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return updateMhRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return mhRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return deleteMhRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return mhManagerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addMhManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return updateMhManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return selectRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deleteMhManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return reSetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getManagerInfo; });
/* unused harmony export managerChangePassword */
/* unused harmony export managerSendCode */
/* unused harmony export managerChangeMoblie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return remindsCount; });
/* unused harmony export getManagerByIds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return changeManagerPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getVisitor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return visitorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return exportVisitorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return serveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return serveDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return feedbackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return feedbackDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return feedbackDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return findEntranceByChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return updateMhUserRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return importUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return faceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return passMhUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return companyAddFace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return detailFace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return faceRecordList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return delPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getPersonPassList; });
/* unused harmony export systemOssByUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return readConfirm; });
/* unused harmony export vrList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return vrDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return erList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deleteVR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addEpidemicRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return logList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return insert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return detail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return isIsolationRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addQuarantine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return updateQuarantine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getQuarantine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deleteQuarantine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return reportState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return policyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return erAuditList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return erAuditApproval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return batchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return viralInfoPersonList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return viralInfoPersonDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return viralInfoPersonToAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return viralInfoPersonAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return toAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addReturnWorkApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getReturnWorkApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return tradeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return templateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return editReturnWorkApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getSystemOssByUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getFileTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getFileManageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getFileDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getFeedbackTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getAttendanceRecordList; });
/* unused harmony export passRecordCompanyList */
/* unused harmony export attedanceEquipmentDownList */
/* unused harmony export getAttendanceSetting */
/* unused harmony export updateAttendanceSetting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getRandomKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return queryFaceProgress; });
/* unused harmony export getHouseRes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return houseResAreaDetail; });
/* unused harmony export contractList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return contractDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return billList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return fileTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return noteGetList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return noteAddNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return noteSure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return noteDelNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return noteCompanyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return noteNoteDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return noteIsCanAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return sendCodeMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return userCompanyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return chooseCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getContracts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getBills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getVehicleApproveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getVehicleDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addVehicleApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return delVehicleApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getAllCarParkGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getAllCarOwnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return editVehicleApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addBalanceWallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getBalanceWallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addWalletContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getWalletContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getContactList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return delWalletContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return workflowApplicationSure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return operationRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return companyInfoList; });
/* unused harmony export defaultField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getCompanyBusiness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return updateCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return companyInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env__ = __webpack_require__("uaSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("Y9Nk");







__WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  var channelId = sessionStorage.getItem("channelId");
  var adminAccount = sessionStorage.getItem("adminAccount");
  var allSessionId = sessionStorage.getItem("allSessionId");
  var permissionId = sessionStorage.getItem("permissionId");
  // if (!channelId || !adminAccount || !allSessionId || !permissionId) {
  //   location.href = localStorage.getItem('channelChannelUrl') ? localStorage.getItem('channelChannelUrl') : localStorage.getItem('channelUrl');
  // }
  config.headers["channelId"] = channelId;
  config.headers["adminAccount"] = adminAccount;
  config.headers["allSessionId"] = allSessionId;
  config.headers["permissionId"] = permissionId;
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

var isOk = true;
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  // token 已过期，重定向到登录页面
  if (response.data.code == 2) {
    if (isOk) {
      isOk = false;
      // alert('登录超时，请重新登录！');
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].replace({ path: "/login" });
      sessionStorage.clear();
      localStorage.clear();
      setTimeout(function () {
        isOk = true;
      }, 2000);
    }
  }
  return response;
}, function (error) {
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

/**
 * 字符串拼接
 * @param info 要拼接的对象
 * @param type 是否是需要？拼接
 */
var stringJoin = void 0;
stringJoin = function stringJoin(info, type) {
  var headerString = '';
  if (!info) {
    return '';
  }
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(info).map(function (data, index) {
    if (index === 0 && type === 2) {
      headerString += data + "=" + info[data];
    } else if (index === 0 && type) {
      headerString += "?" + data + "=" + info[data];
    } else {
      headerString += "&" + data + "=" + info[data];
    }
  });
  return headerString;
};
var searchParams = function searchParams(prop) {
  var param = new URLSearchParams();
  for (var key in prop) {
    param.append(key, prop[key]);
  }
  return param;
};
//手机端
var transformRequest = function transformRequest(data) {
  var ret = "";
  for (var it in data) {
    ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
  }
  return ret;
};

/**
 * 首页和园区通知管理列表接口
 * pageIndex  否  int  页码
 * pageSize  否  int  每页显示数量
 * notifyName  否  String  通知名称
 * isRead  否  int  0未读1已读
 */
var listNotify = function listNotify(pageIndex, pageSize, notifyName, isRead) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/notify/listNotify?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&notifyName=" + notifyName + "&isRead=" + isRead);
};

/**
 * 查看通知详情接口
 * notifyId  是  long  通知主键
 */
var findNotify = function findNotify(notifyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/notify/findNotify?notifyId=" + notifyId);
};

/**
 * 用户获取信息
 *
 */
var getInfo = function getInfo() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/getInfo");
};

/**
 * 用户修改密码
 * userId  Y  String  用户ID
 * oldPassword  Y  String  旧密码
 * newPassword  Y  String  新密码
 * newRepeatPassword  Y  String  重复新密码
 */
var changePassword = function changePassword(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/user/changePassword", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 资料模版列表
 * pageIndex  Y  int  页码
 * pageSize  Y  int  页面显示条数
 * resourceName  N  String  文件名称
 */
var resourceList = function resourceList(pageIndex, pageSize, resourceName) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/resource/resourceList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&resourceName=" + resourceName);
};

/**
 * 企业端-事项列表接口
 * pageIndex  N  Integer
 * pageSize  N  Integer
 * matterName  N  string  事项名称
 * matterTypeId  N  Integer  事项类型 1.默认
 * matterCompanyStatus  N  Integer  0未处理(未提交)1被驳回(驳回待提交)2已处理(待确认)3完成
 */
var listMatterCompany = function listMatterCompany(pageIndex, pageSize, matterName, matterTypeId, matterCompanyStatus) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/matterCompany/listMatterCompany?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&matterName=" + matterName + "&matterTypeId=" + matterTypeId + "&matterCompanyStatus=" + matterCompanyStatus);
};

/**
 * 未处理事项详情
 参数名  必选  类型  说明
 matterCompanyId  是  long  事项id
 */
var matterCompanyDetail = function matterCompanyDetail(matterCompanyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/matterCompany/matterCompanyDetail", { params: { matterCompanyId: matterCompanyId } });
};

/**
 * 企业端-事项详情
 * matterId  Y  Long  事项id
 */
var findMatterById = function findMatterById(matterId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/matter/findMatterById?matterId=" + matterId);
};

/**
 * 获取所有事项类别列表
 */
var getAllType = function getAllType() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/matterType/getAllType");
};

/**
 * 事项管理-处理事项
 */
var handleMatterCompany = function handleMatterCompany(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/matterCompany/handleMatterCompany", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 事项编辑接口
 */
var editMatterCompany = function editMatterCompany(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/matterCompany/editMatterCompany", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 已填报事项详情接口
 参数名  必选  类型  说明
 matterCompanyId  是  long  企业与事项关联id
 */
var matterCompanyDetailDetail = function matterCompanyDetailDetail(matterCompanyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/matterCompany/matterCompanyDetailDetail", { params: { matterCompanyId: matterCompanyId } });
};

/**
 * 企业端-新增关联文件
 * matterCompanyFileName  string  文件名
 * matterCompanyFileUrl  string  文件url
 * matterCompanyFileMatterCompanyId  Long  对应关联id
 */
var addMatterCompanyFile = function addMatterCompanyFile(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/matterCompanyFile/addMatterCompanyFile", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 企业端-关联文件列表
 * matterCompanyId  Y  Long  关联Id
 */
var listFilesByMatterCompanyId = function listFilesByMatterCompanyId(matterCompanyId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/matterCompanyFile/listFilesByMatterCompanyId?matterCompanyId=" + matterCompanyId);
};

/**
 * 企业端-删除关联文件
 * fileId  Y  Long  关联文件id
 */
var deleteMatterCompanyFile = function deleteMatterCompanyFile(fileId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/matterCompanyFile/deleteMatterCompanyFile", "fileId=" + fileId);
};

/**
 * 企业端首页
 */
var indexDate = function indexDate() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/index/indexDate");
};

/**
 * 用户登录
 * phone	是	string	手机号
 * phoneCode	是	string	验证码
 */
var login = function login(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/login", stringJoin(data, 2));
};

/**
 * 用户登录
 * phone	是	string	手机号
 * type	是	integer	1 修改手机号 2 登录
 */
var sendCodeMsg = function sendCodeMsg(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/sendCode", { params: params });
};

/**
 * 用户登出
 */
var logout = function logout(allSessionId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/logout", "allSessionId=" + allSessionId);
};

/**
 * 核对是否登录
 */
var checkLogin = function checkLogin() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/checkLogin");
};

/**
 * 发送验证码
 */
var sendCode = function sendCode(phone, codeState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/sendCode?phone=" + phone + "&codeState=" + codeState);
};

/**
 * 修改手机号
 */
var changeMoblie = function changeMoblie(mobile, code) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/changeMoblie", "mobile=" + mobile + "&code=" + code);
};

/**
 *
 */
var getChannelIdByUrl = function getChannelIdByUrl(url) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_env__["a" /* mainUrl */] + "back/channel/getChannelIdByUrl?url=" + url);
};

/**
 * 新增申请工作流列表
 pageIndex  页码
 pageSize  页面
 */

var workflowList = function workflowList(pageIndex, pageSize) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/workflow/workflowList?pageIndex=" + pageIndex + "&pageSize=" + pageSize);
};

/**
 * 新增申请流程详情
 workflowId  工作流ID
 */

var getWorkflow = function getWorkflow(workflowId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/workflow/getWorkflow?workflowId=" + workflowId);
};

/**
 * 新增工作流申请

 参数名  必选  类型  说明
 workflowId  是  Long  工作流ID
 workflowApplicationTitle  是  string  标题
 workflowApplicationDes  是  string  描述
 files: {workflowApplicationFileUrl: workflowApplicationFileUrl, workflowApplicationFileName: workflowApplicationFileName}
 workflowApplicationFileUrl  否  string  文件地址
 workflowApplicationFileName  否  string  文件名
 */
var addWorkflowApplication = function addWorkflowApplication(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/workflowApplication/addWorkflowApplication", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 我的申请列表
 参数名  必选  类型  说明
 pageIndex  是  Integer  页码
 pageSize  是  Integer  页面
 workflowApplicationStatus  是  Integer  -1全部0审批中1完成2驳回3关闭
 */

var myWorkflowApplicationList = function myWorkflowApplicationList(pageIndex, pageSize, status) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/workflowApplication/myWorkflowApplicationList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&status=" + status);
};

/**
 * 撤回工作流
 参数名  必选  类型  说明
 workflowApplicationId  是  Long  工作流主键
 */

var revocationWorkflowApplication = function revocationWorkflowApplication(workflowApplicationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/workflowApplication/revocationWorkflowApplication", "workflowApplicationId=" + workflowApplicationId);
};

/**
 * 审批详情
 参数名  必选  类型  说明
 workflowApplicationId  是  Long  工作流ID
 */

var getWorkflowApplication = function getWorkflowApplication(workflowApplicationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/workflowApplication/getWorkflowApplication?workflowApplicationId=" + workflowApplicationId);
};

/**
 * 合同提醒列表接口
 参数名  必选  类型  说明
 companyId  是  int  公司id
 type  是  int  合同类型
 pageIndex  是  int  当前页面
 pageSize  是  int  页面大小
 */

var companyContractReminds = function companyContractReminds(companyId, type, pageIndex, pageSize) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/contractRemind/companyContractReminds?companyId=" + companyId + "&type=" + type + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
};

/**
 * 账单提醒列表接口
 参数名  必选  类型  说明
 companyId  是  int  公司id
 contractNumber  是  string  合同编号
 pageIndex  是  int  当前页面
 pageSize  是  int  页面大小
 */

var companyBillList = function companyBillList(companyId, contractNumber, pageIndex, pageSize) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/contractRemind/companyBillList?companyId=" + companyId + "&contractNumber=" + contractNumber + "&pageIndex=" + pageIndex + "&pageSize=" + pageSize);
};

/**
 * 消息列表
 参数名  必选  类型  说明
 pageIndex  是  Integer  页码
 pageSize  是  Integer  页面
 readStatus  是  Integer  -1全部0未读1已读
 */

var messageList = function messageList(pageIndex, pageSize, readStatus) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/message/messageList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&readStatus=" + readStatus);
};

/**
 * 删除消息
 参数名  必选  类型  说明
 messageId  是  Long  消息主键
 */
var deleteMessage = function deleteMessage(messageId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/message/deleteMessage", "messageId=" + messageId);
};

/**
 * 消息详情
 参数名  必选  类型  说明
 messageId  是  Long  消息主键
 */

var getMessage = function getMessage(messageId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/message/getMessage?messageId=" + messageId);
};

/**
 * 移动端人员管理 用户列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  string  每页显示条数
 confirmState  是  int  审核状态 (1未认证2认证中3认证通过 4认证驳回 -1:认证中,认证通过)
 moblie  是  string  手机号码
 companyId  是  Long  公司id
 userName  是  string  用户名
 */

var mhUserList = function mhUserList(pageIndex, pageSize, confirmState, moblie, userName) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/user/mhUserList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&confirmState=" + confirmState + "&moblie=" + moblie + "&userName=" + userName);
};

/**
 * 移动端人员管理 用户新增接口
 * json
 参数名  必选  类型  说明
 userMobile  是  string  用户手机号码
 userName  是  string  用户姓名
 userPostionState  是  int  公司职务状态 1企业员工2企业管理员
 */

var addMhUser = function addMhUser(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/user/addMhUser", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 移动端人员管理 用户审批通过接口
 请求URL：

 http://192.168.0.164:8080/company/user/passMhUser
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 userId  是  Long  用户id
 userPostionState  是  int  用户职务状态 0未填写1企业员工2企业管理员3园区工作人员 4园区管理员
 userMobile 是 用户手机号
 userName   是 用户名
 */

var passMhUser = function passMhUser(userId, userPostionState, userMobile, userName, userNumber) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/user/passMhUser?userId=" + userId + "&userPostionState=" + userPostionState + "&userMobile=" + userMobile + "&userName=" + userName + "&userNumber=" + userNumber);
};

/*
移动端人员管理 已通过用户删除接口
company/user/rebackUser?userId=1
*/

var deleteUser = function deleteUser(userId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/user/rebackUser?userId=" + userId);
};

/**
 * 移动端人员管理 用户审批不通过接口
 请求URL：

 http://xx.com/company/user/noPassMhUser
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 userId  是  Long  用户id
 */

var noPassMhUser = function noPassMhUser(userId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/user/noPassMhUser?userId=" + userId);
};

/**
 * 角色权限管理 角色列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  string  每页显示条数
 mhRoleId  否  Long  角色id
 */

var mhRoleList = function mhRoleList(pageIndex, pageSize, mhRoleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhRole/mhRoleList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&mhRoleId=" + mhRoleId);
};

/**
 * 角色权限管理 获取权限树接口
 */

var getPermissions = function getPermissions() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhPermission/getPermissions");
};

/**
 * 角色权限管理 新建角色接口
 参数名  必选  类型  说明
 mhRoleName  是  string  角色名
 mhRoleDescription  是  string  角色描述
 mhRoleCompanyId  是  Long  公司id
 mhRoleChannelId  是  Long  渠道id
 tpermissions  是  list  权限列表
 mhRoleAdminId  是  Long  当前管理员id
 */

var addMhRole = function addMhRole(mhRoleName, mhRoleDescription, tpermissions) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhRole/addMhRole", "mhRoleName=" + mhRoleName + "&mhRoleDescription=" + mhRoleDescription + "&tpermissions=" + tpermissions);
};

/**
 * 角色权限管理 角色删除接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 */

var deleteMhRole = function deleteMhRole(mhRoleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhRole/deleteMhRole?mhRoleId=" + mhRoleId);
};

/**
 * 角色权限管理 角色更新接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 mhRoleName  是  string  角色名
 mhRoleDescription  是  string  角色描述
 mhRoleCompanyId  是  Long  公司id
 mhRoleChannelId  是  Long  渠道id
 tpermissions  是  list  权限列表
 mhRoleAdminId  是  Long  当前管理员id
 */

var updateMhRole = function updateMhRole(mhRoleId, mhRoleName, mhRoleDescription, tpermissions) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhRole/updateMhRole", "mhRoleId=" + mhRoleId + "&mhRoleName=" + mhRoleName + "&mhRoleDescription=" + mhRoleDescription + "&tpermissions=" + tpermissions);
};

/**
 * 角色权限管理 角色详情接口
 参数名  必选  类型  说明
 mhRoleId  是  Long  角色id
 */

var findMhRole = function findMhRole(mhRoleId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhRole/findMhRole?mhRoleId=" + mhRoleId);
};

/**
 * 系统管理 系统管理员列表接口
 参数名  必选  类型  说明
 pageIndex  是  string  页码
 pageSize  是  string  每页显示条数
 moblie  否  string  手机号码
 name  否  string  名称
 mhManagerId  是  Long  管理员主键
 */

var mhManagerList = function mhManagerList(pageIndex, pageSize, moblie, name) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/mhManagerList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&moblie=" + moblie + "&name=" + name);
};

/**
 * 系统管理 新增管理员接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/addMhManager
 请求方式：

 JSON形式传递
 参数：

 参数名  必选  类型  说明
 mhManagerName  是  string  用户名
 password       是 string 密码
 mhManagerMobile  是  string  手机号码
 mhManagerAccount  否  string  账号
 mhRoleIds  是  List  角色
 */

var addMhManager = function addMhManager(mhManagerName, password, mhManagerMobile, mhManagerAccount, mhRoleIds) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/addMhManager", "mhManagerName=" + mhManagerName + "&password=" + password + "&mhManagerMobile=" + mhManagerMobile + "&mhManagerAccount=" + mhManagerAccount + "&mhRoleIds=" + mhRoleIds);
};

/**
 * 系统管理 管理员更新接口

 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员主键
 mhManagerName  是  string  管理员名称
 mhManagerMobile  否  string  手机号码
 mhManagerAccount  是  string  账号
 mhRoleIds  是  list  角色id列表
 mhManagerChannelId  是  Long  渠道id
 mhManagerCompanyId  是  Long  公司id
 mhManagerCreateId  是  Long  当前管理员id
 */
var updateMhManager = function updateMhManager(mhManagerId, mhManagerName, mhManagerMobile, mhManagerAccount, mhRoleIds) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/updateMhManager", "mhManagerId=" + mhManagerId + "&mhManagerName=" + mhManagerName + "&mhManagerMobile=" + mhManagerMobile + "&mhManagerAccount=" + mhManagerAccount + "&mhRoleIds=" + mhRoleIds);
};

/**
 * 系统管理 删除管理员接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

var deleteMhManager = function deleteMhManager(mhManagerId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/deleteMhManager?mhManagerId=" + mhManagerId);
};

/**
 * 系统管理 管理员重置密码接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/reSetPassword
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

var reSetPassword = function reSetPassword(mhManagerId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/reSetPassword?mhManagerId=" + mhManagerId);
};

/**
 * 系统管理 管理员详情接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 */

var getManagerInfo = function getManagerInfo(mhManagerId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/getManagerInfo?mhManagerId=" + mhManagerId);
};

/**
 * 系统管理 管理员修改密码接口
 参数名  必选  类型  说明
 mhManagerId  是  Long  管理员id
 currPassword  是  string  当前密码
 newPassword  是  string  新密码
 */

var managerChangePassword = function managerChangePassword(mhManagerId, currPassword, newPassword) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/changePassword", "mhManagerId=" + mhManagerId + "&currPassword=" + currPassword + "&newPassword=" + newPassword);
};

/**
 * 系统管理 下拉框选项获取角色列表
 */

var selectRoleList = function selectRoleList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhRole/getAllMhRole");
};

/**
 * 系统管理 发送验证码接口
 参数名  必选  类型  说明
 phone  是  string  管理员手机号
 codeState  是  int  传递0
 mhManagerId  是  long  当前管理员id
 */

var managerSendCode = function managerSendCode(phone, codeState, mhManagerId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/sendCode?phone=" + phone + "&codeState=" + codeState + "&mhManagerId=" + mhManagerId);
};

/**
 * 系统管理 管理员修改手机号接口
 请求URL：

 http://192.168.0.164:8080/company/mhManager/changeMoblie
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 mobile  是  string  手机号
 code  是  string  验证码
 mhManagerId  是  Long  当前管理员id
 */

var managerChangeMoblie = function managerChangeMoblie(mobile, code, mhManagerId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/changeMoblie", "mobile=" + mobile + "&code=" + code + "&mhManagerId=" + mhManagerId);
};

/**
 * 系统管理 根据管理员id列表返回对应的管理员详情接口
 请求URL：

 http://192.168.0.164:8080/manager/mhManager/getManagerByIds
 请求方式：

 POST
 参数：

 参数名  必选  类型  说明
 ids  是  list  管理员id列表
 */

var getManagerByIds = function getManagerByIds(ids) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/manager/mhManager/getManagerByIds", "ids=" + ids);
};

/**
 * 系统管理 统计提醒消息未读数
 */

var remindsCount = function remindsCount() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/contractRemind/remindsCount");
};

/** 获取服务对接列表接口
 参数名  必选  类型  说明
 pageIndex  是  Integer  当前页数
 pageSize  是  Integer  显示条数
 serveType  是  String  服务类别
 */
var serveList = function serveList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/serve/list", { params: params });
};

/**
 * 服务详情接口
 参数名  必选  类型  说明
 serveId  是  long  服务主键
 */
var serveDetail = function serveDetail(serveId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/serve/serveDetail", { params: { serveId: serveId } });
};

/**
 *  问题反馈列表接口
 参数名  必选  类型  说明
 pageIndex  是  int  页码
 pageSize  是  int  显示条数
 type  否  int  类型 1 水电维修 2 卫生保洁 3 设施维修 4 绿化保养 5 其他
 state  否  int  状态（1未处理，2已处理）
 */
var feedbackList = function feedbackList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/feedback/findCompanyFeedbackByCondition", { params: params });
};

/**
 *  问题反馈新增接口
 参数名  必选  类型  说明
 feedType  是  int  类型 1 水电维修 2 卫生保洁 3 设施维修 4 绿化保养 5 其他
 feedTitle  是  string  问题标题
 feedContent  是  string  反馈内容
 backFiles  否  List  文件路径列表,如1.jpg(请求上传接口获取地址)
 */
var addFeedback = function addFeedback(feedType, feedTitle, feedContent, backFiles) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/feedback/addFeedback", "feedType=" + feedType + "&feedTitle=" + feedTitle + "&feedContent=" + feedContent + "&backFiles=" + backFiles);
};

/**
 *  问题反馈新增接口
 参数名  必选  类型  说明
 feedId  是  long  问题反馈主键
 */
var feedbackDetail = function feedbackDetail(feedId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/feedback/feedbackDetail", { params: { feedId: feedId } });
};

/**
 *  问题反馈删除接口
 参数名  必选  类型  说明
 feedId  是  long  问题反馈主键
 */
var feedbackDelete = function feedbackDelete(feedId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/feedback/deleteFeedback", "feedId=" + feedId);
};

var changeManagerPassword = function changeManagerPassword(currPassword, newPassword) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/changePassword", "currPassword=" + currPassword + "&newPassword=" + newPassword);
};

/*
访客详情
用户注册接口
visitorId	是	long	访客ID
http://192.168.0.135:7777/company/visitor/getVisitor
*/
var getVisitor = function getVisitor(visitorId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/visitor/getVisitor?visitorId=" + visitorId);
};

/*
访客管理列表
参数名	必选	类型	说明
pageIndex	是	Integer	页码
pageSize	是	Integer	页面
visitorName	否	String	来访联系人
visitorVisitType	否	Integer	拜访备注0全部;1面试;2商业洽谈;3参观学习;4企业拜访;5领导来访;6其他
visitorState	否	Integer	状态 0全部;1未过期;2已过期
*/
var visitorList = function visitorList(pageIndex, pageSize, visitorName, visitorVisitType, visitorState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/visitor/visitorList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&visitorName=" + visitorName + "&visitorVisitType=" + visitorVisitType + "&visitorState=" + visitorState);
};
/*
导出访客管理列表
参数名	必选	类型	说明
visitorName	否	String	来访联系人
visitorVisitType	否	Integer	拜访备注0全部;1面试;2商业洽谈;3参观学习;4企业拜访;5领导来访;6其他
visitorState	否	Integer	状态 0全部;1未过期;2已过期
*/
var exportVisitorList = function exportVisitorList(visitorName, visitorVisitType, visitorState) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/visitor/exportVisitorList?visitorName=" + visitorName + "&visitorVisitType=" + visitorVisitType + "&visitorState=" + visitorState);
};

/**
 * 快捷入口列表
 */
var findEntranceByChannel = function findEntranceByChannel() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/entrance/findEntranceByChannel');
};

//人脸

/**
 * 人脸列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * personNumber	否	Integer	员工账号
 * endTime	否	Date	录入结束时间
 * startTime	否	Date	录入开始时间
 */
var faceList = function faceList(pageIndex, pageSize, personNumber, startTime, endTime) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/faceList?pageIndex=" + pageIndex + "&pageSize=" + pageSize + "&personNumber=" + personNumber + "&startTime=" + startTime + "&endTime=" + endTime);
};

/**
 * 获取企业不分页员工列表接口
 * moblie	否	string	手机号
 * userName	否	string	用户名
 */
var passMhUserList = function passMhUserList(moblie, userName) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/passMhUserList?moblie=" + moblie + "&userName=" + userName);
};

/**
 * 人脸新增接口
 */
var companyAddFace = function companyAddFace(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/userFace/companyAddFace", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

/**
 * 查看人脸详情接口
 * faceId	是	Long	人脸主键id
 */
var detailFace = function detailFace(faceId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/detailFace?faceId=" + faceId);
};

/**
 * 人脸修改记录接口
 * faceId	是	Long	人脸主键id
 */
var faceRecordList = function faceRecordList(faceId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/faceRecordList?faceId=" + faceId);
};

/**
 * 批量删除人脸接口
 * personIds 是 [] 人脸主键id数组
 */
var delPerson = function delPerson(personIds) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/userFace/delPerson", "personIds=" + personIds);
};

/**
 * 通行记录
 * companyId 是 Long 企业id
 * type 否 Long 人员类型(1/企业员工 2/园区员工 3/访客)
 * nameOrNumber 否 String 人员姓名或账号
 * buildId 否 Long 楼宇id
 * time 否 String 筛选时间年月日 yyyy-MM-dd
 * pageIndex 否 int 当前页
 * pageSize 否 int 每页数据量
 */
// let getPersonPassList = (pageIndex,pageSize,nameOrNumber,time,companyId,type,buildId) => axios.get(`company/userFace/getPersonPassList?pageIndex=${pageIndex}&pageSize=${pageSize}&companyId=${companyId}&type=${type}&nameOrNumber=${nameOrNumber}&buildId=${buildId}&time=${time}`);
var getPersonPassList = function getPersonPassList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/getPersonPassList", { params: params });
};

/**
 * 获取sso信息接口
 * url	是	string	当前服务域名
 */
var systemOssByUrl = function systemOssByUrl(url) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/userFace/systemOssByUrl?url=" + url, "");
};

var updateMhUserRole = function updateMhUserRole(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/user/updateMhUserRole", stringJoin(data, 2));
};

/**
 * 确认通知接口
 */
var readConfirm = function readConfirm(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/notify/readConfirm", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { "Content-Type": "application/json" } });
};

// 疫情

/**
 * 公司名称列表接口
 */
// let getCompanyNameList = () => axios.get('garden/orderDepartment/getCompanyNameList');

/**
 * 企业端列表
 参数名	必选	类型	说明
name	否	string	用户名
time	否	Date	登记时间
reworkTime	否	Date	反园时间
pageIndex	否	int	当前页数
pageSize	否	int	每页数量
 */
var erList = function erList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/er/list', { params: data });
};

/**
 * 企业端详情
 参数名	必选	类型	说明
id	是	Long	主键id
 */
var vrDetail = function vrDetail(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/er/detail?id=' + id);
};

/**
 * 园区端删除防疫登记
 * 参数名	必选	类型	说明
vrId	是	int	主键ID
 */
var deleteVR = function deleteVR(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/er/delete', { params: data });
};

/**
 * 园区端新增防疫登记
 */
var addEpidemicRegister = function addEpidemicRegister(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/er/addEpidemicRegister', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 企业端-历史登记企业复工记录列表
 参数名	必选	类型	说明

 */
var logList = function logList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/VrCompany/logList');
};

/**
 * 判断是否已经隔离登记
 参数名	必选	类型	说明
baseInfoId	是	int	基本信息主键ID
 */
var isIsolationRegister = function isIsolationRegister(baseId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/vr/isRegister?baseInfoId=' + baseId);
};

/**
 * 根据ID得到详情
 参数名	必选	类型	说明
id	是	int	隔离登记主键ID
 */
var getQuarantine = function getQuarantine(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/vr/getQuarantine?id=' + id);
};

/**
 * 新增隔离登记
 */
// let addQuarantin = (data) => axios.post('company/vr/addQuarantine', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

var addQuarantine = function addQuarantine(quarantineWay, quarantineStartTime, quarantineDays, quarantinePerson, quarantineDescription, quarantineBaseId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/vr/addQuarantine', "quarantineWay=" + quarantineWay + "&quarantineStartTime=" + quarantineStartTime + "&quarantineDays=" + quarantineDays + "&quarantinePerson=" + quarantinePerson + "&quarantineDescription=" + quarantineDescription + "&quarantineBaseId=" + quarantineBaseId);
};

/**
 * 新增隔离登记
 */
// let updateQuarantine = (data) => axios.post('company/vr/updateQuarantine', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });
var updateQuarantine = function updateQuarantine(quarantineId, quarantineWay, quarantineStartTime, quarantineDays, quarantinePerson, quarantineDescription, quarantineBaseId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/vr/updateQuarantine', "quarantineId=" + quarantineId + "&quarantineWay=" + quarantineWay + "&quarantineStartTime=" + quarantineStartTime + "&quarantineDays=" + quarantineDays + "&quarantinePerson=" + quarantinePerson + "&quarantineDescription=" + quarantineDescription + "&quarantineBaseId=" + quarantineBaseId);
};

/**
 * 解除隔离登记
 参数名	必选	类型	说明
id	是	Long	主键id
 */
var deleteQuarantine = function deleteQuarantine(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/vr/deleteQuarantine?id=' + id);
};

/**
 * 企业登记审核列表
 参数名	必选	类型	说明
pageIndex	否	int	pageIndex
pageSize	否	int	pageSize
name	否	string	姓名
 */
var erAuditList = function erAuditList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/erAudit/list', { params: data });
};

/**
 * 评审接口
 参数名	必选	类型	说明

 */
var erAuditApproval = function erAuditApproval(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/erAudit/approval', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 批量列表接口
 参数名	必选	类型	说明

 */
var batchList = function batchList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/erAudit/batchList');
};

/**
 * 获取二维码图像
参数名	必选	类型	说明
healthCodeContent	是	string	二维码内容
width	是	int	二维码宽度
height	是	int	二维码高度
type	是	int	二维码颜色 1绿 2红 （对应healthCodeType）
 */
// let getImage = (healthCodeContent,width,height,type) => axios.get('company/viral/getImage', {
//   params: {
//     healthCodeContent: healthCodeContent,
//     width: width,
//     height: height,
//     type: type,
//   }
// });


/**
 * 企业端-历史登记企业复工记录列表
 参数名	必选	类型	说明

 */
var insert = function insert(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/VrCompany/insert', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

var detail = function detail(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/VrCompany/detail', { params: { id: id } });
};

/**
 *是否已上报
 参数名	必选	类型	说明

 */

var reportState = function reportState() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/policyDemand/reportState');
};

/**
 *新增接口
 参数名	必选	类型	说明

 */

var add = function add(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/policyDemand/add', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *详情接口
 参数名	必选	类型	说明

 */

var policyDetail = function policyDetail() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/policyDemand/detail');
};

/**
 *企业人员登记列表口
 参数名	必选	类型	说明
name	是	string	名称
pageIndex	是	int	页码
pageSize	否	int	行数
 */

var viralInfoPersonList = function viralInfoPersonList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/viralInfoPerson/list', { params: data });
};

/**
 *企业人员登记-移除接口
 参数名	必选	类型	说明
cvipId	是	int	主键id
 */

var viralInfoPersonDel = function viralInfoPersonDel(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/viralInfoPerson/del?cvipId=" + id);
};

/**
 *添加企业复工
 参数名	必选	类型	说明

 */

var addReturnWorkApplication = function addReturnWorkApplication(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/returnWork/addReturnWorkApplication', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *添加企业复工
 参数名	必选	类型	说明

 */

var editReturnWorkApplication = function editReturnWorkApplication(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('company/returnWork/editReturnWorkApplication', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 *跳转企业复工人员登记页面
 参数名	必选	类型	说明
cvipId	是	int	主键id
 */

var viralInfoPersonToAdd = function viralInfoPersonToAdd(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/viralInfoPerson/toAdd");
};
/**
 *企业复工详情
 参数名	必选	类型	说明

 */

var getReturnWorkApplication = function getReturnWorkApplication(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/returnWork/getReturnWorkApplication');
};

/**
 *企业人员登记-新增登记接口
 参数名	必选	类型	说明
baseIds	是	【】	人员id数组 （例：baseIds=2,62）
 */
var viralInfoPersonAdd = function viralInfoPersonAdd(id) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/viralInfoPerson/add?baseIds=" + id);
};

/**
 *企业人员登记-新增登记接口
 参数名	必选	类型	说明
baseIds	是	【】	人员id数组 （例：baseIds=2,62）
 */
var toAdd = function toAdd() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/VrCompany/toAdd");
};

/**
 *行业分类列表
 参数名	必选	类型	说明

 */

var tradeList = function tradeList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/returnWork/tradeList');
};

/**
 *模板列表
 参数名	必选	类型	说明

 */

var templateList = function templateList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/returnWork/templateList');
};

/**
 * 获取oss配置信息
 *
 */
var getSystemOssByUrl = function getSystemOssByUrl() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_env__["a" /* mainUrl */] + "back/systemOss/systemOssByUrl?url=" + __WEBPACK_IMPORTED_MODULE_4__config_env__["b" /* ossUrl */]);
};

/**
 *获取文件类型下拉列表接口
 参数名	必选	类型	说明

 */

var getFileTypeList = function getFileTypeList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/fileManage/getFileTypeList');
};

/**
 *文件管理展示列表接口
 参数名	必选	类型	说明

 */

var getFileManageList = function getFileManageList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/fileManage/getFileManageList', { params: data });
};

/**
 *文件管理展示列表接口
 参数名	必选	类型	说明

 */

var getFileDetail = function getFileDetail(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/fileManage/getFileDetail', { params: data });
};

/**
 *获取类型

 */

var getFeedbackTypes = function getFeedbackTypes(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('company/feedback/getFeedbackTypes', { params: data });
};

/**
 * 人员考勤记录列表接口
 */
var getAttendanceRecordList = function getAttendanceRecordList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get((sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : '') + "property/employeeAttendance/getAttendanceRecordList", { params: params });
};

/**
 * 获取企业列表接口

 */
var passRecordCompanyList = function passRecordCompanyList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get((sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : '') + "property/passRecord/companyList");
};

/**
 * 获取考勤设备列表接口

 */
var attedanceEquipmentDownList = function attedanceEquipmentDownList() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get((sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : '') + "property/employeeAttendance/attedanceEquipmentDownList");
};

/**
 * 查看考勤设置接口

 */
var getAttendanceSetting = function getAttendanceSetting() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get((sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : '') + "property/employeeAttendance/getAttendanceSetting");
};

/**
 * 修改考勤设置接口

 */
var updateAttendanceSetting = function updateAttendanceSetting(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post((sessionStorage.getItem('channelMortarBackUrl') ? sessionStorage.getItem('channelMortarBackUrl') : '') + "property/employeeAttendance/updateAttendanceSetting", params, { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 企业门户用户导入
 * 参数名	必选	类型	说明
file	是	file	文件
 */

var importUser = function importUser(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/user/importUser", data);
};

/**
pageIndex	是	int
pageSize	是	int
name	否	string	企业名称
twoId	否	int	二级区域id
oneId	否	int	一级区域id
status	否	long	1未响应2未评分3已完成
order	否	long	1 自评降序 2自评升序 3终评升序 4终评降序
 */

var getList = function getList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/assessmentCompany/getList", { params: data });
};

/**
评分
 */

var assessmentscore = function assessmentscore(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/assessmentCompany/score", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
企业考核评分详情
assessmentCompanyId	是	long	企业考核详情
 */

var assessmentdetail = function assessmentdetail(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/assessmentCompany/detail", { params: data });
};

/**
 *
企业考核字段附件列表

 */

var assessmentFileList = function assessmentFileList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/assessmentCompany/fileList", { params: data });
};

/**
 * 获取redis随机key值接口
 */
var getRandomKey = function getRandomKey(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(sessionStorage.getItem('channelMortarBackUrl') + "mortar/face/getRandomKey");
};

/**
 * 查询上传人脸进度（轮训接口）
 */
var queryFaceProgress = function queryFaceProgress(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(sessionStorage.getItem('channelMortarBackUrl') + "mortar/face/queryFaceProgress", { params: params });
};

/**
 * 获取房源列表
 */
var getHouseRes = function getHouseRes(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/getHouseRes", { params: params });
};

/**
 * 场地信息详情
 */
var houseResAreaDetail = function houseResAreaDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/houseResAreaDetail", { params: params });
};

/**
 * 合同列表
 */
var contractList = function contractList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/contractList", { params: params });
};

/**
 * 合同详情
 */
var contractDetail = function contractDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/contractDetail", { params: params });
};

/**
 * 账单列表
 */
var billList = function billList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/billList", { params: params });
};

/**
 * 查看电子合同
 */
var fileTemplate = function fileTemplate(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/mhHouseRes/fileTemplate", { params: params });
};

/**
 * 票据申请记录列表
 */
var noteGetList = function noteGetList(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/note/getList", { params: params });
};

/*
审批
参数名	必选	类型	说明
*/
var noteAddNote = function noteAddNote(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/note/addNote", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 确认票据申请
 */
var noteSure = function noteSure(noteId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/note/sure?noteId=" + noteId);
};

/**
 * 撤回申请
 */
var noteDelNote = function noteDelNote(noteId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("company/note/delNote?noteId=" + noteId);
};

/**
 * 新增票据申请时所需企业信息
 */
var noteCompanyDetail = function noteCompanyDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/note/companyDetail", { params: params });
};

/**
查看票据申请详情
 */
var noteNoteDetail = function noteNoteDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("company/note/noteDetail", { params: params });
};

/**
判断当前用户是否具有新增票据申请的权限
 */
var noteIsCanAdd = function noteIsCanAdd(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/note/isCanAdd", { params: data });
};

/**
用户所属企业下拉接口
 */
var userCompanyList = function userCompanyList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/userCompanyList", { params: data });
};

/*
切换企业
参数名	必选	类型	说明
*/
var chooseCompany = function chooseCompany(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/mhManager/chooseCompany", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
企业门户获取合同列表
 */
var getContracts = function getContracts(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhHouseRes/getContracts", { params: data });
};

/**
企业门户获取账单列表
 */
var getBills = function getBills(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhHouseRes/getBills", { params: data });
};

/**
车位租赁申请列表
 */
var getVehicleApproveList = function getVehicleApproveList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/parkSpaceApplication/getVehicleApproveList", { params: data });
};

/**
车位租赁申请列表
 */
var getVehicleDetail = function getVehicleDetail(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/parkSpaceApplication/getVehicleDetail", { params: data });
};
/*
新增编辑余额提醒详情
参数名	必选	类型	说明
*/
var addBalanceWallet = function addBalanceWallet(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/balanceDetail/addBalanceWallet", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
水电余额提醒详情
 */
var getBalanceWallet = function getBalanceWallet(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/balanceDetail/getBalanceWallet", { params: data });
};

/*
新增编辑水电余额提醒联系人
参数名	必选	类型	说明
*/
var addWalletContact = function addWalletContact(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/balanceDetail/addWalletContact", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
水电余额提醒联系人详情
 */
var getWalletContact = function getWalletContact(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/balanceDetail/getWalletContact", { params: data });
};

/**
水电余额提醒联系人列表
 */
var getContactList = function getContactList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/balanceDetail/getContactList", { params: data });
};

/**
删除水电余额提醒联系人
 */
var delWalletContact = function delWalletContact(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/balanceDetail/delWalletContact", { params: data });
};

/*
新增车位申请
*/
var addVehicleApprove = function addVehicleApprove(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/company/parkSpaceApplication/addVehicleApprove', stringJoin(data, 2));
};

/*
删除车位申请
*/
var delVehicleApprove = function delVehicleApprove(vaId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/parkSpaceApplication/delVehicleApprove?vaId=" + vaId);
};

/**
获取渠道下所有车场下拉列表
 */
var getAllCarParkGroupList = function getAllCarParkGroupList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/parkSpaceApplication/getAllCarParkGroupList", { params: data });
};

/**
获取车主下拉列表
 */
var getAllCarOwnerList = function getAllCarOwnerList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/parkSpaceApplication/getAllCarOwnerList", { params: data });
};

/*
新增车位申请
*/
var editVehicleApprove = function editVehicleApprove(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/company/parkSpaceApplication/editVehicleApprove', stringJoin(data, 2));
};

/*
删除车位申请
*/
var workflowApplicationSure = function workflowApplicationSure(workflowApplicationId) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/company/workflowApplication/sure?workflowApplicationId=" + workflowApplicationId);
};

/**
 * 操作记录
 */
var operationRecord = function operationRecord(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/company/safe/recordLog', { params: data });
};

/**
 * 企业档案信息列表
 */
var companyInfoList = function companyInfoList(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/company/safe/mhList', { params: data });
};

/**
 * 
 */
var defaultField = function defaultField() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/company/safe/defaultField');
};

/**
 * 获取工商信息
 */
var getCompanyBusiness = function getCompanyBusiness(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/company/safe/matching', { params: data });
};

/**
 * 更新企业档案
 */
var updateCompany = function updateCompany(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/company/safe/update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), { headers: { 'Content-Type': 'application/json' } });
};

/**
 * 获取工商信息
 */
var companyInfo = function companyInfo(data) {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/company/safe/info', { params: data });
};

/**
 * 获取图形验证码
 */
var mhManagergCaptcha = function mhManagergCaptcha() {
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/company/mhManager/gCaptcha");
};



/***/ }),

/***/ "iB7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_electronic_contract_vue__ = __webpack_require__("XzEk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_52aa166c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_electronic_contract_vue__ = __webpack_require__("W+tM");
function injectStyle (ssrContext) {
  __webpack_require__("oQ02")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52aa166c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_electronic_contract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_52aa166c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_electronic_contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iC9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_add_remind_staff_vue__ = __webpack_require__("25Ue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_086f299a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_add_remind_staff_vue__ = __webpack_require__("sxsC");
function injectStyle (ssrContext) {
  __webpack_require__("3gFr")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-086f299a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_add_remind_staff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_086f299a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_add_remind_staff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iLE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('el-popover',{attrs:{"placement":"bottom","width":"300","trigger":"manual"},model:{value:(_vm.provinceVisible),callback:function ($$v) {_vm.provinceVisible=$$v},expression:"provinceVisible"}},[_c('ul',{staticClass:"province"},_vm._l((_vm.provinceList),function(item,index){return _c('li',{key:index,staticClass:"province-item",class:{active:_vm.info.province === item.value},on:{"click":function($event){$event.stopPropagation();return _vm.selectProvince(item,index)}}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"reference"},slot:"reference"},[_c('el-input',{attrs:{"placeholder":"省","disabled":_vm.disabled,"maxLength":"1"},on:{"focus":_vm.provinceFocus,"input":_vm.provinceInput,"blur":_vm.provinceBlur},model:{value:(_vm.info.province),callback:function ($$v) {_vm.$set(_vm.info, "province", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.province"}})],1)])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":4}},[_c('el-popover',{attrs:{"placement":"bottom","width":"300","trigger":"manual"},model:{value:(_vm.letterVisible),callback:function ($$v) {_vm.letterVisible=$$v},expression:"letterVisible"}},[_c('ul',{staticClass:"province"},_vm._l((_vm.letterList),function(item,index){return _c('li',{key:index,staticClass:"province-item",class:{active:_vm.info.letter === item.value},on:{"click":function($event){$event.stopPropagation();return _vm.selectLetter(item,index)}}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])}),0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"reference"},slot:"reference"},[_c('el-input',{staticClass:"click_input",attrs:{"placeholder":"字母","disabled":_vm.disabled,"maxLength":"1"},on:{"focus":_vm.letterFocus,"input":_vm.letterInput,"blur":_vm.letterBlur},model:{value:(_vm.info.letter),callback:function ($$v) {_vm.$set(_vm.info, "letter", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.letter"}})],1)])],1),_vm._v(" "),_c('el-col',{staticStyle:{"margin-left":"10px"},attrs:{"span":14}},[_c('el-input',{attrs:{"placeholder":"请输入5/6位车牌号","disabled":_vm.disabled,"maxLength":"6"},on:{"blur":_vm.getCardNumber,"input":_vm.getCardNumber},model:{value:(_vm.info.licensePlateNumber),callback:function ($$v) {_vm.$set(_vm.info, "licensePlateNumber", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.licensePlateNumber"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iXIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-box",staticStyle:{"flex-wrap":"wrap"},attrs:{"id":"file-box"}},[_vm._l((_vm.fileList),function(item,index){return _c('div',{key:index,staticClass:"text-center contract-upload-file"},[(!_vm.img)?_c('div',[_c('div',{staticClass:"position-relative"},[(item.imgUrl)?_c('img',{staticClass:"file-img",staticStyle:{"cursor":"pointer"},attrs:{"src":item.imgUrl,"alt":"图片不见了"},on:{"click":function($event){return _vm.lookBigImg(item)}}}):(!item.imgUrl&&item.type==='video')?_c('img',{staticClass:"file-img",staticStyle:{"cursor":"pointer"},attrs:{"src":__webpack_require__("jv0K"),"alt":"图片不见了"},on:{"click":function($event){return _vm.lookFile(item)}}}):_vm._e(),_vm._v(" "),(!item.imgUrl&&item.type!=='video')?_c('img',{staticClass:"file-img",attrs:{"src":__webpack_require__("c0HD"),"alt":"图片不见了"}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"position el-icon-error",staticStyle:{"right":"6px","top":"-6px","cursor":"pointer"},on:{"click":function($event){return _vm.del(_vm.fileList,index,1)}}})]),_vm._v(" "),_c('p',{staticClass:"ellipsis",attrs:{"title":item.fileName}},[_vm._v(_vm._s(item.fileName))])]):_c('div',{staticClass:"position-relative"},[(item.imgUrl)?_c('img',{staticClass:"img-type",attrs:{"src":item.imgUrl,"alt":"图片不见了"},on:{"click":function($event){return _vm.lookBigImg(item)}}}):_vm._e(),_vm._v(" "),(!item.imgUrl)?_c('img',{staticClass:"img-type",attrs:{"src":__webpack_require__("D9Wk"),"alt":"图片不见了"}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"position el-icon-error",staticStyle:{"right":"-6px","top":"-8px","cursor":"pointer","color":"red"},on:{"click":function($event){return _vm.del(_vm.fileList,index,1)}}})])])}),_vm._v(" "),_c('div',{staticClass:"el-upload-file"},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.checkOss}})]),_vm._v(" "),_c('el-dialog',{staticClass:"file-big-img append-body",attrs:{"title":"查看大图","visible":_vm.lookBigImgDialog,"top":"5%","append-to-body":true,"center":"","width":"900px"},on:{"update:visible":function($event){_vm.lookBigImgDialog=$event}}},[_c('div',{staticClass:"dialog-warp text-center"},[_c('img',{staticClass:"big-img",attrs:{"src":_vm.imgUrl,"alt":"图片不见了"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8Tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_card_number_vue__ = __webpack_require__("rngL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_151c58a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_card_number_vue__ = __webpack_require__("iLE1");
function injectStyle (ssrContext) {
  __webpack_require__("xvNd")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-151c58a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_card_number_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_151c58a3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_card_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j8X4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        feedTitle: '',
        feedContent: '',
        feedType: '',
        backFiles: []
      },
      problemInfo: {
        handleBack: ''
      },
      rule: {
        feedTitle: [{ required: true, message: '请输入反馈标题', trigger: ['blur', 'change'] }, { max: 20, message: '反馈标题不能超过20个字符', trigger: ['blur', 'change'] }],
        feedType: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
        feedContent: [{ required: true, message: '请输入反馈内容', trigger: ['blur', 'change'] }, { max: 200, message: '反馈内容不能超过200个字符', trigger: ['blur', 'change'] }]
      },
      fileList: [],
      imgUrl: '',
      lookBigImgDialog: false,
      submitLoading: false,
      imgArr: [],
      feedbackTypeList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
    this.getFeedbackTypes();
  },

  props: ['type', 'id'],
  computed: {},
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      }
      this.$emit('closeDialog');
    },
    onFileChange: function onFileChange(obj) {
      this.fileList = obj.fileList ? obj.fileList : [];
    },
    getFeedbackTypes: function getFeedbackTypes() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_14" /* getFeedbackTypes */]().then(function (res) {
        if (res.data.code != 'success') {
          _this.$message({
            type: 'error',
            message: res.data.message || res.data.Msg
          });
          return;
        }
        _this.feedbackTypeList = res.data.data.feedbackTypes;
      }).catch(function (_) {
        _this.resourceListLoading = false;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs['info'].validate(function (valid) {
        if (valid) {
          _this2.fileList.forEach(function (item, index) {
            _this2.info.backFiles.push(item.imgUrl);
          });
          __WEBPACK_IMPORTED_MODULE_0__service_getData__["d" /* addFeedback */](_this2.info.feedType, _this2.info.feedTitle, _this2.info.feedContent, _this2.info.backFiles).then(function (res) {
            if (res.data.code === 1) {
              _this2.$message.success('提交成功！');
              _this2.submitLoading = false;
              _this2.info.feedContent = '';
              _this2.info.feedTitle = '';
              _this2.info.feedType = [];
              _this2.info.fileList = [];
              _this2.close(1);
            } else {
              _this2.$message.error(res.data.message);
            }
          }).catch(function (_) {
            _this2.submitLoading = false;
            _this2.$message.warning('新增失败！');
          });
        } else {
          _this2.$message({
            type: 'warning',
            message: '请认真检查一下！'
          });
        }
      });
    },
    init: function init() {}
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "jEQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f7497756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__("pElk");
function injectStyle (ssrContext) {
  __webpack_require__("nHU2")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7497756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f7497756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jKFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isEdit', 'companyId'],
  data: function data() {
    return {
      filters: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        companyId: 0
      },
      activities: []
    };
  },
  mounted: function mounted() {
    this.filters.companyId = this.companyId;
    this.init();
  },

  methods: {
    close: function close() {
      this.$emit("closeDialog");
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_62" /* operationRecord */](this.filters).then(function (res) {
        if (res.data.code === 1) {
          _this.activities = res.data.data.list;
          _this.filters.total = res.data.data.total;
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filters.pageIndex = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.filters.pageIndex = val;
      this.init();
    }
  }
});

/***/ }),

/***/ "jv0K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/timg.b3aa434.jpg";

/***/ }),

/***/ "kkNK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // basicInfo: {
      //   visitorName: "张三",
      //   phone: 15757101234,
      //   card: 330125196712281867,
      //   facePictures: "",
      //   uploadTime: "2019-04-19  12:12:12",
      //   registerTime: "2019-04-19 12:12:12",
      //   registerType: 1,
      //   VisitingTime: "2019-04-19",
      //   visitPurpose: "参观",
      //   companyName: "园区",
      //   entryExitBuild: "全部",
      //   stairsControlFloor: "全部",
      //   remark: "",
      //   visitorState: ''
      // },
      lookBigImgDialog: false,
      imgUrl: '',
      visitorRecordList: [{}, {}, {}, {}, {}, {}]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['basicInfo'],
  computed: {},
  methods: {
    close: function close() {
      this.$emit("closeDialog");
    },
    init: function init() {
      console.log(this.basicInfo, 77);
    },
    lookBigImg: function lookBigImg() {
      this.imgUrl = this.basicInfo.facePhotoUrl;
      this.lookBigImgDialog = true;
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "l6+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","label-position":"top"}},[_c('h3',{staticClass:"title"},[_vm._v("基础信息：")]),_vm._v(" "),_c('v-bill-order-info',{attrs:{"infoDetail":_vm.info,"noteCreateName":_vm.noteCreateName}}),_vm._v(" "),_c('h3',{staticClass:"title"},[_vm._v("审批流程信息：")]),_vm._v(" "),_c('div',{staticClass:"dialog_form basic_info"},[_c('el-timeline',_vm._l((_vm.activities),function(activity,index){return _c('el-timeline-item',{key:index,attrs:{"icon":activity.icon,"type":activity.type,"color":activity.color,"size":activity.size,"timestamp":activity.timestamp}},[_vm._v("\n          "+_vm._s(activity.content)+"\n          "),(index == 0)?_c('span',{staticStyle:{"color":"#909399","font-size":"13px"}},[_vm._v(_vm._s(activity.state))]):_vm._e(),_vm._v(" "),(activity.noteRecordRemark)?_c('div',{staticStyle:{"color":"#909399","font-size":"13px"}},[_vm._v("审批意见："+_vm._s(activity.noteRecordRemark))]):_vm._e()])}),1)],1),_vm._v(" "),(_vm.info.noteUploadTime)?_c('h3',{staticClass:"title"},[_vm._v("票据信息：")]):_vm._e(),_vm._v(" "),(_vm.info.noteUploadTime)?_c('div',{staticClass:"dialog_form g-basic-info"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("票据上传时间："+_vm._s(_vm._f("datetime")(_vm.info.noteUploadTime)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("票据确认时间："+_vm._s(_vm._f("datetime")(_vm.info.noteSureTime)))])])],1),_vm._v(" "),_c('div',{staticClass:"g-col-line"}),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("备注信息："+_vm._s(_vm._f("empty")(_vm.info.noteRemark)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticStyle:{"display":"flex"},attrs:{"span":24}},[_c('span',{staticStyle:{"line-height":"30px"}},[_vm._v("票据文件：")]),_vm._v(" "),(_vm.info.noteFile)?_c('ul',{staticClass:"fileList"},_vm._l((_vm.info.noteFile),function(file,index){return _c('li',{key:index},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(file.fileName))]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.openFile(file.exportFile)}}},[_vm._v("预览")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.downLoad(file)}}},[_vm._v("下载")])],1)}),0):_c('span',{staticStyle:{"line-height":"30px"}},[_vm._v("暂无文件")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.info.noteUploadTime&&_vm.info.noteState==2)?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.submit}},[_vm._v("我已确认票据无误，确认签收")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lUoY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "mLUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: this.$route.path,
      query: this.$route.query.single,
      netaddress: '',
      isCollapse: false,
      billRemindsCount: 0,
      contractRemindsCount: 0,
      channelId: Number(sessionStorage.getItem('channelId'))
    };
  },

  // props: ['number', 'type', 'size', 'list'],
  created: function created() {},
  mounted: function mounted() {
    this.urlRedirect(this.url);
    this.init();
  },

  computed: {
    getBillRemindsCount: function getBillRemindsCount() {
      return this.billRemindsCount;
    },
    getContractRemindsCount: function getContractRemindsCount() {
      return this.contractRemindsCount;
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_69" /* remindsCount */]().then(function (res) {
        if (res.data.code === 'success') {
          _this.billRemindsCount = res.data.data.billRemindsCount;
          _this.contractRemindsCount = res.data.data.contractRemindsCount;
        }
      });
    },
    shows: function shows(path) {},
    openUrl: function openUrl(path) {
      window.open(path);
    },
    urlRedirect: function urlRedirect(val) {
      var _this2 = this;

      var routerList = this.$router.options.routes;
      routerList.forEach(function (parent) {
        if (parent.children) {
          parent.children.forEach(function (child, childIndex, children) {
            if (child.path === val && child.hidden) {
              _this2.url = child.from;
              _this2.netaddress = children[0].path;
            } else if (child.path === val) {
              _this2.netaddress = child.path;
              _this2.url = child.path;
            }
          });
        }
      });
    }
  },
  components: {},
  watch: {
    '$route': function $route(val) {
      this.urlRedirect(val.path);
      console.log(this.netaddress + ':::' + this.url);
    }
  }
});

/***/ }),

/***/ "mQ6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form"},[_c('div',{staticClass:"g-thing-tit flex-box"},[_c('div',{staticClass:"g-widths"},[_c('h4',{},[_vm._v(_vm._s(_vm.info.fileSendName))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('p',[_vm._v("发起人："+_vm._s(_vm.info.fileSendPublishUnit))]),_vm._v(" "),_c('p',[_vm._v("发起时间："+_vm._s(_vm._f("datetimeType")(_vm.info.fileSendCreateTime,"yyyy-MM-dd hh:mm")))])])]),_vm._v(" "),_c('el-tag',[_vm._v(_vm._s(_vm.info.fileSendTypeName))])],1),_vm._v(" "),_c('p',{staticClass:"g-contp",domProps:{"innerHTML":_vm._s(_vm.info.fileSendContent)}})]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{staticClass:"f-search-btn g-success",attrs:{"size":"small","type":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_vm._v("确认\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n8Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      vrInfo: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ["id"],
  computed: {},
  methods: {
    timeFormat: function timeFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["q" /* toDateTime */](time);
    },
    orginText: function orginText(text) {
      switch (text) {
        case 1:
          return "微信提交";
        case 2:
          return "后台添加";
      }
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["M" /* detail */](this.id).then(function (res) {
        if (res.data.code != "success") {
          _this.$message.error(res.data.message);
          return;
        }
        _this.vrInfo = res.data.data.info;
        _this.vrInfo.cviFileName = _this.vrInfo.cviFileName ? _this.vrInfo.cviFileName.split(",") : [];
        _this.vrInfo.cviFileUrl = _this.vrInfo.cviFileUrl ? _this.vrInfo.cviFileUrl.split(",") : [];
      }).catch(function (_) {
        console.log(_);
      });
    },

    //下载
    downFile: function downFile(FileUrl, FileName) {
      //参数名随意
      window.open("/company/download/downloadWorkflowFileUseName?fileUrl=" + FileUrl + "&fileName=" + FileName);
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "nHU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nieQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o6N2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  props: ['isEdit', 'baseData', 'recordId'],
  components: {},
  data: function data() {
    return {
      tableDataLoading: false,
      tableData: [],
      formList: [],
      specialEquipmentList: [],
      delArr: [],
      isE: false
    };
  },
  mounted: function mounted() {
    // let arr = []
    // this.specialEquipmentList.forEach((item)=>{
    //   arr.push(JSON.parse(item.cdValue))
    // })
    // for(let i=0;i<this.specialEquipmentList.length;)
    this.formList = this.baseData.companyDataListVos;
    this.specialEquipmentList = this.baseData.companyDataTableListVos;

    var arr = [];
    for (var i = 0; i < this.specialEquipmentList.length; i++) {
      arr.push(JSON.parse(this.specialEquipmentList[i].cdValue));
    }
    this.tableData = arr;
  },

  watch: {
    baseData: function baseData() {
      this.formList = this.baseData.companyDataListVos;
      this.specialEquipmentList = this.baseData.companyDataTableListVos;

      var arr = [];
      for (var i = 0; i < this.specialEquipmentList.length; i++) {
        arr.push(JSON.parse(this.specialEquipmentList[i].cdValue));
      }
      this.tableData = arr;
    },
    isEdit: function isEdit() {
      this.isE = this.isEdit;
    }
  },

  methods: {
    look: function look(row, item) {
      console.log(row, item);
    },
    add: function add() {
      var obj = new Object();
      this.formList.forEach(function (ele, index) {
        var nature = ele.valueKey;
        obj[nature] = '';
      });
      this.tableData.push(obj);
      this.specialEquipmentList.push({
        id: null,
        cdId: null,
        cdValue: ""
      });
    },
    save: function save() {
      var _this = this;

      var name = '';
      for (var i = 0; i < this.formList.length; i++) {
        name = '';
        if (this.formList[i].rfIsMust) {
          for (var j = 0; j < this.tableData.length; j++) {
            if (this.tableData[j][this.formList[i].valueKey] == '') {
              name = this.formList[i].rfName;
              break;
            }
          }
        }
        if (name != '') {
          break;
        }
      }
      if (name != '') {
        this.$message.error(name + '不能为空');
      } else {
        // this.$emit('load')
        // console.log(this.tableData)
        for (var _i = 0; _i < this.specialEquipmentList.length; _i++) {
          this.baseData.companyDataTableListVos[_i].cdValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableData[_i]);
          this.baseData.companyDataTableListVos[_i].id = _i + 1;
        }
        this.baseData.delCompanyData = this.delArr;
        __WEBPACK_IMPORTED_MODULE_1__service_getData__["_81" /* updateCompany */](this.baseData).then(function (res) {
          if (res.data.code === 1) {
            _this.$message.success('操作成功');
            _this.$emit('load');
            _this.delArr = [];
          } else {
            _this.$message.error(res.data.message);
          }
        });
        console.log(this.baseData);
      }
    },
    del: function del(index) {
      var _this2 = this;

      this.$confirm('删除后将无法恢复，确认删除当前行？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (_this2.specialEquipmentList[index].cdId) {
          _this2.delArr.push(_this2.specialEquipmentList[index].cdId);
        }
        _this2.specialEquipmentList.splice(index, 1);
        _this2.tableData.splice(index, 1);
        _this2.$message.success('操作成功');
      }).catch(function (e) {
        _this2.$message.info('操作取消');
        console.log(e);
      });
    },
    selectOption: function selectOption(itemData) {
      if (Array.isArray(itemData)) {
        return itemData.join('，');
      } else {
        return itemData;
      }
    },
    getOptions: function getOptions(val) {
      if (val) {
        var arr = val.split('$-$');
        return arr;
      }
    },
    onFileChange: function onFileChange(obj, index, key) {
      var file = {
        fileName: obj[0].fileList[0].fileName,
        filePath: obj[0].fileList[0].exportFile
      };
      this.tableData[index][key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(file);
    },
    delFile: function delFile(index, key) {
      var _this3 = this;

      this.$confirm('确认要删除该附件吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.tableData[index][key] = '';
      }).catch(function () {
        _this3.$message.info('操作取消');
      });
    },
    getFilePath: function getFilePath(data) {
      return JSON.parse(data).filePath;
    },
    getFileName: function getFileName(data) {
      return JSON.parse(data).fileName;
    }
  }
});

/***/ }),

/***/ "oDp4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rework_details_vue__ = __webpack_require__("n8Kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0ce8517d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rework_details_vue__ = __webpack_require__("PF1P");
function injectStyle (ssrContext) {
  __webpack_require__("/aVu")
  __webpack_require__("Sva6")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ce8517d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_rework_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0ce8517d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_rework_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oQ02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oSCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('div',{staticClass:"dialog-form",staticStyle:{"padding-left":"30px","padding-right":"20px"}},[_c('div',{staticClass:"g-thing-tit"},[_c('div',{staticClass:"flex-box",staticStyle:{"min-height":"40px"}},[_c('h4',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterName)))]),_vm._v(" "),_c('div',{staticClass:"thingstate"},[(_vm.type === 0)?_c('span',[_vm._v("待处理")]):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('span',[_vm._v("驳回待处理")]):_vm._e(),_vm._v(" "),(_vm.type === 2)?_c('span',[_vm._v("待确认")]):_vm._e(),_vm._v(" "),(_vm.type === 3)?_c('span',[_vm._v("已完成")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box",staticStyle:{"min-height":"40px","align-items":"flex-start"}},[_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("事项类型："+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterTypeName)))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0 20px","font-size":"12px"}},[_vm._v("发起人："+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.adminName)))]),_vm._v(" "),_c('p',{staticStyle:{"flex":"1","font-size":"12px"}},[_vm._v("发起时间："+_vm._s(_vm._f("datetimeType")(_vm.matterTypeInfo.matterCreateTime,'yyyy-MM-dd hh:mm')))])])]),_vm._v(" "),_c('p',{staticClass:"g-contp",staticStyle:{"min-height":"40px","padding-top":"10px","text-indent":"2em"}},[_vm._v("\n      "+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterDes)))]),_vm._v(" "),_c('div',[_vm._v("\n        事项附件：\n        "),_vm._l((_vm.matterFileList),function(item,index){return _c('p',{key:index,staticStyle:{"margin-left":"70px","margin-top":"5px"}},[_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.downFile(item.matterFileUrl,item.matterFileName)}}},[_vm._v("\n            "+_vm._s(item.matterFileName)+"\n          ")])],1)})],2)]),_vm._v(" "),(_vm.type===1)?_c('el-form',{ref:"matterTypeInfo",staticClass:"dialog-form",attrs:{"model":_vm.matterTypeInfo,"size":"mini","label-width":"90px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"驳回时间：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.recordInfo.matterRejectRecordCreateTime)))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"驳回人：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("empty")(_vm.recordInfo.matterRejectRecordAdminName)))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"驳回理由：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("empty")(_vm.recordInfo.matterRejectRecordReason)))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form',{ref:"matterTypeInfo",staticClass:"dialog-form g-matter-form",attrs:{"model":_vm.matterTypeInfo,"size":"mini","label-width":"90px","label-position":"top","disabled":""}},[_c('el-row',{staticStyle:{"padding":"20px","box-sizing":"border-box"}},_vm._l((_vm.labelList),function(matter,matterIndex){return _c('el-col',{key:matterIndex,attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":matter.matterTypeFiledName+'：',"prop":""}},[(matter.matterTypeFiledType===1)?_c('el-input',{attrs:{"maxLength":"30"},model:{value:(matter.matterCompanyFiledValue),callback:function ($$v) {_vm.$set(matter, "matterCompanyFiledValue", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"matter.matterCompanyFiledValue"}}):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===2)?_c('el-input',{attrs:{"type":"textarea","rows":2,"maxLength":"500"},model:{value:(matter.matterCompanyFiledValue),callback:function ($$v) {_vm.$set(matter, "matterCompanyFiledValue", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"matter.matterCompanyFiledValue"}}):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===3)?_c('el-radio-group',{model:{value:(matter.radioValue),callback:function ($$v) {_vm.$set(matter, "radioValue", $$v)},expression:"matter.radioValue"}},[_c('div',{staticStyle:{"margin-top":"-10px"}},_vm._l((matter.radioList),function(radio,radioIndex){return _c('div',{key:radioIndex,staticClass:"g-radio-box"},[_c('el-radio',{attrs:{"label":radio.value}},[_vm._v(_vm._s(radio.label))])],1)}),0)]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===4)?_c('el-checkbox-group',{model:{value:(matter.checkboxValue),callback:function ($$v) {_vm.$set(matter, "checkboxValue", $$v)},expression:"matter.checkboxValue"}},[_c('div',{staticStyle:{"margin-top":"-10px"}},_vm._l((matter.checkboxList),function(checkbox,checkboxIndex){return _c('div',{key:checkboxIndex,staticClass:"g-checkbox-box"},[_c('el-checkbox',{attrs:{"label":checkbox.value}},[_vm._v(_vm._s(checkbox.label))])],1)}),0)]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===5)?_c('ul',_vm._l((matter.fileList),function(file,fileIndex){return _c('li',{key:fileIndex,staticClass:"flex-box",staticStyle:{"width":"250px","padding":"5px 15px"}},[_c('p',{staticClass:"ellipsis",staticStyle:{"flex":"1","color":"#0066FF"},attrs:{"title":file.matterCompanyFileName}},[_vm._v("\n                "+_vm._s(_vm._f("empty")(file.matterCompanyFileName)))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download download-icon",staticStyle:{"color":"#1396db"},on:{"click":function($event){return _vm.downloadFile(file,fileIndex)}}})])}),0):_vm._e(),_vm._v(" "),(matter.matterTypeFiledAnnotation)?_c('p',{staticClass:"field-content"},[_vm._v("注："+_vm._s(matter.matterTypeFiledAnnotation))]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledExample)?_c('p',{staticClass:"field-content"},[_vm._v("例："+_vm._s(matter.matterTypeFiledExample))]):_vm._e()],1)],1)}),1),_vm._v(" "),(_vm.labelListLoading||(!_vm.labelListLoading&&(!_vm.labelList||_vm.labelList.length===0)))?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"-40px"}},[(_vm.labelListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.labelListLoading&&(!_vm.labelList||_vm.labelList.length===0))?_c('span',[_vm._v("暂无数据")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("   返回   ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ofJ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pCsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",attrs:{"size":"small","model":_vm.approvalInfo,"label-width":"120px"}},[_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-form-item',{attrs:{"label-width":"180px","label":"审批结果：","prop":"result"}},[_c('el-radio',{attrs:{"label":1},model:{value:(_vm.approvalInfo.result),callback:function ($$v) {_vm.$set(_vm.approvalInfo, "result", $$v)},expression:"approvalInfo.result"}},[_vm._v("通过")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},model:{value:(_vm.approvalInfo.result),callback:function ($$v) {_vm.$set(_vm.approvalInfo, "result", $$v)},expression:"approvalInfo.result"}},[_vm._v("驳回")])],1)],1)],1)],1),_vm._v(" "),(_vm.approvalTitle=='批量审批')?_c('h3',{staticClass:"title"},[_vm._v("\n      选择员工：\n      "),_c('el-checkbox',{staticClass:"title-label-right",attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}},[_vm._v("全选")])],1):_vm._e(),_vm._v(" "),(_vm.approvalTitle=='批量审批')?_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('el-row',[_c('el-checkbox-group',{on:{"change":_vm.handlecheckedStaffChange},model:{value:(_vm.checkedStaff),callback:function ($$v) {_vm.checkedStaff=$$v},expression:"checkedStaff"}},_vm._l((_vm.staffs),function(item,index){return _c('el-checkbox',{key:index,staticStyle:{"display":"block"},attrs:{"label":item}},[_vm._v("\n              "+_vm._s(item.baseName)+"\n              "),_c('span',{staticStyle:{"padding":"0 20px"}},[_vm._v(_vm._s(item.baseCompanyName))]),_vm._v("\n              "+_vm._s(item.basePhone)+"\n            ")])}),1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pElk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"page-container"},[_vm._v("404 page not found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "psg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('div',{staticClass:"dialog-form",staticStyle:{"padding-left":"30px","padding-right":"20px"}},[_c('div',{staticClass:"g-thing-tit"},[_c('div',{staticClass:"flex-box",staticStyle:{"min-height":"40px"}},[_c('h4',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterName)))]),_vm._v(" "),_c('div',{staticClass:"thingstate"},[(_vm.type === 0)?_c('span',[_vm._v("待处理")]):_vm._e(),_vm._v(" "),(_vm.type === 1)?_c('span',[_vm._v("驳回待处理")]):_vm._e(),_vm._v(" "),(_vm.type === 2)?_c('span',[_vm._v("待确认")]):_vm._e(),_vm._v(" "),(_vm.type === 3)?_c('span',[_vm._v("已完成")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"flex-box",staticStyle:{"min-height":"40px","align-items":"flex-start"}},[_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("事项类型："+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterTypeName)))]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0 20px","font-size":"12px"}},[_vm._v("发起人："+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.adminName)))]),_vm._v(" "),_c('p',{staticStyle:{"flex":"1","font-size":"12px"}},[_vm._v("发起时间："+_vm._s(_vm._f("datetimeType")(_vm.matterTypeInfo.matterCreateTime,'yyyy-MM-dd hh:mm')))])])]),_vm._v(" "),_c('p',{staticClass:"g-contp",staticStyle:{"min-height":"40px","padding-top":"10px","text-indent":"2em"}},[_vm._v("\n      "+_vm._s(_vm._f("empty")(_vm.matterTypeInfo.matterDes)))])]),_vm._v(" "),(_vm.type===1)?_c('el-form',{ref:"matterTypeInfo",staticClass:"dialog-form",attrs:{"model":_vm.matterTypeInfo,"size":"mini","label-width":"90px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"驳回时间：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.recordInfo.matterRejectRecordCreateTime)))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"驳回人：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("empty")(_vm.recordInfo.matterRejectRecordAdminName)))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"驳回理由：","prop":""}},[_c('span',[_vm._v(_vm._s(_vm._f("empty")(_vm.recordInfo.matterRejectRecordReason)))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form',{ref:"matterTypeInfo",staticClass:"dialog-form g-matter-form",attrs:{"model":_vm.matterTypeInfo,"size":"mini","label-width":"90px","label-position":"top"}},[_c('el-row',{staticStyle:{"padding":"20px","box-sizing":"border-box"}},_vm._l((_vm.labelList),function(matter,matterIndex){return _c('el-col',{key:matterIndex,attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":matter.matterTypeFiledName+'：',"prop":""}},[(matter.matterTypeFiledType===1)?_c('el-input',{attrs:{"maxLength":"30"},model:{value:(matter.matterCompanyFiledValue),callback:function ($$v) {_vm.$set(matter, "matterCompanyFiledValue", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"matter.matterCompanyFiledValue"}}):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===2)?_c('el-input',{attrs:{"type":"textarea","rows":2,"maxLength":"500"},model:{value:(matter.matterCompanyFiledValue),callback:function ($$v) {_vm.$set(matter, "matterCompanyFiledValue", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"matter.matterCompanyFiledValue"}}):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===3)?_c('el-radio-group',{model:{value:(matter.radioValue),callback:function ($$v) {_vm.$set(matter, "radioValue", $$v)},expression:"matter.radioValue"}},[_c('div',{staticStyle:{"margin-top":"-10px"}},_vm._l((matter.radioList),function(radio,radioIndex){return _c('div',{key:radioIndex,staticClass:"g-radio-box"},[_c('el-radio',{attrs:{"label":radio.value}},[_vm._v(_vm._s(radio.label))])],1)}),0)]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===4)?_c('el-checkbox-group',{model:{value:(matter.checkboxValue),callback:function ($$v) {_vm.$set(matter, "checkboxValue", $$v)},expression:"matter.checkboxValue"}},[_c('div',{staticStyle:{"margin-top":"-10px"}},_vm._l((matter.checkboxList),function(checkbox,checkboxIndex){return _c('div',{key:checkboxIndex,staticClass:"g-checkbox-box"},[_c('el-checkbox',{attrs:{"label":checkbox.value}},[_vm._v(_vm._s(checkbox.label))])],1)}),0)]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===5)?_c('ul',_vm._l((matter.fileList),function(file,fileIndex){return _c('li',{key:fileIndex,staticClass:"flex-box",staticStyle:{"width":"250px","padding":"5px 15px"}},[_c('p',{staticClass:"ellipsis",staticStyle:{"flex":"1","color":"#0066FF"},attrs:{"title":file.matterCompanyFileName}},[_vm._v("\n                "+_vm._s(_vm._f("empty")(file.matterCompanyFileName)))]),_vm._v(" "),_c('i',{staticClass:"el-icon-download download-icon",staticStyle:{"color":"#1396db"},on:{"click":function($event){return _vm.downloadFile(file,fileIndex)}}}),_vm._v(" "),(matter.fileList.length)?_c('i',{staticClass:"icon el-icon-delete",staticStyle:{"color":"#000"},on:{"click":function($event){return _vm.delFile(matter.fileList,matter.uploadFileList,fileIndex)}}}):_vm._e()])}),0):_vm._e(),_vm._v(" "),(matter.matterTypeFiledType===5)?_c('div',{staticClass:"enclosure-upload"},[(_vm.type===1)?_c('el-upload',{staticClass:"upload-drag",attrs:{"limit":matter.limit,"file-list":matter.uploadFileList,"multiple":"","drag":"","action":"company/matterCompany/receiveFile","show-file-list":false,"before-upload":function (file, fileLists){_vm.beforeUpdate(file, fileLists,matter,matterIndex);},"on-success":_vm.success,"on-error":_vm.error,"on-remove":_vm.remove,"on-exceed":_vm.handleExceed,"headers":_vm.contractFileHeader}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])]):_c('el-upload',{staticClass:"upload-drag",attrs:{"limit":5,"file-list":matter.uploadFileList,"multiple":"","drag":"","action":"company/matterCompany/receiveFile","show-file-list":false,"before-upload":function (file, fileLists){_vm.beforeUpdate(file, fileLists,matter,matterIndex);},"on-success":_vm.success,"on-error":_vm.error,"on-remove":_vm.remove,"on-exceed":function (file, fileLists){_vm.handleExceed(file, fileLists,matter,matterIndex);},"headers":_vm.contractFileHeader}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])])])],1):_vm._e(),_vm._v(" "),(matter.matterTypeFiledAnnotation)?_c('p',{staticClass:"field-content"},[_vm._v("注："+_vm._s(matter.matterTypeFiledAnnotation))]):_vm._e(),_vm._v(" "),(matter.matterTypeFiledExample)?_c('p',{staticClass:"field-content"},[_vm._v("例："+_vm._s(matter.matterTypeFiledExample))]):_vm._e()],1)],1)}),1),_vm._v(" "),(_vm.labelListLoading||(!_vm.labelListLoading&&(!_vm.labelList||_vm.labelList.length===0)))?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"-40px"}},[(_vm.labelListLoading)?_c('el-button',{attrs:{"type":"text","loading":true}},[_vm._v("加载中")]):_vm._e(),_vm._v(" "),(!_vm.labelListLoading&&(!_vm.labelList||_vm.labelList.length===0))?_c('span',[_vm._v("暂无数据")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("   取消   ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"success","loading":_vm.handleLoading},on:{"click":_vm.handle}},[_vm._v("   处理   \n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q+d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q57K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qRh5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // orderComment: {},
      // orderDepartment: {},
      // lookBigImgDialog: false,
      // imgUrl: '',
      // odJson: []
      vrInfo: {
        baseName: "", //姓名
        // vrSex: 3,                            //1/男 2/女 3/未知
        baseCompanyName: "", //所在企业
        baseIdcrad: "", //身份证号码
        basePhone: "", //手机号码
        baseProvince: "", //户籍 省
        baseCity: "", //户籍 市
        baseDistrict: "", //户籍 区
        erLocation: "", //当前位置
        erReworkTime: "", //预计复工（返园）时间
        erHealth: 0, //是否有发热、乏力、干咳等症状1/正常  2/异常
        erHealthRemark: "",
        erContact: 0, //疫区接触史1/无  2/有
        erContactRemark: "", //疫区接触史描述
        erIsAirplane: 2, //涉及交通工具情况  是否坐飞机  1/是  2/否
        erIsBulletTrain: 2, //涉及交通工具情况  是否坐动车 1/是  2/否
        erIsBus: 2, //涉及交通工具情况  是否坐汽车  1/是 2/否
        erIsPrivateCar: 2, //私家车
        erFlightNumber: "",
        erTrainService: "",
        erBusNumber: "",
        // vrTrainRemark: '',                //行程描述
        erOtherRemark: "", //其他备注描述

        erCreateTime: "", //登记时间
        erHolidayProvince: "", //假期所在地区 省
        erHolidayCity: "", //假期所在地区 市
        erHolidayDistrict: "", //假期所在地区 区
        erHolidayAddress: "", //假期所在地居住地址
        erIsReturn: 0, //是否返回工作所在地 1/已返回 2/未返回
        erReturnTime: "", //返程时间
        erContactHistory: 1, //是否有新型冠状感染者接触史 1/无  2/有
        erContactHistoryRemark: "", //是否有新型冠状感染者接触史情况描述
        // erIsRework: 2,
        // erLeaveTime: "",
        erFamilyHealth: 2,
        erFamilyHealthRemark: "",
        erIsIsolation: 1
        // erIsolationStartTime: new Date().format("yyyy-MM-dd"),
        // erIsolationEndTime: '',

        // healthCodeType:'',
        // healthCodeContent:'',
      },
      quarantineInfo: {
        quarantineWay: 1,
        quarantineStartTime: "",
        quarantineDays: '',
        quarantinePerson: '',
        quarantineDescription: '',
        quarantineEndTime: '',
        quarantineAdminName: '',
        companyName: ''

      },
      isolationDialog: false,
      quarantine: null,
      quarantineRegisterAddDialog: false,
      isEdit: false,
      isRelieve: false,
      healthCode: {
        healthCodeContent: '',
        width: 74,
        height: 74,
        type: ''
      },
      imgUrl: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ["id", "baseId", "activeId"],
  computed: {},
  methods: {
    timeFormat: function timeFormat(time) {
      return __WEBPACK_IMPORTED_MODULE_0__config_mUtils__["q" /* toDateTime */](time);
    },
    orginText: function orginText(text) {
      switch (text) {
        case 1:
          return "微信提交";
        case 2:
          return "后台添加";
      }
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_39" /* isIsolationRegister */](this.baseId).then(function (res) {
        if (res.data.code != 'success') {
          _this.$message.error(res.data.message);
          return;
        }
        var data = res.data.data;
        _this.quarantine = data.quarantine;
        if (_this.quarantine != null) {

          _this.getQuarantine(_this.quarantine.quarantineId);
        }
      }).catch(function (_) {
        console.log(_);
      });

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_92" /* vrDetail */](this.id).then(function (res) {
        var data = res.data.data;
        _this.vrInfo.baseName = data.epidemicRegister.baseName; //姓名
        //  this.vrInfo.vrSex=data.epidemicRegister.vrSex;                            //1/男 2/女 3/未知
        _this.vrInfo.baseCompanyName = data.epidemicRegister.baseCompanyName; //所在企业
        _this.vrInfo.baseIdcrad = data.epidemicRegister.baseIdcrad; //身份证号码
        _this.vrInfo.basePhone = data.epidemicRegister.basePhone; //手机号码
        _this.vrInfo.baseProvince = data.epidemicRegister.baseProvince; //户籍 省
        _this.vrInfo.baseCity = data.epidemicRegister.baseCity; //户籍 市
        _this.vrInfo.baseDistrict = data.epidemicRegister.baseDistrict; //户籍 区
        _this.vrInfo.erLocation = data.epidemicRegister.erLocation; //当前位置
        _this.vrInfo.erReworkTime = data.epidemicRegister.erReworkTime; //预计复工（返园）时间
        _this.vrInfo.erHealth = data.epidemicRegister.erHealth; //身体状况1/正常  2/异常
        _this.vrInfo.erHealthRemark = data.epidemicRegister.erHealthRemark;
        _this.vrInfo.erContact = data.epidemicRegister.erContact; //疫区接触史1/无  2/有
        _this.vrInfo.erContactRemark = data.epidemicRegister.erContactRemark; //疫区接触史描述
        _this.vrInfo.erIsAirplane = data.epidemicRegister.erIsAirplane; //涉及交通工具情况  是否坐飞机  1/是  2/否
        _this.vrInfo.erIsBulletTrain = data.epidemicRegister.erIsBulletTrain; //涉及交通工具情况  是否坐动车 1/是  2/否
        _this.vrInfo.erIsBus = data.epidemicRegister.erIsBus; //涉及交通工具情况  是否坐汽车  1/是 2/否
        _this.vrInfo.erIsPrivateCar = data.epidemicRegister.erIsPrivateCar;
        _this.vrInfo.erFlightNumber = data.epidemicRegister.erFlightNumber;
        _this.vrInfo.erTrainService = data.epidemicRegister.erTrainService;
        _this.vrInfo.erBusNumber = data.epidemicRegister.erBusNumber;
        //  this.vrInfo.vrTrainRemark= data.epidemicRegister.vrTrainRemark;              //行程描述
        _this.vrInfo.erOtherRemark = data.epidemicRegister.erOtherRemark; //其他备注描述
        _this.vrInfo.erCreateTime = data.epidemicRegister.erCreateTime;
        // this.vrInfo.erIsRework = data.epidemicRegister.erIsRework; 
        // this.vrInfo.erLeaveTime = data.epidemicRegister.erLeaveTime; 
        _this.vrInfo.erFamilyHealth = data.epidemicRegister.erFamilyHealth;
        _this.vrInfo.erFamilyHealthRemark = data.epidemicRegister.erFamilyHealthRemark;
        _this.vrInfo.erIsIsolation = data.epidemicRegister.erIsIsolation;
        // this.vrInfo.erIsolationStartTime = data.epidemicRegister.erIsolationStartTime; 
        _this.vrInfo.erIsolationEndTime = data.epidemicRegister.erIsolationEndTime;
        // this.vrInfo.erHaveReworkTime = data.epidemicRegister.erHaveReworkTime; 

        _this.vrInfo.erHolidayProvince = data.epidemicRegister.erHolidayProvince, //假期所在地区 省
        _this.vrInfo.erHolidayCity = data.epidemicRegister.erHolidayCity, //假期所在地区 市
        _this.vrInfo.erHolidayDistrict = data.epidemicRegister.erHolidayDistrict, //假期所在地区 区
        _this.vrInfo.erHolidayAddress = data.epidemicRegister.erHolidayAddress, //假期所在地居住地址
        _this.vrInfo.erIsReturn = data.epidemicRegister.erIsReturn, //是否返回工作所在地 1/已返回 2/未返回
        _this.vrInfo.erReturnTime = data.epidemicRegister.erReturnTime, //返程时间
        _this.vrInfo.erContactHistory = data.epidemicRegister.erContactHistory, //是否有新型冠状感染者接触史 1/无  2/有
        _this.vrInfo.erContactHistoryRemark = data.epidemicRegister.erContactHistoryRemark; //是否有新型冠状感染者接触史情况描述

        _this.healthCode.healthCodeType = data.healthCode.healthCodeType;
        _this.healthCode.healthCodeContent = data.healthCode.healthCodeContent;
        // this.getImage()
        _this.imgUrl = 'company/viral/getImage?healthCodeContent=' + _this.healthCode.healthCodeContent + '&width=74' + '&height=74' + '&type=' + _this.healthCode.healthCodeType;
        console.log(_this.imgUrl, 111);
      });
    },

    /* getImage(){
      getData.getImage(this.healthCode).then(res=>{
        console.log(res)
      }).catch(_=>{
        console.log(_)
      })
    }, */
    getQuarantine: function getQuarantine(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["_24" /* getQuarantine */](id).then(function (res) {
        var data = res.data.data.quarantine;
        _this2.quarantineInfo.quarantineWay = data.quarantineWay;
        _this2.quarantineInfo.quarantineStartTime = data.quarantineStartTime;
        _this2.quarantineInfo.quarantineDays = data.quarantineDays;
        _this2.quarantineInfo.quarantinePerson = data.quarantinePerson;
        _this2.quarantineInfo.quarantineDescription = data.quarantineDescription;
        _this2.quarantineInfo.quarantineEndTime = data.quarantineEndTime;
        _this2.quarantineInfo.quarantineAdminName = data.quarantineAdminName;
        _this2.quarantineInfo.companyName = data.companyName;
      }).catch(function (_) {
        console.log(_);
      });
    },
    quarantineRegisterEdit: function quarantineRegisterEdit() {
      this.quarantineRegisterAddDialog = true;
      this.isolationDialog = false;
    },
    relieve: function relieve() {
      var _this3 = this;

      this.isolationDialog = false;
      __WEBPACK_IMPORTED_MODULE_1__service_getData__["J" /* deleteQuarantine */](this.quarantine.quarantineId).then(function (res) {
        console.log(res);
        if (res.data.code == 'success') {
          _this3.$message.success("解除成功！");
          _this3.init();
        } else {
          _this3.$message.error("解除失败！");
        }
      }).catch(function (_) {
        console.log(_);
      });
    },
    relieveTheIsolation: function relieveTheIsolation() {
      this.isolationDialog = true;
      this.isRelieve = true;
      this.isEdit = false;
    },
    editTheIsolation: function editTheIsolation() {
      this.isolationDialog = true;
      this.isEdit = true;
      this.isRelieve = false;
    },
    dowloadImg: function dowloadImg() {
      window.location.href = 'company/viral/getImage?healthCodeContent=' + this.healthCode.healthCodeContent + '&width=200' + '&height=200' + '&type=' + this.healthCode.healthCodeType + '&down=1' + '&name=' + '健康码';
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "qveY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qzG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("CETB");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_eee32b38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("h/+a");
function injectStyle (ssrContext) {
  __webpack_require__("L/ig")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eee32b38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_eee32b38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "rESV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.infoDetail)?_c('el-row',{staticClass:"dialog-form"},[_c('el-col',{staticClass:"g-basic-info"},[_c('div',{staticClass:"g-service-type"},[_vm._v(_vm._s(_vm._f("noteState")(_vm.infoDetail.noteState)))]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("票据类型："+_vm._s(_vm._f("noteType")(_vm.infoDetail.noteType)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("申请提交时间："+_vm._s(new Date(_vm.infoDetail.noteCreateTime).format('yyyy-MM-dd hh:mm:ss')))])])],1),_vm._v(" "),_c('div',{staticClass:"g-col-line"}),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("申请企业："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteCompanyName)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("申请人："+_vm._s(_vm._f("empty")(_vm.noteCreateName)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("关联合同："+_vm._s(_vm.infoDetail.noteContractInfo?_vm.infoDetail.noteContractInfo:'暂无数据'))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("关联账单："+_vm._s(_vm.infoDetail.noteBillInfo?_vm.infoDetail.noteBillInfo:'暂无数据'))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("情况描述："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteDescription)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticStyle:{"display":"flex"},attrs:{"span":24}},[_c('span',{staticStyle:{"line-height":"30px"}},[_vm._v("凭证文件：")]),_vm._v(" "),(_vm.infoDetail.noteVoucherFile)?_c('ul',{staticClass:"fileList"},_vm._l((JSON.parse(_vm.infoDetail.noteVoucherFile)),function(file,index){return _c('li',{key:index},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(file.fileName))]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.openFile(file.exportFile)}}},[_vm._v("预览")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.downLoad(file)}}},[_vm._v("下载")])],1)}),0):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"g-col-line"}),_vm._v(" "),(_vm.infoDetail.noteType != 3)?_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("纳税人识别号："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteTaxpayer)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("地址："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteAddress)))])])],1):_vm._e(),_vm._v(" "),(_vm.infoDetail.noteType != 3)?_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("电话："+_vm._s(_vm._f("empty")(_vm.infoDetail.notePhone)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("开户行："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteBank)))])])],1):_vm._e(),_vm._v(" "),(_vm.infoDetail.noteType != 3)?_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("帐号："+_vm._s(_vm._f("empty")(_vm.infoDetail.noteAccount)))])])],1):_vm._e()],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rG00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_mUtils__ = __webpack_require__("yclV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      serveInfo: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['type', 'serveId'],
  computed: {},
  methods: {
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__service_getData__["_76" /* serveDetail */](this.serveId).then(function (res) {
        if (res.data.code != 'success') {
          _this.$message({
            type: 'error',
            message: res.data.message || res.data.Msg
          });
          return;
        }
        _this.serveInfo = res.data.data.serve;
      }).catch(function (_) {});
    },
    close: function close() {
      this.$emit('closeDialog');
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "rLMe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rRop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        heyuezujin: [],
        mianzutiaokuan: []
      },
      fileList: [],
      submitLoading: false,
      conts: '',
      tableList: [],
      parkListLoading: false,
      electronicContractDialog: false,
      contractBillDialog: false,
      fileOutPath: '',
      filters: {
        contractId: '',
        type: ''
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.filters.contractId = this.contractId;
    this.filters.type = this.contractType;
    this.init();
  },

  computed: {},
  props: ['contractId', 'contractType'],
  methods: {
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      } else {
        this.$emit('closeDialog');
      }
    },
    init: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__service_getData__["B" /* contractDetail */](this.filters).then(function (res) {
        _this.parkListLoading = false;
        if (res.data.code == "success") {
          _this.info = res.data.data.data.contractVO;
        }
      }).catch(function (_) {
        console.log(_);
        _this.parkListLoading = false;
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "rmvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp"},[_c('div',{staticClass:"dialog_form g-glun"},[_c('ul',{staticClass:"g-handle-type"},_vm._l((_vm.companyIcList),function(item,index){return _c('li',{key:index,staticClass:"list-item",class:_vm.companyId == item.companyId ? 'p-active':'p-disabled',on:{"click":function($event){return _vm.getAdminInfo(item,index)}}},[_c('h3',[_vm._v(_vm._s(item.companyName))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":_vm.examineInvestment}},[_vm._v("确定")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rngL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      info: {
        province: "",
        letter: "",
        licensePlateNumber: "",
        carNumber: ""
      },
      provinceList: [],
      letterList: [],
      provinceVisible: false,
      letterVisible: false
    };
  },
  created: function created() {
    this.provinceList = this.province ? this.province : [];
    this.letterList = this.letter ? this.letter : [];
    this.info.province = this.provinceFather;
    this.info.letter = this.letterFather;
    this.info.licensePlateNumber = this.licensePlateNumberFather;
  },
  mounted: function mounted() {},

  props: {
    value: {
      default: ""
    },
    provinceFather: {
      default: ""
    },
    letterFather: {
      default: ""
    },
    licensePlateNumberFather: {
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    province: {
      type: Array,
      default: function _default() {
        return [{ "label": "京", "value": "京" }, { "label": "津", "value": "津" }, { "label": "沪", "value": "沪" }, { "label": "渝", "value": "渝" }, { "label": "冀", "value": "冀" }, { "label": "豫", "value": "豫" }, { "label": "云", "value": "云" }, { "label": "辽", "value": "辽" }, { "label": "黑", "value": "黑" }, { "label": "湘", "value": "湘" }, { "label": "皖", "value": "皖" }, { "label": "鲁", "value": "鲁" }, { "label": "新", "value": "新" }, { "label": "苏", "value": "苏" }, { "label": "浙", "value": "浙" }, { "label": "赣", "value": "赣" }, { "label": "鄂", "value": "鄂" }, { "label": "桂", "value": "桂" }, { "label": "甘", "value": "甘" }, { "label": "晋", "value": "晋" }, { "label": "蒙", "value": "蒙" }, { "label": "陕", "value": "陕" }, { "label": "吉", "value": "吉" }, { "label": "闽", "value": "闽" }, { "label": "贵", "value": "贵" }, { "label": "粤", "value": "粤" }, { "label": "青", "value": "青" }, { "label": "藏", "value": "藏" }, { "label": "川", "value": "川" }, { "label": "宁", "value": "宁" }, { "label": "琼", "value": "琼" }, { "label": "使", "value": "使" }, { "label": "领", "value": "领" }];
      }
    },
    letter: {
      type: Array,
      default: function _default() {
        return [{ "label": "A", "value": "A" }, { "label": "B", "value": "B" }, { "label": "C", "value": "C" }, { "label": "D", "value": "D" }, { "label": "E", "value": "E" }, { "label": "F", "value": "F" }, { "label": "G", "value": "G" }, { "label": "H", "value": "H" }, { "label": "I", "value": "I" }, { "label": "J", "value": "J" }, { "label": "K", "value": "K" }, { "label": "L", "value": "L" }, { "label": "M", "value": "M" }, { "label": "N", "value": "N" }, { "label": "O", "value": "O" }, { "label": "P", "value": "P" }, { "label": "Q", "value": "Q" }, { "label": "R", "value": "R" }, { "label": "S", "value": "S" }, { "label": "T", "value": "T" }, { "label": "U", "value": "U" }, { "label": "V", "value": "V" }, { "label": "W", "value": "W" }, { "label": "X", "value": "X" }, { "label": "Y", "value": "Y" }, { "label": "Z", "value": "Z" }];
      }
    }
  },
  computed: {},
  methods: {
    provinceFocus: function provinceFocus() {
      if (this.disabled) {
        return;
      }
      this.provinceVisible = true;
      this.letterVisible = false;
    },
    provinceInput: function provinceInput() {
      if (this.disabled) {
        return;
      }
      this.provinceVisible = true;
      var reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}$/;
      if (!reg.test(this.info.province)) {
        this.info.province = "";
      }
      this.getCardNumber();
    },
    provinceBlur: function provinceBlur() {
      this.provinceVisible = false;
    },
    letterFocus: function letterFocus() {
      if (this.type === 1) {
        return;
      }
      this.letterVisible = true;
      this.provinceVisible = false;
    },
    letterInput: function letterInput() {
      if (this.type === 1) {
        return;
      }
      this.letterVisible = true;
      var reg = /^[A-Z]{1}$/;
      if (!reg.test(this.info.letter)) {
        this.info.letter = "";
      }
      this.getCardNumber();
    },
    letterBlur: function letterBlur() {
      this.letterVisible = false;
    },
    getCardNumber: function getCardNumber() {
      var info = this.info;
      this.info.carNumber = "" + (info.province ? info.province : "") + (info.letter ? info.letter : "") + (info.licensePlateNumber ? info.licensePlateNumber : "");
      this.$emit("getCarNumber", info.province, info.letter, info.licensePlateNumber);
      this.$emit("input", this.info.carNumber);
    },
    selectProvince: function selectProvince(row, index) {
      this.info.province = row.value;
      this.provinceVisible = false;
      this.getCardNumber();
    },
    selectLetter: function selectLetter(row, index) {
      this.info.letter = row.value;
      this.letterVisible = false;
      this.getCardNumber();
    }
  },
  components: {},
  watch: {
    province: {
      handler: function handler(val) {
        this.letterList = this.letter ? this.letter : [];
      },

      immediate: true
    },
    letter: {
      handler: function handler(val) {
        this.provinceList = this.province ? this.province : [];
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ "rziK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "s+Ew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vue__ = __webpack_require__("SYVz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b5c2592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vue__ = __webpack_require__("WHJM");
function injectStyle (ssrContext) {
  __webpack_require__("CyG9")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b5c2592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_6b5c2592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s+T+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "swQV":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "sxsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-warp"},[_c('el-form',{ref:"info",staticClass:"dialog-form",attrs:{"model":_vm.info,"rules":_vm.rules,"size":"small","label-width":"200px"}},[_c('el-row',[_c('el-col',{attrs:{"span":22}},[_c('el-form-item',{attrs:{"label":"提醒人员名称：","prop":"bwcName"}},[_c('el-input',{attrs:{"placeholder":"请输入提醒人员名称"},model:{value:(_vm.info.bwcName),callback:function ($$v) {_vm.$set(_vm.info, "bwcName", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.bwcName"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('el-form-item',{attrs:{"label":"常用联系方式：","prop":"bwcContact"}},[_c('el-input',{attrs:{"placeholder":"请填写常用联系方式"},model:{value:(_vm.info.bwcContact),callback:function ($$v) {_vm.$set(_vm.info, "bwcContact", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.bwcContact"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('el-form-item',{attrs:{"label":"提醒内容","prop":"remindContent"}},[_c('el-checkbox-group',{model:{value:(_vm.info.remindContent),callback:function ($$v) {_vm.$set(_vm.info, "remindContent", $$v)},expression:"info.remindContent"}},[_c('el-checkbox',{attrs:{"label":"1"}},[_vm._v("企业电费")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"2"}},[_vm._v("企业水费")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"3"}},[_vm._v("公寓电费")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"4"}},[_vm._v("公寓水费")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.close}},[_vm._v("返回")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"success","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("保存")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t5Kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backUrl */
/* unused harmony export ssoUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mainUrl; });
/* unused harmony export clickUrl */
/* unused harmony export downloadUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ossUrl; });
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgCode： 图片验证码地址
 * clickUrl: 菜单点击地址
 *
 */
var backUrl = void 0;
var mainUrl = void 0;
var ssoUrl = void 0;
var clickUrl = void 0;
var downloadUrl = void 0;
var ossUrl = void 0;
var adminAccount = void 0;
var allSessionId = void 0;
if (false) {
  backUrl = 'http://test-pk-ht.hzqisheng.cn/';
  // ssoUrl = 'http://47.97.104.158:12080'//正式网
  mainUrl = 'http://test-user-center.test176.cn/';
  ossUrl = 'http://test-mh-company.test176.cn'; //测式网
  ssoUrl = 'http://47.98.61.135:12080/'; //测式网
  clickUrl = 'http://localhost:';
  downloadUrl = 'http://192.168.0.188:8088/park_cms/';

  // adminAccount = "zyh";
  // allSessionId = "2855E6A721FF349764CF47B4E1A741C9";//todo 该id失效时，请到相应测试网或正式网获取
  // sessionStorage.setItem("adminAccount", adminAccount);
  // sessionStorage.setItem("allSessionId", allSessionId);
} else {
  backUrl = '/';
  clickUrl = '';
  ossUrl = window.location.origin;
  downloadUrl = 'http://test-pk-ht.hzqisheng.cn/'; // todo 测式网
  if (false) {
    mainUrl = 'http://test-user-center.test176.cn/'; //测式网
    ssoUrl = 'http://47.98.61.135:12080/'; //测式网
  } else if (false) {
    mainUrl = "http://prep-center.zhihuipk.com/"; //预生产
    ssoUrl = "http://prep-center.zhihuipk.com/"; //预生产
  } else if (true) {
    mainUrl = 'http://user-center.zhihuipk.com/'; //正式网
    ssoUrl = 'http://user-center.zhihuipk.com/'; //正式网
  }
}



/***/ }),

/***/ "uh6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_file_details_vue__ = __webpack_require__("/1cT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0c4c6808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_file_details_vue__ = __webpack_require__("mQ6k");
function injectStyle (ssrContext) {
  __webpack_require__("vNop")
  __webpack_require__("D9sh")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c4c6808"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_file_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0c4c6808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_file_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uiVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
var require;var require;
(function (r) {
    if ((typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(exports)) === "object" && typeof module !== "undefined") {
        module.exports = r();
    } else {
        if (typeof define === "function" && __webpack_require__("Ycmu")) {
            define([], r);
        } else {
            var e;if (typeof window !== "undefined") {
                e = window;
            } else {
                if (typeof global !== "undefined") {
                    e = global;
                } else {
                    if (typeof self !== "undefined") {
                        e = self;
                    } else {
                        e = this;
                    }
                }
            }e.base64js = r();
        }
    }
})(function () {
    var r, e, t;return function r(e, t, n) {
        function o(i, a) {
            if (!t[i]) {
                if (!e[i]) {
                    var u = typeof require == "function" && require;if (!a && u) {
                        return require(i, !0);
                    }if (f) {
                        return f(i, !0);
                    }var d = new Error("Cannot find module '" + i + "'");throw d.code = "MODULE_NOT_FOUND", d;
                }
                var c = t[i] = { exports: {} };e[i][0].call(c.exports, function (r) {
                    var t = e[i][1][r];return o(t ? t : r);
                }, c, c.exports, r, e, t, n);
            }return t[i].exports;
        }
        var f = typeof require == "function" && require;for (var i = 0; i < n.length; i++) {
            o(n[i]);
        }return o;
    }({ "/": [function (r, e, t) {
            t.byteLength = c;
            t.toByteArray = v;t.fromByteArray = s;var n = [];var o = [];var f = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
            var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";for (var a = 0, u = i.length; a < u; ++a) {
                n[a] = i[a];
                o[i.charCodeAt(a)] = a;
            }o["-".charCodeAt(0)] = 62;o["_".charCodeAt(0)] = 63;function d(r) {
                var e = r.length;if (e % 4 > 0) {
                    throw new Error("Invalid string. Length must be a multiple of 4");
                }return r[e - 2] === "=" ? 2 : r[e - 1] === "=" ? 1 : 0;
            }
            function c(r) {
                return r.length * 3 / 4 - d(r);
            }function v(r) {
                var e, t, n, i, a;var u = r.length;i = d(r);a = new f(u * 3 / 4 - i);t = i > 0 ? u - 4 : u;
                var c = 0;for (e = 0; e < t; e += 4) {
                    n = o[r.charCodeAt(e)] << 18 | o[r.charCodeAt(e + 1)] << 12 | o[r.charCodeAt(e + 2)] << 6 | o[r.charCodeAt(e + 3)];
                    a[c++] = n >> 16 & 255;a[c++] = n >> 8 & 255;a[c++] = n & 255;
                }if (i === 2) {
                    n = o[r.charCodeAt(e)] << 2 | o[r.charCodeAt(e + 1)] >> 4;a[c++] = n & 255;
                } else {
                    if (i === 1) {
                        n = o[r.charCodeAt(e)] << 10 | o[r.charCodeAt(e + 1)] << 4 | o[r.charCodeAt(e + 2)] >> 2;a[c++] = n >> 8 & 255;a[c++] = n & 255;
                    }
                }return a;
            }
            function l(r) {
                return n[r >> 18 & 63] + n[r >> 12 & 63] + n[r >> 6 & 63] + n[r & 63];
            }function h(r, e, t) {
                var n;var o = [];for (var f = e; f < t; f += 3) {
                    n = (r[f] << 16) + (r[f + 1] << 8) + r[f + 2];o.push(l(n));
                }return o.join("");
            }function s(r) {
                var e;var t = r.length;var o = t % 3;var f = "";var i = [];
                var a = 16383;for (var u = 0, d = t - o; u < d; u += a) {
                    i.push(h(r, u, u + a > d ? d : u + a));
                }if (o === 1) {
                    e = r[t - 1];f += n[e >> 2];f += n[e << 4 & 63];f += "==";
                } else {
                    if (o === 2) {
                        e = (r[t - 2] << 8) + r[t - 1];f += n[e >> 10];f += n[e >> 4 & 63];f += n[e << 2 & 63];f += "=";
                    }
                }i.push(f);return i.join("");
            }
        }, {}] }, {}, [])("/");
});
function SM4_Context() {
    this.mode = 1;
    this.isPadding = true;
    this.sk = new Array(32);
}

function SM4() {
    this.SM4_ENCRYPT = 1;
    this.SM4_DECRYPT = 0;

    var SboxTable = [0xd6, 0x90, 0xe9, 0xfe, 0xcc, 0xe1, 0x3d, 0xb7, 0x16, 0xb6, 0x14, 0xc2, 0x28, 0xfb, 0x2c, 0x05, 0x2b, 0x67, 0x9a, 0x76, 0x2a, 0xbe, 0x04, 0xc3, 0xaa, 0x44, 0x13, 0x26, 0x49, 0x86, 0x06, 0x99, 0x9c, 0x42, 0x50, 0xf4, 0x91, 0xef, 0x98, 0x7a, 0x33, 0x54, 0x0b, 0x43, 0xed, 0xcf, 0xac, 0x62, 0xe4, 0xb3, 0x1c, 0xa9, 0xc9, 0x08, 0xe8, 0x95, 0x80, 0xdf, 0x94, 0xfa, 0x75, 0x8f, 0x3f, 0xa6, 0x47, 0x07, 0xa7, 0xfc, 0xf3, 0x73, 0x17, 0xba, 0x83, 0x59, 0x3c, 0x19, 0xe6, 0x85, 0x4f, 0xa8, 0x68, 0x6b, 0x81, 0xb2, 0x71, 0x64, 0xda, 0x8b, 0xf8, 0xeb, 0x0f, 0x4b, 0x70, 0x56, 0x9d, 0x35, 0x1e, 0x24, 0x0e, 0x5e, 0x63, 0x58, 0xd1, 0xa2, 0x25, 0x22, 0x7c, 0x3b, 0x01, 0x21, 0x78, 0x87, 0xd4, 0x00, 0x46, 0x57, 0x9f, 0xd3, 0x27, 0x52, 0x4c, 0x36, 0x02, 0xe7, 0xa0, 0xc4, 0xc8, 0x9e, 0xea, 0xbf, 0x8a, 0xd2, 0x40, 0xc7, 0x38, 0xb5, 0xa3, 0xf7, 0xf2, 0xce, 0xf9, 0x61, 0x15, 0xa1, 0xe0, 0xae, 0x5d, 0xa4, 0x9b, 0x34, 0x1a, 0x55, 0xad, 0x93, 0x32, 0x30, 0xf5, 0x8c, 0xb1, 0xe3, 0x1d, 0xf6, 0xe2, 0x2e, 0x82, 0x66, 0xca, 0x60, 0xc0, 0x29, 0x23, 0xab, 0x0d, 0x53, 0x4e, 0x6f, 0xd5, 0xdb, 0x37, 0x45, 0xde, 0xfd, 0x8e, 0x2f, 0x03, 0xff, 0x6a, 0x72, 0x6d, 0x6c, 0x5b, 0x51, 0x8d, 0x1b, 0xaf, 0x92, 0xbb, 0xdd, 0xbc, 0x7f, 0x11, 0xd9, 0x5c, 0x41, 0x1f, 0x10, 0x5a, 0xd8, 0x0a, 0xc1, 0x31, 0x88, 0xa5, 0xcd, 0x7b, 0xbd, 0x2d, 0x74, 0xd0, 0x12, 0xb8, 0xe5, 0xb4, 0xb0, 0x89, 0x69, 0x97, 0x4a, 0x0c, 0x96, 0x77, 0x7e, 0x65, 0xb9, 0xf1, 0x09, 0xc5, 0x6e, 0xc6, 0x84, 0x18, 0xf0, 0x7d, 0xec, 0x3a, 0xdc, 0x4d, 0x20, 0x79, 0xee, 0x5f, 0x3e, 0xd7, 0xcb, 0x39, 0x48];

    var FK = [0xa3b1bac6, 0x56aa3350, 0x677d9197, 0xb27022dc];

    var CK = [0x00070e15, 0x1c232a31, 0x383f464d, 0x545b6269, 0x70777e85, 0x8c939aa1, 0xa8afb6bd, 0xc4cbd2d9, 0xe0e7eef5, 0xfc030a11, 0x181f262d, 0x343b4249, 0x50575e65, 0x6c737a81, 0x888f969d, 0xa4abb2b9, 0xc0c7ced5, 0xdce3eaf1, 0xf8ff060d, 0x141b2229, 0x30373e45, 0x4c535a61, 0x686f767d, 0x848b9299, 0xa0a7aeb5, 0xbcc3cad1, 0xd8dfe6ed, 0xf4fb0209, 0x10171e25, 0x2c333a41, 0x484f565d, 0x646b7279];

    this.GET_ULONG_BE = function (b, i) {
        return (b[i] & 0xff) << 24 | (b[i + 1] & 0xff) << 16 | (b[i + 2] & 0xff) << 8 | b[i + 3] & 0xff & 0xffffffff;
    };

    this.PUT_ULONG_BE = function (n, b, i) {
        var t1 = 0xFF & n >> 24;
        var t2 = 0xFF & n >> 16;
        var t3 = 0xFF & n >> 8;
        var t4 = 0xFF & n;
        b[i] = t1 > 128 ? t1 - 256 : t1;
        b[i + 1] = t2 > 128 ? t2 - 256 : t2;
        b[i + 2] = t3 > 128 ? t3 - 256 : t3;
        b[i + 3] = t4 > 128 ? t4 - 256 : t4;
    };

    this.SHL = function (x, n) {
        return (x & 0xFFFFFFFF) << n;
    };

    this.ROTL = function (x, n) {
        var s = this.SHL(x, n);
        var ss = x >> 32 - n;
        return this.SHL(x, n) | x >> 32 - n;
    };

    this.sm4Lt = function (ka) {
        var bb = 0;
        var c = 0;
        var a = new Array(4);
        var b = new Array(4);
        this.PUT_ULONG_BE(ka, a, 0);
        b[0] = this.sm4Sbox(a[0]);
        b[1] = this.sm4Sbox(a[1]);
        b[2] = this.sm4Sbox(a[2]);
        b[3] = this.sm4Sbox(a[3]);
        bb = this.GET_ULONG_BE(b, 0);
        c = bb ^ this.ROTL(bb, 2) ^ this.ROTL(bb, 10) ^ this.ROTL(bb, 18) ^ this.ROTL(bb, 24);
        return c;
    };

    this.sm4F = function (x0, x1, x2, x3, rk) {
        return x0 ^ this.sm4Lt(x1 ^ x2 ^ x3 ^ rk);
    };

    this.sm4CalciRK = function (ka) {
        var bb = 0;
        var rk = 0;
        var a = new Array(4);
        var b = new Array(4);
        this.PUT_ULONG_BE(ka, a, 0);
        b[0] = this.sm4Sbox(a[0]);
        b[1] = this.sm4Sbox(a[1]);
        b[2] = this.sm4Sbox(a[2]);
        b[3] = this.sm4Sbox(a[3]);
        bb = this.GET_ULONG_BE(b, 0);
        rk = bb ^ this.ROTL(bb, 13) ^ this.ROTL(bb, 23);
        return rk;
    };

    this.sm4Sbox = function (inch) {
        var i = inch & 0xFF;
        var retVal = SboxTable[i];
        return retVal > 128 ? retVal - 256 : retVal;
    };

    this.sm4_setkey_enc = function (ctx, key) {
        if (ctx == null) {
            alert("ctx is null!");
            return false;
        }
        if (key == null || key.length != 16) {
            alert("key error!");
            return false;
        }
        ctx.mode = this.SM4_ENCRYPT;
        this.sm4_setkey(ctx.sk, key);
    };

    this.sm4_setkey = function (SK, key) {
        var MK = new Array(4);
        var k = new Array(36);
        var i = 0;
        MK[0] = this.GET_ULONG_BE(key, 0);
        MK[1] = this.GET_ULONG_BE(key, 4);
        MK[2] = this.GET_ULONG_BE(key, 8);
        MK[3] = this.GET_ULONG_BE(key, 12);
        k[0] = MK[0] ^ FK[0];
        k[1] = MK[1] ^ FK[1];
        k[2] = MK[2] ^ FK[2];
        k[3] = MK[3] ^ FK[3];
        for (var i = 0; i < 32; i++) {
            k[i + 4] = k[i] ^ this.sm4CalciRK(k[i + 1] ^ k[i + 2] ^ k[i + 3] ^ CK[i]);
            SK[i] = k[i + 4];
        }
    };
    this.padding = function (input, mode) {
        if (input == null) {
            return null;
        }
        var ret = null;
        if (mode == this.SM4_ENCRYPT) {
            var p = parseInt(16 - input.length % 16);
            ret = input.slice(0);
            for (var i = 0; i < p; i++) {
                ret[input.length + i] = p;
            }
        } else {
            var p = input[input.length - 1];
            ret = input.slice(0, input.length - p);
        }
        return ret;
    };
    this.sm4_one_round = function (sk, input, output) {
        var i = 0;
        var ulbuf = new Array(36);
        ulbuf[0] = this.GET_ULONG_BE(input, 0);
        ulbuf[1] = this.GET_ULONG_BE(input, 4);
        ulbuf[2] = this.GET_ULONG_BE(input, 8);
        ulbuf[3] = this.GET_ULONG_BE(input, 12);
        while (i < 32) {
            ulbuf[i + 4] = this.sm4F(ulbuf[i], ulbuf[i + 1], ulbuf[i + 2], ulbuf[i + 3], sk[i]);
            i++;
        }
        this.PUT_ULONG_BE(ulbuf[35], output, 0);
        this.PUT_ULONG_BE(ulbuf[34], output, 4);
        this.PUT_ULONG_BE(ulbuf[33], output, 8);
        this.PUT_ULONG_BE(ulbuf[32], output, 12);
    };

    this.sm4_crypt_ecb = function (ctx, input) {
        if (input == null) {
            alert("input is null!");
        }
        if (ctx.isPadding && ctx.mode == this.SM4_ENCRYPT) {
            input = this.padding(input, this.SM4_ENCRYPT);
        }

        var i = 0;
        var length = input.length;
        var bous = new Array();
        for (; length > 0; length -= 16) {
            var out = new Array(16);
            var ins = input.slice(i * 16, 16 * (i + 1));
            this.sm4_one_round(ctx.sk, ins, out);
            bous = bous.concat(out);
            i++;
        }

        var output = bous;
        if (ctx.isPadding && ctx.mode == this.SM4_DECRYPT) {
            output = this.padding(output, this.SM4_DECRYPT);
        }
        for (var i = 0; i < output.length; i++) {
            if (output[i] < 0) {
                output[i] = output[i] + 256;
            }
        }
        return output;
    };

    this.sm4_crypt_cbc = function (ctx, iv, input) {
        if (iv == null || iv.length != 16) {
            alert("iv error!");
        }

        if (input == null) {
            alert("input is null!");
        }

        if (ctx.isPadding && ctx.mode == this.SM4_ENCRYPT) {
            input = this.padding(input, this.SM4_ENCRYPT);
        }

        var i = 0;
        var length = input.length;
        var bous = new Array();
        if (ctx.mode == this.SM4_ENCRYPT) {
            var k = 0;
            for (; length > 0; length -= 16) {
                var out = new Array(16);
                var out1 = new Array(16);
                var ins = input.slice(k * 16, 16 * (k + 1));

                for (i = 0; i < 16; i++) {
                    out[i] = ins[i] ^ iv[i];
                }
                this.sm4_one_round(ctx.sk, out, out1);
                iv = out1.slice(0, 16);
                bous = bous.concat(out1);
                k++;
            }
        } else {
            var temp = [];
            var k = 0;
            for (; length > 0; length -= 16) {
                var out = new Array(16);
                var out1 = new Array(16);
                var ins = input.slice(k * 16, 16 * (k + 1));
                temp = ins.slice(0, 16);
                sm4_one_round(ctx.sk, ins, out);
                for (i = 0; i < 16; i++) {
                    out1[i] = out[i] ^ iv[i];
                }
                iv = temp.slice(0, 16);
                bous = bous.concat(out1);
                k++;
            }
        }

        var output = bous;
        if (ctx.isPadding && ctx.mode == this.SM4_DECRYPT) {
            output = this.padding(output, this.SM4_DECRYPT);
        }

        for (var i = 0; i < output.length; i++) {
            if (output[i] < 0) {
                output[i] = output[i] + 256;
            }
        }
        return output;
    };
}

function SM4Util(sk) {
    // 和后端key一致
    this.secretKey = sk;
    // 当时用CBC模式的时候
    this.iv = "ZkR_SiNoSOFT=568";
    this.hexString = false;

    // ECB模式加密
    this.encryptData_ECB = function (plainText) {
        try {
            var sm4 = new SM4();
            var ctx = new SM4_Context();
            ctx.isPadding = true;
            ctx.mode = sm4.SM4_ENCRYPT;
            var keyBytes = stringToByte(this.secretKey);
            sm4.sm4_setkey_enc(ctx, keyBytes);
            var encrypted = sm4.sm4_crypt_ecb(ctx, stringToByte(plainText));
            var cipherText = base64js.fromByteArray(encrypted);
            if (cipherText != null && cipherText.trim().length > 0) {
                cipherText.replace(/(\s*|\t|\r|\n)/g, "");
            }
            return cipherText;
        } catch (e) {
            console.error(e);
            return null;
        }
    };
    // CBC模式加密
    this.encryptData_CBC = function (plainText) {
        try {
            var sm4 = new SM4();
            var ctx = new SM4_Context();
            ctx.isPadding = true;
            ctx.mode = sm4.SM4_ENCRYPT;

            var keyBytes = stringToByte(this.secretKey);
            var ivBytes = stringToByte(this.iv);

            sm4.sm4_setkey_enc(ctx, keyBytes);
            var encrypted = sm4.sm4_crypt_cbc(ctx, ivBytes, stringToByte(plainText));
            var cipherText = base64js.fromByteArray(encrypted);
            if (cipherText != null && cipherText.trim().length > 0) {
                cipherText.replace(/(\s*|\t|\r|\n)/g, "");
            }
            return cipherText;
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    var stringToByte = function stringToByte(str) {
        var bytes = new Array();
        var len, c;
        len = str.length;
        for (var i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if (c >= 0x010000 && c <= 0x10FFFF) {
                bytes.push(c >> 18 & 0x07 | 0xF0);
                bytes.push(c >> 12 & 0x3F | 0x80);
                bytes.push(c >> 6 & 0x3F | 0x80);
                bytes.push(c & 0x3F | 0x80);
            } else if (c >= 0x000800 && c <= 0x00FFFF) {
                bytes.push(c >> 12 & 0x0F | 0xE0);
                bytes.push(c >> 6 & 0x3F | 0x80);
                bytes.push(c & 0x3F | 0x80);
            } else if (c >= 0x000080 && c <= 0x0007FF) {
                bytes.push(c >> 6 & 0x1F | 0xC0);
                bytes.push(c & 0x3F | 0x80);
            } else {
                bytes.push(c & 0xFF);
            }
        }
        return bytes;
    };

    var byteToString = function byteToString(arr) {
        if (typeof arr === 'string') {
            return arr;
        }
        var str = '',
            _arr = arr;
        for (var i = 0; i < _arr.length; i++) {
            var one = _arr[i].toString(2),
                v = one.match(/^1+?(?=0)/);
            if (v && one.length == 8) {
                var bytesLength = v[0].length;
                var store = _arr[i].toString(2).slice(7 - bytesLength);
                for (var st = 1; st < bytesLength; st++) {
                    store += _arr[st + i].toString(2).slice(2);
                }
                str += String.fromCharCode(parseInt(store, 2));
                i += bytesLength - 1;
            } else {
                str += String.fromCharCode(_arr[i]);
            }
        }
        return str;
    };
};

/* harmony default export */ __webpack_exports__["a"] = (SM4Util);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("VC+f")(module), __webpack_require__("9AUj")))

/***/ }),

/***/ "urj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("IHPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_getData__ = __webpack_require__("i84Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_mUtils__ = __webpack_require__("yclV");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isEdit: false,
      confirmDialog: false,
      rejectDialog: false,
      labelListLoading: false,
      matterTypeInfo: {
        typeName: '',
        intoGeneralTable: 1
      },
      labelList: [],
      updateLoading: false,
      submitLoading: false,
      rejectLoading: false,
      rejectInfo: {
        matterRejectReason: ''
      },
      contractFileHeader: {
        allSessionId: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('allSessionId'),
        adminAccount: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('adminAccount'),
        channelId: __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["d" /* getSession */]('channelId')
      },
      recordInfo: {},
      rules: {
        matterRejectReason: [{ required: true, message: '请填写驳回理由', trigger: ['blur', 'change'] }]
      },
      radioList: [{
        label: '',
        value: 1
      }, {
        label: '',
        value: 2
      }],
      checkboxList: [{
        label: '',
        value: 1
      }, {
        label: '',
        value: 2
      }],
      fileList: [],
      matter: '',
      handleLoading: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },

  props: ['type', 'matterId', 'matterCompanyId'],
  computed: {},
  methods: {
    reset: function reset() {
      this.rejectInfo.matterRejectReason = '';
      this.$refs['rejectInfo'].resetFields();
    },
    close: function close(type) {
      if (type === 1) {
        this.$emit('init');
      }
      this.$emit('closeDialog');
    },
    init: function init() {
      this.type === 1 ? this.getMatterCompanyDetailDetail() : this.getMatterCompanyDetail();
    },
    getMatterCompanyDetailDetail: function getMatterCompanyDetailDetail() {
      var _this = this;

      this.labelListLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__service_getData__["_47" /* matterCompanyDetailDetail */](this.matterId).then(function (res) {
        _this.labelListLoading = false;
        if (res.data.code != 'success') {
          _this.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this.matterTypeInfo = res.data.data.matter ? res.data.data.matter : {};
        _this.recordInfo = res.data.data.record ? res.data.data.record : {};
        var matterCompany = res.data.data.matterCompany;
        var filedList = matterCompany.matterCompanyValue ? __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](matterCompany.matterCompanyValue) : [];
        filedList = filedList ? filedList : [];
        filedList.forEach(function (item) {
          delete item.matterTypeFiledCreateTime;
          !item.matterCompanyFiledValue ? item.matterCompanyFiledValue = '' : '';
          if (item.matterTypeFiledType === 3 && item.matterTypeFiledValue) {
            var obj = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            obj = obj ? obj : {};
            item.radioValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue : '';
            item.radioList = obj.radioList ? obj.radioList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 4 && item.matterTypeFiledValue) {
            var _obj = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            _obj = _obj ? _obj : {};
            item.checkboxValue = item.matterCompanyFiledValue ? item.matterCompanyFiledValue.split(',') : [];
            item.checkboxList = _obj.checkboxList ? _obj.checkboxList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 5) {
            item.fileList = [];
            item.uploadFileList = [];
            item.limit = 5;
            if (item.matterCompanyFiledValue) {
              var _obj2 = JSON.parse(item.matterCompanyFiledValue);
              item.fileList = _obj2 ? _obj2 : [];
              item.fileList.forEach(function (item) {
                delete item.matterCompanyFileCreateTime;
              });
              item.limit = 5 - item.fileList.length;
            }
          }
        });
        _this.labelList = filedList;
      }).catch(function (_) {
        _this.labelListLoading = false;
      });
    },
    getMatterCompanyDetail: function getMatterCompanyDetail() {
      var _this2 = this;

      this.labelListLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__service_getData__["_46" /* matterCompanyDetail */](this.matterId).then(function (res) {
        _this2.labelListLoading = false;
        if (res.data.code != 'success') {
          _this2.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this2.matterTypeInfo = res.data.data.matter ? res.data.data.matter : {};
        var filedList = res.data.data.filedList ? res.data.data.filedList : [];
        filedList.forEach(function (item) {
          delete item.matterTypeFiledCreateTime;
          item.matterCompanyFiledValue = '';
          if (item.matterTypeFiledType === 3 && item.matterTypeFiledValue) {
            var obj = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            obj = obj ? obj : {};
            item.radioValue = obj.radioValue ? obj.radioValue : '';
            item.radioList = obj.radioList ? obj.radioList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 4 && item.matterTypeFiledValue) {
            var _obj3 = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterTypeFiledValue);
            _obj3 = _obj3 ? _obj3 : {};
            item.checkboxValue = _obj3.checkboxValue ? _obj3.checkboxValue.split(',') : [];
            item.checkboxList = _obj3.checkboxList ? _obj3.checkboxList : [];
            item.matterTypeFiledValue = '';
          } else if (item.matterTypeFiledType === 5) {
            item.fileList = [];
            item.uploadFileList = [];
            if (item.matterCompanyFiledValue) {
              var _obj4 = __WEBPACK_IMPORTED_MODULE_3__config_mUtils__["p" /* strParse */](item.matterCompanyFiledValue);
              item.fileList.forEach(function (item) {
                delete item.matterCompanyFileCreateTime;
              });
              item.fileList = _obj4 ? _obj4 : [];
            }
          } else {
            item.matterCompanyFiledValue = '';
          }
        });
        _this2.labelList = filedList;
      }).catch(function (_) {
        _this2.labelListLoading = false;
      });
    },
    downloadFile: function downloadFile(row, index) {
      if (!row.matterCompanyFileUrl || !row.matterCompanyFileName) {
        this.$message({
          type: 'warning',
          message: '下载地址不存在！'
        });
        return;
      }
      // window.open(row.matterCompanyFileUrl);
      if (row.matterCompanyFileId) {
        window.location.href = 'company/matterCompany/downloadFile?matterCompanyFileId=' + row.matterCompanyFileId;
      } else {
        window.location.href = 'company/matterCompany/downloadFile?matterCompanyFileUrl=' + row.matterCompanyFileUrl + '&matterCompanyFileName=' + row.matterCompanyFileName;
      }
    },
    delFile: function delFile(arr, arr2, index) {
      var _this3 = this;

      this.$confirm('确认删除该文件？').then(function (_) {
        arr.splice(index, 1);
        _this3.$message.success('删除成功！');
        arr2.splice(index, 1);
      }).catch(function (_) {});
    },
    beforeUpdate: function beforeUpdate(file, fileList, row, index) {
      this.matter = row;
      var isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      if (this.type === 1) {
        var is5Length = row.uploadFileList.length < row.limit;
        if (!is5Length) {
          this.$message.error('当前限制选择 5 个文件');
          return false;
        }
      }
      return true;
    },
    remove: function remove(file, fileList) {
      console.log(file, fileList);
      console.log(file, fileList, 'resmove');
      // this.fileList = fileList;
      if (this.matter) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.uploadFileList) === 'object' ? this.matter.uploadFileList = fileList : '';
      } else {
        console.log('data remove file fail');
      }
    },
    success: function success(response, file, fileList) {
      if (response.code == 'success') {
        this.$message({
          type: 'success',
          message: '上传文件成功！'
        });
        if (this.matter) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.uploadFileList) === 'object' ? this.matter.uploadFileList = fileList : '';
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.matter.fileList) === 'object' ? this.matter.fileList.push({
            matterCompanyFileName: response.data.fileName,
            matterCompanyFileUrl: response.data.fileUrl
          }) : '';
        }
      }
    },
    handleExceed: function handleExceed(files, fileList, row, index) {
      if (this.type === 1) {
        this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + (row ? row.fileList ? row.fileList.length : 0 : 0)) + ' \u4E2A\u6587\u4EF6');
      } else {
        this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 5  \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
      }
    },
    error: function error(err, file, fileList) {
      this.$message({
        type: 'error',
        message: '上传文件失败！'
      });
      console.log(err, file, fileList);
    },
    checkData: function checkData() {
      var isOk = [];
      this.labelList.forEach(function (item, index) {
        if (item.need) {
          if (item.matterTypeFiledType === 3) {
            if (!item.radioValue) {
              isOk.push(3);
            } else {
              isOk.push(1);
            }
          } else if (item.matterTypeFiledType === 4) {
            if (!item.checkboxValue || item.checkboxValue.length === 0) {
              isOk.push(4);
            } else {
              isOk.push(1);
            }
          } else if (item.matterTypeFiledType === 5) {
            if (!item.fileList || item.fileList.length === 0) {
              isOk.push(5);
            } else {
              isOk.push(1);
            }
          } else {
            if (!item.matterCompanyFiledValue) {
              isOk.push(0);
            } else {
              isOk.push(1);
            }
          }
        } else {
          isOk.push(1);
        }
      });
      if (isOk.indexOf(0) !== -1) {
        this.$message.warning('\u8BF7\u586B\u5199\u5B8C\u6574\u77ED\u6587\u672C\u6216\u8005\u957F\u6587\u672C\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(3) !== -1) {
        this.$message.warning('\u8BF7\u9009\u62E9\u5355\u9009\u9879\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(4) !== -1) {
        this.$message.warning('\u8BF7\u9009\u62E9\u591A\u9009\u9879\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      } else if (isOk.indexOf(5) !== -1) {
        this.$message.warning('\u8BF7\u4E0A\u4F20\u6587\u4EF6\u6570\u636E\u540E\u5728\u63D0\u4EA4\uFF01');
        return false;
      }
      return true;
    },
    handle: function handle() {
      if (!this.checkData()) {
        return;
      }
      var arr = [];
      arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.labelList)).map(function (item) {
        if (item.matterTypeFiledType === 3) {
          item.matterCompanyFiledActualValue = '';
          var radioValue = item.radioValue;
          item.radioList.forEach(function (radio) {
            if (!radio.value == radioValue) {
              item.matterCompanyFiledActualValue = radio.label;
            }
          });
          item.matterCompanyFiledValue = radioValue;
        } else if (item.matterTypeFiledType === 4) {
          item.matterCompanyFiledActualValue = '';
          var checkboxValue = item.checkboxValue;
          var _arr = [];
          item.checkboxList.forEach(function (checkbox) {
            if (checkboxValue.indexOf(checkbox.value) !== -1) {
              _arr.push(checkbox.label);
            }
          });
          item.matterCompanyFiledActualValue = _arr.join(',');
          item.matterCompanyFiledValue = checkboxValue.join(',');
        } else if (item.matterTypeFiledType === 5) {
          delete item.uploadFileList;
        }
        return item;
      });
      var data = {
        matterCompanyId: this.matterCompanyId,
        filedList: arr
      };
      console.log(data);
      this.handleLoading = true;
      this.type === 1 ? this.editMatterCompany(data) : this.handleMatterCompany(data);
    },
    handleMatterCompany: function handleMatterCompany(data) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_getData__["_34" /* handleMatterCompany */](data).then(function (res) {
        _this4.handleLoading = false;
        if (res.data.code != 'success') {
          _this4.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this4.$message.success('操作成功！');
        _this4.close(1);
      }).catch(function (_) {
        _this4.handleLoading = false;
        _this4.$message.warning('操作失败！');
      });
    },
    editMatterCompany: function editMatterCompany(data) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2__service_getData__["O" /* editMatterCompany */](data).then(function (res) {
        _this5.handleLoading = false;
        if (res.data.code != 'success') {
          _this5.$message({
            type: 'error',
            message: res.data.message || res.data.msg
          });
          return;
        }
        _this5.$message.success('操作成功！');
        _this5.close(1);
      }).catch(function (_) {
        _this5.handleLoading = false;
        _this5.$message.warning('操作失败！');
      });
    }
  },
  components: {},
  watch: {}
});

/***/ }),

/***/ "v0B7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vGBH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vGzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNop":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vnwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("4GFx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_67d648a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_input_vue__ = __webpack_require__("/RBp");
function injectStyle (ssrContext) {
  __webpack_require__("MUKV")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67d648a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_67d648a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_form_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vqgf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vtmy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExtranetUrl; });
/* unused harmony export multipartUploadWithSts */
/* unused harmony export multitest */
/* unused harmony export deleteFile */
/* unused harmony export uploadBase64 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("lC5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("J0Oq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("aA9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);




var OSS = __webpack_require__("7sBM");
var files = [];
var client = '',
    fileName = '';
var isNotNeedRequest = false;
var notNeedClientRequest = '';
window.Promise = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a;

//获取OSS上传必须的秘钥及其他设置信息 （注意：如果拥有上传必备的秘钥以及其他配置信息，可以跳过本操作）
function multipartUploadWithSts(storeAs, file, uploadConfig) {
  //参数说明：文件名；文件；配置对象
  var action = uploadConfig.action; //请求地址
  if (uploadConfig.isNotNeedRequest && uploadConfig.clientRequest) {
    try {
      client = new OSS(uploadConfig.clientRequest); //初始化OSS对象
      multitest(client, storeAs, file, uploadConfig); //使用OSS上传文件
    } catch (e) {
      uploadConfig.reject({ err: e, storeAs: storeAs });
    }
    return;
  } else if (!action) {
    uploadConfig.reject({
      uploadCode: 0,
      message: '\u5982\u679C\u8981\u8BF7\u6C42\u83B7\u53D6\u914D\u7F6E\u63A5\u53E3\uFF0C\u8BF7\u7ED9\u5B9A\u63A5\u53E3\u5730\u5740\uFF01',
      storeAs: storeAs
    });
  }
  OSS.urllib.request(action, {
    method: 'GET'
  }, function (err, response) {
    var result = void 0,
        errmsg = void 0;
    if (err) {
      uploadConfig.reject({ err: err, storeAs: storeAs });
      return console.error(err);
    }
    try {
      result = JSON.parse(response);
    } catch (e) {
      errmsg = 'parse sts response info error: ' + e.message;
      uploadConfig.reject({ err: e, storeAs: storeAs });
      return console.error(errmsg);
    }
    var clientRequest = {
      accessKeyId: result.AccessKeyId, //通过阿里云控制台创建的access key
      accessKeySecret: result.AccessKeySecret, //通过阿里云控制台创建的access secret。
      stsToken: result.SecurityToken, //使用临时授权方式。
      bucket: 'park-static', // 通过控制台创建的bucket。
      endpoint: 'oss.zhihuipk.com', //OSS域名。
      cname: true,
      region: 'oss-cn-hangzhou'
    };
    //上传前的准备
    try {
      client = new OSS(clientRequest); //初始化OSS对象
      multitest(client, storeAs, file, uploadConfig); //使用OSS上传文件
    } catch (e) {
      uploadConfig.reject({ err: e, storeAs: storeAs });
    }
  });
}

function uploadBase64(storeAs, base64url, config) {
  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(',');
    //注意base64的最后面中括号和引号是不转译的   
    var _arr = arr[1].substring(0, arr[1].length - 2);
    var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  }
  var file = dataURLtoBlob(base64url);
  files = config.fileList ? config.fileList : []; //当前文件列表
  var fileNumber = config.fileNumber,
      //文件限制数量
  action = config.action,
      //请求地址
  template = config.template,
      //文件添加时的其他默认值
  cb = config.cb; //文件上传时的回调函数
  isNotNeedRequest = !!config.isNotNeedRequest; //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
  var fileTemplate = template && template.constructor === Object ? template : {},
      progressCb = cb && cb.constructor === Function ? cb : '';
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    //上传配置项
    var uploadConfig = {
      action: action, //请求地址
      resolve: resolve, //Promise(成功的返回)
      reject: reject, // Promise(失败的返回)
      progressCb: progressCb //上传进度回调函数
    };
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(uploadConfig, config);
    try {
      client = new OSS(uploadConfig.clientRequest); //初始化OSS对象
      multitest(client, storeAs, file, uploadConfig); //使用OSS上传文件
    } catch (e) {
      uploadConfig.reject({ err: e, storeAs: storeAs });
    }
  });
}

//使用OSS上传文件
function multitest(ossClient, storeAs, file, multitestConfig) {
  //参数说明：oss对象；文件名；文件；配置对象
  var checkpoint_temp = void 0,
      //当前节点（重新上传时需要）
  cpt = multitestConfig.cpt,
      //上一个节点（重新上传时需要）
  progressCb = multitestConfig.progressCb; //上传进度回调函数
  if (cpt) {
    //如果有断点则继续上一个节点上传该文件
    console.log("multitest with cpt", cpt);
    ossClient.multipartUpload(ossClient.options.SystemOssChannelName + '/' + storeAs, file, {
      parallel: 2,
      checkpoint: cpt,
      //进度回调函数
      progress: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(percent, storeAs, cpt) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  //参数说明：当前上传进度的；当前上传的文件名；当前上传节点（进行重新上传时使用）
                  progressCb && progressCb(percent, storeAs, cpt);
                  checkpoint_temp = cpt;

                case 2:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function progress(_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        }

        return progress;
      }()
    }).then(function (result) {
      //成功的返回
      multitestConfig.resolve({
        data: result,
        fileList: files
      });
    }).catch(function (err) {
      //失败的返回
      var errObj = { err: err, storeAs: storeAs };
      checkpoint_temp !== undefined && checkpoint_temp !== null && (errObj.cpt = checkpoint_temp);
      multitestConfig.reject(errObj); //将当前节点返回，使其可以重新从该节点继续上传文件
    });
  } else {
    console.log("multitest without cpt");
    ossClient.multipartUpload(ossClient.options.SystemOssChannelName + '/' + storeAs, file instanceof Blob ? file : new Blob([file]), {
      parallel: 2,
      //进度回调函数
      progress: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(percent, cpt) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  //参数说明：当前上传进度的；当前上传的文件名；当前上传节点（进行重新上传时使用）
                  progressCb && progressCb(percent, storeAs, cpt);
                  checkpoint_temp = cpt;

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function progress(_x4, _x5) {
          return _ref2.apply(this, arguments);
        }

        return progress;
      }()
    }).then(function (result) {
      //成功的返回
      multitestConfig.resolve({
        data: result,
        fileList: files
      });
    }).catch(function (err) {
      //失败的返回
      var errObj = { err: err, storeAs: storeAs };
      checkpoint_temp !== undefined && checkpoint_temp !== null && (errObj.cpt = checkpoint_temp);
      multitestConfig.reject(errObj); //将当前节点返回，使其可以重新从该节点继续上传文件
    });
  }
}

//获取选中的文件
function upload(e, config, type) {
  // type === 1 代表传进来的 是e.target.files[0]
  files = config.fileList ? config.fileList : []; //当前文件列表
  var fileNumber = config.fileNumber,
      //文件限制数量
  action = config.action,
      //请求地址
  template = config.template,
      //文件添加时的其他默认值
  cb = config.cb; //文件上传时的回调函数
  isNotNeedRequest = !!config.isNotNeedRequest; //默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
  var fileTemplate = template && template.constructor === Object ? template : {},
      progressCb = cb && cb.constructor === Function ? cb : '';
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

    var file = void 0,
        target = void 0;
    if (type) {
      file = e;
    } else {
      target = e.target.files || e.dataTransfer.files;
      file = target[0]; //文件
    }

    var storeAs = new Date().getTime() + '=-=' + file.name; //文件名
    fileName = storeAs; //文件名
    var fileType = ['image/png', 'image/jpeg ', 'image/jpg', 'image/gif'].indexOf(file.type) > -1; //获取文件类型
    var hasFile = files.filter(function (item) {
      return item.name === storeAs;
    }); //查找该文件
    if (isNotNeedRequest) {
      notNeedClientRequest = config.clientRequest; //获取OSS上传配置项
      if (!notNeedClientRequest) {
        reject({
          uploadCode: 0,
          message: '\u5982\u679C\u4E0D\u9700\u8981\u8BF7\u6C42\u83B7\u53D6\u914D\u7F6E\u63A5\u53E3\uFF0C\u8BF7\u7ED9\u5B9A\u89C4\u8303\u7684\u914D\u7F6E\u5BF9\u8C61\uFF01\u8BE6\u60C5\u8BF7\u67E5\u770BOSS\u6587\u6863'
        });
        return;
      }
    }
    if (fileNumber && fileNumber <= files.length) {
      //文件限制数量
      reject({
        uploadCode: 0,
        message: '\u6700\u5927\u4E0A\u4F20' + fileNumber + '\u4E2A\u6587\u4EF6\uFF01'
      });
      return;
    }
    if (hasFile.length) {
      //如果本次已经上传了该文件则提示
      reject({
        uploadCode: 0,
        message: '该文件已经上传过了'
      });
      console.warning('该文件已经上传过了');
    } else {
      //上传配置项
      var uploadConfig = {
        action: action, //请求地址
        resolve: resolve, //Promise(成功的返回)
        reject: reject, // Promise(失败的返回)
        progressCb: progressCb //上传进度回调函数
      };
      if (fileType) {
        //如果该文件是图片格式，则使先转换成base64
        /*target*/
        getImgUrl(file).then(function (res) {
          if (fileNumber === 1) {
            config.fileList ? config.fileList = [] : files = [];
          }
          files.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(fileTemplate, {

            // target: target[0],//文件
            target: file, //文件

            name: storeAs, //文件名
            type: 1, //文件格式为图片
            fileUrl: res, //该文件的图片base64
            address: '' //该文件的OSS地址
          }));
          //是否请求接口获取配置信息
          if (isNotNeedRequest) {
            try {
              client = new OSS(notNeedClientRequest); //初始化OSS对象
              multitest(client, storeAs, file, uploadConfig); //使用OSS上传文件
            } catch (e) {
              uploadConfig.reject({ err: e, storeAs: storeAs });
            }
          } else {
            multipartUploadWithSts(storeAs, file, uploadConfig); //获取OSS上传必须的秘钥及其他设置信息
          }
        });
      } else {
        if (fileNumber === 1) {
          config.fileList ? config.fileList = [] : files = [];
        }
        files.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(fileTemplate, {

          // target: target[0],//文件
          target: file, //文件

          name: storeAs, //文件名
          type: 0, //文件格式为其他类型的文件
          address: '' //该文件的OSS地址
        }));
        //是否请求接口获取配置信息
        if (isNotNeedRequest) {
          try {
            client = new OSS(notNeedClientRequest); //初始化OSS对象
            multitest(client, storeAs, file, uploadConfig); //使用OSS上传文件
          } catch (e) {
            uploadConfig.reject({ err: e, storeAs: storeAs });
          }
        } else {
          multipartUploadWithSts(storeAs, file, uploadConfig); //获取OSS上传必须的秘钥及其他设置信息
        }
      }
    }
  });
}

//获取图片base64
function getImgUrl(files) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (res, err) {
    /*const len = files.length;
    for (let i = 0; i < len; i++) {
      let reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = function (e) {
        let image = new Image();
        image.src = this.result;
        res(this.result);
      };
    }*/
    var reader = new FileReader();
    reader.readAsDataURL(files);
    reader.onload = function (e) {
      var image = new Image();
      image.src = this.result;
      res(this.result);
    };
  });
}

/**获取图片外网访问地址
 * 如果图片的读写权限为私有
 * client.signatureUrl("你的图片地址/名字")
 例如我的图片(名字为testImg)在根目录
 client.signatureUrl("testImg");//返回的就是带加密签名的图片路径，复制这个路径到浏览器上，便可以在浏览器上访问

 * 如果图片的读写权限为公共
 client.getObjectUrl("你的图片名字");//返回的就是不带签名的图片路径，复制路径也可以在浏览器上访问.
 */
function getExtranetUrl(name, type) {
  if (client) {
    return type === 1 ? client.signatureUrl(name) : client.getObjectUrl(name); //1 为私有
  }
}

//删除OSS服务器上的文件
function deleteFile(name, index) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    client && client.delete ? client.delete(name).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      reject(err);
    }) : reject({ errCode: 999, errContent: 'client is null , Please upload the file before deleting it !' });
  });
}



/***/ }),

/***/ "wG2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_left_navbar_vue__ = __webpack_require__("mLUR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_59cfa138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_left_navbar_vue__ = __webpack_require__("+uJk");
function injectStyle (ssrContext) {
  __webpack_require__("GVgq")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59cfa138"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_left_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_59cfa138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_left_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wYzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_create_invoice_vue__ = __webpack_require__("/Me2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_15fe2c1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_create_invoice_vue__ = __webpack_require__("Bu6g");
function injectStyle (ssrContext) {
  __webpack_require__("zHEt")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_create_invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_15fe2c1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_create_invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xBfx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xvNd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yH66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.fileList),function(item,index){return (item.imgUrl)?_c('div',{key:index,staticClass:"text-center contract-upload-file"},[(!_vm.img)?_c('div',[_c('div',{staticClass:"position-relative"},[(item.imgUrl)?_c('img',{staticClass:"file-img",staticStyle:{"cursor":"pointer"},attrs:{"src":item.imgUrl,"alt":"图片不见了"},on:{"click":function($event){return _vm.lookBigImg(item)}}}):(!item.imgUrl&&item.type==='video')?_c('img',{staticClass:"file-img",staticStyle:{"cursor":"pointer"},attrs:{"src":__webpack_require__("jv0K"),"alt":"图片不见了"},on:{"click":function($event){return _vm.lookFile(item)}}}):_vm._e(),_vm._v(" "),(!item.imgUrl&&item.type!=='video')?_c('img',{staticClass:"file-img",attrs:{"src":__webpack_require__("c0HD"),"alt":"图片不见了"}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"position el-icon-error",staticStyle:{"right":"6px","top":"-6px","cursor":"pointer"},on:{"click":function($event){return _vm.del(_vm.fileList,index,1)}}})]),_vm._v(" "),_c('p',{staticClass:"ellipsis",attrs:{"title":item.fileName}},[_vm._v(_vm._s(item.fileName))])]):_c('div',{staticClass:"position-relative"},[(item.imgUrl)?_c('img',{staticClass:"img-type",attrs:{"src":item.imgUrl,"alt":"图片不见了"},on:{"click":function($event){return _vm.lookBigImg(item)}}}):_vm._e(),_vm._v(" "),(!item.imgUrl)?_c('img',{staticClass:"img-type",attrs:{"src":__webpack_require__("D9Wk"),"alt":"图片不见了"}}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"position el-icon-error",staticStyle:{"right":"-6px","top":"-8px","cursor":"pointer","color":"red"},on:{"click":function($event){return _vm.del(_vm.fileList,index,1)}}})])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"el-upload-file"},[_c('i',{staticClass:"el-icon-upload2"}),_vm._v("\n    上传\n    "),_c('input',{ref:"file",attrs:{"type":"file","accept":_vm.accept,"disabled":_vm.disabled},on:{"change":_vm.checkOss}})]),_vm._v(" "),_c('el-dialog',{staticClass:"file-big-img append-body",attrs:{"title":"查看大图","visible":_vm.lookBigImgDialog,"top":"5%","append-to-body":true,"center":"","width":"900px"},on:{"update:visible":function($event){_vm.lookBigImgDialog=$event}}},[_c('div',{staticClass:"dialog-warp text-center"},[_c('img',{staticClass:"big-img",attrs:{"src":_vm.imgUrl,"alt":"图片不见了"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yclV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setSession */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSession; });
/* unused harmony export setStore */
/* unused harmony export getStore */
/* unused harmony export removeStore */
/* unused harmony export getQueryString */
/* unused harmony export islength */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return rule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return phoneRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return phoneRule2; });
/* unused harmony export phoneRule3 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return phoneRule5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return idcard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cardNumRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return noChinese; });
/* unused harmony export overscroll */
/* unused harmony export unique */
/* unused harmony export showBack */
/* unused harmony export toast */
/* unused harmony export currency */
/* unused harmony export isEmoji */
/* unused harmony export selectImgFile */
/* unused harmony export empty */
/* unused harmony export date */
/* unused harmony export getFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectOtherFile; });
/* unused harmony export throttle */
/* unused harmony export del */
/* unused harmony export getCascaderObj */
/* unused harmony export deepClone */
/* unused harmony export getType */
/* unused harmony export deepCopy */
/* unused harmony export getState */
/* unused harmony export getChartType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return billTypeNew; });
/* unused harmony export removeFile */
/* unused harmony export ridFirstAndEnd */
/* unused harmony export resizeMe */
/* unused harmony export resizeMe2 */
/* unused harmony export chinese */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return number; });
/* unused harmony export number0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return price; });
/* unused harmony export email */
/* unused harmony export bankCode */
/* unused harmony export http */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return numberCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return strParse; });
/* unused harmony export getFormData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return replaceTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return toDateTime2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fileUrl; });
/* unused harmony export image2base64 */
/* unused harmony export download */
/* unused harmony export handlePdfLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("HzJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__story___ = __webpack_require__("Zsfk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("Y9Nk");




var _this2 = this,
    _arguments = arguments;



/**
 * 存储localSession
 */
var setSession = function setSession(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.sessionStorage.setItem(name, content);
};

/**
 * 获取localSession
 */
var getSession = function getSession(name) {
  if (!name) return;
  return window.sessionStorage.getItem(name);
};
/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};
/**
 * 获取地址栏参数
 */
var getQueryString = function getQueryString(name) {
  var pam = window.location.href.split('?')[1] || '';
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = pam.match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
};

/**
 * 补0
 */
var islength = function islength(num) {
  if (Number(num) < 10) {
    return '0' + num;
  } else {
    return num;
  }
};

/**
 * 表单校验
 */
var rule = {
  alert: function alert(mess) {
    __WEBPACK_IMPORTED_MODULE_3__story___["a" /* default */].state.alertMessage = mess;
    __WEBPACK_IMPORTED_MODULE_3__story___["a" /* default */].state.showAlert = true;
  },
  empty: function empty(str, mess) {
    //不能为空
    if (str == '') {
      this.alert(mess);
      return false;
    } else {
      return true;
    }
  },
  phone: function phone(str) {
    //手机号校验
    var myReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!myReg.test(str)) {
      this.alert('手机号码有误');
      return false;
    } else {
      return true;
    }
  },
  password: function password(str) {
    //登录密码校验（必须包含数字密码 8-16 可输入字符）
    var regex = /^(?![^a-zA-Z]+$)(?!\D+$).{8,16}$/;
    if (regex.test(str)) {
      return true;
    } else {
      return false;
    }
  }

};

var phoneRule = /^1(3|4|5|6|7|8|9)\d{9}$/; //11位的电话号码
var phoneRule2 = /(^(\d{3,4}-)?\d{7,8})$|((^(\d{3,4})?\d{7,8})$)|(^1(3|4|5|6|7|8|9)\d{9}$)/; //8位固话+11位的电话号码
var phoneRule3 = /(^([0-9]+(-?)[0-9]+)+)$/; //不限位数，只限制数字加-的电话号码 110等电话也可以输入
var phoneRule5 = /^\d{11}$/; //联系方式只需限制11位数字
var chinese = /^[\u4E00-\u9FA5]+$/;
var idcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
var number = /(^[1-9]([0-9]+)$)|(^[1-9]?$)/;
var number0 = /(^[1-9]([0-9]+)$)|(^(0){1}$)|(^[1-9]?$)/;
var price = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
var email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
var bankCode = /^([1-9]{1})(\d{14}|\d{18})$/;
var http = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:\/~\+#][^\u4E00-\u9FA5]*[\w\-\@?^=%&\/~\+#][^\u4E00-\u9FA5])?/;
var numberCode = /^(\w)+$/;
var cardNumRule = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/; //车牌号验证规则
var noChinese = /^[0-9a-zA-Z\u0000-\u00FF]+$/; //只能输入数字、字母、半角符号（即不包括中文符号和汉子）
var overscroll = function overscroll(els) {
  for (var i = 0; i < els.length; ++i) {
    var el = els[i];
    el.addEventListener('touchstart', function () {
      var top = this.scrollTop,
          totalScroll = this.scrollHeight,
          currentScroll = top + this.offsetHeight;
      if (top === 0) {
        this.scrollTop = 1;
      } else if (currentScroll === totalScroll) {
        this.scrollTop = top - 1;
      }
    });
    el.addEventListener('touchmove', function (evt) {
      if (this.offsetHeight < this.scrollHeight) evt._isScroller = true;
    });
  }
}; //禁止body的滚动事件
document.body.addEventListener('touchmove', function (evt) {
  if (!evt._isScroller) {
    evt.preventDefault();
  }
}); //给class为.scroll的元素加上自定义的滚动事件
//overscroll(document.querySelectorAll('.scroll'));


//删除数组指定的某个元素
Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

//数组去重
var unique = function unique(arr) {
  return arr.filter(function (element, index, self) {
    return self.indexOf(element) === index;
  });
};

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1, //month
    "d+": this.getDate(), //day
    "h+": this.getHours(), //hour
    "m+": this.getMinutes(), //minute
    "s+": this.getSeconds(), //second
    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
    "S": this.getMilliseconds() //millisecond
  };
  var week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  if (/(w+)/.test(format)) {
    format = format.replace(RegExp.$1, week[this.getDay()]);
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

Date.prototype.add = function (part, value) {
  value *= 1;
  if (isNaN(value)) {
    value = 0;
  }
  switch (part) {
    case "y":
      this.setFullYear(this.getFullYear() + value);
      break;
    case "m":
      this.setMonth(this.getMonth() + value);
      break;
    case "d":
      this.setDate(this.getDate() + value);
      break;
    case "h":
      this.setHours(this.getHours() + value);
      break;
    case "n":
      this.setMinutes(this.getMinutes() + value);
      break;
    case "s":
      this.setSeconds(this.getSeconds() + value);
      break;
    default:

  }
  return this;
};

//alert(new Date().add("m", -1).format('yyyy-MM-dd hh:mm:ss'));

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
var showBack = function showBack(el, callback) {
  var requestFram = void 0;
  var oldScrollTop = void 0;

  document.addEventListener('scroll', function () {
    showBackFun();
  }, false);
  document.addEventListener('touchstart', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchmove', function () {
    showBackFun();
  }, { passive: true });

  document.addEventListener('touchend', function () {
    oldScrollTop = el.getPosition().top;
    moveEnd();
  }, { passive: true });

  var moveEnd = function moveEnd() {
    requestFram = requestAnimationFrame(function () {
      if (el.getPosition().top != oldScrollTop) {
        oldScrollTop = el.getPosition().top;
        moveEnd();
      } else {
        cancelAnimationFrame(requestFram);
      }
      showBackFun();
    });
  };

  //判断是否达到目标点
  var showBackFun = function showBackFun() {
    if (el.getPosition().top > 500) {
      callback(true);
    } else {
      callback(false);
    }
  };
};

var toast = function toast() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

  var toast = document.createElement('div');
  toast.className = 'common-toast common-toast-show';
  toast.innerHTML = msg;
  document.body.appendChild(toast);
  toast.style.display = 'block';
  toast.style.margin = '-' + toast.offsetHeight / 2 + 'px 0 0 -' + toast.offsetWidth / 2 + 'px';
  var timer = setTimeout(function () {
    toast.className = 'common-toast common-toast-hide';
    clearTimeout(timer);
    var timer2 = setTimeout(function () {
      document.body.removeChild(toast);
      clearTimeout(timer2);
    }, 200);
  }, time);
};

var digitsRE = /(\d{3})(?=\d)/g;

function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

/**
 * 检查是否为Emoji
 */
var isEmoji = function isEmoji(name) {
  if (escape(name).toLocaleLowerCase().match(/(\%\ue[0-9a-f]{3})|(\%\ud[0-9a-f]{3})/)) {
    return true;
  } else {
    return false;
  }
};

var resizeMe = function resizeMe(img, maxW, maxH, nocheck) {

  var browser = {
    versions: function () {
      var u = navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger', //是否微信
        qq: u.match(/\sQQ/i) == " qq" //是否QQ
      };
    }()
  };

  var canvas = document.createElement('canvas');
  var width = img.width;
  var height = img.height;
  var max_width = maxW || 640;
  var max_height = maxH || 640;
  var max_size = 300; //k
  if (width > max_width) {
    height *= max_width / width;
    height = Math.round(height);
    width = max_width;
  }
  if (height > max_height) {
    width *= max_height / height;
    width = Math.round(width);
    height = max_height;
  }
  //将图片放入canvas，并重置canvas大小
  if (browser.versions.ios || browser.versions.webApp) {
    var mpImg = new MegaPixImage(img);
    canvas.width = width;
    canvas.height = height;
    mpImg.render(canvas, { width: width, height: height });
  } else {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
  }
  var res,
      quality = .7,
      resSize,
      ratio = 1;

  res = canvas.toDataURL("image/jpeg", quality); // 截取canvas对应的jpg图片，并且画质为70%（默认就是70%，可以改变）

  // Android 2.x、Android 4.1.2、4.3 的 toDataURL 不支持jpeg格式；
  if (res.substr(0, "data:image/png".length) == "data:image/png" || res.substr(0, 6) == "data:,") {
    var encoder = new JPEGEncoder();
    res = encoder.encode(canvas.getContext("2d").getImageData(0, 0, width, height), quality * 100, true);
  }
  resSize = Math.ceil(res.length / 1024); //k

  if (resSize > max_size && !nocheck) {
    ratio = Math.ceil(Math.sqrt(max_size / resSize) * 100) / 100;
    if (ratio >= .9) {
      ratio -= .1;
    }

    res = resizeMe(img, max_width * ratio, max_height * ratio, true);
  }
  return res;
};

var resizeMe2 = function resizeMe2(img) {
  var canvas = document.createElement('canvas');
  var ress = resizeMe(img);
  var imgs = new Image();
  imgs.src = ress;

  var prom = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    imgs.onload = function () {
      var height = imgs.height;
      var width = imgs.width;
      var widthheight = height >= width ? width : height;
      canvas.width = widthheight;
      canvas.height = widthheight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(imgs, (width - widthheight) / 2, (height - widthheight) / 2, widthheight, widthheight, 0, 0, widthheight, widthheight);
      var res = canvas.toDataURL("image/jpeg", 1); // 截取canvas对应的jpg图片，并且画质为70%（默认就是70%，可以改变）
      // Android 2.x、Android 4.1.2、4.3 的 toDataURL 不支持jpeg格式；
      if (res.substr(0, "data:image/png".length) == "data:image/png" || res.substr(0, 6) == "data:,") {
        var encoder = new JPEGEncoder();
        res = encoder.encode(canvas.getContext("2d").getImageData(0, 0, widthheight, widthheight), 100, true);
      }
      resolve(res);
    };
  });

  return prom;
};

/**将选中的图片转化成base64
 * @param files
 */
var imgFile = function imgFile(files) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res, err) {
    var image = new Image();
    var _this = _this2;
    var leng = files.length;
    for (var i = 0; i < leng; i++) {
      var reader = new FileReader();
      reader.readAsDataURL(files[i]);
      reader.onload = function (e) {
        var image = new Image();
        image.src = this.result;
        image.onload = function () {
          var resized = resizeMe(image);
          if (!resized) {
            err('图片加载出错，请选择其他图片！');
            return;
          } else {
            res(resized);
          }
        };
      };
    }
  });
};

/**
 * 选择图片
 */
var selectImgFile = function selectImgFile(e, message, type) {
  var files = e.target.files || e.dataTransfer.files;
  console.log(files);
  type = type || ['image/png', 'image/jpeg', 'image/gif', 'application/pdf'];
  // list = list || 0;
  var ok = [];
  if (type instanceof Array) {
    type.forEach(function (item) {
      ok.push(files[0].type === item ? 0 : 1);
    });
  } else {
    ok.push(files[0].type === type ? 0 : 1);
  }
  if (!files.length) return;
  if (ok.indexOf(0) === -1) {
    message({
      type: 'error',
      message: '图片类型选择错误！'
    });
    return;
  }
  if (files[0].size >= 20 * 1024 * 1024) {
    message({
      type: 'error',
      message: '选择图片最大为20M'
    });
    return;
  }
  if (typeof FileReader === 'undefined') {
    //globel.toast('不支持图片上传');
    return false;
  }
  return imgFile(files);
};

var empty = function empty(val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return val;
  }
};
var date = function date(val) {
  switch (val) {
    case null:
    case undefined:
    case '':
      return '-';
    default:
      return new Date(val).format('yyyy-MM-dd hh:mm:ss');
  }
};

var getFilters = function getFilters(arr, val) {
  arr = arr || [];
  var message = '';
  arr.forEach(function (item) {
    if (item.value === val) {
      message = item.label;
      return;
    }
  });
  return message;
};
/**
 * 选择文件
 */
var selectOtherFile = function selectOtherFile(e, message, size, type) {
  var files = e.target.files || e.dataTransfer.files;
  var ok = [];
  if (type) {
    if (type instanceof Array) {
      type.forEach(function (item) {
        ok.push(files[0].type === item ? 0 : 1);
      });
    } else {
      ok.push(files[0].type === type ? 0 : 1);
    }
  } else {
    ok.push(0);
  }
  console.log(files);
  if (!files.length) return;
  if (ok.indexOf(0) === -1) {
    message({
      type: 'error',
      message: '文件类型选择错误！'
    });
    return;
  }
  if (files[0].size >= size * 1024 * 1024) {
    message({
      type: 'error',
      message: '\u9009\u62E9\u6587\u4EF6\u6700\u5927\u4E3A' + size + 'M'
    });
    return;
  }
  if (typeof FileReader === 'undefined') {
    //globel.toast('不支持图片上传');
    return false;
  }
  return files;
};
var throttle = function throttle(func, delay) {
  //函数节流
  var timer = null;
  var startTime = Date.now();
  return function () {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = _this2;
    var args = _arguments;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, args);
      startTime = Date.now();
    } else {
      timer = setTimeout(func, remaining);
    }
  };
};
var del = function del(arr, index, type) {
  arr.splice(index, 1);
  if (type) {
    var file = document.getElementById(type);
    file.value = ''; //虽然file的value不能设为有字符的值，但是可以设置为空值
  }
};
/**
 *获取级联选择器的选项
 * @param val
 * @param opt
 * @param config
 * @returns {*}
 */
var getCascaderObj = function getCascaderObj(val, opt, config) {
  var value = config || 'value';
  return val.map(function (value, index, array) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(opt), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var itm = _step.value;

        if (itm[value] == val) {
          opt = itm.children;
          return itm;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  });
};
/**
 *获取选择器的选项
 * @param val
 * @param opt
 * @returns {string}
 */
var deepClone = function deepClone(val, opt) {
  var arr = '',
      item;
  if (val.constructor == Array) {
    val.map(function (value, index, array) {
      item = opt.filter(function (item) {
        return item.value === value;
      })[0];
      return item ? arr = item : '';
    });
  } else {
    item = opt.filter(function (item) {
      return item.value === val;
    })[0];
    return item ? arr = item : '';
  }
  return arr;
};
var getType = function getType(obj) {
  //tostring会返回对应不同的标签的构造函数
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};
var deepCopy = function deepCopy(o) {
  if (o instanceof Array) {
    var n = [];
    for (var i = 0; i < o.length; ++i) {
      n[i] = deepCopy(o[i]);
    }
    return n;
  } else if (o instanceof Function) {
    var n = new Function("return " + o.toString())();
    return n;
  } else if (o instanceof Object) {
    var n = {};
    for (var i in o) {
      n[i] = deepCopy(o[i]);
    }
    return n;
  } else {
    return o;
  }
};
var getState = function getState(val) {
  switch (val) {
    case 0:
      return '待招商';
    case 1:
      return '已招商';
    case 2:
      return '已锁定';

  }
};

var getChartType = function getChartType(val) {
  switch (val) {
    case 0:
      return '商务';
    case 1:
      return '办公';
    case 2:
      return '工位';
  }
};
var billTypeNew = function billTypeNew(val) {
  switch (val) {
    case 1:
      return '租赁费';
    case 2:
      return '物业费';
    case 3:
      return '车位费';
    case 4:
      return '租赁押金';
    case 5:
      return '物业押金';
    case 6:
      return '车位押金';
    case 7:
      return '公寓租金';
    case 8:
      return '公寓押金';
    case 9:
      return '公寓物业租金';
    case 10:
      return '公寓物业押金';
    case 11:
      return '租赁自定义账单';
    case 12:
      return '物业自定义账单';
    default:
      return '-';
  }
};

/**
 *重置文件选择
 * @param id
 */
var removeFile = function removeFile(id) {
  var fileObj = document.getElementById(id);
  if (fileObj) {
    fileObj.value = '';
  }
};

var ridFirstAndEnd = function ridFirstAndEnd(arr) {
  var str = '';
  arr.forEach(function (item, index) {
    if (index == 0) {
      str += item;
    } else {
      str += ',' + item;
    }
  });
  return str;
};


/**
 *用JSON.parse()转译字符串的判断
 * @param str
 * @returns {*}
 */
var strParse = function strParse(str) {
  switch (str) {
    case undefined:
    case 'undefined':
      return undefined;
    case null:
    case 'null':
      return null;
    case '':
      return '';
    default:
      try {
        return str ? JSON.parse(str) : '';
      } catch (err) {
        return '';
      }
  }
};

/**
 * 获取表单数据
 * @param o
 * @param j
 * @returns {FormData}
 */
var getFormData = function getFormData(o, j) {
  var formData = new FormData();

  var _loop = function _loop(i) {
    if (getType(o[i]) === 'array') {
      // formData.append(i, o[i]);
      o[i].forEach(function (item) {
        formData.append(i, item);
      });
    } else {
      formData.append(i, o[i]);
    }
  };

  for (var i in o) {
    _loop(i);
  }
  return formData;
};
/**
 * 转换前先替换为 IE 可识别的格式
 * @param time
 * @returns {string}
 */
var replaceTime = function replaceTime(time) {
  return typeof time === 'string' ? time.replace(/-/g, '/') : time;
};

var toDateTime = function toDateTime(time) {
  return time ? new Date(time).format("yyyy-MM-dd hh:mm:ss") : "";
};

var toDateTime2 = function toDateTime2(time) {
  return time ? new Date(time).format("yyyy-MM-dd") : "";
};

/**判断文件格式
 * @param fileUrl
 */
var fileUrl = function fileUrl(url) {
  // 后缀获取
  var suffix = '';
  // 获取类型结果
  var result = '';
  try {
    var flieArr = url.split('.');
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    return false;
  }
  suffix = suffix.toLocaleLowerCase();
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  // 进行图片匹配
  result = imglist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'image';
  }
  // 匹配txt
  var txtlist = ['txt'];
  result = txtlist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'txt';
  }
  // 匹配 excel
  var excelist = ['xls', 'xlsx'];
  result = excelist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'excel';
  }
  // 匹配 word
  var wordlist = ['doc', 'docx'];
  result = wordlist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'word';
  }
  // 匹配 pdf
  var pdflist = ['pdf'];
  result = pdflist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'pdf';
  }
  // 匹配 ppt
  var pptlist = ['ppt', 'pptx'];
  result = pptlist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'ppt';
  }
  // 匹配 视频
  var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
  result = videolist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'video';
  }
  // 匹配 音频
  var radiolist = ['mp3', 'wav', 'wmv'];
  result = radiolist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'radio';
  }

  var packagelist = ['zip', 'rar'];
  result = packagelist.find(function (item) {
    return item === suffix;
  });
  if (result) {
    return 'package';
  }
  // 其他 文件类型
  return 'other';
};

function image2base64(img) {
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var mime = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
  var dataUrl = canvas.toDataURL("image/" + mime);
  return dataUrl;
}

function download(url) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  function iframeLoad() {
    console.log('iframe onload');
    var win = iframe.contentWindow;
    var doc = win.document;
    if (win.location.href === url) {
      if (doc.body.childNodes.length > 0) {
        // response is error
      }
      iframe.parentNode.removeChild(iframe);
    }
  }
  if ('onload' in iframe) {
    iframe.onload = iframeLoad;
  } else if (iframe.attachEvent) {
    iframe.attachEvent('onload', iframeLoad);
  } else {
    iframe.onreadystatechange = function onreadystatechange() {
      if (iframe.readyState === 'complete') {
        iframeLoad;
      }
    };
  }
  iframe.src = '';
  document.body.appendChild(iframe);

  setTimeout(function loadUrl() {
    iframe.contentWindow.location.href = url;
  }, 50);
}

/**
 * @deprecated 处理 pdf url，使其不在浏览器打开
 * @param {string} url
 */

function handlePdfLink(url, filename) {
  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$http.fetch(url, {
    method: 'get',
    responseType: 'arraybuffer'
  }).then(function (res) {
    if (res.status !== 200) {
      return res.json();
    }
    return res.arrayBuffer();
  }).then(function (blobRes) {
    // 生成 Blob 对象，设置 type 等信息
    var e = new Blob([blobRes], {
      type: 'application/octet-stream',
      'Content-Disposition': 'attachment'
    });
    // 将 Blob 对象转为 url
    var link = window.URL.createObjectURL(e);
    var a = document.createElement('a');
    a.href = link;
    a.download = filename;
    a.click();
  }).catch(function (err) {
    console.error(err);
  });
}

/***/ }),

/***/ "yd53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog_warp",staticStyle:{"padding-top":"0"}},[_c('el-form',{ref:"info",staticClass:"dialog_form",attrs:{"model":_vm.info,"rules":_vm.rule,"size":"small","label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":16,"offset":4}},[_c('el-form-item',{attrs:{"label":"反馈标题：","prop":"feedTitle"}},[_c('el-input',{attrs:{"placeholder":"请输入反馈标题"},model:{value:(_vm.info.feedTitle),callback:function ($$v) {_vm.$set(_vm.info, "feedTitle", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.feedTitle"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"类型：","prop":"feedType"}},[_c('el-select',{attrs:{"placeholder":"请选择类型"},model:{value:(_vm.info.feedType),callback:function ($$v) {_vm.$set(_vm.info, "feedType", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.feedType"}},_vm._l((_vm.feedbackTypeList),function(item,index){return _c('el-option',{key:item.feedbackTypeId,attrs:{"label":item.feedbackTypeName,"value":item.feedbackTypeId}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"处理反馈：","prop":"feedContent"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"请输入反馈内容","rows":4},model:{value:(_vm.info.feedContent),callback:function ($$v) {_vm.$set(_vm.info, "feedContent", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"info.feedContent"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容图片："}},[_c('div',{staticClass:"flex-box"},[_c('v-upload-file',{attrs:{"number":3,"size":20,"img":true,"list":_vm.fileList},on:{"onFileChange":_vm.onFileChange}})],1)])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-right",staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"success","loading":_vm.submitLoading},on:{"click":_vm.submit}},[_vm._v("确 认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zHEt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zz7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_mUtils__ = __webpack_require__("yclV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__("i84Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imgUrl: '',
      lookBigImgDialog: false,
      fileList: []
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  props: ['infoDetail', 'noteCreateName'],
  computed: {},
  methods: {
    openFile: function openFile(url) {
      window.open(url);
    },
    downLoad: function downLoad(file) {
      window.open('/company/download/downloadWorkflowFileUseName?fileName=' + file.fileName + '&fileUrl=' + file.exportFile);
    }
  },
  components: {},
  watch: {}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f2550e5bd13e2b571cfc.js